var We = "top", st = "bottom", it = "right", qe = "left", ei = "auto", rn = [We, st, it, qe], Or = "start", qr = "end", Du = "clippingParents", da = "viewport", Fr = "popper", Iu = "reference", Do = /* @__PURE__ */ rn.reduce(function(e, t) {
  return e.concat([t + "-" + Or, t + "-" + qr]);
}, []), fa = /* @__PURE__ */ [].concat(rn, [ei]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Or, t + "-" + qr]);
}, []), Mu = "beforeRead", Lu = "read", Ru = "afterRead", ku = "beforeMain", xu = "main", Pu = "afterMain", $u = "beforeWrite", Fu = "write", Vu = "afterWrite", Bu = [Mu, Lu, Ru, ku, xu, Pu, $u, Fu, Vu];
function Vt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function ot(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Ar(e) {
  var t = ot(e).Element;
  return e instanceof t || e instanceof Element;
}
function ct(e) {
  var t = ot(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function pa(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = ot(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Pp(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, s = t.attributes[r] || {}, i = t.elements[r];
    !ct(i) || !Vt(i) || (Object.assign(i.style, n), Object.keys(s).forEach(function(o) {
      var a = s[o];
      a === !1 ? i.removeAttribute(o) : i.setAttribute(o, a === !0 ? "" : a);
    }));
  });
}
function $p(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var s = t.elements[n], i = t.attributes[n] || {}, o = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), a = o.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !ct(s) || !Vt(s) || (Object.assign(s.style, a), Object.keys(i).forEach(function(l) {
        s.removeAttribute(l);
      }));
    });
  };
}
const ha = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Pp,
  effect: $p,
  requires: ["computeStyles"]
};
function Pt(e) {
  return e.split("-")[0];
}
var Er = Math.max, Ps = Math.min, Kr = Math.round;
function Io() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Uu() {
  return !/^((?!chrome|android).)*safari/i.test(Io());
}
function zr(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), s = 1, i = 1;
  t && ct(e) && (s = e.offsetWidth > 0 && Kr(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && Kr(n.height) / e.offsetHeight || 1);
  var o = Ar(e) ? ot(e) : window, a = o.visualViewport, l = !Uu() && r, u = (n.left + (l && a ? a.offsetLeft : 0)) / s, c = (n.top + (l && a ? a.offsetTop : 0)) / i, d = n.width / s, f = n.height / i;
  return {
    width: d,
    height: f,
    top: c,
    right: u + d,
    bottom: c + f,
    left: u,
    x: u,
    y: c
  };
}
function ga(e) {
  var t = zr(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function Hu(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && pa(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Kt(e) {
  return ot(e).getComputedStyle(e);
}
function Fp(e) {
  return ["table", "td", "th"].indexOf(Vt(e)) >= 0;
}
function cr(e) {
  return ((Ar(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function ti(e) {
  return Vt(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (pa(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    cr(e)
  );
}
function dl(e) {
  return !ct(e) || // https://github.com/popperjs/popper-core/issues/837
  Kt(e).position === "fixed" ? null : e.offsetParent;
}
function Vp(e) {
  var t = /firefox/i.test(Io()), r = /Trident/i.test(Io());
  if (r && ct(e)) {
    var n = Kt(e);
    if (n.position === "fixed")
      return null;
  }
  var s = ti(e);
  for (pa(s) && (s = s.host); ct(s) && ["html", "body"].indexOf(Vt(s)) < 0; ) {
    var i = Kt(s);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return s;
    s = s.parentNode;
  }
  return null;
}
function Bn(e) {
  for (var t = ot(e), r = dl(e); r && Fp(r) && Kt(r).position === "static"; )
    r = dl(r);
  return r && (Vt(r) === "html" || Vt(r) === "body" && Kt(r).position === "static") ? t : r || Vp(e) || t;
}
function _a(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Cn(e, t, r) {
  return Er(e, Ps(t, r));
}
function Bp(e, t, r) {
  var n = Cn(e, t, r);
  return n > r ? r : n;
}
function ju() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Yu(e) {
  return Object.assign({}, ju(), e);
}
function Gu(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var Up = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, Yu(typeof t != "number" ? t : Gu(t, rn));
};
function Hp(e) {
  var t, r = e.state, n = e.name, s = e.options, i = r.elements.arrow, o = r.modifiersData.popperOffsets, a = Pt(r.placement), l = _a(a), u = [qe, it].indexOf(a) >= 0, c = u ? "height" : "width";
  if (!(!i || !o)) {
    var d = Up(s.padding, r), f = ga(i), _ = l === "y" ? We : qe, g = l === "y" ? st : it, p = r.rects.reference[c] + r.rects.reference[l] - o[l] - r.rects.popper[c], y = o[l] - r.rects.reference[l], A = Bn(i), T = A ? l === "y" ? A.clientHeight || 0 : A.clientWidth || 0 : 0, b = p / 2 - y / 2, C = d[_], v = T - f[c] - d[g], Y = T / 2 - f[c] / 2 + b, K = Cn(C, Y, v), ee = l;
    r.modifiersData[n] = (t = {}, t[ee] = K, t.centerOffset = K - Y, t);
  }
}
function jp(e) {
  var t = e.state, r = e.options, n = r.element, s = n === void 0 ? "[data-popper-arrow]" : n;
  s != null && (typeof s == "string" && (s = t.elements.popper.querySelector(s), !s) || Hu(t.elements.popper, s) && (t.elements.arrow = s));
}
const Wu = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Hp,
  effect: jp,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Jr(e) {
  return e.split("-")[1];
}
var Yp = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Gp(e, t) {
  var r = e.x, n = e.y, s = t.devicePixelRatio || 1;
  return {
    x: Kr(r * s) / s || 0,
    y: Kr(n * s) / s || 0
  };
}
function fl(e) {
  var t, r = e.popper, n = e.popperRect, s = e.placement, i = e.variation, o = e.offsets, a = e.position, l = e.gpuAcceleration, u = e.adaptive, c = e.roundOffsets, d = e.isFixed, f = o.x, _ = f === void 0 ? 0 : f, g = o.y, p = g === void 0 ? 0 : g, y = typeof c == "function" ? c({
    x: _,
    y: p
  }) : {
    x: _,
    y: p
  };
  _ = y.x, p = y.y;
  var A = o.hasOwnProperty("x"), T = o.hasOwnProperty("y"), b = qe, C = We, v = window;
  if (u) {
    var Y = Bn(r), K = "clientHeight", ee = "clientWidth";
    if (Y === ot(r) && (Y = cr(r), Kt(Y).position !== "static" && a === "absolute" && (K = "scrollHeight", ee = "scrollWidth")), Y = Y, s === We || (s === qe || s === it) && i === qr) {
      C = st;
      var Q = d && Y === v && v.visualViewport ? v.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        Y[K]
      );
      p -= Q - n.height, p *= l ? 1 : -1;
    }
    if (s === qe || (s === We || s === st) && i === qr) {
      b = it;
      var Z = d && Y === v && v.visualViewport ? v.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        Y[ee]
      );
      _ -= Z - n.width, _ *= l ? 1 : -1;
    }
  }
  var X = Object.assign({
    position: a
  }, u && Yp), le = c === !0 ? Gp({
    x: _,
    y: p
  }, ot(r)) : {
    x: _,
    y: p
  };
  if (_ = le.x, p = le.y, l) {
    var ae;
    return Object.assign({}, X, (ae = {}, ae[C] = T ? "0" : "", ae[b] = A ? "0" : "", ae.transform = (v.devicePixelRatio || 1) <= 1 ? "translate(" + _ + "px, " + p + "px)" : "translate3d(" + _ + "px, " + p + "px, 0)", ae));
  }
  return Object.assign({}, X, (t = {}, t[C] = T ? p + "px" : "", t[b] = A ? _ + "px" : "", t.transform = "", t));
}
function Wp(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, s = n === void 0 ? !0 : n, i = r.adaptive, o = i === void 0 ? !0 : i, a = r.roundOffsets, l = a === void 0 ? !0 : a, u = {
    placement: Pt(t.placement),
    variation: Jr(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: s,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, fl(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, fl(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const ma = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Wp,
  data: {}
};
var es = {
  passive: !0
};
function qp(e) {
  var t = e.state, r = e.instance, n = e.options, s = n.scroll, i = s === void 0 ? !0 : s, o = n.resize, a = o === void 0 ? !0 : o, l = ot(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(c) {
    c.addEventListener("scroll", r.update, es);
  }), a && l.addEventListener("resize", r.update, es), function() {
    i && u.forEach(function(c) {
      c.removeEventListener("scroll", r.update, es);
    }), a && l.removeEventListener("resize", r.update, es);
  };
}
const ya = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: qp,
  data: {}
};
var Kp = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function hs(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Kp[t];
  });
}
var zp = {
  start: "end",
  end: "start"
};
function pl(e) {
  return e.replace(/start|end/g, function(t) {
    return zp[t];
  });
}
function Ea(e) {
  var t = ot(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function va(e) {
  return zr(cr(e)).left + Ea(e).scrollLeft;
}
function Jp(e, t) {
  var r = ot(e), n = cr(e), s = r.visualViewport, i = n.clientWidth, o = n.clientHeight, a = 0, l = 0;
  if (s) {
    i = s.width, o = s.height;
    var u = Uu();
    (u || !u && t === "fixed") && (a = s.offsetLeft, l = s.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: a + va(e),
    y: l
  };
}
function Xp(e) {
  var t, r = cr(e), n = Ea(e), s = (t = e.ownerDocument) == null ? void 0 : t.body, i = Er(r.scrollWidth, r.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), o = Er(r.scrollHeight, r.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), a = -n.scrollLeft + va(e), l = -n.scrollTop;
  return Kt(s || r).direction === "rtl" && (a += Er(r.clientWidth, s ? s.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: a,
    y: l
  };
}
function ba(e) {
  var t = Kt(e), r = t.overflow, n = t.overflowX, s = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + s + n);
}
function qu(e) {
  return ["html", "body", "#document"].indexOf(Vt(e)) >= 0 ? e.ownerDocument.body : ct(e) && ba(e) ? e : qu(ti(e));
}
function Dn(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = qu(e), s = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = ot(n), o = s ? [i].concat(i.visualViewport || [], ba(n) ? n : []) : n, a = t.concat(o);
  return s ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(Dn(ti(o)))
  );
}
function Mo(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Qp(e, t) {
  var r = zr(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function hl(e, t, r) {
  return t === da ? Mo(Jp(e, r)) : Ar(t) ? Qp(t, r) : Mo(Xp(cr(e)));
}
function Zp(e) {
  var t = Dn(ti(e)), r = ["absolute", "fixed"].indexOf(Kt(e).position) >= 0, n = r && ct(e) ? Bn(e) : e;
  return Ar(n) ? t.filter(function(s) {
    return Ar(s) && Hu(s, n) && Vt(s) !== "body";
  }) : [];
}
function eh(e, t, r, n) {
  var s = t === "clippingParents" ? Zp(e) : [].concat(t), i = [].concat(s, [r]), o = i[0], a = i.reduce(function(l, u) {
    var c = hl(e, u, n);
    return l.top = Er(c.top, l.top), l.right = Ps(c.right, l.right), l.bottom = Ps(c.bottom, l.bottom), l.left = Er(c.left, l.left), l;
  }, hl(e, o, n));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function Ku(e) {
  var t = e.reference, r = e.element, n = e.placement, s = n ? Pt(n) : null, i = n ? Jr(n) : null, o = t.x + t.width / 2 - r.width / 2, a = t.y + t.height / 2 - r.height / 2, l;
  switch (s) {
    case We:
      l = {
        x: o,
        y: t.y - r.height
      };
      break;
    case st:
      l = {
        x: o,
        y: t.y + t.height
      };
      break;
    case it:
      l = {
        x: t.x + t.width,
        y: a
      };
      break;
    case qe:
      l = {
        x: t.x - r.width,
        y: a
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var u = s ? _a(s) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (i) {
      case Or:
        l[u] = l[u] - (t[c] / 2 - r[c] / 2);
        break;
      case qr:
        l[u] = l[u] + (t[c] / 2 - r[c] / 2);
        break;
    }
  }
  return l;
}
function Xr(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, s = n === void 0 ? e.placement : n, i = r.strategy, o = i === void 0 ? e.strategy : i, a = r.boundary, l = a === void 0 ? Du : a, u = r.rootBoundary, c = u === void 0 ? da : u, d = r.elementContext, f = d === void 0 ? Fr : d, _ = r.altBoundary, g = _ === void 0 ? !1 : _, p = r.padding, y = p === void 0 ? 0 : p, A = Yu(typeof y != "number" ? y : Gu(y, rn)), T = f === Fr ? Iu : Fr, b = e.rects.popper, C = e.elements[g ? T : f], v = eh(Ar(C) ? C : C.contextElement || cr(e.elements.popper), l, c, o), Y = zr(e.elements.reference), K = Ku({
    reference: Y,
    element: b,
    placement: s
  }), ee = Mo(Object.assign({}, b, K)), Q = f === Fr ? ee : Y, Z = {
    top: v.top - Q.top + A.top,
    bottom: Q.bottom - v.bottom + A.bottom,
    left: v.left - Q.left + A.left,
    right: Q.right - v.right + A.right
  }, X = e.modifiersData.offset;
  if (f === Fr && X) {
    var le = X[s];
    Object.keys(Z).forEach(function(ae) {
      var W = [it, st].indexOf(ae) >= 0 ? 1 : -1, V = [We, st].indexOf(ae) >= 0 ? "y" : "x";
      Z[ae] += le[V] * W;
    });
  }
  return Z;
}
function th(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, s = r.boundary, i = r.rootBoundary, o = r.padding, a = r.flipVariations, l = r.allowedAutoPlacements, u = l === void 0 ? fa : l, c = Jr(n), d = c ? a ? Do : Do.filter(function(g) {
    return Jr(g) === c;
  }) : rn, f = d.filter(function(g) {
    return u.indexOf(g) >= 0;
  });
  f.length === 0 && (f = d);
  var _ = f.reduce(function(g, p) {
    return g[p] = Xr(e, {
      placement: p,
      boundary: s,
      rootBoundary: i,
      padding: o
    })[Pt(p)], g;
  }, {});
  return Object.keys(_).sort(function(g, p) {
    return _[g] - _[p];
  });
}
function rh(e) {
  if (Pt(e) === ei)
    return [];
  var t = hs(e);
  return [pl(e), t, pl(t)];
}
function nh(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var s = r.mainAxis, i = s === void 0 ? !0 : s, o = r.altAxis, a = o === void 0 ? !0 : o, l = r.fallbackPlacements, u = r.padding, c = r.boundary, d = r.rootBoundary, f = r.altBoundary, _ = r.flipVariations, g = _ === void 0 ? !0 : _, p = r.allowedAutoPlacements, y = t.options.placement, A = Pt(y), T = A === y, b = l || (T || !g ? [hs(y)] : rh(y)), C = [y].concat(b).reduce(function(te, fe) {
      return te.concat(Pt(fe) === ei ? th(t, {
        placement: fe,
        boundary: c,
        rootBoundary: d,
        padding: u,
        flipVariations: g,
        allowedAutoPlacements: p
      }) : fe);
    }, []), v = t.rects.reference, Y = t.rects.popper, K = /* @__PURE__ */ new Map(), ee = !0, Q = C[0], Z = 0; Z < C.length; Z++) {
      var X = C[Z], le = Pt(X), ae = Jr(X) === Or, W = [We, st].indexOf(le) >= 0, V = W ? "width" : "height", L = Xr(t, {
        placement: X,
        boundary: c,
        rootBoundary: d,
        altBoundary: f,
        padding: u
      }), R = W ? ae ? it : qe : ae ? st : We;
      v[V] > Y[V] && (R = hs(R));
      var M = hs(R), w = [];
      if (i && w.push(L[le] <= 0), a && w.push(L[R] <= 0, L[M] <= 0), w.every(function(te) {
        return te;
      })) {
        Q = X, ee = !1;
        break;
      }
      K.set(X, w);
    }
    if (ee)
      for (var S = g ? 3 : 1, D = function(fe) {
        var Se = C.find(function(ve) {
          var ye = K.get(ve);
          if (ye)
            return ye.slice(0, fe).every(function(ne) {
              return ne;
            });
        });
        if (Se)
          return Q = Se, "break";
      }, G = S; G > 0; G--) {
        var U = D(G);
        if (U === "break") break;
      }
    t.placement !== Q && (t.modifiersData[n]._skip = !0, t.placement = Q, t.reset = !0);
  }
}
const zu = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: nh,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function gl(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function _l(e) {
  return [We, it, st, qe].some(function(t) {
    return e[t] >= 0;
  });
}
function sh(e) {
  var t = e.state, r = e.name, n = t.rects.reference, s = t.rects.popper, i = t.modifiersData.preventOverflow, o = Xr(t, {
    elementContext: "reference"
  }), a = Xr(t, {
    altBoundary: !0
  }), l = gl(o, n), u = gl(a, s, i), c = _l(l), d = _l(u);
  t.modifiersData[r] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": d
  });
}
const Ju = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: sh
};
function ih(e, t, r) {
  var n = Pt(e), s = [qe, We].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, o = i[0], a = i[1];
  return o = o || 0, a = (a || 0) * s, [qe, it].indexOf(n) >= 0 ? {
    x: a,
    y: o
  } : {
    x: o,
    y: a
  };
}
function oh(e) {
  var t = e.state, r = e.options, n = e.name, s = r.offset, i = s === void 0 ? [0, 0] : s, o = fa.reduce(function(c, d) {
    return c[d] = ih(d, t.rects, i), c;
  }, {}), a = o[t.placement], l = a.x, u = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[n] = o;
}
const Xu = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: oh
};
function ah(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = Ku({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const wa = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: ah,
  data: {}
};
function lh(e) {
  return e === "x" ? "y" : "x";
}
function ch(e) {
  var t = e.state, r = e.options, n = e.name, s = r.mainAxis, i = s === void 0 ? !0 : s, o = r.altAxis, a = o === void 0 ? !1 : o, l = r.boundary, u = r.rootBoundary, c = r.altBoundary, d = r.padding, f = r.tether, _ = f === void 0 ? !0 : f, g = r.tetherOffset, p = g === void 0 ? 0 : g, y = Xr(t, {
    boundary: l,
    rootBoundary: u,
    padding: d,
    altBoundary: c
  }), A = Pt(t.placement), T = Jr(t.placement), b = !T, C = _a(A), v = lh(C), Y = t.modifiersData.popperOffsets, K = t.rects.reference, ee = t.rects.popper, Q = typeof p == "function" ? p(Object.assign({}, t.rects, {
    placement: t.placement
  })) : p, Z = typeof Q == "number" ? {
    mainAxis: Q,
    altAxis: Q
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, Q), X = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, le = {
    x: 0,
    y: 0
  };
  if (Y) {
    if (i) {
      var ae, W = C === "y" ? We : qe, V = C === "y" ? st : it, L = C === "y" ? "height" : "width", R = Y[C], M = R + y[W], w = R - y[V], S = _ ? -ee[L] / 2 : 0, D = T === Or ? K[L] : ee[L], G = T === Or ? -ee[L] : -K[L], U = t.elements.arrow, te = _ && U ? ga(U) : {
        width: 0,
        height: 0
      }, fe = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : ju(), Se = fe[W], ve = fe[V], ye = Cn(0, K[L], te[L]), ne = b ? K[L] / 2 - S - ye - Se - Z.mainAxis : D - ye - Se - Z.mainAxis, re = b ? -K[L] / 2 + S + ye + ve + Z.mainAxis : G + ye + ve + Z.mainAxis, de = t.elements.arrow && Bn(t.elements.arrow), Ie = de ? C === "y" ? de.clientTop || 0 : de.clientLeft || 0 : 0, h = (ae = X == null ? void 0 : X[C]) != null ? ae : 0, E = R + ne - h - Ie, I = R + re - h, P = Cn(_ ? Ps(M, E) : M, R, _ ? Er(w, I) : w);
      Y[C] = P, le[C] = P - R;
    }
    if (a) {
      var k, x = C === "x" ? We : qe, q = C === "x" ? st : it, H = Y[v], j = v === "y" ? "height" : "width", B = H + y[x], ie = H - y[q], J = [We, qe].indexOf(A) !== -1, se = (k = X == null ? void 0 : X[v]) != null ? k : 0, ce = J ? B : H - K[j] - ee[j] - se + Z.altAxis, Ee = J ? H + K[j] + ee[j] - se - Z.altAxis : ie, Oe = _ && J ? Bp(ce, H, Ee) : Cn(_ ? ce : B, H, _ ? Ee : ie);
      Y[v] = Oe, le[v] = Oe - H;
    }
    t.modifiersData[n] = le;
  }
}
const Qu = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: ch,
  requiresIfExists: ["offset"]
};
function uh(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function dh(e) {
  return e === ot(e) || !ct(e) ? Ea(e) : uh(e);
}
function fh(e) {
  var t = e.getBoundingClientRect(), r = Kr(t.width) / e.offsetWidth || 1, n = Kr(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function ph(e, t, r) {
  r === void 0 && (r = !1);
  var n = ct(t), s = ct(t) && fh(t), i = cr(t), o = zr(e, s, r), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Vt(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  ba(i)) && (a = dh(t)), ct(t) ? (l = zr(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : i && (l.x = va(i))), {
    x: o.left + a.scrollLeft - l.x,
    y: o.top + a.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function hh(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function s(i) {
    r.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(a) {
      if (!r.has(a)) {
        var l = t.get(a);
        l && s(l);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || s(i);
  }), n;
}
function gh(e) {
  var t = hh(e);
  return Bu.reduce(function(r, n) {
    return r.concat(t.filter(function(s) {
      return s.phase === n;
    }));
  }, []);
}
function _h(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function mh(e) {
  var t = e.reduce(function(r, n) {
    var s = r[n.name];
    return r[n.name] = s ? Object.assign({}, s, n, {
      options: Object.assign({}, s.options, n.options),
      data: Object.assign({}, s.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var ml = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function yl() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function ri(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, s = t.defaultOptions, i = s === void 0 ? ml : s;
  return function(a, l, u) {
    u === void 0 && (u = i);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ml, i),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, _ = {
      state: c,
      setOptions: function(A) {
        var T = typeof A == "function" ? A(c.options) : A;
        p(), c.options = Object.assign({}, i, c.options, T), c.scrollParents = {
          reference: Ar(a) ? Dn(a) : a.contextElement ? Dn(a.contextElement) : [],
          popper: Dn(l)
        };
        var b = gh(mh([].concat(n, c.options.modifiers)));
        return c.orderedModifiers = b.filter(function(C) {
          return C.enabled;
        }), g(), _.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var A = c.elements, T = A.reference, b = A.popper;
          if (yl(T, b)) {
            c.rects = {
              reference: ph(T, Bn(b), c.options.strategy === "fixed"),
              popper: ga(b)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(Z) {
              return c.modifiersData[Z.name] = Object.assign({}, Z.data);
            });
            for (var C = 0; C < c.orderedModifiers.length; C++) {
              if (c.reset === !0) {
                c.reset = !1, C = -1;
                continue;
              }
              var v = c.orderedModifiers[C], Y = v.fn, K = v.options, ee = K === void 0 ? {} : K, Q = v.name;
              typeof Y == "function" && (c = Y({
                state: c,
                options: ee,
                name: Q,
                instance: _
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: _h(function() {
        return new Promise(function(y) {
          _.forceUpdate(), y(c);
        });
      }),
      destroy: function() {
        p(), f = !0;
      }
    };
    if (!yl(a, l))
      return _;
    _.setOptions(u).then(function(y) {
      !f && u.onFirstUpdate && u.onFirstUpdate(y);
    });
    function g() {
      c.orderedModifiers.forEach(function(y) {
        var A = y.name, T = y.options, b = T === void 0 ? {} : T, C = y.effect;
        if (typeof C == "function") {
          var v = C({
            state: c,
            name: A,
            instance: _,
            options: b
          }), Y = function() {
          };
          d.push(v || Y);
        }
      });
    }
    function p() {
      d.forEach(function(y) {
        return y();
      }), d = [];
    }
    return _;
  };
}
var yh = /* @__PURE__ */ ri(), Eh = [ya, wa, ma, ha], vh = /* @__PURE__ */ ri({
  defaultModifiers: Eh
}), bh = [ya, wa, ma, ha, Xu, zu, Qu, Wu, Ju], Ta = /* @__PURE__ */ ri({
  defaultModifiers: bh
});
const Zu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  afterMain: Pu,
  afterRead: Ru,
  afterWrite: Vu,
  applyStyles: ha,
  arrow: Wu,
  auto: ei,
  basePlacements: rn,
  beforeMain: ku,
  beforeRead: Mu,
  beforeWrite: $u,
  bottom: st,
  clippingParents: Du,
  computeStyles: ma,
  createPopper: Ta,
  createPopperBase: yh,
  createPopperLite: vh,
  detectOverflow: Xr,
  end: qr,
  eventListeners: ya,
  flip: zu,
  hide: Ju,
  left: qe,
  main: xu,
  modifierPhases: Bu,
  offset: Xu,
  placements: fa,
  popper: Fr,
  popperGenerator: ri,
  popperOffsets: wa,
  preventOverflow: Qu,
  read: Lu,
  reference: Iu,
  right: it,
  start: Or,
  top: We,
  variationPlacements: Do,
  viewport: da,
  write: Fu
}, Symbol.toStringTag, { value: "Module" }));
/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
const Xt = /* @__PURE__ */ new Map(), Ci = {
  set(e, t, r) {
    Xt.has(e) || Xt.set(e, /* @__PURE__ */ new Map());
    const n = Xt.get(e);
    if (!n.has(t) && n.size !== 0) {
      console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(n.keys())[0]}.`);
      return;
    }
    n.set(t, r);
  },
  get(e, t) {
    return Xt.has(e) && Xt.get(e).get(t) || null;
  },
  remove(e, t) {
    if (!Xt.has(e))
      return;
    const r = Xt.get(e);
    r.delete(t), r.size === 0 && Xt.delete(e);
  }
}, wh = 1e6, Th = 1e3, Lo = "transitionend", ed = (e) => (e && window.CSS && window.CSS.escape && (e = e.replace(/#([^\s"#']+)/g, (t, r) => `#${CSS.escape(r)}`)), e), Sh = (e) => e == null ? `${e}` : Object.prototype.toString.call(e).match(/\s([a-z]+)/i)[1].toLowerCase(), Oh = (e) => {
  do
    e += Math.floor(Math.random() * wh);
  while (document.getElementById(e));
  return e;
}, Ah = (e) => {
  if (!e)
    return 0;
  let {
    transitionDuration: t,
    transitionDelay: r
  } = window.getComputedStyle(e);
  const n = Number.parseFloat(t), s = Number.parseFloat(r);
  return !n && !s ? 0 : (t = t.split(",")[0], r = r.split(",")[0], (Number.parseFloat(t) + Number.parseFloat(r)) * Th);
}, td = (e) => {
  e.dispatchEvent(new Event(Lo));
}, Wt = (e) => !e || typeof e != "object" ? !1 : (typeof e.jquery < "u" && (e = e[0]), typeof e.nodeType < "u"), sr = (e) => Wt(e) ? e.jquery ? e[0] : e : typeof e == "string" && e.length > 0 ? document.querySelector(ed(e)) : null, nn = (e) => {
  if (!Wt(e) || e.getClientRects().length === 0)
    return !1;
  const t = getComputedStyle(e).getPropertyValue("visibility") === "visible", r = e.closest("details:not([open])");
  if (!r)
    return t;
  if (r !== e) {
    const n = e.closest("summary");
    if (n && n.parentNode !== r || n === null)
      return !1;
  }
  return t;
}, ir = (e) => !e || e.nodeType !== Node.ELEMENT_NODE || e.classList.contains("disabled") ? !0 : typeof e.disabled < "u" ? e.disabled : e.hasAttribute("disabled") && e.getAttribute("disabled") !== "false", rd = (e) => {
  if (!document.documentElement.attachShadow)
    return null;
  if (typeof e.getRootNode == "function") {
    const t = e.getRootNode();
    return t instanceof ShadowRoot ? t : null;
  }
  return e instanceof ShadowRoot ? e : e.parentNode ? rd(e.parentNode) : null;
}, $s = () => {
}, Un = (e) => {
  e.offsetHeight;
}, nd = () => window.jQuery && !document.body.hasAttribute("data-bs-no-jquery") ? window.jQuery : null, Di = [], Nh = (e) => {
  document.readyState === "loading" ? (Di.length || document.addEventListener("DOMContentLoaded", () => {
    for (const t of Di)
      t();
  }), Di.push(e)) : e();
}, ut = () => document.documentElement.dir === "rtl", ft = (e) => {
  Nh(() => {
    const t = nd();
    if (t) {
      const r = e.NAME, n = t.fn[r];
      t.fn[r] = e.jQueryInterface, t.fn[r].Constructor = e, t.fn[r].noConflict = () => (t.fn[r] = n, e.jQueryInterface);
    }
  });
}, Xe = (e, t = [], r = e) => typeof e == "function" ? e.call(...t) : r, sd = (e, t, r = !0) => {
  if (!r) {
    Xe(e);
    return;
  }
  const s = Ah(t) + 5;
  let i = !1;
  const o = ({
    target: a
  }) => {
    a === t && (i = !0, t.removeEventListener(Lo, o), Xe(e));
  };
  t.addEventListener(Lo, o), setTimeout(() => {
    i || td(t);
  }, s);
}, Sa = (e, t, r, n) => {
  const s = e.length;
  let i = e.indexOf(t);
  return i === -1 ? !r && n ? e[s - 1] : e[0] : (i += r ? 1 : -1, n && (i = (i + s) % s), e[Math.max(0, Math.min(i, s - 1))]);
}, Ch = /[^.]*(?=\..*)\.|.*/, Dh = /\..*/, Ih = /::\d+$/, Ii = {};
let El = 1;
const id = {
  mouseenter: "mouseover",
  mouseleave: "mouseout"
}, Mh = /* @__PURE__ */ new Set(["click", "dblclick", "mouseup", "mousedown", "contextmenu", "mousewheel", "DOMMouseScroll", "mouseover", "mouseout", "mousemove", "selectstart", "selectend", "keydown", "keypress", "keyup", "orientationchange", "touchstart", "touchmove", "touchend", "touchcancel", "pointerdown", "pointermove", "pointerup", "pointerleave", "pointercancel", "gesturestart", "gesturechange", "gestureend", "focus", "blur", "change", "reset", "select", "submit", "focusin", "focusout", "load", "unload", "beforeunload", "resize", "move", "DOMContentLoaded", "readystatechange", "error", "abort", "scroll"]);
function od(e, t) {
  return t && `${t}::${El++}` || e.uidEvent || El++;
}
function ad(e) {
  const t = od(e);
  return e.uidEvent = t, Ii[t] = Ii[t] || {}, Ii[t];
}
function Lh(e, t) {
  return function r(n) {
    return Oa(n, {
      delegateTarget: e
    }), r.oneOff && F.off(e, n.type, t), t.apply(e, [n]);
  };
}
function Rh(e, t, r) {
  return function n(s) {
    const i = e.querySelectorAll(t);
    for (let {
      target: o
    } = s; o && o !== this; o = o.parentNode)
      for (const a of i)
        if (a === o)
          return Oa(s, {
            delegateTarget: o
          }), n.oneOff && F.off(e, s.type, t, r), r.apply(o, [s]);
  };
}
function ld(e, t, r = null) {
  return Object.values(e).find((n) => n.callable === t && n.delegationSelector === r);
}
function cd(e, t, r) {
  const n = typeof t == "string", s = n ? r : t || r;
  let i = ud(e);
  return Mh.has(i) || (i = e), [n, s, i];
}
function vl(e, t, r, n, s) {
  if (typeof t != "string" || !e)
    return;
  let [i, o, a] = cd(t, r, n);
  t in id && (o = ((g) => function(p) {
    if (!p.relatedTarget || p.relatedTarget !== p.delegateTarget && !p.delegateTarget.contains(p.relatedTarget))
      return g.call(this, p);
  })(o));
  const l = ad(e), u = l[a] || (l[a] = {}), c = ld(u, o, i ? r : null);
  if (c) {
    c.oneOff = c.oneOff && s;
    return;
  }
  const d = od(o, t.replace(Ch, "")), f = i ? Rh(e, r, o) : Lh(e, o);
  f.delegationSelector = i ? r : null, f.callable = o, f.oneOff = s, f.uidEvent = d, u[d] = f, e.addEventListener(a, f, i);
}
function Ro(e, t, r, n, s) {
  const i = ld(t[r], n, s);
  i && (e.removeEventListener(r, i, !!s), delete t[r][i.uidEvent]);
}
function kh(e, t, r, n) {
  const s = t[r] || {};
  for (const [i, o] of Object.entries(s))
    i.includes(n) && Ro(e, t, r, o.callable, o.delegationSelector);
}
function ud(e) {
  return e = e.replace(Dh, ""), id[e] || e;
}
const F = {
  on(e, t, r, n) {
    vl(e, t, r, n, !1);
  },
  one(e, t, r, n) {
    vl(e, t, r, n, !0);
  },
  off(e, t, r, n) {
    if (typeof t != "string" || !e)
      return;
    const [s, i, o] = cd(t, r, n), a = o !== t, l = ad(e), u = l[o] || {}, c = t.startsWith(".");
    if (typeof i < "u") {
      if (!Object.keys(u).length)
        return;
      Ro(e, l, o, i, s ? r : null);
      return;
    }
    if (c)
      for (const d of Object.keys(l))
        kh(e, l, d, t.slice(1));
    for (const [d, f] of Object.entries(u)) {
      const _ = d.replace(Ih, "");
      (!a || t.includes(_)) && Ro(e, l, o, f.callable, f.delegationSelector);
    }
  },
  trigger(e, t, r) {
    if (typeof t != "string" || !e)
      return null;
    const n = nd(), s = ud(t), i = t !== s;
    let o = null, a = !0, l = !0, u = !1;
    i && n && (o = n.Event(t, r), n(e).trigger(o), a = !o.isPropagationStopped(), l = !o.isImmediatePropagationStopped(), u = o.isDefaultPrevented());
    const c = Oa(new Event(t, {
      bubbles: a,
      cancelable: !0
    }), r);
    return u && c.preventDefault(), l && e.dispatchEvent(c), c.defaultPrevented && o && o.preventDefault(), c;
  }
};
function Oa(e, t = {}) {
  for (const [r, n] of Object.entries(t))
    try {
      e[r] = n;
    } catch {
      Object.defineProperty(e, r, {
        configurable: !0,
        get() {
          return n;
        }
      });
    }
  return e;
}
function bl(e) {
  if (e === "true")
    return !0;
  if (e === "false")
    return !1;
  if (e === Number(e).toString())
    return Number(e);
  if (e === "" || e === "null")
    return null;
  if (typeof e != "string")
    return e;
  try {
    return JSON.parse(decodeURIComponent(e));
  } catch {
    return e;
  }
}
function Mi(e) {
  return e.replace(/[A-Z]/g, (t) => `-${t.toLowerCase()}`);
}
const qt = {
  setDataAttribute(e, t, r) {
    e.setAttribute(`data-bs-${Mi(t)}`, r);
  },
  removeDataAttribute(e, t) {
    e.removeAttribute(`data-bs-${Mi(t)}`);
  },
  getDataAttributes(e) {
    if (!e)
      return {};
    const t = {}, r = Object.keys(e.dataset).filter((n) => n.startsWith("bs") && !n.startsWith("bsConfig"));
    for (const n of r) {
      let s = n.replace(/^bs/, "");
      s = s.charAt(0).toLowerCase() + s.slice(1), t[s] = bl(e.dataset[n]);
    }
    return t;
  },
  getDataAttribute(e, t) {
    return bl(e.getAttribute(`data-bs-${Mi(t)}`));
  }
};
class Hn {
  // Getters
  static get Default() {
    return {};
  }
  static get DefaultType() {
    return {};
  }
  static get NAME() {
    throw new Error('You have to implement the static method "NAME", for each component!');
  }
  _getConfig(t) {
    return t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
  }
  _configAfterMerge(t) {
    return t;
  }
  _mergeConfigObj(t, r) {
    const n = Wt(r) ? qt.getDataAttribute(r, "config") : {};
    return {
      ...this.constructor.Default,
      ...typeof n == "object" ? n : {},
      ...Wt(r) ? qt.getDataAttributes(r) : {},
      ...typeof t == "object" ? t : {}
    };
  }
  _typeCheckConfig(t, r = this.constructor.DefaultType) {
    for (const [n, s] of Object.entries(r)) {
      const i = t[n], o = Wt(i) ? "element" : Sh(i);
      if (!new RegExp(s).test(o))
        throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${n}" provided type "${o}" but expected type "${s}".`);
    }
  }
}
const xh = "5.3.8";
class Tt extends Hn {
  constructor(t, r) {
    super(), t = sr(t), t && (this._element = t, this._config = this._getConfig(r), Ci.set(this._element, this.constructor.DATA_KEY, this));
  }
  // Public
  dispose() {
    Ci.remove(this._element, this.constructor.DATA_KEY), F.off(this._element, this.constructor.EVENT_KEY);
    for (const t of Object.getOwnPropertyNames(this))
      this[t] = null;
  }
  // Private
  _queueCallback(t, r, n = !0) {
    sd(t, r, n);
  }
  _getConfig(t) {
    return t = this._mergeConfigObj(t, this._element), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
  }
  // Static
  static getInstance(t) {
    return Ci.get(sr(t), this.DATA_KEY);
  }
  static getOrCreateInstance(t, r = {}) {
    return this.getInstance(t) || new this(t, typeof r == "object" ? r : null);
  }
  static get VERSION() {
    return xh;
  }
  static get DATA_KEY() {
    return `bs.${this.NAME}`;
  }
  static get EVENT_KEY() {
    return `.${this.DATA_KEY}`;
  }
  static eventName(t) {
    return `${t}${this.EVENT_KEY}`;
  }
}
const Li = (e) => {
  let t = e.getAttribute("data-bs-target");
  if (!t || t === "#") {
    let r = e.getAttribute("href");
    if (!r || !r.includes("#") && !r.startsWith("."))
      return null;
    r.includes("#") && !r.startsWith("#") && (r = `#${r.split("#")[1]}`), t = r && r !== "#" ? r.trim() : null;
  }
  return t ? t.split(",").map((r) => ed(r)).join(",") : null;
}, oe = {
  find(e, t = document.documentElement) {
    return [].concat(...Element.prototype.querySelectorAll.call(t, e));
  },
  findOne(e, t = document.documentElement) {
    return Element.prototype.querySelector.call(t, e);
  },
  children(e, t) {
    return [].concat(...e.children).filter((r) => r.matches(t));
  },
  parents(e, t) {
    const r = [];
    let n = e.parentNode.closest(t);
    for (; n; )
      r.push(n), n = n.parentNode.closest(t);
    return r;
  },
  prev(e, t) {
    let r = e.previousElementSibling;
    for (; r; ) {
      if (r.matches(t))
        return [r];
      r = r.previousElementSibling;
    }
    return [];
  },
  // TODO: this is now unused; remove later along with prev()
  next(e, t) {
    let r = e.nextElementSibling;
    for (; r; ) {
      if (r.matches(t))
        return [r];
      r = r.nextElementSibling;
    }
    return [];
  },
  focusableChildren(e) {
    const t = ["a", "button", "input", "textarea", "select", "details", "[tabindex]", '[contenteditable="true"]'].map((r) => `${r}:not([tabindex^="-"])`).join(",");
    return this.find(t, e).filter((r) => !ir(r) && nn(r));
  },
  getSelectorFromElement(e) {
    const t = Li(e);
    return t && oe.findOne(t) ? t : null;
  },
  getElementFromSelector(e) {
    const t = Li(e);
    return t ? oe.findOne(t) : null;
  },
  getMultipleElementsFromSelector(e) {
    const t = Li(e);
    return t ? oe.find(t) : [];
  }
}, ni = (e, t = "hide") => {
  const r = `click.dismiss${e.EVENT_KEY}`, n = e.NAME;
  F.on(document, r, `[data-bs-dismiss="${n}"]`, function(s) {
    if (["A", "AREA"].includes(this.tagName) && s.preventDefault(), ir(this))
      return;
    const i = oe.getElementFromSelector(this) || this.closest(`.${n}`);
    e.getOrCreateInstance(i)[t]();
  });
}, Ph = "alert", $h = "bs.alert", dd = `.${$h}`, Fh = `close${dd}`, Vh = `closed${dd}`, Bh = "fade", Uh = "show";
class si extends Tt {
  // Getters
  static get NAME() {
    return Ph;
  }
  // Public
  close() {
    if (F.trigger(this._element, Fh).defaultPrevented)
      return;
    this._element.classList.remove(Uh);
    const r = this._element.classList.contains(Bh);
    this._queueCallback(() => this._destroyElement(), this._element, r);
  }
  // Private
  _destroyElement() {
    this._element.remove(), F.trigger(this._element, Vh), this.dispose();
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = si.getOrCreateInstance(this);
      if (typeof t == "string") {
        if (r[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        r[t](this);
      }
    });
  }
}
ni(si, "close");
ft(si);
const Hh = "button", jh = "bs.button", Yh = `.${jh}`, Gh = ".data-api", Wh = "active", wl = '[data-bs-toggle="button"]', qh = `click${Yh}${Gh}`;
class ii extends Tt {
  // Getters
  static get NAME() {
    return Hh;
  }
  // Public
  toggle() {
    this._element.setAttribute("aria-pressed", this._element.classList.toggle(Wh));
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = ii.getOrCreateInstance(this);
      t === "toggle" && r[t]();
    });
  }
}
F.on(document, qh, wl, (e) => {
  e.preventDefault();
  const t = e.target.closest(wl);
  ii.getOrCreateInstance(t).toggle();
});
ft(ii);
const Kh = "swipe", sn = ".bs.swipe", zh = `touchstart${sn}`, Jh = `touchmove${sn}`, Xh = `touchend${sn}`, Qh = `pointerdown${sn}`, Zh = `pointerup${sn}`, eg = "touch", tg = "pen", rg = "pointer-event", ng = 40, sg = {
  endCallback: null,
  leftCallback: null,
  rightCallback: null
}, ig = {
  endCallback: "(function|null)",
  leftCallback: "(function|null)",
  rightCallback: "(function|null)"
};
class Fs extends Hn {
  constructor(t, r) {
    super(), this._element = t, !(!t || !Fs.isSupported()) && (this._config = this._getConfig(r), this._deltaX = 0, this._supportPointerEvents = !!window.PointerEvent, this._initEvents());
  }
  // Getters
  static get Default() {
    return sg;
  }
  static get DefaultType() {
    return ig;
  }
  static get NAME() {
    return Kh;
  }
  // Public
  dispose() {
    F.off(this._element, sn);
  }
  // Private
  _start(t) {
    if (!this._supportPointerEvents) {
      this._deltaX = t.touches[0].clientX;
      return;
    }
    this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX);
  }
  _end(t) {
    this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX - this._deltaX), this._handleSwipe(), Xe(this._config.endCallback);
  }
  _move(t) {
    this._deltaX = t.touches && t.touches.length > 1 ? 0 : t.touches[0].clientX - this._deltaX;
  }
  _handleSwipe() {
    const t = Math.abs(this._deltaX);
    if (t <= ng)
      return;
    const r = t / this._deltaX;
    this._deltaX = 0, r && Xe(r > 0 ? this._config.rightCallback : this._config.leftCallback);
  }
  _initEvents() {
    this._supportPointerEvents ? (F.on(this._element, Qh, (t) => this._start(t)), F.on(this._element, Zh, (t) => this._end(t)), this._element.classList.add(rg)) : (F.on(this._element, zh, (t) => this._start(t)), F.on(this._element, Jh, (t) => this._move(t)), F.on(this._element, Xh, (t) => this._end(t)));
  }
  _eventIsPointerPenTouch(t) {
    return this._supportPointerEvents && (t.pointerType === tg || t.pointerType === eg);
  }
  // Static
  static isSupported() {
    return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
  }
}
const og = "carousel", ag = "bs.carousel", ur = `.${ag}`, fd = ".data-api", lg = "ArrowLeft", cg = "ArrowRight", ug = 500, _n = "next", Rr = "prev", Vr = "left", gs = "right", dg = `slide${ur}`, Ri = `slid${ur}`, fg = `keydown${ur}`, pg = `mouseenter${ur}`, hg = `mouseleave${ur}`, gg = `dragstart${ur}`, _g = `load${ur}${fd}`, mg = `click${ur}${fd}`, pd = "carousel", ts = "active", yg = "slide", Eg = "carousel-item-end", vg = "carousel-item-start", bg = "carousel-item-next", wg = "carousel-item-prev", hd = ".active", gd = ".carousel-item", Tg = hd + gd, Sg = ".carousel-item img", Og = ".carousel-indicators", Ag = "[data-bs-slide], [data-bs-slide-to]", Ng = '[data-bs-ride="carousel"]', Cg = {
  [lg]: gs,
  [cg]: Vr
}, Dg = {
  interval: 5e3,
  keyboard: !0,
  pause: "hover",
  ride: !1,
  touch: !0,
  wrap: !0
}, Ig = {
  interval: "(number|boolean)",
  // TODO:v6 remove boolean support
  keyboard: "boolean",
  pause: "(string|boolean)",
  ride: "(boolean|string)",
  touch: "boolean",
  wrap: "boolean"
};
class jn extends Tt {
  constructor(t, r) {
    super(t, r), this._interval = null, this._activeElement = null, this._isSliding = !1, this.touchTimeout = null, this._swipeHelper = null, this._indicatorsElement = oe.findOne(Og, this._element), this._addEventListeners(), this._config.ride === pd && this.cycle();
  }
  // Getters
  static get Default() {
    return Dg;
  }
  static get DefaultType() {
    return Ig;
  }
  static get NAME() {
    return og;
  }
  // Public
  next() {
    this._slide(_n);
  }
  nextWhenVisible() {
    !document.hidden && nn(this._element) && this.next();
  }
  prev() {
    this._slide(Rr);
  }
  pause() {
    this._isSliding && td(this._element), this._clearInterval();
  }
  cycle() {
    this._clearInterval(), this._updateInterval(), this._interval = setInterval(() => this.nextWhenVisible(), this._config.interval);
  }
  _maybeEnableCycle() {
    if (this._config.ride) {
      if (this._isSliding) {
        F.one(this._element, Ri, () => this.cycle());
        return;
      }
      this.cycle();
    }
  }
  to(t) {
    const r = this._getItems();
    if (t > r.length - 1 || t < 0)
      return;
    if (this._isSliding) {
      F.one(this._element, Ri, () => this.to(t));
      return;
    }
    const n = this._getItemIndex(this._getActive());
    if (n === t)
      return;
    const s = t > n ? _n : Rr;
    this._slide(s, r[t]);
  }
  dispose() {
    this._swipeHelper && this._swipeHelper.dispose(), super.dispose();
  }
  // Private
  _configAfterMerge(t) {
    return t.defaultInterval = t.interval, t;
  }
  _addEventListeners() {
    this._config.keyboard && F.on(this._element, fg, (t) => this._keydown(t)), this._config.pause === "hover" && (F.on(this._element, pg, () => this.pause()), F.on(this._element, hg, () => this._maybeEnableCycle())), this._config.touch && Fs.isSupported() && this._addTouchEventListeners();
  }
  _addTouchEventListeners() {
    for (const n of oe.find(Sg, this._element))
      F.on(n, gg, (s) => s.preventDefault());
    const r = {
      leftCallback: () => this._slide(this._directionToOrder(Vr)),
      rightCallback: () => this._slide(this._directionToOrder(gs)),
      endCallback: () => {
        this._config.pause === "hover" && (this.pause(), this.touchTimeout && clearTimeout(this.touchTimeout), this.touchTimeout = setTimeout(() => this._maybeEnableCycle(), ug + this._config.interval));
      }
    };
    this._swipeHelper = new Fs(this._element, r);
  }
  _keydown(t) {
    if (/input|textarea/i.test(t.target.tagName))
      return;
    const r = Cg[t.key];
    r && (t.preventDefault(), this._slide(this._directionToOrder(r)));
  }
  _getItemIndex(t) {
    return this._getItems().indexOf(t);
  }
  _setActiveIndicatorElement(t) {
    if (!this._indicatorsElement)
      return;
    const r = oe.findOne(hd, this._indicatorsElement);
    r.classList.remove(ts), r.removeAttribute("aria-current");
    const n = oe.findOne(`[data-bs-slide-to="${t}"]`, this._indicatorsElement);
    n && (n.classList.add(ts), n.setAttribute("aria-current", "true"));
  }
  _updateInterval() {
    const t = this._activeElement || this._getActive();
    if (!t)
      return;
    const r = Number.parseInt(t.getAttribute("data-bs-interval"), 10);
    this._config.interval = r || this._config.defaultInterval;
  }
  _slide(t, r = null) {
    if (this._isSliding)
      return;
    const n = this._getActive(), s = t === _n, i = r || Sa(this._getItems(), n, s, this._config.wrap);
    if (i === n)
      return;
    const o = this._getItemIndex(i), a = (_) => F.trigger(this._element, _, {
      relatedTarget: i,
      direction: this._orderToDirection(t),
      from: this._getItemIndex(n),
      to: o
    });
    if (a(dg).defaultPrevented || !n || !i)
      return;
    const u = !!this._interval;
    this.pause(), this._isSliding = !0, this._setActiveIndicatorElement(o), this._activeElement = i;
    const c = s ? vg : Eg, d = s ? bg : wg;
    i.classList.add(d), Un(i), n.classList.add(c), i.classList.add(c);
    const f = () => {
      i.classList.remove(c, d), i.classList.add(ts), n.classList.remove(ts, d, c), this._isSliding = !1, a(Ri);
    };
    this._queueCallback(f, n, this._isAnimated()), u && this.cycle();
  }
  _isAnimated() {
    return this._element.classList.contains(yg);
  }
  _getActive() {
    return oe.findOne(Tg, this._element);
  }
  _getItems() {
    return oe.find(gd, this._element);
  }
  _clearInterval() {
    this._interval && (clearInterval(this._interval), this._interval = null);
  }
  _directionToOrder(t) {
    return ut() ? t === Vr ? Rr : _n : t === Vr ? _n : Rr;
  }
  _orderToDirection(t) {
    return ut() ? t === Rr ? Vr : gs : t === Rr ? gs : Vr;
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = jn.getOrCreateInstance(this, t);
      if (typeof t == "number") {
        r.to(t);
        return;
      }
      if (typeof t == "string") {
        if (r[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        r[t]();
      }
    });
  }
}
F.on(document, mg, Ag, function(e) {
  const t = oe.getElementFromSelector(this);
  if (!t || !t.classList.contains(pd))
    return;
  e.preventDefault();
  const r = jn.getOrCreateInstance(t), n = this.getAttribute("data-bs-slide-to");
  if (n) {
    r.to(n), r._maybeEnableCycle();
    return;
  }
  if (qt.getDataAttribute(this, "slide") === "next") {
    r.next(), r._maybeEnableCycle();
    return;
  }
  r.prev(), r._maybeEnableCycle();
});
F.on(window, _g, () => {
  const e = oe.find(Ng);
  for (const t of e)
    jn.getOrCreateInstance(t);
});
ft(jn);
const Mg = "collapse", Lg = "bs.collapse", Yn = `.${Lg}`, Rg = ".data-api", kg = `show${Yn}`, xg = `shown${Yn}`, Pg = `hide${Yn}`, $g = `hidden${Yn}`, Fg = `click${Yn}${Rg}`, ki = "show", Hr = "collapse", rs = "collapsing", Vg = "collapsed", Bg = `:scope .${Hr} .${Hr}`, Ug = "collapse-horizontal", Hg = "width", jg = "height", Yg = ".collapse.show, .collapse.collapsing", ko = '[data-bs-toggle="collapse"]', Gg = {
  parent: null,
  toggle: !0
}, Wg = {
  parent: "(null|element)",
  toggle: "boolean"
};
class Qr extends Tt {
  constructor(t, r) {
    super(t, r), this._isTransitioning = !1, this._triggerArray = [];
    const n = oe.find(ko);
    for (const s of n) {
      const i = oe.getSelectorFromElement(s), o = oe.find(i).filter((a) => a === this._element);
      i !== null && o.length && this._triggerArray.push(s);
    }
    this._initializeChildren(), this._config.parent || this._addAriaAndCollapsedClass(this._triggerArray, this._isShown()), this._config.toggle && this.toggle();
  }
  // Getters
  static get Default() {
    return Gg;
  }
  static get DefaultType() {
    return Wg;
  }
  static get NAME() {
    return Mg;
  }
  // Public
  toggle() {
    this._isShown() ? this.hide() : this.show();
  }
  show() {
    if (this._isTransitioning || this._isShown())
      return;
    let t = [];
    if (this._config.parent && (t = this._getFirstLevelChildren(Yg).filter((a) => a !== this._element).map((a) => Qr.getOrCreateInstance(a, {
      toggle: !1
    }))), t.length && t[0]._isTransitioning || F.trigger(this._element, kg).defaultPrevented)
      return;
    for (const a of t)
      a.hide();
    const n = this._getDimension();
    this._element.classList.remove(Hr), this._element.classList.add(rs), this._element.style[n] = 0, this._addAriaAndCollapsedClass(this._triggerArray, !0), this._isTransitioning = !0;
    const s = () => {
      this._isTransitioning = !1, this._element.classList.remove(rs), this._element.classList.add(Hr, ki), this._element.style[n] = "", F.trigger(this._element, xg);
    }, o = `scroll${n[0].toUpperCase() + n.slice(1)}`;
    this._queueCallback(s, this._element, !0), this._element.style[n] = `${this._element[o]}px`;
  }
  hide() {
    if (this._isTransitioning || !this._isShown() || F.trigger(this._element, Pg).defaultPrevented)
      return;
    const r = this._getDimension();
    this._element.style[r] = `${this._element.getBoundingClientRect()[r]}px`, Un(this._element), this._element.classList.add(rs), this._element.classList.remove(Hr, ki);
    for (const s of this._triggerArray) {
      const i = oe.getElementFromSelector(s);
      i && !this._isShown(i) && this._addAriaAndCollapsedClass([s], !1);
    }
    this._isTransitioning = !0;
    const n = () => {
      this._isTransitioning = !1, this._element.classList.remove(rs), this._element.classList.add(Hr), F.trigger(this._element, $g);
    };
    this._element.style[r] = "", this._queueCallback(n, this._element, !0);
  }
  // Private
  _isShown(t = this._element) {
    return t.classList.contains(ki);
  }
  _configAfterMerge(t) {
    return t.toggle = !!t.toggle, t.parent = sr(t.parent), t;
  }
  _getDimension() {
    return this._element.classList.contains(Ug) ? Hg : jg;
  }
  _initializeChildren() {
    if (!this._config.parent)
      return;
    const t = this._getFirstLevelChildren(ko);
    for (const r of t) {
      const n = oe.getElementFromSelector(r);
      n && this._addAriaAndCollapsedClass([r], this._isShown(n));
    }
  }
  _getFirstLevelChildren(t) {
    const r = oe.find(Bg, this._config.parent);
    return oe.find(t, this._config.parent).filter((n) => !r.includes(n));
  }
  _addAriaAndCollapsedClass(t, r) {
    if (t.length)
      for (const n of t)
        n.classList.toggle(Vg, !r), n.setAttribute("aria-expanded", r);
  }
  // Static
  static jQueryInterface(t) {
    const r = {};
    return typeof t == "string" && /show|hide/.test(t) && (r.toggle = !1), this.each(function() {
      const n = Qr.getOrCreateInstance(this, r);
      if (typeof t == "string") {
        if (typeof n[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        n[t]();
      }
    });
  }
}
F.on(document, Fg, ko, function(e) {
  (e.target.tagName === "A" || e.delegateTarget && e.delegateTarget.tagName === "A") && e.preventDefault();
  for (const t of oe.getMultipleElementsFromSelector(this))
    Qr.getOrCreateInstance(t, {
      toggle: !1
    }).toggle();
});
ft(Qr);
const Tl = "dropdown", qg = "bs.dropdown", Dr = `.${qg}`, Aa = ".data-api", Kg = "Escape", Sl = "Tab", zg = "ArrowUp", Ol = "ArrowDown", Jg = 2, Xg = `hide${Dr}`, Qg = `hidden${Dr}`, Zg = `show${Dr}`, e_ = `shown${Dr}`, _d = `click${Dr}${Aa}`, md = `keydown${Dr}${Aa}`, t_ = `keyup${Dr}${Aa}`, Br = "show", r_ = "dropup", n_ = "dropend", s_ = "dropstart", i_ = "dropup-center", o_ = "dropdown-center", _r = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)', a_ = `${_r}.${Br}`, _s = ".dropdown-menu", l_ = ".navbar", c_ = ".navbar-nav", u_ = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)", d_ = ut() ? "top-end" : "top-start", f_ = ut() ? "top-start" : "top-end", p_ = ut() ? "bottom-end" : "bottom-start", h_ = ut() ? "bottom-start" : "bottom-end", g_ = ut() ? "left-start" : "right-start", __ = ut() ? "right-start" : "left-start", m_ = "top", y_ = "bottom", E_ = {
  autoClose: !0,
  boundary: "clippingParents",
  display: "dynamic",
  offset: [0, 2],
  popperConfig: null,
  reference: "toggle"
}, v_ = {
  autoClose: "(boolean|string)",
  boundary: "(string|element)",
  display: "string",
  offset: "(array|string|function)",
  popperConfig: "(null|object|function)",
  reference: "(string|element|object)"
};
class _t extends Tt {
  constructor(t, r) {
    super(t, r), this._popper = null, this._parent = this._element.parentNode, this._menu = oe.next(this._element, _s)[0] || oe.prev(this._element, _s)[0] || oe.findOne(_s, this._parent), this._inNavbar = this._detectNavbar();
  }
  // Getters
  static get Default() {
    return E_;
  }
  static get DefaultType() {
    return v_;
  }
  static get NAME() {
    return Tl;
  }
  // Public
  toggle() {
    return this._isShown() ? this.hide() : this.show();
  }
  show() {
    if (ir(this._element) || this._isShown())
      return;
    const t = {
      relatedTarget: this._element
    };
    if (!F.trigger(this._element, Zg, t).defaultPrevented) {
      if (this._createPopper(), "ontouchstart" in document.documentElement && !this._parent.closest(c_))
        for (const n of [].concat(...document.body.children))
          F.on(n, "mouseover", $s);
      this._element.focus(), this._element.setAttribute("aria-expanded", !0), this._menu.classList.add(Br), this._element.classList.add(Br), F.trigger(this._element, e_, t);
    }
  }
  hide() {
    if (ir(this._element) || !this._isShown())
      return;
    const t = {
      relatedTarget: this._element
    };
    this._completeHide(t);
  }
  dispose() {
    this._popper && this._popper.destroy(), super.dispose();
  }
  update() {
    this._inNavbar = this._detectNavbar(), this._popper && this._popper.update();
  }
  // Private
  _completeHide(t) {
    if (!F.trigger(this._element, Xg, t).defaultPrevented) {
      if ("ontouchstart" in document.documentElement)
        for (const n of [].concat(...document.body.children))
          F.off(n, "mouseover", $s);
      this._popper && this._popper.destroy(), this._menu.classList.remove(Br), this._element.classList.remove(Br), this._element.setAttribute("aria-expanded", "false"), qt.removeDataAttribute(this._menu, "popper"), F.trigger(this._element, Qg, t);
    }
  }
  _getConfig(t) {
    if (t = super._getConfig(t), typeof t.reference == "object" && !Wt(t.reference) && typeof t.reference.getBoundingClientRect != "function")
      throw new TypeError(`${Tl.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
    return t;
  }
  _createPopper() {
    if (typeof Zu > "u")
      throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org/docs/v2/)");
    let t = this._element;
    this._config.reference === "parent" ? t = this._parent : Wt(this._config.reference) ? t = sr(this._config.reference) : typeof this._config.reference == "object" && (t = this._config.reference);
    const r = this._getPopperConfig();
    this._popper = Ta(t, this._menu, r);
  }
  _isShown() {
    return this._menu.classList.contains(Br);
  }
  _getPlacement() {
    const t = this._parent;
    if (t.classList.contains(n_))
      return g_;
    if (t.classList.contains(s_))
      return __;
    if (t.classList.contains(i_))
      return m_;
    if (t.classList.contains(o_))
      return y_;
    const r = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
    return t.classList.contains(r_) ? r ? f_ : d_ : r ? h_ : p_;
  }
  _detectNavbar() {
    return this._element.closest(l_) !== null;
  }
  _getOffset() {
    const {
      offset: t
    } = this._config;
    return typeof t == "string" ? t.split(",").map((r) => Number.parseInt(r, 10)) : typeof t == "function" ? (r) => t(r, this._element) : t;
  }
  _getPopperConfig() {
    const t = {
      placement: this._getPlacement(),
      modifiers: [{
        name: "preventOverflow",
        options: {
          boundary: this._config.boundary
        }
      }, {
        name: "offset",
        options: {
          offset: this._getOffset()
        }
      }]
    };
    return (this._inNavbar || this._config.display === "static") && (qt.setDataAttribute(this._menu, "popper", "static"), t.modifiers = [{
      name: "applyStyles",
      enabled: !1
    }]), {
      ...t,
      ...Xe(this._config.popperConfig, [void 0, t])
    };
  }
  _selectMenuItem({
    key: t,
    target: r
  }) {
    const n = oe.find(u_, this._menu).filter((s) => nn(s));
    n.length && Sa(n, r, t === Ol, !n.includes(r)).focus();
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = _t.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof r[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        r[t]();
      }
    });
  }
  static clearMenus(t) {
    if (t.button === Jg || t.type === "keyup" && t.key !== Sl)
      return;
    const r = oe.find(a_);
    for (const n of r) {
      const s = _t.getInstance(n);
      if (!s || s._config.autoClose === !1)
        continue;
      const i = t.composedPath(), o = i.includes(s._menu);
      if (i.includes(s._element) || s._config.autoClose === "inside" && !o || s._config.autoClose === "outside" && o || s._menu.contains(t.target) && (t.type === "keyup" && t.key === Sl || /input|select|option|textarea|form/i.test(t.target.tagName)))
        continue;
      const a = {
        relatedTarget: s._element
      };
      t.type === "click" && (a.clickEvent = t), s._completeHide(a);
    }
  }
  static dataApiKeydownHandler(t) {
    const r = /input|textarea/i.test(t.target.tagName), n = t.key === Kg, s = [zg, Ol].includes(t.key);
    if (!s && !n || r && !n)
      return;
    t.preventDefault();
    const i = this.matches(_r) ? this : oe.prev(this, _r)[0] || oe.next(this, _r)[0] || oe.findOne(_r, t.delegateTarget.parentNode), o = _t.getOrCreateInstance(i);
    if (s) {
      t.stopPropagation(), o.show(), o._selectMenuItem(t);
      return;
    }
    o._isShown() && (t.stopPropagation(), o.hide(), i.focus());
  }
}
F.on(document, md, _r, _t.dataApiKeydownHandler);
F.on(document, md, _s, _t.dataApiKeydownHandler);
F.on(document, _d, _t.clearMenus);
F.on(document, t_, _t.clearMenus);
F.on(document, _d, _r, function(e) {
  e.preventDefault(), _t.getOrCreateInstance(this).toggle();
});
ft(_t);
const yd = "backdrop", b_ = "fade", Al = "show", Nl = `mousedown.bs.${yd}`, w_ = {
  className: "modal-backdrop",
  clickCallback: null,
  isAnimated: !1,
  isVisible: !0,
  // if false, we use the backdrop helper without adding any element to the dom
  rootElement: "body"
  // give the choice to place backdrop under different elements
}, T_ = {
  className: "string",
  clickCallback: "(function|null)",
  isAnimated: "boolean",
  isVisible: "boolean",
  rootElement: "(element|string)"
};
class Ed extends Hn {
  constructor(t) {
    super(), this._config = this._getConfig(t), this._isAppended = !1, this._element = null;
  }
  // Getters
  static get Default() {
    return w_;
  }
  static get DefaultType() {
    return T_;
  }
  static get NAME() {
    return yd;
  }
  // Public
  show(t) {
    if (!this._config.isVisible) {
      Xe(t);
      return;
    }
    this._append();
    const r = this._getElement();
    this._config.isAnimated && Un(r), r.classList.add(Al), this._emulateAnimation(() => {
      Xe(t);
    });
  }
  hide(t) {
    if (!this._config.isVisible) {
      Xe(t);
      return;
    }
    this._getElement().classList.remove(Al), this._emulateAnimation(() => {
      this.dispose(), Xe(t);
    });
  }
  dispose() {
    this._isAppended && (F.off(this._element, Nl), this._element.remove(), this._isAppended = !1);
  }
  // Private
  _getElement() {
    if (!this._element) {
      const t = document.createElement("div");
      t.className = this._config.className, this._config.isAnimated && t.classList.add(b_), this._element = t;
    }
    return this._element;
  }
  _configAfterMerge(t) {
    return t.rootElement = sr(t.rootElement), t;
  }
  _append() {
    if (this._isAppended)
      return;
    const t = this._getElement();
    this._config.rootElement.append(t), F.on(t, Nl, () => {
      Xe(this._config.clickCallback);
    }), this._isAppended = !0;
  }
  _emulateAnimation(t) {
    sd(t, this._getElement(), this._config.isAnimated);
  }
}
const S_ = "focustrap", O_ = "bs.focustrap", Vs = `.${O_}`, A_ = `focusin${Vs}`, N_ = `keydown.tab${Vs}`, C_ = "Tab", D_ = "forward", Cl = "backward", I_ = {
  autofocus: !0,
  trapElement: null
  // The element to trap focus inside of
}, M_ = {
  autofocus: "boolean",
  trapElement: "element"
};
class vd extends Hn {
  constructor(t) {
    super(), this._config = this._getConfig(t), this._isActive = !1, this._lastTabNavDirection = null;
  }
  // Getters
  static get Default() {
    return I_;
  }
  static get DefaultType() {
    return M_;
  }
  static get NAME() {
    return S_;
  }
  // Public
  activate() {
    this._isActive || (this._config.autofocus && this._config.trapElement.focus(), F.off(document, Vs), F.on(document, A_, (t) => this._handleFocusin(t)), F.on(document, N_, (t) => this._handleKeydown(t)), this._isActive = !0);
  }
  deactivate() {
    this._isActive && (this._isActive = !1, F.off(document, Vs));
  }
  // Private
  _handleFocusin(t) {
    const {
      trapElement: r
    } = this._config;
    if (t.target === document || t.target === r || r.contains(t.target))
      return;
    const n = oe.focusableChildren(r);
    n.length === 0 ? r.focus() : this._lastTabNavDirection === Cl ? n[n.length - 1].focus() : n[0].focus();
  }
  _handleKeydown(t) {
    t.key === C_ && (this._lastTabNavDirection = t.shiftKey ? Cl : D_);
  }
}
const Dl = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", Il = ".sticky-top", ns = "padding-right", Ml = "margin-right";
class xo {
  constructor() {
    this._element = document.body;
  }
  // Public
  getWidth() {
    const t = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - t);
  }
  hide() {
    const t = this.getWidth();
    this._disableOverFlow(), this._setElementAttributes(this._element, ns, (r) => r + t), this._setElementAttributes(Dl, ns, (r) => r + t), this._setElementAttributes(Il, Ml, (r) => r - t);
  }
  reset() {
    this._resetElementAttributes(this._element, "overflow"), this._resetElementAttributes(this._element, ns), this._resetElementAttributes(Dl, ns), this._resetElementAttributes(Il, Ml);
  }
  isOverflowing() {
    return this.getWidth() > 0;
  }
  // Private
  _disableOverFlow() {
    this._saveInitialAttribute(this._element, "overflow"), this._element.style.overflow = "hidden";
  }
  _setElementAttributes(t, r, n) {
    const s = this.getWidth(), i = (o) => {
      if (o !== this._element && window.innerWidth > o.clientWidth + s)
        return;
      this._saveInitialAttribute(o, r);
      const a = window.getComputedStyle(o).getPropertyValue(r);
      o.style.setProperty(r, `${n(Number.parseFloat(a))}px`);
    };
    this._applyManipulationCallback(t, i);
  }
  _saveInitialAttribute(t, r) {
    const n = t.style.getPropertyValue(r);
    n && qt.setDataAttribute(t, r, n);
  }
  _resetElementAttributes(t, r) {
    const n = (s) => {
      const i = qt.getDataAttribute(s, r);
      if (i === null) {
        s.style.removeProperty(r);
        return;
      }
      qt.removeDataAttribute(s, r), s.style.setProperty(r, i);
    };
    this._applyManipulationCallback(t, n);
  }
  _applyManipulationCallback(t, r) {
    if (Wt(t)) {
      r(t);
      return;
    }
    for (const n of oe.find(t, this._element))
      r(n);
  }
}
const L_ = "modal", R_ = "bs.modal", dt = `.${R_}`, k_ = ".data-api", x_ = "Escape", P_ = `hide${dt}`, $_ = `hidePrevented${dt}`, bd = `hidden${dt}`, wd = `show${dt}`, F_ = `shown${dt}`, V_ = `resize${dt}`, B_ = `click.dismiss${dt}`, U_ = `mousedown.dismiss${dt}`, H_ = `keydown.dismiss${dt}`, j_ = `click${dt}${k_}`, Ll = "modal-open", Y_ = "fade", Rl = "show", xi = "modal-static", G_ = ".modal.show", W_ = ".modal-dialog", q_ = ".modal-body", K_ = '[data-bs-toggle="modal"]', z_ = {
  backdrop: !0,
  focus: !0,
  keyboard: !0
}, J_ = {
  backdrop: "(boolean|string)",
  focus: "boolean",
  keyboard: "boolean"
};
class $t extends Tt {
  constructor(t, r) {
    super(t, r), this._dialog = oe.findOne(W_, this._element), this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._isShown = !1, this._isTransitioning = !1, this._scrollBar = new xo(), this._addEventListeners();
  }
  // Getters
  static get Default() {
    return z_;
  }
  static get DefaultType() {
    return J_;
  }
  static get NAME() {
    return L_;
  }
  // Public
  toggle(t) {
    return this._isShown ? this.hide() : this.show(t);
  }
  show(t) {
    this._isShown || this._isTransitioning || F.trigger(this._element, wd, {
      relatedTarget: t
    }).defaultPrevented || (this._isShown = !0, this._isTransitioning = !0, this._scrollBar.hide(), document.body.classList.add(Ll), this._adjustDialog(), this._backdrop.show(() => this._showElement(t)));
  }
  hide() {
    !this._isShown || this._isTransitioning || F.trigger(this._element, P_).defaultPrevented || (this._isShown = !1, this._isTransitioning = !0, this._focustrap.deactivate(), this._element.classList.remove(Rl), this._queueCallback(() => this._hideModal(), this._element, this._isAnimated()));
  }
  dispose() {
    F.off(window, dt), F.off(this._dialog, dt), this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
  }
  handleUpdate() {
    this._adjustDialog();
  }
  // Private
  _initializeBackDrop() {
    return new Ed({
      isVisible: !!this._config.backdrop,
      // 'static' option will be translated to true, and booleans will keep their value,
      isAnimated: this._isAnimated()
    });
  }
  _initializeFocusTrap() {
    return new vd({
      trapElement: this._element
    });
  }
  _showElement(t) {
    document.body.contains(this._element) || document.body.append(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0;
    const r = oe.findOne(q_, this._dialog);
    r && (r.scrollTop = 0), Un(this._element), this._element.classList.add(Rl);
    const n = () => {
      this._config.focus && this._focustrap.activate(), this._isTransitioning = !1, F.trigger(this._element, F_, {
        relatedTarget: t
      });
    };
    this._queueCallback(n, this._dialog, this._isAnimated());
  }
  _addEventListeners() {
    F.on(this._element, H_, (t) => {
      if (t.key === x_) {
        if (this._config.keyboard) {
          this.hide();
          return;
        }
        this._triggerBackdropTransition();
      }
    }), F.on(window, V_, () => {
      this._isShown && !this._isTransitioning && this._adjustDialog();
    }), F.on(this._element, U_, (t) => {
      F.one(this._element, B_, (r) => {
        if (!(this._element !== t.target || this._element !== r.target)) {
          if (this._config.backdrop === "static") {
            this._triggerBackdropTransition();
            return;
          }
          this._config.backdrop && this.hide();
        }
      });
    });
  }
  _hideModal() {
    this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._backdrop.hide(() => {
      document.body.classList.remove(Ll), this._resetAdjustments(), this._scrollBar.reset(), F.trigger(this._element, bd);
    });
  }
  _isAnimated() {
    return this._element.classList.contains(Y_);
  }
  _triggerBackdropTransition() {
    if (F.trigger(this._element, $_).defaultPrevented)
      return;
    const r = this._element.scrollHeight > document.documentElement.clientHeight, n = this._element.style.overflowY;
    n === "hidden" || this._element.classList.contains(xi) || (r || (this._element.style.overflowY = "hidden"), this._element.classList.add(xi), this._queueCallback(() => {
      this._element.classList.remove(xi), this._queueCallback(() => {
        this._element.style.overflowY = n;
      }, this._dialog);
    }, this._dialog), this._element.focus());
  }
  /**
   * The following methods are used to handle overflowing modals
   */
  _adjustDialog() {
    const t = this._element.scrollHeight > document.documentElement.clientHeight, r = this._scrollBar.getWidth(), n = r > 0;
    if (n && !t) {
      const s = ut() ? "paddingLeft" : "paddingRight";
      this._element.style[s] = `${r}px`;
    }
    if (!n && t) {
      const s = ut() ? "paddingRight" : "paddingLeft";
      this._element.style[s] = `${r}px`;
    }
  }
  _resetAdjustments() {
    this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
  }
  // Static
  static jQueryInterface(t, r) {
    return this.each(function() {
      const n = $t.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof n[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        n[t](r);
      }
    });
  }
}
F.on(document, j_, K_, function(e) {
  const t = oe.getElementFromSelector(this);
  ["A", "AREA"].includes(this.tagName) && e.preventDefault(), F.one(t, wd, (s) => {
    s.defaultPrevented || F.one(t, bd, () => {
      nn(this) && this.focus();
    });
  });
  const r = oe.findOne(G_);
  r && $t.getInstance(r).hide(), $t.getOrCreateInstance(t).toggle(this);
});
ni($t);
ft($t);
const X_ = "offcanvas", Q_ = "bs.offcanvas", zt = `.${Q_}`, Td = ".data-api", Z_ = `load${zt}${Td}`, em = "Escape", kl = "show", xl = "showing", Pl = "hiding", tm = "offcanvas-backdrop", Sd = ".offcanvas.show", rm = `show${zt}`, nm = `shown${zt}`, sm = `hide${zt}`, $l = `hidePrevented${zt}`, Od = `hidden${zt}`, im = `resize${zt}`, om = `click${zt}${Td}`, am = `keydown.dismiss${zt}`, lm = '[data-bs-toggle="offcanvas"]', cm = {
  backdrop: !0,
  keyboard: !0,
  scroll: !1
}, um = {
  backdrop: "(boolean|string)",
  keyboard: "boolean",
  scroll: "boolean"
};
class Bt extends Tt {
  constructor(t, r) {
    super(t, r), this._isShown = !1, this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._addEventListeners();
  }
  // Getters
  static get Default() {
    return cm;
  }
  static get DefaultType() {
    return um;
  }
  static get NAME() {
    return X_;
  }
  // Public
  toggle(t) {
    return this._isShown ? this.hide() : this.show(t);
  }
  show(t) {
    if (this._isShown || F.trigger(this._element, rm, {
      relatedTarget: t
    }).defaultPrevented)
      return;
    this._isShown = !0, this._backdrop.show(), this._config.scroll || new xo().hide(), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.classList.add(xl);
    const n = () => {
      (!this._config.scroll || this._config.backdrop) && this._focustrap.activate(), this._element.classList.add(kl), this._element.classList.remove(xl), F.trigger(this._element, nm, {
        relatedTarget: t
      });
    };
    this._queueCallback(n, this._element, !0);
  }
  hide() {
    if (!this._isShown || F.trigger(this._element, sm).defaultPrevented)
      return;
    this._focustrap.deactivate(), this._element.blur(), this._isShown = !1, this._element.classList.add(Pl), this._backdrop.hide();
    const r = () => {
      this._element.classList.remove(kl, Pl), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._config.scroll || new xo().reset(), F.trigger(this._element, Od);
    };
    this._queueCallback(r, this._element, !0);
  }
  dispose() {
    this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
  }
  // Private
  _initializeBackDrop() {
    const t = () => {
      if (this._config.backdrop === "static") {
        F.trigger(this._element, $l);
        return;
      }
      this.hide();
    }, r = !!this._config.backdrop;
    return new Ed({
      className: tm,
      isVisible: r,
      isAnimated: !0,
      rootElement: this._element.parentNode,
      clickCallback: r ? t : null
    });
  }
  _initializeFocusTrap() {
    return new vd({
      trapElement: this._element
    });
  }
  _addEventListeners() {
    F.on(this._element, am, (t) => {
      if (t.key === em) {
        if (this._config.keyboard) {
          this.hide();
          return;
        }
        F.trigger(this._element, $l);
      }
    });
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = Bt.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (r[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        r[t](this);
      }
    });
  }
}
F.on(document, om, lm, function(e) {
  const t = oe.getElementFromSelector(this);
  if (["A", "AREA"].includes(this.tagName) && e.preventDefault(), ir(this))
    return;
  F.one(t, Od, () => {
    nn(this) && this.focus();
  });
  const r = oe.findOne(Sd);
  r && r !== t && Bt.getInstance(r).hide(), Bt.getOrCreateInstance(t).toggle(this);
});
F.on(window, Z_, () => {
  for (const e of oe.find(Sd))
    Bt.getOrCreateInstance(e).show();
});
F.on(window, im, () => {
  for (const e of oe.find("[aria-modal][class*=show][class*=offcanvas-]"))
    getComputedStyle(e).position !== "fixed" && Bt.getOrCreateInstance(e).hide();
});
ni(Bt);
ft(Bt);
const dm = /^aria-[\w-]*$/i, Ad = {
  // Global attributes allowed on any supplied element below.
  "*": ["class", "dir", "id", "lang", "role", dm],
  a: ["target", "href", "title", "rel"],
  area: [],
  b: [],
  br: [],
  col: [],
  code: [],
  dd: [],
  div: [],
  dl: [],
  dt: [],
  em: [],
  hr: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: [],
  i: [],
  img: ["src", "srcset", "alt", "title", "width", "height"],
  li: [],
  ol: [],
  p: [],
  pre: [],
  s: [],
  small: [],
  span: [],
  sub: [],
  sup: [],
  strong: [],
  u: [],
  ul: []
}, fm = /* @__PURE__ */ new Set(["background", "cite", "href", "itemtype", "longdesc", "poster", "src", "xlink:href"]), pm = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i, hm = (e, t) => {
  const r = e.nodeName.toLowerCase();
  return t.includes(r) ? fm.has(r) ? !!pm.test(e.nodeValue) : !0 : t.filter((n) => n instanceof RegExp).some((n) => n.test(r));
};
function gm(e, t, r) {
  if (!e.length)
    return e;
  if (r && typeof r == "function")
    return r(e);
  const s = new window.DOMParser().parseFromString(e, "text/html"), i = [].concat(...s.body.querySelectorAll("*"));
  for (const o of i) {
    const a = o.nodeName.toLowerCase();
    if (!Object.keys(t).includes(a)) {
      o.remove();
      continue;
    }
    const l = [].concat(...o.attributes), u = [].concat(t["*"] || [], t[a] || []);
    for (const c of l)
      hm(c, u) || o.removeAttribute(c.nodeName);
  }
  return s.body.innerHTML;
}
const _m = "TemplateFactory", mm = {
  allowList: Ad,
  content: {},
  // { selector : text ,  selector2 : text2 , }
  extraClass: "",
  html: !1,
  sanitize: !0,
  sanitizeFn: null,
  template: "<div></div>"
}, ym = {
  allowList: "object",
  content: "object",
  extraClass: "(string|function)",
  html: "boolean",
  sanitize: "boolean",
  sanitizeFn: "(null|function)",
  template: "string"
}, Em = {
  entry: "(string|element|function|null)",
  selector: "(string|element)"
};
class vm extends Hn {
  constructor(t) {
    super(), this._config = this._getConfig(t);
  }
  // Getters
  static get Default() {
    return mm;
  }
  static get DefaultType() {
    return ym;
  }
  static get NAME() {
    return _m;
  }
  // Public
  getContent() {
    return Object.values(this._config.content).map((t) => this._resolvePossibleFunction(t)).filter(Boolean);
  }
  hasContent() {
    return this.getContent().length > 0;
  }
  changeContent(t) {
    return this._checkContent(t), this._config.content = {
      ...this._config.content,
      ...t
    }, this;
  }
  toHtml() {
    const t = document.createElement("div");
    t.innerHTML = this._maybeSanitize(this._config.template);
    for (const [s, i] of Object.entries(this._config.content))
      this._setContent(t, i, s);
    const r = t.children[0], n = this._resolvePossibleFunction(this._config.extraClass);
    return n && r.classList.add(...n.split(" ")), r;
  }
  // Private
  _typeCheckConfig(t) {
    super._typeCheckConfig(t), this._checkContent(t.content);
  }
  _checkContent(t) {
    for (const [r, n] of Object.entries(t))
      super._typeCheckConfig({
        selector: r,
        entry: n
      }, Em);
  }
  _setContent(t, r, n) {
    const s = oe.findOne(n, t);
    if (s) {
      if (r = this._resolvePossibleFunction(r), !r) {
        s.remove();
        return;
      }
      if (Wt(r)) {
        this._putElementInTemplate(sr(r), s);
        return;
      }
      if (this._config.html) {
        s.innerHTML = this._maybeSanitize(r);
        return;
      }
      s.textContent = r;
    }
  }
  _maybeSanitize(t) {
    return this._config.sanitize ? gm(t, this._config.allowList, this._config.sanitizeFn) : t;
  }
  _resolvePossibleFunction(t) {
    return Xe(t, [void 0, this]);
  }
  _putElementInTemplate(t, r) {
    if (this._config.html) {
      r.innerHTML = "", r.append(t);
      return;
    }
    r.textContent = t.textContent;
  }
}
const bm = "tooltip", wm = /* @__PURE__ */ new Set(["sanitize", "allowList", "sanitizeFn"]), Pi = "fade", Tm = "modal", ss = "show", Sm = ".tooltip-inner", Fl = `.${Tm}`, Vl = "hide.bs.modal", mn = "hover", $i = "focus", Fi = "click", Om = "manual", Am = "hide", Nm = "hidden", Cm = "show", Dm = "shown", Im = "inserted", Mm = "click", Lm = "focusin", Rm = "focusout", km = "mouseenter", xm = "mouseleave", Pm = {
  AUTO: "auto",
  TOP: "top",
  RIGHT: ut() ? "left" : "right",
  BOTTOM: "bottom",
  LEFT: ut() ? "right" : "left"
}, $m = {
  allowList: Ad,
  animation: !0,
  boundary: "clippingParents",
  container: !1,
  customClass: "",
  delay: 0,
  fallbackPlacements: ["top", "right", "bottom", "left"],
  html: !1,
  offset: [0, 6],
  placement: "top",
  popperConfig: null,
  sanitize: !0,
  sanitizeFn: null,
  selector: !1,
  template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  title: "",
  trigger: "hover focus"
}, Fm = {
  allowList: "object",
  animation: "boolean",
  boundary: "(string|element)",
  container: "(string|element|boolean)",
  customClass: "(string|function)",
  delay: "(number|object)",
  fallbackPlacements: "array",
  html: "boolean",
  offset: "(array|string|function)",
  placement: "(string|function)",
  popperConfig: "(null|object|function)",
  sanitize: "boolean",
  sanitizeFn: "(null|function)",
  selector: "(string|boolean)",
  template: "string",
  title: "(string|element|function)",
  trigger: "string"
};
class on extends Tt {
  constructor(t, r) {
    if (typeof Zu > "u")
      throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org/docs/v2/)");
    super(t, r), this._isEnabled = !0, this._timeout = 0, this._isHovered = null, this._activeTrigger = {}, this._popper = null, this._templateFactory = null, this._newContent = null, this.tip = null, this._setListeners(), this._config.selector || this._fixTitle();
  }
  // Getters
  static get Default() {
    return $m;
  }
  static get DefaultType() {
    return Fm;
  }
  static get NAME() {
    return bm;
  }
  // Public
  enable() {
    this._isEnabled = !0;
  }
  disable() {
    this._isEnabled = !1;
  }
  toggleEnabled() {
    this._isEnabled = !this._isEnabled;
  }
  toggle() {
    if (this._isEnabled) {
      if (this._isShown()) {
        this._leave();
        return;
      }
      this._enter();
    }
  }
  dispose() {
    clearTimeout(this._timeout), F.off(this._element.closest(Fl), Vl, this._hideModalHandler), this._element.getAttribute("data-bs-original-title") && this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title")), this._disposePopper(), super.dispose();
  }
  show() {
    if (this._element.style.display === "none")
      throw new Error("Please use show on visible elements");
    if (!(this._isWithContent() && this._isEnabled))
      return;
    const t = F.trigger(this._element, this.constructor.eventName(Cm)), n = (rd(this._element) || this._element.ownerDocument.documentElement).contains(this._element);
    if (t.defaultPrevented || !n)
      return;
    this._disposePopper();
    const s = this._getTipElement();
    this._element.setAttribute("aria-describedby", s.getAttribute("id"));
    const {
      container: i
    } = this._config;
    if (this._element.ownerDocument.documentElement.contains(this.tip) || (i.append(s), F.trigger(this._element, this.constructor.eventName(Im))), this._popper = this._createPopper(s), s.classList.add(ss), "ontouchstart" in document.documentElement)
      for (const a of [].concat(...document.body.children))
        F.on(a, "mouseover", $s);
    const o = () => {
      F.trigger(this._element, this.constructor.eventName(Dm)), this._isHovered === !1 && this._leave(), this._isHovered = !1;
    };
    this._queueCallback(o, this.tip, this._isAnimated());
  }
  hide() {
    if (!this._isShown() || F.trigger(this._element, this.constructor.eventName(Am)).defaultPrevented)
      return;
    if (this._getTipElement().classList.remove(ss), "ontouchstart" in document.documentElement)
      for (const s of [].concat(...document.body.children))
        F.off(s, "mouseover", $s);
    this._activeTrigger[Fi] = !1, this._activeTrigger[$i] = !1, this._activeTrigger[mn] = !1, this._isHovered = null;
    const n = () => {
      this._isWithActiveTrigger() || (this._isHovered || this._disposePopper(), this._element.removeAttribute("aria-describedby"), F.trigger(this._element, this.constructor.eventName(Nm)));
    };
    this._queueCallback(n, this.tip, this._isAnimated());
  }
  update() {
    this._popper && this._popper.update();
  }
  // Protected
  _isWithContent() {
    return !!this._getTitle();
  }
  _getTipElement() {
    return this.tip || (this.tip = this._createTipElement(this._newContent || this._getContentForTemplate())), this.tip;
  }
  _createTipElement(t) {
    const r = this._getTemplateFactory(t).toHtml();
    if (!r)
      return null;
    r.classList.remove(Pi, ss), r.classList.add(`bs-${this.constructor.NAME}-auto`);
    const n = Oh(this.constructor.NAME).toString();
    return r.setAttribute("id", n), this._isAnimated() && r.classList.add(Pi), r;
  }
  setContent(t) {
    this._newContent = t, this._isShown() && (this._disposePopper(), this.show());
  }
  _getTemplateFactory(t) {
    return this._templateFactory ? this._templateFactory.changeContent(t) : this._templateFactory = new vm({
      ...this._config,
      // the `content` var has to be after `this._config`
      // to override config.content in case of popover
      content: t,
      extraClass: this._resolvePossibleFunction(this._config.customClass)
    }), this._templateFactory;
  }
  _getContentForTemplate() {
    return {
      [Sm]: this._getTitle()
    };
  }
  _getTitle() {
    return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
  }
  // Private
  _initializeOnDelegatedTarget(t) {
    return this.constructor.getOrCreateInstance(t.delegateTarget, this._getDelegateConfig());
  }
  _isAnimated() {
    return this._config.animation || this.tip && this.tip.classList.contains(Pi);
  }
  _isShown() {
    return this.tip && this.tip.classList.contains(ss);
  }
  _createPopper(t) {
    const r = Xe(this._config.placement, [this, t, this._element]), n = Pm[r.toUpperCase()];
    return Ta(this._element, t, this._getPopperConfig(n));
  }
  _getOffset() {
    const {
      offset: t
    } = this._config;
    return typeof t == "string" ? t.split(",").map((r) => Number.parseInt(r, 10)) : typeof t == "function" ? (r) => t(r, this._element) : t;
  }
  _resolvePossibleFunction(t) {
    return Xe(t, [this._element, this._element]);
  }
  _getPopperConfig(t) {
    const r = {
      placement: t,
      modifiers: [{
        name: "flip",
        options: {
          fallbackPlacements: this._config.fallbackPlacements
        }
      }, {
        name: "offset",
        options: {
          offset: this._getOffset()
        }
      }, {
        name: "preventOverflow",
        options: {
          boundary: this._config.boundary
        }
      }, {
        name: "arrow",
        options: {
          element: `.${this.constructor.NAME}-arrow`
        }
      }, {
        name: "preSetPlacement",
        enabled: !0,
        phase: "beforeMain",
        fn: (n) => {
          this._getTipElement().setAttribute("data-popper-placement", n.state.placement);
        }
      }]
    };
    return {
      ...r,
      ...Xe(this._config.popperConfig, [void 0, r])
    };
  }
  _setListeners() {
    const t = this._config.trigger.split(" ");
    for (const r of t)
      if (r === "click")
        F.on(this._element, this.constructor.eventName(Mm), this._config.selector, (n) => {
          const s = this._initializeOnDelegatedTarget(n);
          s._activeTrigger[Fi] = !(s._isShown() && s._activeTrigger[Fi]), s.toggle();
        });
      else if (r !== Om) {
        const n = r === mn ? this.constructor.eventName(km) : this.constructor.eventName(Lm), s = r === mn ? this.constructor.eventName(xm) : this.constructor.eventName(Rm);
        F.on(this._element, n, this._config.selector, (i) => {
          const o = this._initializeOnDelegatedTarget(i);
          o._activeTrigger[i.type === "focusin" ? $i : mn] = !0, o._enter();
        }), F.on(this._element, s, this._config.selector, (i) => {
          const o = this._initializeOnDelegatedTarget(i);
          o._activeTrigger[i.type === "focusout" ? $i : mn] = o._element.contains(i.relatedTarget), o._leave();
        });
      }
    this._hideModalHandler = () => {
      this._element && this.hide();
    }, F.on(this._element.closest(Fl), Vl, this._hideModalHandler);
  }
  _fixTitle() {
    const t = this._element.getAttribute("title");
    t && (!this._element.getAttribute("aria-label") && !this._element.textContent.trim() && this._element.setAttribute("aria-label", t), this._element.setAttribute("data-bs-original-title", t), this._element.removeAttribute("title"));
  }
  _enter() {
    if (this._isShown() || this._isHovered) {
      this._isHovered = !0;
      return;
    }
    this._isHovered = !0, this._setTimeout(() => {
      this._isHovered && this.show();
    }, this._config.delay.show);
  }
  _leave() {
    this._isWithActiveTrigger() || (this._isHovered = !1, this._setTimeout(() => {
      this._isHovered || this.hide();
    }, this._config.delay.hide));
  }
  _setTimeout(t, r) {
    clearTimeout(this._timeout), this._timeout = setTimeout(t, r);
  }
  _isWithActiveTrigger() {
    return Object.values(this._activeTrigger).includes(!0);
  }
  _getConfig(t) {
    const r = qt.getDataAttributes(this._element);
    for (const n of Object.keys(r))
      wm.has(n) && delete r[n];
    return t = {
      ...r,
      ...typeof t == "object" && t ? t : {}
    }, t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
  }
  _configAfterMerge(t) {
    return t.container = t.container === !1 ? document.body : sr(t.container), typeof t.delay == "number" && (t.delay = {
      show: t.delay,
      hide: t.delay
    }), typeof t.title == "number" && (t.title = t.title.toString()), typeof t.content == "number" && (t.content = t.content.toString()), t;
  }
  _getDelegateConfig() {
    const t = {};
    for (const [r, n] of Object.entries(this._config))
      this.constructor.Default[r] !== n && (t[r] = n);
    return t.selector = !1, t.trigger = "manual", t;
  }
  _disposePopper() {
    this._popper && (this._popper.destroy(), this._popper = null), this.tip && (this.tip.remove(), this.tip = null);
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = on.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof r[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        r[t]();
      }
    });
  }
}
ft(on);
const Vm = "popover", Bm = ".popover-header", Um = ".popover-body", Hm = {
  ...on.Default,
  content: "",
  offset: [0, 8],
  placement: "right",
  template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
  trigger: "click"
}, jm = {
  ...on.DefaultType,
  content: "(null|string|element|function)"
};
class Na extends on {
  // Getters
  static get Default() {
    return Hm;
  }
  static get DefaultType() {
    return jm;
  }
  static get NAME() {
    return Vm;
  }
  // Overrides
  _isWithContent() {
    return this._getTitle() || this._getContent();
  }
  // Private
  _getContentForTemplate() {
    return {
      [Bm]: this._getTitle(),
      [Um]: this._getContent()
    };
  }
  _getContent() {
    return this._resolvePossibleFunction(this._config.content);
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = Na.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof r[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        r[t]();
      }
    });
  }
}
ft(Na);
const Ym = "scrollspy", Gm = "bs.scrollspy", Ca = `.${Gm}`, Wm = ".data-api", qm = `activate${Ca}`, Bl = `click${Ca}`, Km = `load${Ca}${Wm}`, zm = "dropdown-item", kr = "active", Jm = '[data-bs-spy="scroll"]', Vi = "[href]", Xm = ".nav, .list-group", Ul = ".nav-link", Qm = ".nav-item", Zm = ".list-group-item", ey = `${Ul}, ${Qm} > ${Ul}, ${Zm}`, ty = ".dropdown", ry = ".dropdown-toggle", ny = {
  offset: null,
  // TODO: v6 @deprecated, keep it for backwards compatibility reasons
  rootMargin: "0px 0px -25%",
  smoothScroll: !1,
  target: null,
  threshold: [0.1, 0.5, 1]
}, sy = {
  offset: "(number|null)",
  // TODO v6 @deprecated, keep it for backwards compatibility reasons
  rootMargin: "string",
  smoothScroll: "boolean",
  target: "element",
  threshold: "array"
};
class oi extends Tt {
  constructor(t, r) {
    super(t, r), this._targetLinks = /* @__PURE__ */ new Map(), this._observableSections = /* @__PURE__ */ new Map(), this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element, this._activeTarget = null, this._observer = null, this._previousScrollData = {
      visibleEntryTop: 0,
      parentScrollTop: 0
    }, this.refresh();
  }
  // Getters
  static get Default() {
    return ny;
  }
  static get DefaultType() {
    return sy;
  }
  static get NAME() {
    return Ym;
  }
  // Public
  refresh() {
    this._initializeTargetsAndObservables(), this._maybeEnableSmoothScroll(), this._observer ? this._observer.disconnect() : this._observer = this._getNewObserver();
    for (const t of this._observableSections.values())
      this._observer.observe(t);
  }
  dispose() {
    this._observer.disconnect(), super.dispose();
  }
  // Private
  _configAfterMerge(t) {
    return t.target = sr(t.target) || document.body, t.rootMargin = t.offset ? `${t.offset}px 0px -30%` : t.rootMargin, typeof t.threshold == "string" && (t.threshold = t.threshold.split(",").map((r) => Number.parseFloat(r))), t;
  }
  _maybeEnableSmoothScroll() {
    this._config.smoothScroll && (F.off(this._config.target, Bl), F.on(this._config.target, Bl, Vi, (t) => {
      const r = this._observableSections.get(t.target.hash);
      if (r) {
        t.preventDefault();
        const n = this._rootElement || window, s = r.offsetTop - this._element.offsetTop;
        if (n.scrollTo) {
          n.scrollTo({
            top: s,
            behavior: "smooth"
          });
          return;
        }
        n.scrollTop = s;
      }
    }));
  }
  _getNewObserver() {
    const t = {
      root: this._rootElement,
      threshold: this._config.threshold,
      rootMargin: this._config.rootMargin
    };
    return new IntersectionObserver((r) => this._observerCallback(r), t);
  }
  // The logic of selection
  _observerCallback(t) {
    const r = (o) => this._targetLinks.get(`#${o.target.id}`), n = (o) => {
      this._previousScrollData.visibleEntryTop = o.target.offsetTop, this._process(r(o));
    }, s = (this._rootElement || document.documentElement).scrollTop, i = s >= this._previousScrollData.parentScrollTop;
    this._previousScrollData.parentScrollTop = s;
    for (const o of t) {
      if (!o.isIntersecting) {
        this._activeTarget = null, this._clearActiveClass(r(o));
        continue;
      }
      const a = o.target.offsetTop >= this._previousScrollData.visibleEntryTop;
      if (i && a) {
        if (n(o), !s)
          return;
        continue;
      }
      !i && !a && n(o);
    }
  }
  _initializeTargetsAndObservables() {
    this._targetLinks = /* @__PURE__ */ new Map(), this._observableSections = /* @__PURE__ */ new Map();
    const t = oe.find(Vi, this._config.target);
    for (const r of t) {
      if (!r.hash || ir(r))
        continue;
      const n = oe.findOne(decodeURI(r.hash), this._element);
      nn(n) && (this._targetLinks.set(decodeURI(r.hash), r), this._observableSections.set(r.hash, n));
    }
  }
  _process(t) {
    this._activeTarget !== t && (this._clearActiveClass(this._config.target), this._activeTarget = t, t.classList.add(kr), this._activateParents(t), F.trigger(this._element, qm, {
      relatedTarget: t
    }));
  }
  _activateParents(t) {
    if (t.classList.contains(zm)) {
      oe.findOne(ry, t.closest(ty)).classList.add(kr);
      return;
    }
    for (const r of oe.parents(t, Xm))
      for (const n of oe.prev(r, ey))
        n.classList.add(kr);
  }
  _clearActiveClass(t) {
    t.classList.remove(kr);
    const r = oe.find(`${Vi}.${kr}`, t);
    for (const n of r)
      n.classList.remove(kr);
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = oi.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (r[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        r[t]();
      }
    });
  }
}
F.on(window, Km, () => {
  for (const e of oe.find(Jm))
    oi.getOrCreateInstance(e);
});
ft(oi);
const iy = "tab", oy = "bs.tab", Ir = `.${oy}`, ay = `hide${Ir}`, ly = `hidden${Ir}`, cy = `show${Ir}`, uy = `shown${Ir}`, dy = `click${Ir}`, fy = `keydown${Ir}`, py = `load${Ir}`, hy = "ArrowLeft", Hl = "ArrowRight", gy = "ArrowUp", jl = "ArrowDown", Bi = "Home", Yl = "End", mr = "active", Gl = "fade", Ui = "show", _y = "dropdown", Nd = ".dropdown-toggle", my = ".dropdown-menu", Hi = `:not(${Nd})`, yy = '.list-group, .nav, [role="tablist"]', Ey = ".nav-item, .list-group-item", vy = `.nav-link${Hi}, .list-group-item${Hi}, [role="tab"]${Hi}`, Cd = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', ji = `${vy}, ${Cd}`, by = `.${mr}[data-bs-toggle="tab"], .${mr}[data-bs-toggle="pill"], .${mr}[data-bs-toggle="list"]`;
class Zr extends Tt {
  constructor(t) {
    super(t), this._parent = this._element.closest(yy), this._parent && (this._setInitialAttributes(this._parent, this._getChildren()), F.on(this._element, fy, (r) => this._keydown(r)));
  }
  // Getters
  static get NAME() {
    return iy;
  }
  // Public
  show() {
    const t = this._element;
    if (this._elemIsActive(t))
      return;
    const r = this._getActiveElem(), n = r ? F.trigger(r, ay, {
      relatedTarget: t
    }) : null;
    F.trigger(t, cy, {
      relatedTarget: r
    }).defaultPrevented || n && n.defaultPrevented || (this._deactivate(r, t), this._activate(t, r));
  }
  // Private
  _activate(t, r) {
    if (!t)
      return;
    t.classList.add(mr), this._activate(oe.getElementFromSelector(t));
    const n = () => {
      if (t.getAttribute("role") !== "tab") {
        t.classList.add(Ui);
        return;
      }
      t.removeAttribute("tabindex"), t.setAttribute("aria-selected", !0), this._toggleDropDown(t, !0), F.trigger(t, uy, {
        relatedTarget: r
      });
    };
    this._queueCallback(n, t, t.classList.contains(Gl));
  }
  _deactivate(t, r) {
    if (!t)
      return;
    t.classList.remove(mr), t.blur(), this._deactivate(oe.getElementFromSelector(t));
    const n = () => {
      if (t.getAttribute("role") !== "tab") {
        t.classList.remove(Ui);
        return;
      }
      t.setAttribute("aria-selected", !1), t.setAttribute("tabindex", "-1"), this._toggleDropDown(t, !1), F.trigger(t, ly, {
        relatedTarget: r
      });
    };
    this._queueCallback(n, t, t.classList.contains(Gl));
  }
  _keydown(t) {
    if (![hy, Hl, gy, jl, Bi, Yl].includes(t.key))
      return;
    t.stopPropagation(), t.preventDefault();
    const r = this._getChildren().filter((s) => !ir(s));
    let n;
    if ([Bi, Yl].includes(t.key))
      n = r[t.key === Bi ? 0 : r.length - 1];
    else {
      const s = [Hl, jl].includes(t.key);
      n = Sa(r, t.target, s, !0);
    }
    n && (n.focus({
      preventScroll: !0
    }), Zr.getOrCreateInstance(n).show());
  }
  _getChildren() {
    return oe.find(ji, this._parent);
  }
  _getActiveElem() {
    return this._getChildren().find((t) => this._elemIsActive(t)) || null;
  }
  _setInitialAttributes(t, r) {
    this._setAttributeIfNotExists(t, "role", "tablist");
    for (const n of r)
      this._setInitialAttributesOnChild(n);
  }
  _setInitialAttributesOnChild(t) {
    t = this._getInnerElement(t);
    const r = this._elemIsActive(t), n = this._getOuterElement(t);
    t.setAttribute("aria-selected", r), n !== t && this._setAttributeIfNotExists(n, "role", "presentation"), r || t.setAttribute("tabindex", "-1"), this._setAttributeIfNotExists(t, "role", "tab"), this._setInitialAttributesOnTargetPanel(t);
  }
  _setInitialAttributesOnTargetPanel(t) {
    const r = oe.getElementFromSelector(t);
    r && (this._setAttributeIfNotExists(r, "role", "tabpanel"), t.id && this._setAttributeIfNotExists(r, "aria-labelledby", `${t.id}`));
  }
  _toggleDropDown(t, r) {
    const n = this._getOuterElement(t);
    if (!n.classList.contains(_y))
      return;
    const s = (i, o) => {
      const a = oe.findOne(i, n);
      a && a.classList.toggle(o, r);
    };
    s(Nd, mr), s(my, Ui), n.setAttribute("aria-expanded", r);
  }
  _setAttributeIfNotExists(t, r, n) {
    t.hasAttribute(r) || t.setAttribute(r, n);
  }
  _elemIsActive(t) {
    return t.classList.contains(mr);
  }
  // Try to get the inner element (usually the .nav-link)
  _getInnerElement(t) {
    return t.matches(ji) ? t : oe.findOne(ji, t);
  }
  // Try to get the outer element (usually the .nav-item)
  _getOuterElement(t) {
    return t.closest(Ey) || t;
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = Zr.getOrCreateInstance(this);
      if (typeof t == "string") {
        if (r[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        r[t]();
      }
    });
  }
}
F.on(document, dy, Cd, function(e) {
  ["A", "AREA"].includes(this.tagName) && e.preventDefault(), !ir(this) && Zr.getOrCreateInstance(this).show();
});
F.on(window, py, () => {
  for (const e of oe.find(by))
    Zr.getOrCreateInstance(e);
});
ft(Zr);
const wy = "toast", Ty = "bs.toast", dr = `.${Ty}`, Sy = `mouseover${dr}`, Oy = `mouseout${dr}`, Ay = `focusin${dr}`, Ny = `focusout${dr}`, Cy = `hide${dr}`, Dy = `hidden${dr}`, Iy = `show${dr}`, My = `shown${dr}`, Ly = "fade", Wl = "hide", is = "show", os = "showing", Ry = {
  animation: "boolean",
  autohide: "boolean",
  delay: "number"
}, ky = {
  animation: !0,
  autohide: !0,
  delay: 5e3
};
class ai extends Tt {
  constructor(t, r) {
    super(t, r), this._timeout = null, this._hasMouseInteraction = !1, this._hasKeyboardInteraction = !1, this._setListeners();
  }
  // Getters
  static get Default() {
    return ky;
  }
  static get DefaultType() {
    return Ry;
  }
  static get NAME() {
    return wy;
  }
  // Public
  show() {
    if (F.trigger(this._element, Iy).defaultPrevented)
      return;
    this._clearTimeout(), this._config.animation && this._element.classList.add(Ly);
    const r = () => {
      this._element.classList.remove(os), F.trigger(this._element, My), this._maybeScheduleHide();
    };
    this._element.classList.remove(Wl), Un(this._element), this._element.classList.add(is, os), this._queueCallback(r, this._element, this._config.animation);
  }
  hide() {
    if (!this.isShown() || F.trigger(this._element, Cy).defaultPrevented)
      return;
    const r = () => {
      this._element.classList.add(Wl), this._element.classList.remove(os, is), F.trigger(this._element, Dy);
    };
    this._element.classList.add(os), this._queueCallback(r, this._element, this._config.animation);
  }
  dispose() {
    this._clearTimeout(), this.isShown() && this._element.classList.remove(is), super.dispose();
  }
  isShown() {
    return this._element.classList.contains(is);
  }
  // Private
  _maybeScheduleHide() {
    this._config.autohide && (this._hasMouseInteraction || this._hasKeyboardInteraction || (this._timeout = setTimeout(() => {
      this.hide();
    }, this._config.delay)));
  }
  _onInteraction(t, r) {
    switch (t.type) {
      case "mouseover":
      case "mouseout": {
        this._hasMouseInteraction = r;
        break;
      }
      case "focusin":
      case "focusout": {
        this._hasKeyboardInteraction = r;
        break;
      }
    }
    if (r) {
      this._clearTimeout();
      return;
    }
    const n = t.relatedTarget;
    this._element === n || this._element.contains(n) || this._maybeScheduleHide();
  }
  _setListeners() {
    F.on(this._element, Sy, (t) => this._onInteraction(t, !0)), F.on(this._element, Oy, (t) => this._onInteraction(t, !1)), F.on(this._element, Ay, (t) => this._onInteraction(t, !0)), F.on(this._element, Ny, (t) => this._onInteraction(t, !1));
  }
  _clearTimeout() {
    clearTimeout(this._timeout), this._timeout = null;
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const r = ai.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof r[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        r[t](this);
      }
    });
  }
}
ni(ai);
ft(ai);
function Dd(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: xy } = Object.prototype, { getPrototypeOf: Da } = Object, { iterator: li, toStringTag: Id } = Symbol, ci = /* @__PURE__ */ ((e) => (t) => {
  const r = xy.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), St = (e) => (e = e.toLowerCase(), (t) => ci(t) === e), ui = (e) => (t) => typeof t === e, { isArray: an } = Array, en = ui("undefined");
function Gn(e) {
  return e !== null && !en(e) && e.constructor !== null && !en(e.constructor) && Qe(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Md = St("ArrayBuffer");
function Py(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Md(e.buffer), t;
}
const $y = ui("string"), Qe = ui("function"), Ld = ui("number"), Wn = (e) => e !== null && typeof e == "object", Fy = (e) => e === !0 || e === !1, ms = (e) => {
  if (ci(e) !== "object")
    return !1;
  const t = Da(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Id in e) && !(li in e);
}, Vy = (e) => {
  if (!Wn(e) || Gn(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, By = St("Date"), Uy = St("File"), Hy = St("Blob"), jy = St("FileList"), Yy = (e) => Wn(e) && Qe(e.pipe), Gy = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Qe(e.append) && ((t = ci(e)) === "formdata" || // detect form-data instance
  t === "object" && Qe(e.toString) && e.toString() === "[object FormData]"));
}, Wy = St("URLSearchParams"), [qy, Ky, zy, Jy] = ["ReadableStream", "Request", "Response", "Headers"].map(St), Xy = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function qn(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, s;
  if (typeof e != "object" && (e = [e]), an(e))
    for (n = 0, s = e.length; n < s; n++)
      t.call(null, e[n], n, e);
  else {
    if (Gn(e))
      return;
    const i = r ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let a;
    for (n = 0; n < o; n++)
      a = i[n], t.call(null, e[a], a, e);
  }
}
function Rd(e, t) {
  if (Gn(e))
    return null;
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, s;
  for (; n-- > 0; )
    if (s = r[n], t === s.toLowerCase())
      return s;
  return null;
}
const yr = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, kd = (e) => !en(e) && e !== yr;
function Po() {
  const { caseless: e, skipUndefined: t } = kd(this) && this || {}, r = {}, n = (s, i) => {
    const o = e && Rd(r, i) || i;
    ms(r[o]) && ms(s) ? r[o] = Po(r[o], s) : ms(s) ? r[o] = Po({}, s) : an(s) ? r[o] = s.slice() : (!t || !en(s)) && (r[o] = s);
  };
  for (let s = 0, i = arguments.length; s < i; s++)
    arguments[s] && qn(arguments[s], n);
  return r;
}
const Qy = (e, t, r, { allOwnKeys: n } = {}) => (qn(t, (s, i) => {
  r && Qe(s) ? e[i] = Dd(s, r) : e[i] = s;
}, { allOwnKeys: n }), e), Zy = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), eE = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, tE = (e, t, r, n) => {
  let s, i, o;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (s = Object.getOwnPropertyNames(e), i = s.length; i-- > 0; )
      o = s[i], (!n || n(o, e, t)) && !a[o] && (t[o] = e[o], a[o] = !0);
    e = r !== !1 && Da(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, rE = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, nE = (e) => {
  if (!e) return null;
  if (an(e)) return e;
  let t = e.length;
  if (!Ld(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, sE = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Da(Uint8Array)), iE = (e, t) => {
  const n = (e && e[li]).call(e);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const i = s.value;
    t.call(e, i[0], i[1]);
  }
}, oE = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, aE = St("HTMLFormElement"), lE = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, s) {
    return n.toUpperCase() + s;
  }
), ql = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), cE = St("RegExp"), xd = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  qn(r, (s, i) => {
    let o;
    (o = t(s, i, e)) !== !1 && (n[i] = o || s);
  }), Object.defineProperties(e, n);
}, uE = (e) => {
  xd(e, (t, r) => {
    if (Qe(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (Qe(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, dE = (e, t) => {
  const r = {}, n = (s) => {
    s.forEach((i) => {
      r[i] = !0;
    });
  };
  return an(e) ? n(e) : n(String(e).split(t)), r;
}, fE = () => {
}, pE = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function hE(e) {
  return !!(e && Qe(e.append) && e[Id] === "FormData" && e[li]);
}
const gE = (e) => {
  const t = new Array(10), r = (n, s) => {
    if (Wn(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (Gn(n))
        return n;
      if (!("toJSON" in n)) {
        t[s] = n;
        const i = an(n) ? [] : {};
        return qn(n, (o, a) => {
          const l = r(o, s + 1);
          !en(l) && (i[a] = l);
        }), t[s] = void 0, i;
      }
    }
    return n;
  };
  return r(e, 0);
}, _E = St("AsyncFunction"), mE = (e) => e && (Wn(e) || Qe(e)) && Qe(e.then) && Qe(e.catch), Pd = ((e, t) => e ? setImmediate : t ? ((r, n) => (yr.addEventListener("message", ({ source: s, data: i }) => {
  s === yr && i === r && n.length && n.shift()();
}, !1), (s) => {
  n.push(s), yr.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  Qe(yr.postMessage)
), yE = typeof queueMicrotask < "u" ? queueMicrotask.bind(yr) : typeof process < "u" && process.nextTick || Pd, EE = (e) => e != null && Qe(e[li]), N = {
  isArray: an,
  isArrayBuffer: Md,
  isBuffer: Gn,
  isFormData: Gy,
  isArrayBufferView: Py,
  isString: $y,
  isNumber: Ld,
  isBoolean: Fy,
  isObject: Wn,
  isPlainObject: ms,
  isEmptyObject: Vy,
  isReadableStream: qy,
  isRequest: Ky,
  isResponse: zy,
  isHeaders: Jy,
  isUndefined: en,
  isDate: By,
  isFile: Uy,
  isBlob: Hy,
  isRegExp: cE,
  isFunction: Qe,
  isStream: Yy,
  isURLSearchParams: Wy,
  isTypedArray: sE,
  isFileList: jy,
  forEach: qn,
  merge: Po,
  extend: Qy,
  trim: Xy,
  stripBOM: Zy,
  inherits: eE,
  toFlatObject: tE,
  kindOf: ci,
  kindOfTest: St,
  endsWith: rE,
  toArray: nE,
  forEachEntry: iE,
  matchAll: oE,
  isHTMLForm: aE,
  hasOwnProperty: ql,
  hasOwnProp: ql,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: xd,
  freezeMethods: uE,
  toObjectSet: dE,
  toCamelCase: lE,
  noop: fE,
  toFiniteNumber: pE,
  findKey: Rd,
  global: yr,
  isContextDefined: kd,
  isSpecCompliantForm: hE,
  toJSONObject: gE,
  isAsyncFn: _E,
  isThenable: mE,
  setImmediate: Pd,
  asap: yE,
  isIterable: EE
};
function he(e, t, r, n, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), s && (this.response = s, this.status = s.status ? s.status : null);
}
N.inherits(he, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: N.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const $d = he.prototype, Fd = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Fd[e] = { value: e };
});
Object.defineProperties(he, Fd);
Object.defineProperty($d, "isAxiosError", { value: !0 });
he.from = (e, t, r, n, s, i) => {
  const o = Object.create($d);
  N.toFlatObject(e, o, function(c) {
    return c !== Error.prototype;
  }, (u) => u !== "isAxiosError");
  const a = e && e.message ? e.message : "Error", l = t == null && e ? e.code : t;
  return he.call(o, a, l, r, n, s), e && o.cause == null && Object.defineProperty(o, "cause", { value: e, configurable: !0 }), o.name = e && e.name || "Error", i && Object.assign(o, i), o;
};
const vE = null;
function $o(e) {
  return N.isPlainObject(e) || N.isArray(e);
}
function Vd(e) {
  return N.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Kl(e, t, r) {
  return e ? e.concat(t).map(function(s, i) {
    return s = Vd(s), !r && i ? "[" + s + "]" : s;
  }).join(r ? "." : "") : t;
}
function bE(e) {
  return N.isArray(e) && !e.some($o);
}
const wE = N.toFlatObject(N, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function di(e, t, r) {
  if (!N.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = N.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(p, y) {
    return !N.isUndefined(y[p]);
  });
  const n = r.metaTokens, s = r.visitor || c, i = r.dots, o = r.indexes, l = (r.Blob || typeof Blob < "u" && Blob) && N.isSpecCompliantForm(t);
  if (!N.isFunction(s))
    throw new TypeError("visitor must be a function");
  function u(g) {
    if (g === null) return "";
    if (N.isDate(g))
      return g.toISOString();
    if (N.isBoolean(g))
      return g.toString();
    if (!l && N.isBlob(g))
      throw new he("Blob is not supported. Use a Buffer instead.");
    return N.isArrayBuffer(g) || N.isTypedArray(g) ? l && typeof Blob == "function" ? new Blob([g]) : Buffer.from(g) : g;
  }
  function c(g, p, y) {
    let A = g;
    if (g && !y && typeof g == "object") {
      if (N.endsWith(p, "{}"))
        p = n ? p : p.slice(0, -2), g = JSON.stringify(g);
      else if (N.isArray(g) && bE(g) || (N.isFileList(g) || N.endsWith(p, "[]")) && (A = N.toArray(g)))
        return p = Vd(p), A.forEach(function(b, C) {
          !(N.isUndefined(b) || b === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Kl([p], C, i) : o === null ? p : p + "[]",
            u(b)
          );
        }), !1;
    }
    return $o(g) ? !0 : (t.append(Kl(y, p, i), u(g)), !1);
  }
  const d = [], f = Object.assign(wE, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: $o
  });
  function _(g, p) {
    if (!N.isUndefined(g)) {
      if (d.indexOf(g) !== -1)
        throw Error("Circular reference detected in " + p.join("."));
      d.push(g), N.forEach(g, function(A, T) {
        (!(N.isUndefined(A) || A === null) && s.call(
          t,
          A,
          N.isString(T) ? T.trim() : T,
          p,
          f
        )) === !0 && _(A, p ? p.concat(T) : [T]);
      }), d.pop();
    }
  }
  if (!N.isObject(e))
    throw new TypeError("data must be an object");
  return _(e), t;
}
function zl(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function Ia(e, t) {
  this._pairs = [], e && di(e, this, t);
}
const Bd = Ia.prototype;
Bd.append = function(t, r) {
  this._pairs.push([t, r]);
};
Bd.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, zl);
  } : zl;
  return this._pairs.map(function(s) {
    return r(s[0]) + "=" + r(s[1]);
  }, "").join("&");
};
function TE(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Ud(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || TE;
  N.isFunction(r) && (r = {
    serialize: r
  });
  const s = r && r.serialize;
  let i;
  if (s ? i = s(t, r) : i = N.isURLSearchParams(t) ? t.toString() : new Ia(t, r).toString(n), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Jl {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    N.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const Hd = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, SE = typeof URLSearchParams < "u" ? URLSearchParams : Ia, OE = typeof FormData < "u" ? FormData : null, AE = typeof Blob < "u" ? Blob : null, NE = {
  isBrowser: !0,
  classes: {
    URLSearchParams: SE,
    FormData: OE,
    Blob: AE
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ma = typeof window < "u" && typeof document < "u", Fo = typeof navigator == "object" && navigator || void 0, CE = Ma && (!Fo || ["ReactNative", "NativeScript", "NS"].indexOf(Fo.product) < 0), DE = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", IE = Ma && window.location.href || "http://localhost", ME = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ma,
  hasStandardBrowserEnv: CE,
  hasStandardBrowserWebWorkerEnv: DE,
  navigator: Fo,
  origin: IE
}, Symbol.toStringTag, { value: "Module" })), He = {
  ...ME,
  ...NE
};
function LE(e, t) {
  return di(e, new He.classes.URLSearchParams(), {
    visitor: function(r, n, s, i) {
      return He.isNode && N.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function RE(e) {
  return N.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function kE(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const s = r.length;
  let i;
  for (n = 0; n < s; n++)
    i = r[n], t[i] = e[i];
  return t;
}
function jd(e) {
  function t(r, n, s, i) {
    let o = r[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), l = i >= r.length;
    return o = !o && N.isArray(s) ? s.length : o, l ? (N.hasOwnProp(s, o) ? s[o] = [s[o], n] : s[o] = n, !a) : ((!s[o] || !N.isObject(s[o])) && (s[o] = []), t(r, n, s[o], i) && N.isArray(s[o]) && (s[o] = kE(s[o])), !a);
  }
  if (N.isFormData(e) && N.isFunction(e.entries)) {
    const r = {};
    return N.forEachEntry(e, (n, s) => {
      t(RE(n), s, r, 0);
    }), r;
  }
  return null;
}
function xE(e, t, r) {
  if (N.isString(e))
    try {
      return (t || JSON.parse)(e), N.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const Kn = {
  transitional: Hd,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", s = n.indexOf("application/json") > -1, i = N.isObject(t);
    if (i && N.isHTMLForm(t) && (t = new FormData(t)), N.isFormData(t))
      return s ? JSON.stringify(jd(t)) : t;
    if (N.isArrayBuffer(t) || N.isBuffer(t) || N.isStream(t) || N.isFile(t) || N.isBlob(t) || N.isReadableStream(t))
      return t;
    if (N.isArrayBufferView(t))
      return t.buffer;
    if (N.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (i) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return LE(t, this.formSerializer).toString();
      if ((a = N.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return di(
          a ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || s ? (r.setContentType("application/json", !1), xE(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || Kn.transitional, n = r && r.forcedJSONParsing, s = this.responseType === "json";
    if (N.isResponse(t) || N.isReadableStream(t))
      return t;
    if (t && N.isString(t) && (n && !this.responseType || s)) {
      const o = !(r && r.silentJSONParsing) && s;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (a) {
        if (o)
          throw a.name === "SyntaxError" ? he.from(a, he.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: He.classes.FormData,
    Blob: He.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
N.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Kn.headers[e] = {};
});
const PE = N.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), $E = (e) => {
  const t = {};
  let r, n, s;
  return e && e.split(`
`).forEach(function(o) {
    s = o.indexOf(":"), r = o.substring(0, s).trim().toLowerCase(), n = o.substring(s + 1).trim(), !(!r || t[r] && PE[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, Xl = Symbol("internals");
function yn(e) {
  return e && String(e).trim().toLowerCase();
}
function ys(e) {
  return e === !1 || e == null ? e : N.isArray(e) ? e.map(ys) : String(e);
}
function FE(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const VE = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Yi(e, t, r, n, s) {
  if (N.isFunction(n))
    return n.call(this, t, r);
  if (s && (t = r), !!N.isString(t)) {
    if (N.isString(n))
      return t.indexOf(n) !== -1;
    if (N.isRegExp(n))
      return n.test(t);
  }
}
function BE(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function UE(e, t) {
  const r = N.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(s, i, o) {
        return this[n].call(this, t, s, i, o);
      },
      configurable: !0
    });
  });
}
let Ze = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const s = this;
    function i(a, l, u) {
      const c = yn(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const d = N.findKey(s, c);
      (!d || s[d] === void 0 || u === !0 || u === void 0 && s[d] !== !1) && (s[d || l] = ys(a));
    }
    const o = (a, l) => N.forEach(a, (u, c) => i(u, c, l));
    if (N.isPlainObject(t) || t instanceof this.constructor)
      o(t, r);
    else if (N.isString(t) && (t = t.trim()) && !VE(t))
      o($E(t), r);
    else if (N.isObject(t) && N.isIterable(t)) {
      let a = {}, l, u;
      for (const c of t) {
        if (!N.isArray(c))
          throw TypeError("Object iterator must return a key-value pair");
        a[u = c[0]] = (l = a[u]) ? N.isArray(l) ? [...l, c[1]] : [l, c[1]] : c[1];
      }
      o(a, r);
    } else
      t != null && i(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = yn(t), t) {
      const n = N.findKey(this, t);
      if (n) {
        const s = this[n];
        if (!r)
          return s;
        if (r === !0)
          return FE(s);
        if (N.isFunction(r))
          return r.call(this, s, n);
        if (N.isRegExp(r))
          return r.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = yn(t), t) {
      const n = N.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || Yi(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let s = !1;
    function i(o) {
      if (o = yn(o), o) {
        const a = N.findKey(n, o);
        a && (!r || Yi(n, n[a], a, r)) && (delete n[a], s = !0);
      }
    }
    return N.isArray(t) ? t.forEach(i) : i(t), s;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, s = !1;
    for (; n--; ) {
      const i = r[n];
      (!t || Yi(this, this[i], i, t, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(t) {
    const r = this, n = {};
    return N.forEach(this, (s, i) => {
      const o = N.findKey(n, i);
      if (o) {
        r[o] = ys(s), delete r[i];
        return;
      }
      const a = t ? BE(i) : String(i).trim();
      a !== i && delete r[i], r[a] = ys(s), n[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return N.forEach(this, (n, s) => {
      n != null && n !== !1 && (r[s] = t && N.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((s) => n.set(s)), n;
  }
  static accessor(t) {
    const n = (this[Xl] = this[Xl] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(o) {
      const a = yn(o);
      n[a] || (UE(s, o), n[a] = !0);
    }
    return N.isArray(t) ? t.forEach(i) : i(t), this;
  }
};
Ze.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
N.reduceDescriptors(Ze.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
N.freezeMethods(Ze);
function Gi(e, t) {
  const r = this || Kn, n = t || r, s = Ze.from(n.headers);
  let i = n.data;
  return N.forEach(e, function(a) {
    i = a.call(r, i, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), i;
}
function Yd(e) {
  return !!(e && e.__CANCEL__);
}
function ln(e, t, r) {
  he.call(this, e ?? "canceled", he.ERR_CANCELED, t, r), this.name = "CanceledError";
}
N.inherits(ln, he, {
  __CANCEL__: !0
});
function Gd(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new he(
    "Request failed with status code " + r.status,
    [he.ERR_BAD_REQUEST, he.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function HE(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function jE(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let s = 0, i = 0, o;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const u = Date.now(), c = n[i];
    o || (o = u), r[s] = l, n[s] = u;
    let d = i, f = 0;
    for (; d !== s; )
      f += r[d++], d = d % e;
    if (s = (s + 1) % e, s === i && (i = (i + 1) % e), u - o < t)
      return;
    const _ = c && u - c;
    return _ ? Math.round(f * 1e3 / _) : void 0;
  };
}
function YE(e, t) {
  let r = 0, n = 1e3 / t, s, i;
  const o = (u, c = Date.now()) => {
    r = c, s = null, i && (clearTimeout(i), i = null), e(...u);
  };
  return [(...u) => {
    const c = Date.now(), d = c - r;
    d >= n ? o(u, c) : (s = u, i || (i = setTimeout(() => {
      i = null, o(s);
    }, n - d)));
  }, () => s && o(s)];
}
const Bs = (e, t, r = 3) => {
  let n = 0;
  const s = jE(50, 250);
  return YE((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, l = o - n, u = s(l), c = o <= a;
    n = o;
    const d = {
      loaded: o,
      total: a,
      progress: a ? o / a : void 0,
      bytes: l,
      rate: u || void 0,
      estimated: u && a && c ? (a - o) / u : void 0,
      event: i,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, r);
}, Ql = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, Zl = (e) => (...t) => N.asap(() => e(...t)), GE = He.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, He.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(He.origin),
  He.navigator && /(msie|trident)/i.test(He.navigator.userAgent)
) : () => !0, WE = He.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, s, i) {
      const o = [e + "=" + encodeURIComponent(t)];
      N.isNumber(r) && o.push("expires=" + new Date(r).toGMTString()), N.isString(n) && o.push("path=" + n), N.isString(s) && o.push("domain=" + s), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function qE(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function KE(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Wd(e, t, r) {
  let n = !qE(t);
  return e && (n || r == !1) ? KE(e, t) : t;
}
const ec = (e) => e instanceof Ze ? { ...e } : e;
function Nr(e, t) {
  t = t || {};
  const r = {};
  function n(u, c, d, f) {
    return N.isPlainObject(u) && N.isPlainObject(c) ? N.merge.call({ caseless: f }, u, c) : N.isPlainObject(c) ? N.merge({}, c) : N.isArray(c) ? c.slice() : c;
  }
  function s(u, c, d, f) {
    if (N.isUndefined(c)) {
      if (!N.isUndefined(u))
        return n(void 0, u, d, f);
    } else return n(u, c, d, f);
  }
  function i(u, c) {
    if (!N.isUndefined(c))
      return n(void 0, c);
  }
  function o(u, c) {
    if (N.isUndefined(c)) {
      if (!N.isUndefined(u))
        return n(void 0, u);
    } else return n(void 0, c);
  }
  function a(u, c, d) {
    if (d in t)
      return n(u, c);
    if (d in e)
      return n(void 0, u);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: a,
    headers: (u, c, d) => s(ec(u), ec(c), d, !0)
  };
  return N.forEach(Object.keys({ ...e, ...t }), function(c) {
    const d = l[c] || s, f = d(e[c], t[c], c);
    N.isUndefined(f) && d !== a || (r[c] = f);
  }), r;
}
const qd = (e) => {
  const t = Nr({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: a } = t;
  if (t.headers = o = Ze.from(o), t.url = Ud(Wd(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), a && o.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  ), N.isFormData(r)) {
    if (He.hasStandardBrowserEnv || He.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if (N.isFunction(r.getHeaders)) {
      const l = r.getHeaders(), u = ["content-type", "content-length"];
      Object.entries(l).forEach(([c, d]) => {
        u.includes(c.toLowerCase()) && o.set(c, d);
      });
    }
  }
  if (He.hasStandardBrowserEnv && (n && N.isFunction(n) && (n = n(t)), n || n !== !1 && GE(t.url))) {
    const l = s && i && WE.read(i);
    l && o.set(s, l);
  }
  return t;
}, zE = typeof XMLHttpRequest < "u", JE = zE && function(e) {
  return new Promise(function(r, n) {
    const s = qd(e);
    let i = s.data;
    const o = Ze.from(s.headers).normalize();
    let { responseType: a, onUploadProgress: l, onDownloadProgress: u } = s, c, d, f, _, g;
    function p() {
      _ && _(), g && g(), s.cancelToken && s.cancelToken.unsubscribe(c), s.signal && s.signal.removeEventListener("abort", c);
    }
    let y = new XMLHttpRequest();
    y.open(s.method.toUpperCase(), s.url, !0), y.timeout = s.timeout;
    function A() {
      if (!y)
        return;
      const b = Ze.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), v = {
        data: !a || a === "text" || a === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: b,
        config: e,
        request: y
      };
      Gd(function(K) {
        r(K), p();
      }, function(K) {
        n(K), p();
      }, v), y = null;
    }
    "onloadend" in y ? y.onloadend = A : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(A);
    }, y.onabort = function() {
      y && (n(new he("Request aborted", he.ECONNABORTED, e, y)), y = null);
    }, y.onerror = function(C) {
      const v = C && C.message ? C.message : "Network Error", Y = new he(v, he.ERR_NETWORK, e, y);
      Y.event = C || null, n(Y), y = null;
    }, y.ontimeout = function() {
      let C = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const v = s.transitional || Hd;
      s.timeoutErrorMessage && (C = s.timeoutErrorMessage), n(new he(
        C,
        v.clarifyTimeoutError ? he.ETIMEDOUT : he.ECONNABORTED,
        e,
        y
      )), y = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in y && N.forEach(o.toJSON(), function(C, v) {
      y.setRequestHeader(v, C);
    }), N.isUndefined(s.withCredentials) || (y.withCredentials = !!s.withCredentials), a && a !== "json" && (y.responseType = s.responseType), u && ([f, g] = Bs(u, !0), y.addEventListener("progress", f)), l && y.upload && ([d, _] = Bs(l), y.upload.addEventListener("progress", d), y.upload.addEventListener("loadend", _)), (s.cancelToken || s.signal) && (c = (b) => {
      y && (n(!b || b.type ? new ln(null, e, y) : b), y.abort(), y = null);
    }, s.cancelToken && s.cancelToken.subscribe(c), s.signal && (s.signal.aborted ? c() : s.signal.addEventListener("abort", c)));
    const T = HE(s.url);
    if (T && He.protocols.indexOf(T) === -1) {
      n(new he("Unsupported protocol " + T + ":", he.ERR_BAD_REQUEST, e));
      return;
    }
    y.send(i || null);
  });
}, XE = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), s;
    const i = function(u) {
      if (!s) {
        s = !0, a();
        const c = u instanceof Error ? u : this.reason;
        n.abort(c instanceof he ? c : new ln(c instanceof Error ? c.message : c));
      }
    };
    let o = t && setTimeout(() => {
      o = null, i(new he(`timeout ${t} of ms exceeded`, he.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(i) : u.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((u) => u.addEventListener("abort", i));
    const { signal: l } = n;
    return l.unsubscribe = () => N.asap(a), l;
  }
}, QE = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, s;
  for (; n < r; )
    s = n + t, yield e.slice(n, s), n = s;
}, ZE = async function* (e, t) {
  for await (const r of ev(e))
    yield* QE(r, t);
}, ev = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, tc = (e, t, r, n) => {
  const s = ZE(e, t);
  let i = 0, o, a = (l) => {
    o || (o = !0, n && n(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: u, value: c } = await s.next();
        if (u) {
          a(), l.close();
          return;
        }
        let d = c.byteLength;
        if (r) {
          let f = i += d;
          r(f);
        }
        l.enqueue(new Uint8Array(c));
      } catch (u) {
        throw a(u), u;
      }
    },
    cancel(l) {
      return a(l), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, rc = 64 * 1024, { isFunction: as } = N, tv = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(N.global), {
  ReadableStream: nc,
  TextEncoder: sc
} = N.global, ic = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, rv = (e) => {
  e = N.merge.call({
    skipUndefined: !0
  }, tv, e);
  const { fetch: t, Request: r, Response: n } = e, s = t ? as(t) : typeof fetch == "function", i = as(r), o = as(n);
  if (!s)
    return !1;
  const a = s && as(nc), l = s && (typeof sc == "function" ? /* @__PURE__ */ ((g) => (p) => g.encode(p))(new sc()) : async (g) => new Uint8Array(await new r(g).arrayBuffer())), u = i && a && ic(() => {
    let g = !1;
    const p = new r(He.origin, {
      body: new nc(),
      method: "POST",
      get duplex() {
        return g = !0, "half";
      }
    }).headers.has("Content-Type");
    return g && !p;
  }), c = o && a && ic(() => N.isReadableStream(new n("").body)), d = {
    stream: c && ((g) => g.body)
  };
  s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((g) => {
    !d[g] && (d[g] = (p, y) => {
      let A = p && p[g];
      if (A)
        return A.call(p);
      throw new he(`Response type '${g}' is not supported`, he.ERR_NOT_SUPPORT, y);
    });
  });
  const f = async (g) => {
    if (g == null)
      return 0;
    if (N.isBlob(g))
      return g.size;
    if (N.isSpecCompliantForm(g))
      return (await new r(He.origin, {
        method: "POST",
        body: g
      }).arrayBuffer()).byteLength;
    if (N.isArrayBufferView(g) || N.isArrayBuffer(g))
      return g.byteLength;
    if (N.isURLSearchParams(g) && (g = g + ""), N.isString(g))
      return (await l(g)).byteLength;
  }, _ = async (g, p) => {
    const y = N.toFiniteNumber(g.getContentLength());
    return y ?? f(p);
  };
  return async (g) => {
    let {
      url: p,
      method: y,
      data: A,
      signal: T,
      cancelToken: b,
      timeout: C,
      onDownloadProgress: v,
      onUploadProgress: Y,
      responseType: K,
      headers: ee,
      withCredentials: Q = "same-origin",
      fetchOptions: Z
    } = qd(g), X = t || fetch;
    K = K ? (K + "").toLowerCase() : "text";
    let le = XE([T, b && b.toAbortSignal()], C), ae = null;
    const W = le && le.unsubscribe && (() => {
      le.unsubscribe();
    });
    let V;
    try {
      if (Y && u && y !== "get" && y !== "head" && (V = await _(ee, A)) !== 0) {
        let D = new r(p, {
          method: "POST",
          body: A,
          duplex: "half"
        }), G;
        if (N.isFormData(A) && (G = D.headers.get("content-type")) && ee.setContentType(G), D.body) {
          const [U, te] = Ql(
            V,
            Bs(Zl(Y))
          );
          A = tc(D.body, rc, U, te);
        }
      }
      N.isString(Q) || (Q = Q ? "include" : "omit");
      const L = i && "credentials" in r.prototype, R = {
        ...Z,
        signal: le,
        method: y.toUpperCase(),
        headers: ee.normalize().toJSON(),
        body: A,
        duplex: "half",
        credentials: L ? Q : void 0
      };
      ae = i && new r(p, R);
      let M = await (i ? X(ae, Z) : X(p, R));
      const w = c && (K === "stream" || K === "response");
      if (c && (v || w && W)) {
        const D = {};
        ["status", "statusText", "headers"].forEach((fe) => {
          D[fe] = M[fe];
        });
        const G = N.toFiniteNumber(M.headers.get("content-length")), [U, te] = v && Ql(
          G,
          Bs(Zl(v), !0)
        ) || [];
        M = new n(
          tc(M.body, rc, U, () => {
            te && te(), W && W();
          }),
          D
        );
      }
      K = K || "text";
      let S = await d[N.findKey(d, K) || "text"](M, g);
      return !w && W && W(), await new Promise((D, G) => {
        Gd(D, G, {
          data: S,
          headers: Ze.from(M.headers),
          status: M.status,
          statusText: M.statusText,
          config: g,
          request: ae
        });
      });
    } catch (L) {
      throw W && W(), L && L.name === "TypeError" && /Load failed|fetch/i.test(L.message) ? Object.assign(
        new he("Network Error", he.ERR_NETWORK, g, ae),
        {
          cause: L.cause || L
        }
      ) : he.from(L, L && L.code, g, ae);
    }
  };
}, nv = /* @__PURE__ */ new Map(), Kd = (e) => {
  let t = e ? e.env : {};
  const { fetch: r, Request: n, Response: s } = t, i = [
    n,
    s,
    r
  ];
  let o = i.length, a = o, l, u, c = nv;
  for (; a--; )
    l = i[a], u = c.get(l), u === void 0 && c.set(l, u = a ? /* @__PURE__ */ new Map() : rv(t)), c = u;
  return u;
};
Kd();
const Vo = {
  http: vE,
  xhr: JE,
  fetch: {
    get: Kd
  }
};
N.forEach(Vo, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const oc = (e) => `- ${e}`, sv = (e) => N.isFunction(e) || e === null || e === !1, zd = {
  getAdapter: (e, t) => {
    e = N.isArray(e) ? e : [e];
    const { length: r } = e;
    let n, s;
    const i = {};
    for (let o = 0; o < r; o++) {
      n = e[o];
      let a;
      if (s = n, !sv(n) && (s = Vo[(a = String(n)).toLowerCase()], s === void 0))
        throw new he(`Unknown adapter '${a}'`);
      if (s && (N.isFunction(s) || (s = s.get(t))))
        break;
      i[a || "#" + o] = s;
    }
    if (!s) {
      const o = Object.entries(i).map(
        ([l, u]) => `adapter ${l} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = r ? o.length > 1 ? `since :
` + o.map(oc).join(`
`) : " " + oc(o[0]) : "as no adapter specified";
      throw new he(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return s;
  },
  adapters: Vo
};
function Wi(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ln(null, e);
}
function ac(e) {
  return Wi(e), e.headers = Ze.from(e.headers), e.data = Gi.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), zd.getAdapter(e.adapter || Kn.adapter, e)(e).then(function(n) {
    return Wi(e), n.data = Gi.call(
      e,
      e.transformResponse,
      n
    ), n.headers = Ze.from(n.headers), n;
  }, function(n) {
    return Yd(n) || (Wi(e), n && n.response && (n.response.data = Gi.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = Ze.from(n.response.headers))), Promise.reject(n);
  });
}
const Jd = "1.12.2", fi = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  fi[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const lc = {};
fi.transitional = function(t, r, n) {
  function s(i, o) {
    return "[Axios v" + Jd + "] Transitional option '" + i + "'" + o + (n ? ". " + n : "");
  }
  return (i, o, a) => {
    if (t === !1)
      throw new he(
        s(o, " has been removed" + (r ? " in " + r : "")),
        he.ERR_DEPRECATED
      );
    return r && !lc[o] && (lc[o] = !0, console.warn(
      s(
        o,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(i, o, a) : !0;
  };
};
fi.spelling = function(t) {
  return (r, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
function iv(e, t, r) {
  if (typeof e != "object")
    throw new he("options must be an object", he.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let s = n.length;
  for (; s-- > 0; ) {
    const i = n[s], o = t[i];
    if (o) {
      const a = e[i], l = a === void 0 || o(a, i, e);
      if (l !== !0)
        throw new he("option " + i + " must be " + l, he.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new he("Unknown option " + i, he.ERR_BAD_OPTION);
  }
}
const Es = {
  assertOptions: iv,
  validators: fi
}, Ct = Es.validators;
let vr = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Jl(),
      response: new Jl()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? i && !String(n.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + i) : n.stack = i;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = Nr(this.defaults, r);
    const { transitional: n, paramsSerializer: s, headers: i } = r;
    n !== void 0 && Es.assertOptions(n, {
      silentJSONParsing: Ct.transitional(Ct.boolean),
      forcedJSONParsing: Ct.transitional(Ct.boolean),
      clarifyTimeoutError: Ct.transitional(Ct.boolean)
    }, !1), s != null && (N.isFunction(s) ? r.paramsSerializer = {
      serialize: s
    } : Es.assertOptions(s, {
      encode: Ct.function,
      serialize: Ct.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Es.assertOptions(r, {
      baseUrl: Ct.spelling("baseURL"),
      withXsrfToken: Ct.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let o = i && N.merge(
      i.common,
      i[r.method]
    );
    i && N.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (g) => {
        delete i[g];
      }
    ), r.headers = Ze.concat(o, i);
    const a = [];
    let l = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(r) === !1 || (l = l && p.synchronous, a.unshift(p.fulfilled, p.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(p) {
      u.push(p.fulfilled, p.rejected);
    });
    let c, d = 0, f;
    if (!l) {
      const g = [ac.bind(this), void 0];
      for (g.unshift(...a), g.push(...u), f = g.length, c = Promise.resolve(r); d < f; )
        c = c.then(g[d++], g[d++]);
      return c;
    }
    f = a.length;
    let _ = r;
    for (; d < f; ) {
      const g = a[d++], p = a[d++];
      try {
        _ = g(_);
      } catch (y) {
        p.call(this, y);
        break;
      }
    }
    try {
      c = ac.call(this, _);
    } catch (g) {
      return Promise.reject(g);
    }
    for (d = 0, f = u.length; d < f; )
      c = c.then(u[d++], u[d++]);
    return c;
  }
  getUri(t) {
    t = Nr(this.defaults, t);
    const r = Wd(t.baseURL, t.url, t.allowAbsoluteUrls);
    return Ud(r, t.params, t.paramsSerializer);
  }
};
N.forEach(["delete", "get", "head", "options"], function(t) {
  vr.prototype[t] = function(r, n) {
    return this.request(Nr(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
N.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(i, o, a) {
      return this.request(Nr(a || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  vr.prototype[t] = r(), vr.prototype[t + "Form"] = r(!0);
});
let ov = class Xd {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(i) {
      r = i;
    });
    const n = this;
    this.promise.then((s) => {
      if (!n._listeners) return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](s);
      n._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((a) => {
        n.subscribe(a), i = a;
      }).then(s);
      return o.cancel = function() {
        n.unsubscribe(i);
      }, o;
    }, t(function(i, o, a) {
      n.reason || (n.reason = new ln(i, o, a), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Xd(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
};
function av(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function lv(e) {
  return N.isObject(e) && e.isAxiosError === !0;
}
const Bo = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Bo).forEach(([e, t]) => {
  Bo[t] = e;
});
function Qd(e) {
  const t = new vr(e), r = Dd(vr.prototype.request, t);
  return N.extend(r, vr.prototype, t, { allOwnKeys: !0 }), N.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(s) {
    return Qd(Nr(e, s));
  }, r;
}
const Le = Qd(Kn);
Le.Axios = vr;
Le.CanceledError = ln;
Le.CancelToken = ov;
Le.isCancel = Yd;
Le.VERSION = Jd;
Le.toFormData = di;
Le.AxiosError = he;
Le.Cancel = Le.CanceledError;
Le.all = function(t) {
  return Promise.all(t);
};
Le.spread = av;
Le.isAxiosError = lv;
Le.mergeConfig = Nr;
Le.AxiosHeaders = Ze;
Le.formToJSON = (e) => jd(N.isHTMLForm(e) ? new FormData(e) : e);
Le.getAdapter = zd.getAdapter;
Le.HttpStatusCode = Bo;
Le.default = Le;
const {
  Axios: _O,
  AxiosError: mO,
  CanceledError: yO,
  isCancel: EO,
  CancelToken: vO,
  VERSION: bO,
  all: wO,
  Cancel: TO,
  isAxiosError: SO,
  spread: OO,
  toFormData: AO,
  AxiosHeaders: NO,
  HttpStatusCode: CO,
  formToJSON: DO,
  getAdapter: IO,
  mergeConfig: MO
} = Le, cv = 2e4, _e = (e) => {
  window.store.dispatch("showSuccessModal", e);
}, m = (e) => {
  window.store.dispatch("showErrorModal", e);
}, Re = {
  initOffCanvas(e) {
    const t = typeof e == "string" ? document.querySelector(e) : e;
    return Bt.getInstance(t) || new Bt(t);
  },
  initCollapse(e) {
    return new Qr(e);
  },
  initDropdown(e) {
    return new _t(e);
  },
  showLogin(e = "#loginModal") {
    new $t(e).show();
  },
  openModal(e) {
    setTimeout(() => {
      new $t(e).show();
    }, 100);
  },
  closeModal(e) {
    setTimeout(() => {
      let t = document.getElementById(e), r = $t.getInstance(t);
      r && r.hide();
    }, 100);
  },
  kFormatter(e) {
    return Math.abs(e) > 999 ? Math.sign(e) * (Math.abs(e) / 1e3).toFixed(1) + "k" : Math.sign(e) * Math.abs(e);
  },
  formatNumber(e) {
    return e !== null ? parseFloat(e).toFixed(2) : 0;
  },
  downloadExcel(e, t) {
    let r = require("xlsx");
    const n = r.utils.json_to_sheet(e), s = r.utils.book_new();
    r.utils.book_append_sheet(s, n, "Sheet1"), r.writeFile(s, t);
  },
  downloadPdf(e, t) {
    const { jsPDF: r } = require("jspdf"), n = require("jspdf-autotable").default, s = new r();
    n(s, {
      head: [Object.keys(e[0])],
      body: e.map((i) => Object.values(i))
    }), s.save(t);
  },
  notNull(e) {
    return e !== void 0;
  },
  compareLength: (e, t) => t.length == e,
  testRegex(e, t) {
    return e.test(t);
  },
  isMobile() {
    return window.innerWidth <= 991;
  },
  //----- sanitization helpers
  sanitizeDetails(e, t, r) {
    const n = {
      userId: /[^a-zA-Z0-9_.]/g,
      oldLoginUserId: /[\s]/g,
      password: /[\s]/g,
      oldLoginPassword: /[\s]/g,
      referCode: /[^0-9]/g,
      withdrawPassword: /[\s]/g,
      utrNumber: /[^0-9]/g
    };
    if (n[e]) {
      let s = t.replace(n[e], "");
      return r && (s = s.slice(0, r)), s;
    }
    return t;
  },
  sanitizeNumber(e, t) {
    if (e != "") {
      let r = e.toString();
      r = r.replace(/[^0-9]/g, "").replace(/[+-]/g, "");
      let n = "";
      return t == 999999 ? n = r.slice(0, 6) ?? "" : n = r == "" ? "" : Math.max(0, Math.min(t, r)).toString(), n;
    }
    return e;
  },
  //----- sanitization helpers
  positive(e) {
    return e < 0 ? e * -1 : e;
  },
  addCommas(t) {
    var t = parseFloat(t).toFixed(2);
    t += "";
    for (var r = t.split("."), n = r[0], s = r.length > 1 ? "." + r[1] : "", i = /(\d+)(\d{3})/; i.test(n); )
      n = n.replace(i, "$1,$2");
    var o = n + s;
    return o;
  },
  scrollToElement(e) {
    setTimeout(() => {
      e.scrollIntoView({
        behavior: "smooth",
        inline: "nearest"
      });
    }, 200);
  },
  currencyConverter(e, t = 1) {
    let r = {
      1: 1,
      2: 2,
      3: 0.01,
      4: 0.01
    };
    return e && r[t] ? r[t] * e : e;
  },
  formatTime(e) {
    return e < 10 ? `0${e}` : e;
  },
  checkForNonNumericals(e, t = null) {
    /^[a-zA-Z0-9]+$/.test(e.key.toLowerCase()) || e.preventDefault();
  },
  getKFormatter(e) {
    return Math.abs(e) > 999 ? Math.sign(e) * (Math.abs(e) / 1e3).toFixed(1) + "k" : Math.sign(e) * Math.abs(e);
  },
  getPaginationData(e) {
    return {
      currPage: e.current_page,
      from: e.from,
      to: e.to,
      lastPage: e.last_page,
      perPage: e.per_page,
      total: e.total
    };
  },
  applySharedComputed(e, t) {
    Object.assign(e.$options.computed, t);
  }
};
function uv(e) {
  var r, n, s, i, o, a, l, u, c, d, f, _, g, p, y, A, T, b, C;
  if (!(e != null && e.response))
    return Promise.reject(["Error CORS: Check your NETWORK agian and refresh the page."]);
  const t = (r = e == null ? void 0 : e.response) == null ? void 0 : r.status;
  switch (t) {
    case 422:
      return e.response.data.details ? Promise.reject(`Error ${t}: ${(l = (s = (n = e == null ? void 0 : e.response) == null ? void 0 : n.data) == null ? void 0 : s.details) == null ? void 0 : l[(a = Object.keys((o = (i = e == null ? void 0 : e.response) == null ? void 0 : i.data) == null ? void 0 : o.details)) == null ? void 0 : a[0]]}`) : Promise.reject([`Error ${t}: ${((c = (u = e == null ? void 0 : e.response) == null ? void 0 : u.data) == null ? void 0 : c.errors) ?? ((f = (d = e == null ? void 0 : e.response) == null ? void 0 : d.data) == null ? void 0 : f.message) ?? ((g = (_ = e == null ? void 0 : e.response) == null ? void 0 : _.data) == null ? void 0 : g.error)}`]);
    case 401:
      m("You Have Been Logged Out From This Device."), dv();
      break;
    case 400:
    case 500:
      return Promise.reject([`Error ${t}: ${((y = (p = e == null ? void 0 : e.response) == null ? void 0 : p.data) == null ? void 0 : y.message) || ((T = (A = e == null ? void 0 : e.response) == null ? void 0 : A.data) == null ? void 0 : T.error) || ((C = (b = e == null ? void 0 : e.response) == null ? void 0 : b.data) == null ? void 0 : C.errors)}`]);
    default:
      return Promise.reject([`Error ${t}: Refresh the page and try again.`]);
  }
}
function dv() {
  try {
    window.cookies.keys().forEach((e) => window.cookies.remove(e)), window.store.dispatch("resetAllState"), window.router.push({ name: "Home" }), setTimeout(() => {
      location.reload();
    }, 100);
  } catch (e) {
    console.log(e);
  }
}
const Mr = (e) => Le.create({
  baseURL: e,
  timeout: cv
}), fv = Mr("https://click11.hurry2.com/"), pv = Mr("https://central.zplay1.in/pb/api/"), hv = Mr("https://zplay1.in/"), gv = Mr("https://pool-main.zplay1.in"), _v = Mr("https://bonus.zplay1.in"), mv = Mr("https://new-notification.zplay1.in"), yv = Mr("https://api.transaction1.live/api/v1"), Zd = {
  user: fv,
  sports: pv,
  fantasy: hv,
  pool: gv,
  bonus: _v,
  notification: mv,
  wallet: yv
  // walletConfig: walletConigApiInstance,
  // walletRequest: walletRequestApiInstance,
};
Object.values(Zd).forEach((e) => {
  e.interceptors.response.use(
    (t) => Promise.resolve(t),
    (t) => uv(t)
  );
});
const cc = {
  user: {
    GET_SITE_SETTINGS: "api/site-settings",
    WALLET_BALANCE: "api/user-info",
    AUTH_REFRESH: "api/auth-refresh",
    LOGIN_API: "api/user-login",
    DEMO_LOGIN_API: "api/demo-user",
    LOGOUT_API: "api/logout",
    GET_FAVOURITE_LIST: "api/favorite-list",
    GET_EVENT_EXPOSURES: "api/get-event-book-and-fancy-exposures-by-event-id/:matchId",
    // OPEN_BETS_EVENT_LISTING: 'api/get-my-bets',
    SAVE_BETS: "api/save-bet",
    BET_CASHOUT: "api/cashout",
    GET_FANCY_BOOK: "api/get-fancy-book",
    MAKE_FAVOURITE: "api/make-event-favorite",
    CHANGE_STAKE_VALUES: "api/change-stake-values",
    GET_WALLET_GETWAY: "api/get-payment-getway-iframe-url",
    GET_CASINO_GAMES: "api/get-casino-games",
    GET_MY_MARKETS: "api/get-my-markets/:sport_type",
    GET_THIRD_PARTY_API: "api/load-third-party-url",
    GET_SITE_RULES: "api/get-site-rules",
    UPDATE_WALLET_TYPE: "api/wallet-switch",
    SEND_OTP: "api/send-otp",
    LOGIN_WITH_OTP: "api/login-with-otp",
    REGISTER: "api/registration",
    FORGOT_PASSWORD: "api/reset-forgot-password",
    CHANGE_MY_PASSWORD: "api/change-my-password",
    GET_SITE_VERSION: "api/site-status-version",
    GET_MATKA_SINGLE_BETS: "api/get-matka-single-bets/:id",
    SAVE_WORLI_MATKA_BET: "api/save-worli-matka-bet",
    GET_STATEMENTS: "api/get-statements",
    GET_STATEMENT_INFO: "api/get-statements-info",
    UPDATE_USER_NAME: "api/update-display-name",
    OPEN_BETS_EVENT_LISTING: "api/open-bets-event-listing",
    GET_PROFIT_LOSS: "api/get-user-pl-info",
    GET_PROFIT_LOSS_DETAIL: "api/get-profit-loss-detail",
    GET_PROFIT_LOSS_MATCH_DETAIL: "api/get-user-match-statements",
    GET_PROFIT_LOSS_PL_DETAIL: "api/get-user-pl-statements",
    // GET_MARKET_BETS: 'api/get-market-bets',
    GET_LIVE_POCKER_URL: "api/get-live-poker-url/:game_code",
    DREAM_CASINO: "api/dreamcasino/load-game/:game_code/:sm_id",
    UNIVERSE_CASINO: "api/universe/",
    GET_CHATBOT_IFRAME: "api/chatbot/get-iframe-url",
    GET_CHATBOT_IFRAME_GUEST: "api/chatbot/get-iframe-url-for-guest",
    GET_CHAT_LIST: "api/fetch-user-messages/:id",
    SEND_CHAT_MESSAGE: "api/send-message",
    DELETE_MESSAGE: "api/send-message",
    SEND_EDIT_MESSAGE: "api/editMessage",
    GET_ALL_MARKET_BOOK: "api/get-all-event-book-and-fancy-exposures-by-event-id",
    GET_BET_HISTORY: "api/get-my-bets",
    GET_MARKET_BETS: "api/my-markets",
    GET_OPEN_BETS: "api/get-open-bets",
    GET_SEARCH_EVENTS: "api/searching-event/:searchKey",
    CHANGE_USER_BONUS: "api/change-user-bonus",
    CHANGE_PASSWORD: "api/change-my-password",
    GET_BONUS_STATEMENT: "api/user-bonus-statement/:bonusType",
    REDEEM_USER_BONUS: "api/redeem-user-bonus",
    //BONUS
    GET_REFERED_USER: "api/get-referred-users",
    CLAIM_BONUS: "api/claim-bonus",
    //POOL ZONE
    JOIN_POOL: "api/join-pool",
    //AFFILIATE
    GET_AFFILIATE_DASHBOARD: "api/get-affiliate-dashboard",
    GET_AFFILIATE_USERSLIST: "api/get-affiliate-user-lists",
    GET_PROFIT_LOSS_EVENT_USERS: "api/get-affiliate-profit-loss-events",
    AFFILIATE_REGISTER: "api/add-user",
    GET_AFFILIATE_REGISTER_USER_COUNT: "api/get-affiliate-registered-users-count",
    GET_PAYMENT_WALLET_GETWAY: "api/get-payment-getway-token",
    GET_ID_WALLET_WITHDRAW: "api/get-id/wallet-withdraw"
  },
  pool: {
    GET_POOLS: "api/get-pools",
    POOL_LEADER_BOARD: "api/pool-leader-board",
    POOL_WALLET: "api/user-info",
    GET_FANCY_BOOK: "api/get-fancy-book",
    GET_EVENT_EXPOSURES: "api/get-event-book-and-fancy-exposures-by-event-id/:matchId",
    GET_POOL_OPEN_BETS: "api/pool-bets",
    GET_POOL_WINNERS: "api/pool-winners"
  },
  bonus: {
    GET_BONUS_LOGS: "api/v1/get-bonus-log",
    GET_BONUS_LOGS_DETAILS: "api/v1/get-bonus-log-details",
    GET_USER_LOCKED_BONUS: "api/v1/get-user-locked-bonus",
    GET_LOCKED_EARNED_BONUS: "api/v1/get-locked-earn-bonus"
  },
  notification: {
    NOTIFICATIONS_LIST_API: "api/get-notification",
    UNREAD_NOTIFICATION_COUNT: "api/get-unread-notifications-count",
    SUBSCRIBE_NOTIFICATION: "api/subscribe-notification"
  },
  sports: {
    MATCHES_BY_SPORT_ID: "v1/events/matches/:sport_id",
    GET_SPORTS: "v1/sports/management/getSport",
    GET_MATCH_DETAILS: "v1/events/matchDetails/:event_id",
    FIND_BY_IDS: "v1/events/findByIds",
    INPLAY_MATCHES_COUNT: "v1/events/count",
    GET_MATKAS: "/v1/worli/public/matches",
    GET_MATKA_MARKETS: "/v1/worli/public/matches/:id/all/markets",
    INPLAY_MATCHES_LIST: "v1/events/matches/inplay",
    GET_SPORTS_BOOK_URL: "/get-sap-sportsbook-url",
    GET_UPCOMING_SPORTS: "v1/events/sports/all",
    //POOL ZONE
    INPLAY_POOL_LIST: "v1/events/matches/inplay/pool"
  },
  fantasy: {
    FANTASY_SETUP_DATA: "/get-setup-data",
    GET_REMEMBERED_MATCHES: "/get-remembered-matches",
    ADD_MATCH_REMINDER: "/add-match-reminder",
    REMOVE_MATCH_REMINDER: "/remove-match-reminder",
    PLAYERS_LIST_API: "/get-match-players-list/:matchId",
    GET_MY_STAKES: "/get-my-stakes",
    UPDATE_MY_STAKES: "/update-my-stakes",
    ADD_MY_TEAM: "/add-my-team",
    UPDATE_MYTEAM_NAME: "/update-my-teamname",
    BET_DETAILS: "/get-match-bet-details",
    PLACE_BET: "/place-bet",
    MY_CONTESTS_LIST: "/get-my-contests",
    MY_CONTEST_BET_LIST: "/get-match-teams-and-bet-details",
    CANCEL_BET: "/cancel-bet",
    GET_TEAM_DETAILS: "/get-team-details/:id",
    RESET_MYTEAM: "/reset-my-team",
    GET_MATCHES_LIST: "/get-matches-list"
  },
  wallet: {
    //Config
    GET_WALLET_CONFIG: "client/config",
    UPDATE_TXN_PASSWORD: "client/update-txn-password",
    // Deposit
    PARENT_PAYMENT_METHODS: "client/accounts-master-list",
    GET_AUTO_UTR: "/api/user/get-auto-utr",
    WALLET_DEPOSIT: "client/client-account-transaction",
    PAYMENT_GATEWAY: "client/payment-url",
    // Withdraw
    ACCOUNT_DETAILS: "client/client-account",
    DELETE_ACCOUNT: "client/delete-client-account/:accountId",
    ADD_ACCOUNT: "client/create-client-account",
    UPLOAD_AND_FETCH_QR_DATA: "/dir/settings/getSignedUrl",
    // History
    WALLET_HISTORY: "client/client-account-transaction",
    SENT_OTP_TO_MOBILE: "client/transaction-password/send-otp",
    RESET_WITHDRAWAL_PASSWORD: "client/transaction-password/verify-otp",
    CANCEL_REQUEST: "client/cancel-transaction-request/:transactionId"
  }
}, ef = {
  "Content-Type": "application/json",
  Authorization: window.authorization_token
}, Ev = {
  "Content-Type": "application/json",
  Authorization: window.wallet_token
};
function tf() {
  ef.Authorization = window.authorization_token;
}
function LO() {
  Ev.Authorization = window.wallet_token;
}
let uc = null;
const vv = (e, t) => {
  const r = cc[t] && cc[t][e];
  if (!r)
    throw new Error(`Route not found for type: ${t} and name: ${e}`);
  return r;
}, $ = (e = "get", t, r = null, n = "user", s = null, i = null) => {
  if (!t)
    throw new Error("routeName is required");
  let o = vv(t, n), a = { ...ef };
  n == "fantasy" && (e == "get" ? o = "api/fantasycricket" + o : e == "post" && (o = "api/fantasy" + o, n = "user")), s && Object.keys(s).forEach((c) => {
    o.includes(`:${c}`) && (o = o.replace(`:${c}`, s[c]), delete s[c]);
  }), r instanceof FormData ? delete a["Content-Type"] : a["Content-Type"] = "application/json";
  let l = ["GET_SITE_SETTINGS", "GET_SITE_VERSION"];
  if (uc == "UPDATE_WALLET_TYPE" && t == "WALLET_BALANCE")
    return Promise.reject({ message: "Calling Wallet Switch", retry: !0 });
  uc = t;
  let u = {
    method: e,
    url: o,
    data: r,
    params: s
  };
  return n != "sports" && !l.includes(t) && (u.headers = a), Zd[n](u);
};
function pi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var vs = { exports: {} }, bv = vs.exports, dc;
function wv() {
  return dc || (dc = 1, (function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(bv, (function() {
      var r = 1e3, n = 6e4, s = 36e5, i = "millisecond", o = "second", a = "minute", l = "hour", u = "day", c = "week", d = "month", f = "quarter", _ = "year", g = "date", p = "Invalid Date", y = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, A = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, T = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(W) {
        var V = ["th", "st", "nd", "rd"], L = W % 100;
        return "[" + W + (V[(L - 20) % 10] || V[L] || V[0]) + "]";
      } }, b = function(W, V, L) {
        var R = String(W);
        return !R || R.length >= V ? W : "" + Array(V + 1 - R.length).join(L) + W;
      }, C = { s: b, z: function(W) {
        var V = -W.utcOffset(), L = Math.abs(V), R = Math.floor(L / 60), M = L % 60;
        return (V <= 0 ? "+" : "-") + b(R, 2, "0") + ":" + b(M, 2, "0");
      }, m: function W(V, L) {
        if (V.date() < L.date()) return -W(L, V);
        var R = 12 * (L.year() - V.year()) + (L.month() - V.month()), M = V.clone().add(R, d), w = L - M < 0, S = V.clone().add(R + (w ? -1 : 1), d);
        return +(-(R + (L - M) / (w ? M - S : S - M)) || 0);
      }, a: function(W) {
        return W < 0 ? Math.ceil(W) || 0 : Math.floor(W);
      }, p: function(W) {
        return { M: d, y: _, w: c, d: u, D: g, h: l, m: a, s: o, ms: i, Q: f }[W] || String(W || "").toLowerCase().replace(/s$/, "");
      }, u: function(W) {
        return W === void 0;
      } }, v = "en", Y = {};
      Y[v] = T;
      var K = "$isDayjsObject", ee = function(W) {
        return W instanceof le || !(!W || !W[K]);
      }, Q = function W(V, L, R) {
        var M;
        if (!V) return v;
        if (typeof V == "string") {
          var w = V.toLowerCase();
          Y[w] && (M = w), L && (Y[w] = L, M = w);
          var S = V.split("-");
          if (!M && S.length > 1) return W(S[0]);
        } else {
          var D = V.name;
          Y[D] = V, M = D;
        }
        return !R && M && (v = M), M || !R && v;
      }, Z = function(W, V) {
        if (ee(W)) return W.clone();
        var L = typeof V == "object" ? V : {};
        return L.date = W, L.args = arguments, new le(L);
      }, X = C;
      X.l = Q, X.i = ee, X.w = function(W, V) {
        return Z(W, { locale: V.$L, utc: V.$u, x: V.$x, $offset: V.$offset });
      };
      var le = (function() {
        function W(L) {
          this.$L = Q(L.locale, null, !0), this.parse(L), this.$x = this.$x || L.x || {}, this[K] = !0;
        }
        var V = W.prototype;
        return V.parse = function(L) {
          this.$d = (function(R) {
            var M = R.date, w = R.utc;
            if (M === null) return /* @__PURE__ */ new Date(NaN);
            if (X.u(M)) return /* @__PURE__ */ new Date();
            if (M instanceof Date) return new Date(M);
            if (typeof M == "string" && !/Z$/i.test(M)) {
              var S = M.match(y);
              if (S) {
                var D = S[2] - 1 || 0, G = (S[7] || "0").substring(0, 3);
                return w ? new Date(Date.UTC(S[1], D, S[3] || 1, S[4] || 0, S[5] || 0, S[6] || 0, G)) : new Date(S[1], D, S[3] || 1, S[4] || 0, S[5] || 0, S[6] || 0, G);
              }
            }
            return new Date(M);
          })(L), this.init();
        }, V.init = function() {
          var L = this.$d;
          this.$y = L.getFullYear(), this.$M = L.getMonth(), this.$D = L.getDate(), this.$W = L.getDay(), this.$H = L.getHours(), this.$m = L.getMinutes(), this.$s = L.getSeconds(), this.$ms = L.getMilliseconds();
        }, V.$utils = function() {
          return X;
        }, V.isValid = function() {
          return this.$d.toString() !== p;
        }, V.isSame = function(L, R) {
          var M = Z(L);
          return this.startOf(R) <= M && M <= this.endOf(R);
        }, V.isAfter = function(L, R) {
          return Z(L) < this.startOf(R);
        }, V.isBefore = function(L, R) {
          return this.endOf(R) < Z(L);
        }, V.$g = function(L, R, M) {
          return X.u(L) ? this[R] : this.set(M, L);
        }, V.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, V.valueOf = function() {
          return this.$d.getTime();
        }, V.startOf = function(L, R) {
          var M = this, w = !!X.u(R) || R, S = X.p(L), D = function(ne, re) {
            var de = X.w(M.$u ? Date.UTC(M.$y, re, ne) : new Date(M.$y, re, ne), M);
            return w ? de : de.endOf(u);
          }, G = function(ne, re) {
            return X.w(M.toDate()[ne].apply(M.toDate("s"), (w ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(re)), M);
          }, U = this.$W, te = this.$M, fe = this.$D, Se = "set" + (this.$u ? "UTC" : "");
          switch (S) {
            case _:
              return w ? D(1, 0) : D(31, 11);
            case d:
              return w ? D(1, te) : D(0, te + 1);
            case c:
              var ve = this.$locale().weekStart || 0, ye = (U < ve ? U + 7 : U) - ve;
              return D(w ? fe - ye : fe + (6 - ye), te);
            case u:
            case g:
              return G(Se + "Hours", 0);
            case l:
              return G(Se + "Minutes", 1);
            case a:
              return G(Se + "Seconds", 2);
            case o:
              return G(Se + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, V.endOf = function(L) {
          return this.startOf(L, !1);
        }, V.$set = function(L, R) {
          var M, w = X.p(L), S = "set" + (this.$u ? "UTC" : ""), D = (M = {}, M[u] = S + "Date", M[g] = S + "Date", M[d] = S + "Month", M[_] = S + "FullYear", M[l] = S + "Hours", M[a] = S + "Minutes", M[o] = S + "Seconds", M[i] = S + "Milliseconds", M)[w], G = w === u ? this.$D + (R - this.$W) : R;
          if (w === d || w === _) {
            var U = this.clone().set(g, 1);
            U.$d[D](G), U.init(), this.$d = U.set(g, Math.min(this.$D, U.daysInMonth())).$d;
          } else D && this.$d[D](G);
          return this.init(), this;
        }, V.set = function(L, R) {
          return this.clone().$set(L, R);
        }, V.get = function(L) {
          return this[X.p(L)]();
        }, V.add = function(L, R) {
          var M, w = this;
          L = Number(L);
          var S = X.p(R), D = function(te) {
            var fe = Z(w);
            return X.w(fe.date(fe.date() + Math.round(te * L)), w);
          };
          if (S === d) return this.set(d, this.$M + L);
          if (S === _) return this.set(_, this.$y + L);
          if (S === u) return D(1);
          if (S === c) return D(7);
          var G = (M = {}, M[a] = n, M[l] = s, M[o] = r, M)[S] || 1, U = this.$d.getTime() + L * G;
          return X.w(U, this);
        }, V.subtract = function(L, R) {
          return this.add(-1 * L, R);
        }, V.format = function(L) {
          var R = this, M = this.$locale();
          if (!this.isValid()) return M.invalidDate || p;
          var w = L || "YYYY-MM-DDTHH:mm:ssZ", S = X.z(this), D = this.$H, G = this.$m, U = this.$M, te = M.weekdays, fe = M.months, Se = M.meridiem, ve = function(re, de, Ie, h) {
            return re && (re[de] || re(R, w)) || Ie[de].slice(0, h);
          }, ye = function(re) {
            return X.s(D % 12 || 12, re, "0");
          }, ne = Se || function(re, de, Ie) {
            var h = re < 12 ? "AM" : "PM";
            return Ie ? h.toLowerCase() : h;
          };
          return w.replace(A, (function(re, de) {
            return de || (function(Ie) {
              switch (Ie) {
                case "YY":
                  return String(R.$y).slice(-2);
                case "YYYY":
                  return X.s(R.$y, 4, "0");
                case "M":
                  return U + 1;
                case "MM":
                  return X.s(U + 1, 2, "0");
                case "MMM":
                  return ve(M.monthsShort, U, fe, 3);
                case "MMMM":
                  return ve(fe, U);
                case "D":
                  return R.$D;
                case "DD":
                  return X.s(R.$D, 2, "0");
                case "d":
                  return String(R.$W);
                case "dd":
                  return ve(M.weekdaysMin, R.$W, te, 2);
                case "ddd":
                  return ve(M.weekdaysShort, R.$W, te, 3);
                case "dddd":
                  return te[R.$W];
                case "H":
                  return String(D);
                case "HH":
                  return X.s(D, 2, "0");
                case "h":
                  return ye(1);
                case "hh":
                  return ye(2);
                case "a":
                  return ne(D, G, !0);
                case "A":
                  return ne(D, G, !1);
                case "m":
                  return String(G);
                case "mm":
                  return X.s(G, 2, "0");
                case "s":
                  return String(R.$s);
                case "ss":
                  return X.s(R.$s, 2, "0");
                case "SSS":
                  return X.s(R.$ms, 3, "0");
                case "Z":
                  return S;
              }
              return null;
            })(re) || S.replace(":", "");
          }));
        }, V.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, V.diff = function(L, R, M) {
          var w, S = this, D = X.p(R), G = Z(L), U = (G.utcOffset() - this.utcOffset()) * n, te = this - G, fe = function() {
            return X.m(S, G);
          };
          switch (D) {
            case _:
              w = fe() / 12;
              break;
            case d:
              w = fe();
              break;
            case f:
              w = fe() / 3;
              break;
            case c:
              w = (te - U) / 6048e5;
              break;
            case u:
              w = (te - U) / 864e5;
              break;
            case l:
              w = te / s;
              break;
            case a:
              w = te / n;
              break;
            case o:
              w = te / r;
              break;
            default:
              w = te;
          }
          return M ? w : X.a(w);
        }, V.daysInMonth = function() {
          return this.endOf(d).$D;
        }, V.$locale = function() {
          return Y[this.$L];
        }, V.locale = function(L, R) {
          if (!L) return this.$L;
          var M = this.clone(), w = Q(L, R, !0);
          return w && (M.$L = w), M;
        }, V.clone = function() {
          return X.w(this.$d, this);
        }, V.toDate = function() {
          return new Date(this.valueOf());
        }, V.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, V.toISOString = function() {
          return this.$d.toISOString();
        }, V.toString = function() {
          return this.$d.toUTCString();
        }, W;
      })(), ae = le.prototype;
      return Z.prototype = ae, [["$ms", i], ["$s", o], ["$m", a], ["$H", l], ["$W", u], ["$M", d], ["$y", _], ["$D", g]].forEach((function(W) {
        ae[W[1]] = function(V) {
          return this.$g(V, W[0], W[1]);
        };
      })), Z.extend = function(W, V) {
        return W.$i || (W(V, le, Z), W.$i = !0), Z;
      }, Z.locale = Q, Z.isDayjs = ee, Z.unix = function(W) {
        return Z(1e3 * W);
      }, Z.en = Y[v], Z.Ls = Y, Z.p = {}, Z;
    }));
  })(vs)), vs.exports;
}
var Tv = wv();
const Me = /* @__PURE__ */ pi(Tv);
var bs = { exports: {} }, Sv = bs.exports, fc;
function Ov() {
  return fc || (fc = 1, (function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(Sv, (function() {
      var r = "minute", n = /[+-]\d\d(?::?\d\d)?/g, s = /([+-]|\d\d)/g;
      return function(i, o, a) {
        var l = o.prototype;
        a.utc = function(p) {
          var y = { date: p, utc: !0, args: arguments };
          return new o(y);
        }, l.utc = function(p) {
          var y = a(this.toDate(), { locale: this.$L, utc: !0 });
          return p ? y.add(this.utcOffset(), r) : y;
        }, l.local = function() {
          return a(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var u = l.parse;
        l.parse = function(p) {
          p.utc && (this.$u = !0), this.$utils().u(p.$offset) || (this.$offset = p.$offset), u.call(this, p);
        };
        var c = l.init;
        l.init = function() {
          if (this.$u) {
            var p = this.$d;
            this.$y = p.getUTCFullYear(), this.$M = p.getUTCMonth(), this.$D = p.getUTCDate(), this.$W = p.getUTCDay(), this.$H = p.getUTCHours(), this.$m = p.getUTCMinutes(), this.$s = p.getUTCSeconds(), this.$ms = p.getUTCMilliseconds();
          } else c.call(this);
        };
        var d = l.utcOffset;
        l.utcOffset = function(p, y) {
          var A = this.$utils().u;
          if (A(p)) return this.$u ? 0 : A(this.$offset) ? d.call(this) : this.$offset;
          if (typeof p == "string" && (p = (function(v) {
            v === void 0 && (v = "");
            var Y = v.match(n);
            if (!Y) return null;
            var K = ("" + Y[0]).match(s) || ["-", 0, 0], ee = K[0], Q = 60 * +K[1] + +K[2];
            return Q === 0 ? 0 : ee === "+" ? Q : -Q;
          })(p), p === null)) return this;
          var T = Math.abs(p) <= 16 ? 60 * p : p;
          if (T === 0) return this.utc(y);
          var b = this.clone();
          if (y) return b.$offset = T, b.$u = !1, b;
          var C = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          return (b = this.local().add(T + C, r)).$offset = T, b.$x.$localOffset = C, b;
        };
        var f = l.format;
        l.format = function(p) {
          var y = p || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return f.call(this, y);
        }, l.valueOf = function() {
          var p = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * p;
        }, l.isUTC = function() {
          return !!this.$u;
        }, l.toISOString = function() {
          return this.toDate().toISOString();
        }, l.toString = function() {
          return this.toDate().toUTCString();
        };
        var _ = l.toDate;
        l.toDate = function(p) {
          return p === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : _.call(this);
        };
        var g = l.diff;
        l.diff = function(p, y, A) {
          if (p && this.$u === p.$u) return g.call(this, p, y, A);
          var T = this.local(), b = a(p).local();
          return g.call(T, b, y, A);
        };
      };
    }));
  })(bs)), bs.exports;
}
var Av = Ov();
const Nv = /* @__PURE__ */ pi(Av);
var ws = { exports: {} }, Cv = ws.exports, pc;
function Dv() {
  return pc || (pc = 1, (function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(Cv, (function() {
      var r = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, n = {};
      return function(s, i, o) {
        var a, l = function(f, _, g) {
          g === void 0 && (g = {});
          var p = new Date(f), y = (function(A, T) {
            T === void 0 && (T = {});
            var b = T.timeZoneName || "short", C = A + "|" + b, v = n[C];
            return v || (v = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: A, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: b }), n[C] = v), v;
          })(_, g);
          return y.formatToParts(p);
        }, u = function(f, _) {
          for (var g = l(f, _), p = [], y = 0; y < g.length; y += 1) {
            var A = g[y], T = A.type, b = A.value, C = r[T];
            C >= 0 && (p[C] = parseInt(b, 10));
          }
          var v = p[3], Y = v === 24 ? 0 : v, K = p[0] + "-" + p[1] + "-" + p[2] + " " + Y + ":" + p[4] + ":" + p[5] + ":000", ee = +f;
          return (o.utc(K).valueOf() - (ee -= ee % 1e3)) / 6e4;
        }, c = i.prototype;
        c.tz = function(f, _) {
          f === void 0 && (f = a);
          var g, p = this.utcOffset(), y = this.toDate(), A = y.toLocaleString("en-US", { timeZone: f }), T = Math.round((y - new Date(A)) / 1e3 / 60), b = 15 * -Math.round(y.getTimezoneOffset() / 15) - T;
          if (!Number(b)) g = this.utcOffset(0, _);
          else if (g = o(A, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(b, !0), _) {
            var C = g.utcOffset();
            g = g.add(p - C, "minute");
          }
          return g.$x.$timezone = f, g;
        }, c.offsetName = function(f) {
          var _ = this.$x.$timezone || o.tz.guess(), g = l(this.valueOf(), _, { timeZoneName: f }).find((function(p) {
            return p.type.toLowerCase() === "timezonename";
          }));
          return g && g.value;
        };
        var d = c.startOf;
        c.startOf = function(f, _) {
          if (!this.$x || !this.$x.$timezone) return d.call(this, f, _);
          var g = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return d.call(g, f, _).tz(this.$x.$timezone, !0);
        }, o.tz = function(f, _, g) {
          var p = g && _, y = g || _ || a, A = u(+o(), y);
          if (typeof f != "string") return o(f).tz(y);
          var T = (function(Y, K, ee) {
            var Q = Y - 60 * K * 1e3, Z = u(Q, ee);
            if (K === Z) return [Q, K];
            var X = u(Q -= 60 * (Z - K) * 1e3, ee);
            return Z === X ? [Q, Z] : [Y - 60 * Math.min(Z, X) * 1e3, Math.max(Z, X)];
          })(o.utc(f, p).valueOf(), A, y), b = T[0], C = T[1], v = o(b).utcOffset(C);
          return v.$x.$timezone = y, v;
        }, o.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(f) {
          a = f;
        };
      };
    }));
  })(ws)), ws.exports;
}
var Iv = Dv();
const Mv = /* @__PURE__ */ pi(Iv);
var Ts = { exports: {} }, Lv = Ts.exports, hc;
function Rv() {
  return hc || (hc = 1, (function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(Lv, (function() {
      var r = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, n = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, s = /\d/, i = /\d\d/, o = /\d\d?/, a = /\d*[^-_:/,()\s\d]+/, l = {}, u = function(y) {
        return (y = +y) + (y > 68 ? 1900 : 2e3);
      }, c = function(y) {
        return function(A) {
          this[y] = +A;
        };
      }, d = [/[+-]\d\d:?(\d\d)?|Z/, function(y) {
        (this.zone || (this.zone = {})).offset = (function(A) {
          if (!A || A === "Z") return 0;
          var T = A.match(/([+-]|\d\d)/g), b = 60 * T[1] + (+T[2] || 0);
          return b === 0 ? 0 : T[0] === "+" ? -b : b;
        })(y);
      }], f = function(y) {
        var A = l[y];
        return A && (A.indexOf ? A : A.s.concat(A.f));
      }, _ = function(y, A) {
        var T, b = l.meridiem;
        if (b) {
          for (var C = 1; C <= 24; C += 1) if (y.indexOf(b(C, 0, A)) > -1) {
            T = C > 12;
            break;
          }
        } else T = y === (A ? "pm" : "PM");
        return T;
      }, g = { A: [a, function(y) {
        this.afternoon = _(y, !1);
      }], a: [a, function(y) {
        this.afternoon = _(y, !0);
      }], Q: [s, function(y) {
        this.month = 3 * (y - 1) + 1;
      }], S: [s, function(y) {
        this.milliseconds = 100 * +y;
      }], SS: [i, function(y) {
        this.milliseconds = 10 * +y;
      }], SSS: [/\d{3}/, function(y) {
        this.milliseconds = +y;
      }], s: [o, c("seconds")], ss: [o, c("seconds")], m: [o, c("minutes")], mm: [o, c("minutes")], H: [o, c("hours")], h: [o, c("hours")], HH: [o, c("hours")], hh: [o, c("hours")], D: [o, c("day")], DD: [i, c("day")], Do: [a, function(y) {
        var A = l.ordinal, T = y.match(/\d+/);
        if (this.day = T[0], A) for (var b = 1; b <= 31; b += 1) A(b).replace(/\[|\]/g, "") === y && (this.day = b);
      }], w: [o, c("week")], ww: [i, c("week")], M: [o, c("month")], MM: [i, c("month")], MMM: [a, function(y) {
        var A = f("months"), T = (f("monthsShort") || A.map((function(b) {
          return b.slice(0, 3);
        }))).indexOf(y) + 1;
        if (T < 1) throw new Error();
        this.month = T % 12 || T;
      }], MMMM: [a, function(y) {
        var A = f("months").indexOf(y) + 1;
        if (A < 1) throw new Error();
        this.month = A % 12 || A;
      }], Y: [/[+-]?\d+/, c("year")], YY: [i, function(y) {
        this.year = u(y);
      }], YYYY: [/\d{4}/, c("year")], Z: d, ZZ: d };
      function p(y) {
        var A, T;
        A = y, T = l && l.formats;
        for (var b = (y = A.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(Z, X, le) {
          var ae = le && le.toUpperCase();
          return X || T[le] || r[le] || T[ae].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(W, V, L) {
            return V || L.slice(1);
          }));
        }))).match(n), C = b.length, v = 0; v < C; v += 1) {
          var Y = b[v], K = g[Y], ee = K && K[0], Q = K && K[1];
          b[v] = Q ? { regex: ee, parser: Q } : Y.replace(/^\[|\]$/g, "");
        }
        return function(Z) {
          for (var X = {}, le = 0, ae = 0; le < C; le += 1) {
            var W = b[le];
            if (typeof W == "string") ae += W.length;
            else {
              var V = W.regex, L = W.parser, R = Z.slice(ae), M = V.exec(R)[0];
              L.call(X, M), Z = Z.replace(M, "");
            }
          }
          return (function(w) {
            var S = w.afternoon;
            if (S !== void 0) {
              var D = w.hours;
              S ? D < 12 && (w.hours += 12) : D === 12 && (w.hours = 0), delete w.afternoon;
            }
          })(X), X;
        };
      }
      return function(y, A, T) {
        T.p.customParseFormat = !0, y && y.parseTwoDigitYear && (u = y.parseTwoDigitYear);
        var b = A.prototype, C = b.parse;
        b.parse = function(v) {
          var Y = v.date, K = v.utc, ee = v.args;
          this.$u = K;
          var Q = ee[1];
          if (typeof Q == "string") {
            var Z = ee[2] === !0, X = ee[3] === !0, le = Z || X, ae = ee[2];
            X && (ae = ee[2]), l = this.$locale(), !Z && ae && (l = T.Ls[ae]), this.$d = (function(R, M, w, S) {
              try {
                if (["x", "X"].indexOf(M) > -1) return new Date((M === "X" ? 1e3 : 1) * R);
                var D = p(M)(R), G = D.year, U = D.month, te = D.day, fe = D.hours, Se = D.minutes, ve = D.seconds, ye = D.milliseconds, ne = D.zone, re = D.week, de = /* @__PURE__ */ new Date(), Ie = te || (G || U ? 1 : de.getDate()), h = G || de.getFullYear(), E = 0;
                G && !U || (E = U > 0 ? U - 1 : de.getMonth());
                var I, P = fe || 0, k = Se || 0, x = ve || 0, q = ye || 0;
                return ne ? new Date(Date.UTC(h, E, Ie, P, k, x, q + 60 * ne.offset * 1e3)) : w ? new Date(Date.UTC(h, E, Ie, P, k, x, q)) : (I = new Date(h, E, Ie, P, k, x, q), re && (I = S(I).week(re).toDate()), I);
              } catch {
                return /* @__PURE__ */ new Date("");
              }
            })(Y, Q, K, T), this.init(), ae && ae !== !0 && (this.$L = this.locale(ae).$L), le && Y != this.format(Q) && (this.$d = /* @__PURE__ */ new Date("")), l = {};
          } else if (Q instanceof Array) for (var W = Q.length, V = 1; V <= W; V += 1) {
            ee[1] = Q[V - 1];
            var L = T.apply(this, ee);
            if (L.isValid()) {
              this.$d = L.$d, this.$L = L.$L, this.init();
              break;
            }
            V === W && (this.$d = /* @__PURE__ */ new Date(""));
          }
          else C.call(this, v);
        };
      };
    }));
  })(Ts)), Ts.exports;
}
var kv = Rv();
const xv = /* @__PURE__ */ pi(kv);
Me.extend(Mv);
Me.extend(Nv);
Me.extend(xv);
const Te = {
  sportItemDate: (e, t = "D MMM, h:mm A", r = "Asia/Kolkata") => Me.utc(e).tz(r).format(t),
  NotInplaySportItemDateOnly(e, t = "DD MMM") {
    return Me(e).isSame(Me(), "day") ? "Today" : this.sportItemDate(e, t);
  },
  convertUnixDate: (e, t = "DD MMM YYYY HH:mm:ss") => Me.unix(e).format(t),
  currentTimestamp: () => Me().unix(),
  convertToTimestamp(e) {
    return Me(e).unix();
  },
  convertDateToTimstamp(e) {
    return Me(e).unix();
  },
  getcurrentDate: (e, t = "YYYY-MM-DD") => Me(e).format(t),
  getDateSaperatedByDays: (e, t = /* @__PURE__ */ new Date(), r = "YYYY-MM-DD") => Me(t).subtract(e, "day").format(r),
  getDateAddedByDays: (e, t = /* @__PURE__ */ new Date(), r = "YYYY-MM-DD") => Me(t).add(e, "day").format(r),
  convertOnlyTime: (e, t = "hh:mm A") => Me(e, "HH:mm").format(t),
  convertUtcDate: (e) => Me.utc(e),
  // Wallet
  getUTCTime: (e = "HH:mm:ss") => Me.utc().format(e),
  getPreviousDate: (e = 1, t = "YYYY-MM-DD") => Me().subtract(e, "day").format(t),
  getcurrentTime: (e = "HH:mm:ss") => Me().format(e),
  getLocalDate: (e, t = "DD MMM hh:mm A") => Me.utc(e).local().format(t),
  convertDate: (e, t = "DD MMM YYYY HH:mm:ss") => Me(e).format(t),
  // Matka
  isCurrentDateInRange: (e, t) => {
    const r = Me().startOf("day"), n = r.add(1, "day"), s = Me(e).startOf("day"), i = Me(t).startOf("day");
    if (s.isSame(r) && i.isSame(r))
      return "Today";
    if (s.isSame(n) && i.isSame(n))
      return "Tomorrow";
    if (s.isBefore(r) || i.isBefore(r))
      return s.format("DD-MM-YYYY");
  },
  convertDate: (e, t = "DD MMM YYYY HH:mm:ss") => Me(e).format(t),
  // affiliate -----------------------------------------
  getaffcurrentDate: (e, t = "YYYY-MM-DD") => Me(e).format(t)
};
/**
* @vue/shared v3.5.21
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
// @__NO_SIDE_EFFECTS__
function cn(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const r of e.split(",")) t[r] = 1;
  return (r) => r in t;
}
const Ce = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, In = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], ke = () => {
}, rf = () => !1, zn = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), Us = (e) => e.startsWith("onUpdate:"), Ve = Object.assign, La = (e, t) => {
  const r = e.indexOf(t);
  r > -1 && e.splice(r, 1);
}, Pv = Object.prototype.hasOwnProperty, we = (e, t) => Pv.call(e, t), ue = Array.isArray, jr = (e) => hi(e) === "[object Map]", $v = (e) => hi(e) === "[object Set]", pe = (e) => typeof e == "function", Pe = (e) => typeof e == "string", un = (e) => typeof e == "symbol", De = (e) => e !== null && typeof e == "object", Ra = (e) => (De(e) || pe(e)) && pe(e.then) && pe(e.catch), Fv = Object.prototype.toString, hi = (e) => Fv.call(e), ka = (e) => hi(e).slice(8, -1), Vv = (e) => hi(e) === "[object Object]", xa = (e) => Pe(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, Mn = /* @__PURE__ */ cn(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), Bv = /* @__PURE__ */ cn(
  "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
), gi = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return ((r) => t[r] || (t[r] = e(r)));
}, Uv = /-\w/g, mt = gi(
  (e) => e.replace(Uv, (t) => t.slice(1).toUpperCase())
), Hv = /\B([A-Z])/g, or = gi(
  (e) => e.replace(Hv, "-$1").toLowerCase()
), _i = gi((e) => e.charAt(0).toUpperCase() + e.slice(1)), hr = gi(
  (e) => e ? `on${_i(e)}` : ""
), br = (e, t) => !Object.is(e, t), En = (e, ...t) => {
  for (let r = 0; r < e.length; r++)
    e[r](...t);
}, Hs = (e, t, r, n = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: n,
    value: r
  });
}, jv = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
};
let gc;
const tr = () => gc || (gc = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function Pa(e) {
  if (ue(e)) {
    const t = {};
    for (let r = 0; r < e.length; r++) {
      const n = e[r], s = Pe(n) ? qv(n) : Pa(n);
      if (s)
        for (const i in s)
          t[i] = s[i];
    }
    return t;
  } else if (Pe(e) || De(e))
    return e;
}
const Yv = /;(?![^(]*\))/g, Gv = /:([^]+)/, Wv = /\/\*[^]*?\*\//g;
function qv(e) {
  const t = {};
  return e.replace(Wv, "").split(Yv).forEach((r) => {
    if (r) {
      const n = r.split(Gv);
      n.length > 1 && (t[n[0].trim()] = n[1].trim());
    }
  }), t;
}
function $a(e) {
  let t = "";
  if (Pe(e))
    t = e;
  else if (ue(e))
    for (let r = 0; r < e.length; r++) {
      const n = $a(e[r]);
      n && (t += n + " ");
    }
  else if (De(e))
    for (const r in e)
      e[r] && (t += r + " ");
  return t.trim();
}
const Kv = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", zv = /* @__PURE__ */ cn(Kv);
function nf(e) {
  return !!e || e === "";
}
/**
* @vue/reactivity v3.5.21
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function vt(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let Je;
class Jv {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = Je, !t && Je && (this.index = (Je.scopes || (Je.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let t, r;
      if (this.scopes)
        for (t = 0, r = this.scopes.length; t < r; t++)
          this.scopes[t].pause();
      for (t = 0, r = this.effects.length; t < r; t++)
        this.effects[t].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let t, r;
      if (this.scopes)
        for (t = 0, r = this.scopes.length; t < r; t++)
          this.scopes[t].resume();
      for (t = 0, r = this.effects.length; t < r; t++)
        this.effects[t].resume();
    }
  }
  run(t) {
    if (this._active) {
      const r = Je;
      try {
        return Je = this, t();
      } finally {
        Je = r;
      }
    } else process.env.NODE_ENV !== "production" && vt("cannot run an inactive effect scope.");
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    ++this._on === 1 && (this.prevScope = Je, Je = this);
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    this._on > 0 && --this._on === 0 && (Je = this.prevScope, this.prevScope = void 0);
  }
  stop(t) {
    if (this._active) {
      this._active = !1;
      let r, n;
      for (r = 0, n = this.effects.length; r < n; r++)
        this.effects[r].stop();
      for (this.effects.length = 0, r = 0, n = this.cleanups.length; r < n; r++)
        this.cleanups[r]();
      if (this.cleanups.length = 0, this.scopes) {
        for (r = 0, n = this.scopes.length; r < n; r++)
          this.scopes[r].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !t) {
        const s = this.parent.scopes.pop();
        s && s !== this && (this.parent.scopes[this.index] = s, s.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function Xv() {
  return Je;
}
let Ae;
const qi = /* @__PURE__ */ new WeakSet();
class sf {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, Je && Je.active && Je.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, qi.has(this) && (qi.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || af(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, _c(this), lf(this);
    const t = Ae, r = yt;
    Ae = this, yt = !0;
    try {
      return this.fn();
    } finally {
      process.env.NODE_ENV !== "production" && Ae !== this && vt(
        "Active effect was not restored correctly - this is likely a Vue internal bug."
      ), cf(this), Ae = t, yt = r, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        Ba(t);
      this.deps = this.depsTail = void 0, _c(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? qi.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    Uo(this) && this.run();
  }
  get dirty() {
    return Uo(this);
  }
}
let of = 0, Ln, Rn;
function af(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = Rn, Rn = e;
    return;
  }
  e.next = Ln, Ln = e;
}
function Fa() {
  of++;
}
function Va() {
  if (--of > 0)
    return;
  if (Rn) {
    let t = Rn;
    for (Rn = void 0; t; ) {
      const r = t.next;
      t.next = void 0, t.flags &= -9, t = r;
    }
  }
  let e;
  for (; Ln; ) {
    let t = Ln;
    for (Ln = void 0; t; ) {
      const r = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (n) {
          e || (e = n);
        }
      t = r;
    }
  }
  if (e) throw e;
}
function lf(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function cf(e) {
  let t, r = e.depsTail, n = r;
  for (; n; ) {
    const s = n.prevDep;
    n.version === -1 ? (n === r && (r = s), Ba(n), Qv(n)) : t = n, n.dep.activeLink = n.prevActiveLink, n.prevActiveLink = void 0, n = s;
  }
  e.deps = t, e.depsTail = r;
}
function Uo(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (uf(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function uf(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === Pn) || (e.globalVersion = Pn, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !Uo(e))))
    return;
  e.flags |= 2;
  const t = e.dep, r = Ae, n = yt;
  Ae = e, yt = !0;
  try {
    lf(e);
    const s = e.fn(e._value);
    (t.version === 0 || br(s, e._value)) && (e.flags |= 128, e._value = s, t.version++);
  } catch (s) {
    throw t.version++, s;
  } finally {
    Ae = r, yt = n, cf(e), e.flags &= -3;
  }
}
function Ba(e, t = !1) {
  const { dep: r, prevSub: n, nextSub: s } = e;
  if (n && (n.nextSub = s, e.prevSub = void 0), s && (s.prevSub = n, e.nextSub = void 0), process.env.NODE_ENV !== "production" && r.subsHead === e && (r.subsHead = s), r.subs === e && (r.subs = n, !n && r.computed)) {
    r.computed.flags &= -5;
    for (let i = r.computed.deps; i; i = i.nextDep)
      Ba(i, !0);
  }
  !t && !--r.sc && r.map && r.map.delete(r.key);
}
function Qv(e) {
  const { prevDep: t, nextDep: r } = e;
  t && (t.nextDep = r, e.prevDep = void 0), r && (r.prevDep = t, e.nextDep = void 0);
}
let yt = !0;
const df = [];
function bt() {
  df.push(yt), yt = !1;
}
function wt() {
  const e = df.pop();
  yt = e === void 0 ? !0 : e;
}
function _c(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const r = Ae;
    Ae = void 0;
    try {
      t();
    } finally {
      Ae = r;
    }
  }
}
let Pn = 0;
class Zv {
  constructor(t, r) {
    this.sub = t, this.dep = r, this.version = r.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class ff {
  // TODO isolatedDeclarations "__v_skip"
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
  }
  track(t) {
    if (!Ae || !yt || Ae === this.computed)
      return;
    let r = this.activeLink;
    if (r === void 0 || r.sub !== Ae)
      r = this.activeLink = new Zv(Ae, this), Ae.deps ? (r.prevDep = Ae.depsTail, Ae.depsTail.nextDep = r, Ae.depsTail = r) : Ae.deps = Ae.depsTail = r, pf(r);
    else if (r.version === -1 && (r.version = this.version, r.nextDep)) {
      const n = r.nextDep;
      n.prevDep = r.prevDep, r.prevDep && (r.prevDep.nextDep = n), r.prevDep = Ae.depsTail, r.nextDep = void 0, Ae.depsTail.nextDep = r, Ae.depsTail = r, Ae.deps === r && (Ae.deps = n);
    }
    return process.env.NODE_ENV !== "production" && Ae.onTrack && Ae.onTrack(
      Ve(
        {
          effect: Ae
        },
        t
      )
    ), r;
  }
  trigger(t) {
    this.version++, Pn++, this.notify(t);
  }
  notify(t) {
    Fa();
    try {
      if (process.env.NODE_ENV !== "production")
        for (let r = this.subsHead; r; r = r.nextSub)
          r.sub.onTrigger && !(r.sub.flags & 8) && r.sub.onTrigger(
            Ve(
              {
                effect: r.sub
              },
              t
            )
          );
      for (let r = this.subs; r; r = r.prevSub)
        r.sub.notify() && r.sub.dep.notify();
    } finally {
      Va();
    }
  }
}
function pf(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let n = t.deps; n; n = n.nextDep)
        pf(n);
    }
    const r = e.dep.subs;
    r !== e && (e.prevSub = r, r && (r.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
  }
}
const Ho = /* @__PURE__ */ new WeakMap(), wr = Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
), jo = Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
), $n = Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
function $e(e, t, r) {
  if (yt && Ae) {
    let n = Ho.get(e);
    n || Ho.set(e, n = /* @__PURE__ */ new Map());
    let s = n.get(r);
    s || (n.set(r, s = new ff()), s.map = n, s.key = r), process.env.NODE_ENV !== "production" ? s.track({
      target: e,
      type: t,
      key: r
    }) : s.track();
  }
}
function Lt(e, t, r, n, s, i) {
  const o = Ho.get(e);
  if (!o) {
    Pn++;
    return;
  }
  const a = (l) => {
    l && (process.env.NODE_ENV !== "production" ? l.trigger({
      target: e,
      type: t,
      key: r,
      newValue: n,
      oldValue: s,
      oldTarget: i
    }) : l.trigger());
  };
  if (Fa(), t === "clear")
    o.forEach(a);
  else {
    const l = ue(e), u = l && xa(r);
    if (l && r === "length") {
      const c = Number(n);
      o.forEach((d, f) => {
        (f === "length" || f === $n || !un(f) && f >= c) && a(d);
      });
    } else
      switch ((r !== void 0 || o.has(void 0)) && a(o.get(r)), u && a(o.get($n)), t) {
        case "add":
          l ? u && a(o.get("length")) : (a(o.get(wr)), jr(e) && a(o.get(jo)));
          break;
        case "delete":
          l || (a(o.get(wr)), jr(e) && a(o.get(jo)));
          break;
        case "set":
          jr(e) && a(o.get(wr));
          break;
      }
  }
  Va();
}
function xr(e) {
  const t = me(e);
  return t === e ? t : ($e(t, "iterate", $n), nt(e) ? t : t.map(tt));
}
function Ua(e) {
  return $e(e = me(e), "iterate", $n), e;
}
const e0 = {
  __proto__: null,
  [Symbol.iterator]() {
    return Ki(this, Symbol.iterator, tt);
  },
  concat(...e) {
    return xr(this).concat(
      ...e.map((t) => ue(t) ? xr(t) : t)
    );
  },
  entries() {
    return Ki(this, "entries", (e) => (e[1] = tt(e[1]), e));
  },
  every(e, t) {
    return jt(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return jt(this, "filter", e, t, (r) => r.map(tt), arguments);
  },
  find(e, t) {
    return jt(this, "find", e, t, tt, arguments);
  },
  findIndex(e, t) {
    return jt(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return jt(this, "findLast", e, t, tt, arguments);
  },
  findLastIndex(e, t) {
    return jt(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return jt(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return zi(this, "includes", e);
  },
  indexOf(...e) {
    return zi(this, "indexOf", e);
  },
  join(e) {
    return xr(this).join(e);
  },
  // keys() iterator only reads `length`, no optimization required
  lastIndexOf(...e) {
    return zi(this, "lastIndexOf", e);
  },
  map(e, t) {
    return jt(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return vn(this, "pop");
  },
  push(...e) {
    return vn(this, "push", e);
  },
  reduce(e, ...t) {
    return mc(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return mc(this, "reduceRight", e, t);
  },
  shift() {
    return vn(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return jt(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return vn(this, "splice", e);
  },
  toReversed() {
    return xr(this).toReversed();
  },
  toSorted(e) {
    return xr(this).toSorted(e);
  },
  toSpliced(...e) {
    return xr(this).toSpliced(...e);
  },
  unshift(...e) {
    return vn(this, "unshift", e);
  },
  values() {
    return Ki(this, "values", tt);
  }
};
function Ki(e, t, r) {
  const n = Ua(e), s = n[t]();
  return n !== e && !nt(e) && (s._next = s.next, s.next = () => {
    const i = s._next();
    return i.value && (i.value = r(i.value)), i;
  }), s;
}
const t0 = Array.prototype;
function jt(e, t, r, n, s, i) {
  const o = Ua(e), a = o !== e && !nt(e), l = o[t];
  if (l !== t0[t]) {
    const d = l.apply(e, i);
    return a ? tt(d) : d;
  }
  let u = r;
  o !== e && (a ? u = function(d, f) {
    return r.call(this, tt(d), f, e);
  } : r.length > 2 && (u = function(d, f) {
    return r.call(this, d, f, e);
  }));
  const c = l.call(o, u, n);
  return a && s ? s(c) : c;
}
function mc(e, t, r, n) {
  const s = Ua(e);
  let i = r;
  return s !== e && (nt(e) ? r.length > 3 && (i = function(o, a, l) {
    return r.call(this, o, a, l, e);
  }) : i = function(o, a, l) {
    return r.call(this, o, tt(a), l, e);
  }), s[t](i, ...n);
}
function zi(e, t, r) {
  const n = me(e);
  $e(n, "iterate", $n);
  const s = n[t](...r);
  return (s === -1 || s === !1) && js(r[0]) ? (r[0] = me(r[0]), n[t](...r)) : s;
}
function vn(e, t, r = []) {
  bt(), Fa();
  const n = me(e)[t].apply(e, r);
  return Va(), wt(), n;
}
const r0 = /* @__PURE__ */ cn("__proto__,__v_isRef,__isVue"), hf = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(un)
);
function n0(e) {
  un(e) || (e = String(e));
  const t = me(this);
  return $e(t, "has", e), t.hasOwnProperty(e);
}
class gf {
  constructor(t = !1, r = !1) {
    this._isReadonly = t, this._isShallow = r;
  }
  get(t, r, n) {
    if (r === "__v_skip") return t.__v_skip;
    const s = this._isReadonly, i = this._isShallow;
    if (r === "__v_isReactive")
      return !s;
    if (r === "__v_isReadonly")
      return s;
    if (r === "__v_isShallow")
      return i;
    if (r === "__v_raw")
      return n === (s ? i ? bf : vf : i ? Ef : yf).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(n) ? t : void 0;
    const o = ue(t);
    if (!s) {
      let l;
      if (o && (l = e0[r]))
        return l;
      if (r === "hasOwnProperty")
        return n0;
    }
    const a = Reflect.get(
      t,
      r,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      Fe(t) ? t : n
    );
    return (un(r) ? hf.has(r) : r0(r)) || (s || $e(t, "get", r), i) ? a : Fe(a) ? o && xa(r) ? a : a.value : De(a) ? s ? wf(a) : Ha(a) : a;
  }
}
class _f extends gf {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, r, n, s) {
    let i = t[r];
    if (!this._isShallow) {
      const l = ar(i);
      if (!nt(n) && !ar(n) && (i = me(i), n = me(n)), !ue(t) && Fe(i) && !Fe(n))
        return l ? (process.env.NODE_ENV !== "production" && vt(
          `Set operation on key "${String(r)}" failed: target is readonly.`,
          t[r]
        ), !0) : (i.value = n, !0);
    }
    const o = ue(t) && xa(r) ? Number(r) < t.length : we(t, r), a = Reflect.set(
      t,
      r,
      n,
      Fe(t) ? t : s
    );
    return t === me(s) && (o ? br(n, i) && Lt(t, "set", r, n, i) : Lt(t, "add", r, n)), a;
  }
  deleteProperty(t, r) {
    const n = we(t, r), s = t[r], i = Reflect.deleteProperty(t, r);
    return i && n && Lt(t, "delete", r, void 0, s), i;
  }
  has(t, r) {
    const n = Reflect.has(t, r);
    return (!un(r) || !hf.has(r)) && $e(t, "has", r), n;
  }
  ownKeys(t) {
    return $e(
      t,
      "iterate",
      ue(t) ? "length" : wr
    ), Reflect.ownKeys(t);
  }
}
class mf extends gf {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, r) {
    return process.env.NODE_ENV !== "production" && vt(
      `Set operation on key "${String(r)}" failed: target is readonly.`,
      t
    ), !0;
  }
  deleteProperty(t, r) {
    return process.env.NODE_ENV !== "production" && vt(
      `Delete operation on key "${String(r)}" failed: target is readonly.`,
      t
    ), !0;
  }
}
const s0 = /* @__PURE__ */ new _f(), i0 = /* @__PURE__ */ new mf(), o0 = /* @__PURE__ */ new _f(!0), a0 = /* @__PURE__ */ new mf(!0), Yo = (e) => e, ls = (e) => Reflect.getPrototypeOf(e);
function l0(e, t, r) {
  return function(...n) {
    const s = this.__v_raw, i = me(s), o = jr(i), a = e === "entries" || e === Symbol.iterator && o, l = e === "keys" && o, u = s[e](...n), c = r ? Yo : t ? Go : tt;
    return !t && $e(
      i,
      "iterate",
      l ? jo : wr
    ), {
      // iterator protocol
      next() {
        const { value: d, done: f } = u.next();
        return f ? { value: d, done: f } : {
          value: a ? [c(d[0]), c(d[1])] : c(d),
          done: f
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function cs(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const r = t[0] ? `on key "${t[0]}" ` : "";
      vt(
        `${_i(e)} operation ${r}failed: target is readonly.`,
        me(this)
      );
    }
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function c0(e, t) {
  const r = {
    get(s) {
      const i = this.__v_raw, o = me(i), a = me(s);
      e || (br(s, a) && $e(o, "get", s), $e(o, "get", a));
      const { has: l } = ls(o), u = t ? Yo : e ? Go : tt;
      if (l.call(o, s))
        return u(i.get(s));
      if (l.call(o, a))
        return u(i.get(a));
      i !== o && i.get(s);
    },
    get size() {
      const s = this.__v_raw;
      return !e && $e(me(s), "iterate", wr), s.size;
    },
    has(s) {
      const i = this.__v_raw, o = me(i), a = me(s);
      return e || (br(s, a) && $e(o, "has", s), $e(o, "has", a)), s === a ? i.has(s) : i.has(s) || i.has(a);
    },
    forEach(s, i) {
      const o = this, a = o.__v_raw, l = me(a), u = t ? Yo : e ? Go : tt;
      return !e && $e(l, "iterate", wr), a.forEach((c, d) => s.call(i, u(c), u(d), o));
    }
  };
  return Ve(
    r,
    e ? {
      add: cs("add"),
      set: cs("set"),
      delete: cs("delete"),
      clear: cs("clear")
    } : {
      add(s) {
        !t && !nt(s) && !ar(s) && (s = me(s));
        const i = me(this);
        return ls(i).has.call(i, s) || (i.add(s), Lt(i, "add", s, s)), this;
      },
      set(s, i) {
        !t && !nt(i) && !ar(i) && (i = me(i));
        const o = me(this), { has: a, get: l } = ls(o);
        let u = a.call(o, s);
        u ? process.env.NODE_ENV !== "production" && yc(o, a, s) : (s = me(s), u = a.call(o, s));
        const c = l.call(o, s);
        return o.set(s, i), u ? br(i, c) && Lt(o, "set", s, i, c) : Lt(o, "add", s, i), this;
      },
      delete(s) {
        const i = me(this), { has: o, get: a } = ls(i);
        let l = o.call(i, s);
        l ? process.env.NODE_ENV !== "production" && yc(i, o, s) : (s = me(s), l = o.call(i, s));
        const u = a ? a.call(i, s) : void 0, c = i.delete(s);
        return l && Lt(i, "delete", s, void 0, u), c;
      },
      clear() {
        const s = me(this), i = s.size !== 0, o = process.env.NODE_ENV !== "production" ? jr(s) ? new Map(s) : new Set(s) : void 0, a = s.clear();
        return i && Lt(
          s,
          "clear",
          void 0,
          void 0,
          o
        ), a;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((s) => {
    r[s] = l0(s, e, t);
  }), r;
}
function mi(e, t) {
  const r = c0(e, t);
  return (n, s, i) => s === "__v_isReactive" ? !e : s === "__v_isReadonly" ? e : s === "__v_raw" ? n : Reflect.get(
    we(r, s) && s in n ? r : n,
    s,
    i
  );
}
const u0 = {
  get: /* @__PURE__ */ mi(!1, !1)
}, d0 = {
  get: /* @__PURE__ */ mi(!1, !0)
}, f0 = {
  get: /* @__PURE__ */ mi(!0, !1)
}, p0 = {
  get: /* @__PURE__ */ mi(!0, !0)
};
function yc(e, t, r) {
  const n = me(r);
  if (n !== r && t.call(e, n)) {
    const s = ka(e);
    vt(
      `Reactive ${s} contains both the raw and reactive versions of the same object${s === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const yf = /* @__PURE__ */ new WeakMap(), Ef = /* @__PURE__ */ new WeakMap(), vf = /* @__PURE__ */ new WeakMap(), bf = /* @__PURE__ */ new WeakMap();
function h0(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function g0(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : h0(ka(e));
}
function Ha(e) {
  return ar(e) ? e : yi(
    e,
    !1,
    s0,
    u0,
    yf
  );
}
function _0(e) {
  return yi(
    e,
    !1,
    o0,
    d0,
    Ef
  );
}
function wf(e) {
  return yi(
    e,
    !0,
    i0,
    f0,
    vf
  );
}
function Rt(e) {
  return yi(
    e,
    !0,
    a0,
    p0,
    bf
  );
}
function yi(e, t, r, n, s) {
  if (!De(e))
    return process.env.NODE_ENV !== "production" && vt(
      `value cannot be made ${t ? "readonly" : "reactive"}: ${String(
        e
      )}`
    ), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const i = g0(e);
  if (i === 0)
    return e;
  const o = s.get(e);
  if (o)
    return o;
  const a = new Proxy(
    e,
    i === 2 ? n : r
  );
  return s.set(e, a), a;
}
function Yr(e) {
  return ar(e) ? Yr(e.__v_raw) : !!(e && e.__v_isReactive);
}
function ar(e) {
  return !!(e && e.__v_isReadonly);
}
function nt(e) {
  return !!(e && e.__v_isShallow);
}
function js(e) {
  return e ? !!e.__v_raw : !1;
}
function me(e) {
  const t = e && e.__v_raw;
  return t ? me(t) : e;
}
function m0(e) {
  return !we(e, "__v_skip") && Object.isExtensible(e) && Hs(e, "__v_skip", !0), e;
}
const tt = (e) => De(e) ? Ha(e) : e, Go = (e) => De(e) ? wf(e) : e;
function Fe(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function y0(e) {
  return Fe(e) ? e.value : e;
}
const E0 = {
  get: (e, t, r) => t === "__v_raw" ? e : y0(Reflect.get(e, t, r)),
  set: (e, t, r, n) => {
    const s = e[t];
    return Fe(s) && !Fe(r) ? (s.value = r, !0) : Reflect.set(e, t, r, n);
  }
};
function Tf(e) {
  return Yr(e) ? e : new Proxy(e, E0);
}
class v0 {
  constructor(t, r, n) {
    this.fn = t, this.setter = r, this._value = void 0, this.dep = new ff(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = Pn - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !r, this.isSSR = n;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    Ae !== this)
      return af(this, !0), !0;
    process.env.NODE_ENV;
  }
  get value() {
    const t = process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track();
    return uf(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter ? this.setter(t) : process.env.NODE_ENV !== "production" && vt("Write operation failed: computed value is readonly");
  }
}
function b0(e, t, r = !1) {
  let n, s;
  pe(e) ? n = e : (n = e.get, s = e.set);
  const i = new v0(n, s, r);
  return process.env.NODE_ENV, i;
}
const us = {}, Ys = /* @__PURE__ */ new WeakMap();
let gr;
function w0(e, t = !1, r = gr) {
  if (r) {
    let n = Ys.get(r);
    n || Ys.set(r, n = []), n.push(e);
  } else process.env.NODE_ENV !== "production" && !t && vt(
    "onWatcherCleanup() was called when there was no active watcher to associate with."
  );
}
function T0(e, t, r = Ce) {
  const { immediate: n, deep: s, once: i, scheduler: o, augmentJob: a, call: l } = r, u = (v) => {
    (r.onWarn || vt)(
      "Invalid watch source: ",
      v,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, c = (v) => s ? v : nt(v) || s === !1 || s === 0 ? er(v, 1) : er(v);
  let d, f, _, g, p = !1, y = !1;
  if (Fe(e) ? (f = () => e.value, p = nt(e)) : Yr(e) ? (f = () => c(e), p = !0) : ue(e) ? (y = !0, p = e.some((v) => Yr(v) || nt(v)), f = () => e.map((v) => {
    if (Fe(v))
      return v.value;
    if (Yr(v))
      return c(v);
    if (pe(v))
      return l ? l(v, 2) : v();
    process.env.NODE_ENV !== "production" && u(v);
  })) : pe(e) ? t ? f = l ? () => l(e, 2) : e : f = () => {
    if (_) {
      bt();
      try {
        _();
      } finally {
        wt();
      }
    }
    const v = gr;
    gr = d;
    try {
      return l ? l(e, 3, [g]) : e(g);
    } finally {
      gr = v;
    }
  } : (f = ke, process.env.NODE_ENV !== "production" && u(e)), t && s) {
    const v = f, Y = s === !0 ? 1 / 0 : s;
    f = () => er(v(), Y);
  }
  const A = Xv(), T = () => {
    d.stop(), A && A.active && La(A.effects, d);
  };
  if (i && t) {
    const v = t;
    t = (...Y) => {
      v(...Y), T();
    };
  }
  let b = y ? new Array(e.length).fill(us) : us;
  const C = (v) => {
    if (!(!(d.flags & 1) || !d.dirty && !v))
      if (t) {
        const Y = d.run();
        if (s || p || (y ? Y.some((K, ee) => br(K, b[ee])) : br(Y, b))) {
          _ && _();
          const K = gr;
          gr = d;
          try {
            const ee = [
              Y,
              // pass undefined as the old value when it's changed for the first time
              b === us ? void 0 : y && b[0] === us ? [] : b,
              g
            ];
            b = Y, l ? l(t, 3, ee) : (
              // @ts-expect-error
              t(...ee)
            );
          } finally {
            gr = K;
          }
        }
      } else
        d.run();
  };
  return a && a(C), d = new sf(f), d.scheduler = o ? () => o(C, !1) : C, g = (v) => w0(v, !1, d), _ = d.onStop = () => {
    const v = Ys.get(d);
    if (v) {
      if (l)
        l(v, 4);
      else
        for (const Y of v) Y();
      Ys.delete(d);
    }
  }, process.env.NODE_ENV !== "production" && (d.onTrack = r.onTrack, d.onTrigger = r.onTrigger), t ? n ? C(!0) : b = d.run() : o ? o(C.bind(null, !0), !0) : d.run(), T.pause = d.pause.bind(d), T.resume = d.resume.bind(d), T.stop = T, T;
}
function er(e, t = 1 / 0, r) {
  if (t <= 0 || !De(e) || e.__v_skip || (r = r || /* @__PURE__ */ new Map(), (r.get(e) || 0) >= t))
    return e;
  if (r.set(e, t), t--, Fe(e))
    er(e.value, t, r);
  else if (ue(e))
    for (let n = 0; n < e.length; n++)
      er(e[n], t, r);
  else if ($v(e) || jr(e))
    e.forEach((n) => {
      er(n, t, r);
    });
  else if (Vv(e)) {
    for (const n in e)
      er(e[n], t, r);
    for (const n of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, n) && er(e[n], t, r);
  }
  return e;
}
/**
* @vue/runtime-core v3.5.21
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const Tr = [];
function Ss(e) {
  Tr.push(e);
}
function Os() {
  Tr.pop();
}
let Ji = !1;
function z(e, ...t) {
  if (Ji) return;
  Ji = !0, bt();
  const r = Tr.length ? Tr[Tr.length - 1].component : null, n = r && r.appContext.config.warnHandler, s = S0();
  if (n)
    dn(
      n,
      r,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((i) => {
          var o, a;
          return (a = (o = i.toString) == null ? void 0 : o.call(i)) != null ? a : JSON.stringify(i);
        }).join(""),
        r && r.proxy,
        s.map(
          ({ vnode: i }) => `at <${wi(r, i.type)}>`
        ).join(`
`),
        s
      ]
    );
  else {
    const i = [`[Vue warn]: ${e}`, ...t];
    s.length && i.push(`
`, ...O0(s)), console.warn(...i);
  }
  wt(), Ji = !1;
}
function S0() {
  let e = Tr[Tr.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const r = t[0];
    r && r.vnode === e ? r.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const n = e.component && e.component.parent;
    e = n && n.vnode;
  }
  return t;
}
function O0(e) {
  const t = [];
  return e.forEach((r, n) => {
    t.push(...n === 0 ? [] : [`
`], ...A0(r));
  }), t;
}
function A0({ vnode: e, recurseCount: t }) {
  const r = t > 0 ? `... (${t} recursive calls)` : "", n = e.component ? e.component.parent == null : !1, s = ` at <${wi(
    e.component,
    e.type,
    n
  )}`, i = ">" + r;
  return e.props ? [s, ...N0(e.props), i] : [s + i];
}
function N0(e) {
  const t = [], r = Object.keys(e);
  return r.slice(0, 3).forEach((n) => {
    t.push(...Sf(n, e[n]));
  }), r.length > 3 && t.push(" ..."), t;
}
function Sf(e, t, r) {
  return Pe(t) ? (t = JSON.stringify(t), r ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? r ? t : [`${e}=${t}`] : Fe(t) ? (t = Sf(e, me(t.value), !0), r ? t : [`${e}=Ref<`, t, ">"]) : pe(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = me(t), r ? t : [`${e}=`, t]);
}
const ja = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function dn(e, t, r, n) {
  try {
    return n ? e(...n) : e();
  } catch (s) {
    Jn(s, t, r);
  }
}
function Ut(e, t, r, n) {
  if (pe(e)) {
    const s = dn(e, t, r, n);
    return s && Ra(s) && s.catch((i) => {
      Jn(i, t, r);
    }), s;
  }
  if (ue(e)) {
    const s = [];
    for (let i = 0; i < e.length; i++)
      s.push(Ut(e[i], t, r, n));
    return s;
  } else process.env.NODE_ENV !== "production" && z(
    `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`
  );
}
function Jn(e, t, r, n = !0) {
  const s = t ? t.vnode : null, { errorHandler: i, throwUnhandledErrorInProduction: o } = t && t.appContext.config || Ce;
  if (t) {
    let a = t.parent;
    const l = t.proxy, u = process.env.NODE_ENV !== "production" ? ja[r] : `https://vuejs.org/error-reference/#runtime-${r}`;
    for (; a; ) {
      const c = a.ec;
      if (c) {
        for (let d = 0; d < c.length; d++)
          if (c[d](e, l, u) === !1)
            return;
      }
      a = a.parent;
    }
    if (i) {
      bt(), dn(i, null, 10, [
        e,
        l,
        u
      ]), wt();
      return;
    }
  }
  C0(e, r, s, n, o);
}
function C0(e, t, r, n = !0, s = !1) {
  if (process.env.NODE_ENV !== "production") {
    const i = ja[t];
    if (r && Ss(r), z(`Unhandled error${i ? ` during execution of ${i}` : ""}`), r && Os(), n)
      throw e;
    console.error(e);
  } else {
    if (s)
      throw e;
    console.error(e);
  }
}
const Ge = [];
let It = -1;
const Gr = [];
let Qt = null, Ur = 0;
const Of = /* @__PURE__ */ Promise.resolve();
let Gs = null;
const D0 = 100;
function I0(e) {
  const t = Gs || Of;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function M0(e) {
  let t = It + 1, r = Ge.length;
  for (; t < r; ) {
    const n = t + r >>> 1, s = Ge[n], i = Fn(s);
    i < e || i === e && s.flags & 2 ? t = n + 1 : r = n;
  }
  return t;
}
function Ei(e) {
  if (!(e.flags & 1)) {
    const t = Fn(e), r = Ge[Ge.length - 1];
    !r || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= Fn(r) ? Ge.push(e) : Ge.splice(M0(t), 0, e), e.flags |= 1, Af();
  }
}
function Af() {
  Gs || (Gs = Of.then(Df));
}
function Nf(e) {
  ue(e) ? Gr.push(...e) : Qt && e.id === -1 ? Qt.splice(Ur + 1, 0, e) : e.flags & 1 || (Gr.push(e), e.flags |= 1), Af();
}
function Ec(e, t, r = It + 1) {
  for (process.env.NODE_ENV !== "production" && (t = t || /* @__PURE__ */ new Map()); r < Ge.length; r++) {
    const n = Ge[r];
    if (n && n.flags & 2) {
      if (e && n.id !== e.uid || process.env.NODE_ENV !== "production" && Ya(t, n))
        continue;
      Ge.splice(r, 1), r--, n.flags & 4 && (n.flags &= -2), n(), n.flags & 4 || (n.flags &= -2);
    }
  }
}
function Cf(e) {
  if (Gr.length) {
    const t = [...new Set(Gr)].sort(
      (r, n) => Fn(r) - Fn(n)
    );
    if (Gr.length = 0, Qt) {
      Qt.push(...t);
      return;
    }
    for (Qt = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), Ur = 0; Ur < Qt.length; Ur++) {
      const r = Qt[Ur];
      process.env.NODE_ENV !== "production" && Ya(e, r) || (r.flags & 4 && (r.flags &= -2), r.flags & 8 || r(), r.flags &= -2);
    }
    Qt = null, Ur = 0;
  }
}
const Fn = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function Df(e) {
  process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map());
  const t = process.env.NODE_ENV !== "production" ? (r) => Ya(e, r) : ke;
  try {
    for (It = 0; It < Ge.length; It++) {
      const r = Ge[It];
      if (r && !(r.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && t(r))
          continue;
        r.flags & 4 && (r.flags &= -2), dn(
          r,
          r.i,
          r.i ? 15 : 14
        ), r.flags & 4 || (r.flags &= -2);
      }
    }
  } finally {
    for (; It < Ge.length; It++) {
      const r = Ge[It];
      r && (r.flags &= -2);
    }
    It = -1, Ge.length = 0, Cf(e), Gs = null, (Ge.length || Gr.length) && Df(e);
  }
}
function Ya(e, t) {
  const r = e.get(t) || 0;
  if (r > D0) {
    const n = t.i, s = n && lp(n.type);
    return Jn(
      `Maximum recursive updates exceeded${s ? ` in component <${s}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return e.set(t, r + 1), !1;
}
let kt = !1;
const As = /* @__PURE__ */ new Map();
if (process.env.NODE_ENV !== "production") {
  const e = tr();
  e.__VUE_HMR_RUNTIME__ || (e.__VUE_HMR_RUNTIME__ = {
    createRecord: Xi(If),
    rerender: Xi(k0),
    reload: Xi(x0)
  });
}
const Cr = /* @__PURE__ */ new Map();
function L0(e) {
  const t = e.type.__hmrId;
  let r = Cr.get(t);
  r || (If(t, e.type), r = Cr.get(t)), r.instances.add(e);
}
function R0(e) {
  Cr.get(e.type.__hmrId).instances.delete(e);
}
function If(e, t) {
  return Cr.has(e) ? !1 : (Cr.set(e, {
    initialDef: Ws(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function Ws(e) {
  return cp(e) ? e.__vccOpts : e;
}
function k0(e, t) {
  const r = Cr.get(e);
  r && (r.initialDef.render = t, [...r.instances].forEach((n) => {
    t && (n.render = t, Ws(n.type).render = t), n.renderCache = [], kt = !0, n.job.flags & 8 || n.update(), kt = !1;
  }));
}
function x0(e, t) {
  const r = Cr.get(e);
  if (!r) return;
  t = Ws(t), vc(r.initialDef, t);
  const n = [...r.instances];
  for (let s = 0; s < n.length; s++) {
    const i = n[s], o = Ws(i.type);
    let a = As.get(o);
    a || (o !== r.initialDef && vc(o, t), As.set(o, a = /* @__PURE__ */ new Set())), a.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (a.add(i), i.ceReload(t.styles), a.delete(i)) : i.parent ? Ei(() => {
      i.job.flags & 8 || (kt = !0, i.parent.update(), kt = !1, a.delete(i));
    }) : i.appContext.reload ? i.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(o);
  }
  Nf(() => {
    As.clear();
  });
}
function vc(e, t) {
  Ve(e, t);
  for (const r in e)
    r !== "__file" && !(r in t) && delete e[r];
}
function Xi(e) {
  return (t, r) => {
    try {
      return e(t, r);
    } catch (n) {
      console.error(n), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let gt, On = [], Wo = !1;
function Xn(e, ...t) {
  gt ? gt.emit(e, ...t) : Wo || On.push({ event: e, args: t });
}
function Ga(e, t) {
  var r, n;
  gt = e, gt ? (gt.enabled = !0, On.forEach(({ event: s, args: i }) => gt.emit(s, ...i)), On = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((n = (r = window.navigator) == null ? void 0 : r.userAgent) != null && n.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((i) => {
    Ga(i, t);
  }), setTimeout(() => {
    gt || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, Wo = !0, On = []);
  }, 3e3)) : (Wo = !0, On = []);
}
function P0(e, t) {
  Xn("app:init", e, t, {
    Fragment: Mt,
    Text: Qn,
    Comment: Et,
    Static: Ds
  });
}
function $0(e) {
  Xn("app:unmount", e);
}
const F0 = /* @__PURE__ */ Wa(
  "component:added"
  /* COMPONENT_ADDED */
), Mf = /* @__PURE__ */ Wa(
  "component:updated"
  /* COMPONENT_UPDATED */
), V0 = /* @__PURE__ */ Wa(
  "component:removed"
  /* COMPONENT_REMOVED */
), B0 = (e) => {
  gt && typeof gt.cleanupBuffer == "function" && // remove the component if it wasn't buffered
  !gt.cleanupBuffer(e) && V0(e);
};
// @__NO_SIDE_EFFECTS__
function Wa(e) {
  return (t) => {
    Xn(
      e,
      t.appContext.app,
      t.uid,
      t.parent ? t.parent.uid : void 0,
      t
    );
  };
}
const U0 = /* @__PURE__ */ Lf(
  "perf:start"
  /* PERFORMANCE_START */
), H0 = /* @__PURE__ */ Lf(
  "perf:end"
  /* PERFORMANCE_END */
);
function Lf(e) {
  return (t, r, n) => {
    Xn(e, t.appContext.app, t.uid, t, r, n);
  };
}
function j0(e, t, r) {
  Xn(
    "component:emit",
    e.appContext.app,
    e,
    t,
    r
  );
}
let rt = null, Rf = null;
function qs(e) {
  const t = rt;
  return rt = e, Rf = e && e.type.__scopeId || null, t;
}
function Y0(e, t = rt, r) {
  if (!t || e._n)
    return e;
  const n = (...s) => {
    n._d && Qs(-1);
    const i = qs(t);
    let o;
    try {
      o = e(...s);
    } finally {
      qs(i), n._d && Qs(1);
    }
    return (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && Mf(t), o;
  };
  return n._n = !0, n._c = !0, n._d = !0, n;
}
function kf(e) {
  Bv(e) && z("Do not use built-in directive ids as custom directive id: " + e);
}
function fr(e, t, r, n) {
  const s = e.dirs, i = t && t.dirs;
  for (let o = 0; o < s.length; o++) {
    const a = s[o];
    i && (a.oldValue = i[o].value);
    let l = a.dir[n];
    l && (bt(), Ut(l, r, 8, [
      e.el,
      a,
      e,
      t
    ]), wt());
  }
}
const G0 = Symbol("_vte"), W0 = (e) => e.__isTeleport, q0 = Symbol("_leaveCb");
function qa(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, qa(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
function xf(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
const bc = /* @__PURE__ */ new WeakSet(), Ks = /* @__PURE__ */ new WeakMap();
function kn(e, t, r, n, s = !1) {
  if (ue(e)) {
    e.forEach(
      (p, y) => kn(
        p,
        t && (ue(t) ? t[y] : t),
        r,
        n,
        s
      )
    );
    return;
  }
  if (xn(n) && !s) {
    n.shapeFlag & 512 && n.type.__asyncResolved && n.component.subTree.component && kn(e, t, r, n.component.subTree);
    return;
  }
  const i = n.shapeFlag & 4 ? el(n.component) : n.el, o = s ? null : i, { i: a, r: l } = e;
  if (process.env.NODE_ENV !== "production" && !a) {
    z(
      "Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function."
    );
    return;
  }
  const u = t && t.r, c = a.refs === Ce ? a.refs = {} : a.refs, d = a.setupState, f = me(d), _ = d === Ce ? rf : (p) => process.env.NODE_ENV !== "production" && (we(f, p) && !Fe(f[p]) && z(
    `Template ref "${p}" used on a non-ref value. It will not work in the production build.`
  ), bc.has(f[p])) ? !1 : we(f, p), g = (p) => process.env.NODE_ENV === "production" || !bc.has(p);
  if (u != null && u !== l) {
    if (wc(t), Pe(u))
      c[u] = null, _(u) && (d[u] = null);
    else if (Fe(u)) {
      g(u) && (u.value = null);
      const p = t;
      p.k && (c[p.k] = null);
    }
  }
  if (pe(l))
    dn(l, a, 12, [o, c]);
  else {
    const p = Pe(l), y = Fe(l);
    if (p || y) {
      const A = () => {
        if (e.f) {
          const T = p ? _(l) ? d[l] : c[l] : g(l) || !e.k ? l.value : c[e.k];
          if (s)
            ue(T) && La(T, i);
          else if (ue(T))
            T.includes(i) || T.push(i);
          else if (p)
            c[l] = [i], _(l) && (d[l] = c[l]);
          else {
            const b = [i];
            g(l) && (l.value = b), e.k && (c[e.k] = b);
          }
        } else p ? (c[l] = o, _(l) && (d[l] = o)) : y ? (g(l) && (l.value = o), e.k && (c[e.k] = o)) : process.env.NODE_ENV !== "production" && z("Invalid template ref type:", l, `(${typeof l})`);
      };
      if (o) {
        const T = () => {
          A(), Ks.delete(e);
        };
        T.id = -1, Ks.set(e, T), et(T, r);
      } else
        wc(e), A();
    } else process.env.NODE_ENV !== "production" && z("Invalid template ref type:", l, `(${typeof l})`);
  }
}
function wc(e) {
  const t = Ks.get(e);
  t && (t.flags |= 8, Ks.delete(e));
}
tr().requestIdleCallback;
tr().cancelIdleCallback;
const xn = (e) => !!e.type.__asyncLoader, Ka = (e) => e.type.__isKeepAlive;
function K0(e, t) {
  Pf(e, "a", t);
}
function z0(e, t) {
  Pf(e, "da", t);
}
function Pf(e, t, r = Ue) {
  const n = e.__wdc || (e.__wdc = () => {
    let s = r;
    for (; s; ) {
      if (s.isDeactivated)
        return;
      s = s.parent;
    }
    return e();
  });
  if (vi(t, n, r), r) {
    let s = r.parent;
    for (; s && s.parent; )
      Ka(s.parent.vnode) && J0(n, t, r, s), s = s.parent;
  }
}
function J0(e, t, r, n) {
  const s = vi(
    t,
    e,
    n,
    !0
    /* prepend */
  );
  $f(() => {
    La(n[t], s);
  }, r);
}
function vi(e, t, r = Ue, n = !1) {
  if (r) {
    const s = r[e] || (r[e] = []), i = t.__weh || (t.__weh = (...o) => {
      bt();
      const a = Zn(r), l = Ut(t, r, e, o);
      return a(), wt(), l;
    });
    return n ? s.unshift(i) : s.push(i), i;
  } else if (process.env.NODE_ENV !== "production") {
    const s = hr(ja[e].replace(/ hook$/, ""));
    z(
      `${s} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const Jt = (e) => (t, r = Ue) => {
  (!Vn || e === "sp") && vi(e, (...n) => t(...n), r);
}, X0 = Jt("bm"), Q0 = Jt("m"), Z0 = Jt(
  "bu"
), eb = Jt("u"), tb = Jt(
  "bum"
), $f = Jt("um"), rb = Jt(
  "sp"
), nb = Jt("rtg"), sb = Jt("rtc");
function ib(e, t = Ue) {
  vi("ec", e, t);
}
const ob = Symbol.for("v-ndc"), qo = (e) => e ? op(e) ? el(e) : qo(e.parent) : null, Sr = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ Ve(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => process.env.NODE_ENV !== "production" ? Rt(e.props) : e.props,
    $attrs: (e) => process.env.NODE_ENV !== "production" ? Rt(e.attrs) : e.attrs,
    $slots: (e) => process.env.NODE_ENV !== "production" ? Rt(e.slots) : e.slots,
    $refs: (e) => process.env.NODE_ENV !== "production" ? Rt(e.refs) : e.refs,
    $parent: (e) => qo(e.parent),
    $root: (e) => qo(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => __VUE_OPTIONS_API__ ? Bf(e) : e.type,
    $forceUpdate: (e) => e.f || (e.f = () => {
      Ei(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = I0.bind(e.proxy)),
    $watch: (e) => __VUE_OPTIONS_API__ ? Vb.bind(e) : ke
  })
), za = (e) => e === "_" || e === "$", Qi = (e, t) => e !== Ce && !e.__isScriptSetup && we(e, t), Ff = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: r, setupState: n, data: s, props: i, accessCache: o, type: a, appContext: l } = e;
    if (process.env.NODE_ENV !== "production" && t === "__isVue")
      return !0;
    let u;
    if (t[0] !== "$") {
      const _ = o[t];
      if (_ !== void 0)
        switch (_) {
          case 1:
            return n[t];
          case 2:
            return s[t];
          case 4:
            return r[t];
          case 3:
            return i[t];
        }
      else {
        if (Qi(n, t))
          return o[t] = 1, n[t];
        if (s !== Ce && we(s, t))
          return o[t] = 2, s[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (u = e.propsOptions[0]) && we(u, t)
        )
          return o[t] = 3, i[t];
        if (r !== Ce && we(r, t))
          return o[t] = 4, r[t];
        (!__VUE_OPTIONS_API__ || Ko) && (o[t] = 0);
      }
    }
    const c = Sr[t];
    let d, f;
    if (c)
      return t === "$attrs" ? ($e(e.attrs, "get", ""), process.env.NODE_ENV !== "production" && Xs()) : process.env.NODE_ENV !== "production" && t === "$slots" && $e(e, "get", t), c(e);
    if (
      // css module (injected by vue-loader)
      (d = a.__cssModules) && (d = d[t])
    )
      return d;
    if (r !== Ce && we(r, t))
      return o[t] = 4, r[t];
    if (
      // global properties
      f = l.config.globalProperties, we(f, t)
    )
      return f[t];
    process.env.NODE_ENV !== "production" && rt && (!Pe(t) || // #1091 avoid internal isRef/isVNode checks on component instance leading
    // to infinite warning loop
    t.indexOf("__v") !== 0) && (s !== Ce && za(t[0]) && we(s, t) ? z(
      `Property ${JSON.stringify(
        t
      )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
    ) : e === rt && z(
      `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
    ));
  },
  set({ _: e }, t, r) {
    const { data: n, setupState: s, ctx: i } = e;
    return Qi(s, t) ? (s[t] = r, !0) : process.env.NODE_ENV !== "production" && s.__isScriptSetup && we(s, t) ? (z(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : n !== Ce && we(n, t) ? (n[t] = r, !0) : we(e.props, t) ? (process.env.NODE_ENV !== "production" && z(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && z(
      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
    ), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(i, t, {
      enumerable: !0,
      configurable: !0,
      value: r
    }) : i[t] = r, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: r, ctx: n, appContext: s, propsOptions: i, type: o }
  }, a) {
    let l, u;
    return !!(r[a] || e !== Ce && a[0] !== "$" && we(e, a) || Qi(t, a) || (l = i[0]) && we(l, a) || we(n, a) || we(Sr, a) || we(s.config.globalProperties, a) || (u = o.__cssModules) && u[a]);
  },
  defineProperty(e, t, r) {
    return r.get != null ? e._.accessCache[t] = 0 : we(r, "value") && this.set(e, t, r.value, null), Reflect.defineProperty(e, t, r);
  }
};
process.env.NODE_ENV !== "production" && (Ff.ownKeys = (e) => (z(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
function ab(e) {
  const t = {};
  return Object.defineProperty(t, "_", {
    configurable: !0,
    enumerable: !1,
    get: () => e
  }), Object.keys(Sr).forEach((r) => {
    Object.defineProperty(t, r, {
      configurable: !0,
      enumerable: !1,
      get: () => Sr[r](e),
      // intercepted by the proxy so no need for implementation,
      // but needed to prevent set errors
      set: ke
    });
  }), t;
}
function lb(e) {
  const {
    ctx: t,
    propsOptions: [r]
  } = e;
  r && Object.keys(r).forEach((n) => {
    Object.defineProperty(t, n, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[n],
      set: ke
    });
  });
}
function cb(e) {
  const { ctx: t, setupState: r } = e;
  Object.keys(me(r)).forEach((n) => {
    if (!r.__isScriptSetup) {
      if (za(n[0])) {
        z(
          `setup() return property ${JSON.stringify(
            n
          )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
        );
        return;
      }
      Object.defineProperty(t, n, {
        enumerable: !0,
        configurable: !0,
        get: () => r[n],
        set: ke
      });
    }
  });
}
function Tc(e) {
  return ue(e) ? e.reduce(
    (t, r) => (t[r] = null, t),
    {}
  ) : e;
}
function ub() {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, r) => {
    e[r] ? z(`${t} property "${r}" is already defined in ${e[r]}.`) : e[r] = t;
  };
}
let Ko = !0;
function db(e) {
  const t = Bf(e), r = e.proxy, n = e.ctx;
  Ko = !1, t.beforeCreate && Sc(t.beforeCreate, e, "bc");
  const {
    // state
    data: s,
    computed: i,
    methods: o,
    watch: a,
    provide: l,
    inject: u,
    // lifecycle
    created: c,
    beforeMount: d,
    mounted: f,
    beforeUpdate: _,
    updated: g,
    activated: p,
    deactivated: y,
    beforeDestroy: A,
    beforeUnmount: T,
    destroyed: b,
    unmounted: C,
    render: v,
    renderTracked: Y,
    renderTriggered: K,
    errorCaptured: ee,
    serverPrefetch: Q,
    // public API
    expose: Z,
    inheritAttrs: X,
    // assets
    components: le,
    directives: ae,
    filters: W
  } = t, V = process.env.NODE_ENV !== "production" ? ub() : null;
  if (process.env.NODE_ENV !== "production") {
    const [R] = e.propsOptions;
    if (R)
      for (const M in R)
        V("Props", M);
  }
  if (u && fb(u, n, V), o)
    for (const R in o) {
      const M = o[R];
      pe(M) ? (process.env.NODE_ENV !== "production" ? Object.defineProperty(n, R, {
        value: M.bind(r),
        configurable: !0,
        enumerable: !0,
        writable: !0
      }) : n[R] = M.bind(r), process.env.NODE_ENV !== "production" && V("Methods", R)) : process.env.NODE_ENV !== "production" && z(
        `Method "${R}" has type "${typeof M}" in the component definition. Did you reference the function correctly?`
      );
    }
  if (s) {
    process.env.NODE_ENV !== "production" && !pe(s) && z(
      "The data option must be a function. Plain object usage is no longer supported."
    );
    const R = s.call(r, r);
    if (process.env.NODE_ENV !== "production" && Ra(R) && z(
      "data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>."
    ), !De(R))
      process.env.NODE_ENV !== "production" && z("data() should return an object.");
    else if (e.data = Ha(R), process.env.NODE_ENV !== "production")
      for (const M in R)
        V("Data", M), za(M[0]) || Object.defineProperty(n, M, {
          configurable: !0,
          enumerable: !0,
          get: () => R[M],
          set: ke
        });
  }
  if (Ko = !0, i)
    for (const R in i) {
      const M = i[R], w = pe(M) ? M.bind(r, r) : pe(M.get) ? M.get.bind(r, r) : ke;
      process.env.NODE_ENV !== "production" && w === ke && z(`Computed property "${R}" has no getter.`);
      const S = !pe(M) && pe(M.set) ? M.set.bind(r) : process.env.NODE_ENV !== "production" ? () => {
        z(
          `Write operation failed: computed property "${R}" is readonly.`
        );
      } : ke, D = up({
        get: w,
        set: S
      });
      Object.defineProperty(n, R, {
        enumerable: !0,
        configurable: !0,
        get: () => D.value,
        set: (G) => D.value = G
      }), process.env.NODE_ENV !== "production" && V("Computed", R);
    }
  if (a)
    for (const R in a)
      Vf(a[R], n, r, R);
  if (l) {
    const R = pe(l) ? l.call(r) : l;
    Reflect.ownKeys(R).forEach((M) => {
      yb(M, R[M]);
    });
  }
  c && Sc(c, e, "c");
  function L(R, M) {
    ue(M) ? M.forEach((w) => R(w.bind(r))) : M && R(M.bind(r));
  }
  if (L(X0, d), L(Q0, f), L(Z0, _), L(eb, g), L(K0, p), L(z0, y), L(ib, ee), L(sb, Y), L(nb, K), L(tb, T), L($f, C), L(rb, Q), ue(Z))
    if (Z.length) {
      const R = e.exposed || (e.exposed = {});
      Z.forEach((M) => {
        Object.defineProperty(R, M, {
          get: () => r[M],
          set: (w) => r[M] = w,
          enumerable: !0
        });
      });
    } else e.exposed || (e.exposed = {});
  v && e.render === ke && (e.render = v), X != null && (e.inheritAttrs = X), le && (e.components = le), ae && (e.directives = ae), Q && xf(e);
}
function fb(e, t, r = ke) {
  ue(e) && (e = zo(e));
  for (const n in e) {
    const s = e[n];
    let i;
    De(s) ? "default" in s ? i = Ns(
      s.from || n,
      s.default,
      !0
    ) : i = Ns(s.from || n) : i = Ns(s), Fe(i) ? Object.defineProperty(t, n, {
      enumerable: !0,
      configurable: !0,
      get: () => i.value,
      set: (o) => i.value = o
    }) : t[n] = i, process.env.NODE_ENV !== "production" && r("Inject", n);
  }
}
function Sc(e, t, r) {
  Ut(
    ue(e) ? e.map((n) => n.bind(t.proxy)) : e.bind(t.proxy),
    t,
    r
  );
}
function Vf(e, t, r, n) {
  let s = n.includes(".") ? Qf(r, n) : () => r[n];
  if (Pe(e)) {
    const i = t[e];
    pe(i) ? eo(s, i) : process.env.NODE_ENV !== "production" && z(`Invalid watch handler specified by key "${e}"`, i);
  } else if (pe(e))
    eo(s, e.bind(r));
  else if (De(e))
    if (ue(e))
      e.forEach((i) => Vf(i, t, r, n));
    else {
      const i = pe(e.handler) ? e.handler.bind(r) : t[e.handler];
      pe(i) ? eo(s, i, e) : process.env.NODE_ENV !== "production" && z(`Invalid watch handler specified by key "${e.handler}"`, i);
    }
  else process.env.NODE_ENV !== "production" && z(`Invalid watch option: "${n}"`, e);
}
function Bf(e) {
  const t = e.type, { mixins: r, extends: n } = t, {
    mixins: s,
    optionsCache: i,
    config: { optionMergeStrategies: o }
  } = e.appContext, a = i.get(t);
  let l;
  return a ? l = a : !s.length && !r && !n ? l = t : (l = {}, s.length && s.forEach(
    (u) => zs(l, u, o, !0)
  ), zs(l, t, o)), De(t) && i.set(t, l), l;
}
function zs(e, t, r, n = !1) {
  const { mixins: s, extends: i } = t;
  i && zs(e, i, r, !0), s && s.forEach(
    (o) => zs(e, o, r, !0)
  );
  for (const o in t)
    if (n && o === "expose")
      process.env.NODE_ENV !== "production" && z(
        '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
      );
    else {
      const a = pb[o] || r && r[o];
      e[o] = a ? a(e[o], t[o]) : t[o];
    }
  return e;
}
const pb = {
  data: Oc,
  props: Ac,
  emits: Ac,
  // objects
  methods: An,
  computed: An,
  // lifecycle
  beforeCreate: Ye,
  created: Ye,
  beforeMount: Ye,
  mounted: Ye,
  beforeUpdate: Ye,
  updated: Ye,
  beforeDestroy: Ye,
  beforeUnmount: Ye,
  destroyed: Ye,
  unmounted: Ye,
  activated: Ye,
  deactivated: Ye,
  errorCaptured: Ye,
  serverPrefetch: Ye,
  // assets
  components: An,
  directives: An,
  // watch
  watch: gb,
  // provide / inject
  provide: Oc,
  inject: hb
};
function Oc(e, t) {
  return t ? e ? function() {
    return Ve(
      pe(e) ? e.call(this, this) : e,
      pe(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function hb(e, t) {
  return An(zo(e), zo(t));
}
function zo(e) {
  if (ue(e)) {
    const t = {};
    for (let r = 0; r < e.length; r++)
      t[e[r]] = e[r];
    return t;
  }
  return e;
}
function Ye(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function An(e, t) {
  return e ? Ve(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function Ac(e, t) {
  return e ? ue(e) && ue(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : Ve(
    /* @__PURE__ */ Object.create(null),
    Tc(e),
    Tc(t ?? {})
  ) : t;
}
function gb(e, t) {
  if (!e) return t;
  if (!t) return e;
  const r = Ve(/* @__PURE__ */ Object.create(null), e);
  for (const n in t)
    r[n] = Ye(e[n], t[n]);
  return r;
}
function Uf() {
  return {
    app: null,
    config: {
      isNativeTag: rf,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let _b = 0;
function mb(e, t) {
  return function(n, s = null) {
    pe(n) || (n = Ve({}, n)), s != null && !De(s) && (process.env.NODE_ENV !== "production" && z("root props passed to app.mount() must be an object."), s = null);
    const i = Uf(), o = /* @__PURE__ */ new WeakSet(), a = [];
    let l = !1;
    const u = i.app = {
      _uid: _b++,
      _component: n,
      _props: s,
      _container: null,
      _context: i,
      _instance: null,
      version: Fc,
      get config() {
        return i.config;
      },
      set config(c) {
        process.env.NODE_ENV !== "production" && z(
          "app.config cannot be replaced. Modify individual options instead."
        );
      },
      use(c, ...d) {
        return o.has(c) ? process.env.NODE_ENV !== "production" && z("Plugin has already been applied to target app.") : c && pe(c.install) ? (o.add(c), c.install(u, ...d)) : pe(c) ? (o.add(c), c(u, ...d)) : process.env.NODE_ENV !== "production" && z(
          'A plugin must either be a function or an object with an "install" function.'
        ), u;
      },
      mixin(c) {
        return __VUE_OPTIONS_API__ ? i.mixins.includes(c) ? process.env.NODE_ENV !== "production" && z(
          "Mixin has already been applied to target app" + (c.name ? `: ${c.name}` : "")
        ) : i.mixins.push(c) : process.env.NODE_ENV !== "production" && z("Mixins are only available in builds supporting Options API"), u;
      },
      component(c, d) {
        return process.env.NODE_ENV !== "production" && ea(c, i.config), d ? (process.env.NODE_ENV !== "production" && i.components[c] && z(`Component "${c}" has already been registered in target app.`), i.components[c] = d, u) : i.components[c];
      },
      directive(c, d) {
        return process.env.NODE_ENV !== "production" && kf(c), d ? (process.env.NODE_ENV !== "production" && i.directives[c] && z(`Directive "${c}" has already been registered in target app.`), i.directives[c] = d, u) : i.directives[c];
      },
      mount(c, d, f) {
        if (l)
          process.env.NODE_ENV !== "production" && z(
            "App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`"
          );
        else {
          process.env.NODE_ENV !== "production" && c.__vue_app__ && z(
            "There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first."
          );
          const _ = u._ceVNode || rr(n, s);
          return _.appContext = i, f === !0 ? f = "svg" : f === !1 && (f = void 0), process.env.NODE_ENV !== "production" && (i.reload = () => {
            const g = lr(_);
            g.el = null, e(g, c, f);
          }), e(_, c, f), l = !0, u._container = c, c.__vue_app__ = u, (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && (u._instance = _.component, P0(u, Fc)), el(_.component);
        }
      },
      onUnmount(c) {
        process.env.NODE_ENV !== "production" && typeof c != "function" && z(
          `Expected function as first argument to app.onUnmount(), but got ${typeof c}`
        ), a.push(c);
      },
      unmount() {
        l ? (Ut(
          a,
          u._instance,
          16
        ), e(null, u._container), (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && (u._instance = null, $0(u)), delete u._container.__vue_app__) : process.env.NODE_ENV !== "production" && z("Cannot unmount an app that is not mounted.");
      },
      provide(c, d) {
        return process.env.NODE_ENV !== "production" && c in i.provides && (we(i.provides, c) ? z(
          `App already provides property with key "${String(c)}". It will be overwritten with the new value.`
        ) : z(
          `App already provides property with key "${String(c)}" inherited from its parent element. It will be overwritten with the new value.`
        )), i.provides[c] = d, u;
      },
      runWithContext(c) {
        const d = Wr;
        Wr = u;
        try {
          return c();
        } finally {
          Wr = d;
        }
      }
    };
    return u;
  };
}
let Wr = null;
function yb(e, t) {
  if (!Ue)
    process.env.NODE_ENV !== "production" && z("provide() can only be used inside setup().");
  else {
    let r = Ue.provides;
    const n = Ue.parent && Ue.parent.provides;
    n === r && (r = Ue.provides = Object.create(n)), r[e] = t;
  }
}
function Ns(e, t, r = !1) {
  const n = ip();
  if (n || Wr) {
    let s = Wr ? Wr._context.provides : n ? n.parent == null || n.ce ? n.vnode.appContext && n.vnode.appContext.provides : n.parent.provides : void 0;
    if (s && e in s)
      return s[e];
    if (arguments.length > 1)
      return r && pe(t) ? t.call(n && n.proxy) : t;
    process.env.NODE_ENV !== "production" && z(`injection "${String(e)}" not found.`);
  } else process.env.NODE_ENV !== "production" && z("inject() can only be used inside setup() or functional components.");
}
const Hf = {}, jf = () => Object.create(Hf), Yf = (e) => Object.getPrototypeOf(e) === Hf;
function Eb(e, t, r, n = !1) {
  const s = {}, i = jf();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), Gf(e, t, s, i);
  for (const o in e.propsOptions[0])
    o in s || (s[o] = void 0);
  process.env.NODE_ENV !== "production" && qf(t || {}, s, e), r ? e.props = n ? s : _0(s) : e.type.props ? e.props = s : e.props = i, e.attrs = i;
}
function vb(e) {
  for (; e; ) {
    if (e.type.__hmrId) return !0;
    e = e.parent;
  }
}
function bb(e, t, r, n) {
  const {
    props: s,
    attrs: i,
    vnode: { patchFlag: o }
  } = e, a = me(s), [l] = e.propsOptions;
  let u = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !(process.env.NODE_ENV !== "production" && vb(e)) && (n || o > 0) && !(o & 16)
  ) {
    if (o & 8) {
      const c = e.vnode.dynamicProps;
      for (let d = 0; d < c.length; d++) {
        let f = c[d];
        if (bi(e.emitsOptions, f))
          continue;
        const _ = t[f];
        if (l)
          if (we(i, f))
            _ !== i[f] && (i[f] = _, u = !0);
          else {
            const g = mt(f);
            s[g] = Jo(
              l,
              a,
              g,
              _,
              e,
              !1
            );
          }
        else
          _ !== i[f] && (i[f] = _, u = !0);
      }
    }
  } else {
    Gf(e, t, s, i) && (u = !0);
    let c;
    for (const d in a)
      (!t || // for camelCase
      !we(t, d) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((c = or(d)) === d || !we(t, c))) && (l ? r && // for camelCase
      (r[d] !== void 0 || // for kebab-case
      r[c] !== void 0) && (s[d] = Jo(
        l,
        a,
        d,
        void 0,
        e,
        !0
      )) : delete s[d]);
    if (i !== a)
      for (const d in i)
        (!t || !we(t, d)) && (delete i[d], u = !0);
  }
  u && Lt(e.attrs, "set", ""), process.env.NODE_ENV !== "production" && qf(t || {}, s, e);
}
function Gf(e, t, r, n) {
  const [s, i] = e.propsOptions;
  let o = !1, a;
  if (t)
    for (let l in t) {
      if (Mn(l))
        continue;
      const u = t[l];
      let c;
      s && we(s, c = mt(l)) ? !i || !i.includes(c) ? r[c] = u : (a || (a = {}))[c] = u : bi(e.emitsOptions, l) || (!(l in n) || u !== n[l]) && (n[l] = u, o = !0);
    }
  if (i) {
    const l = me(r), u = a || Ce;
    for (let c = 0; c < i.length; c++) {
      const d = i[c];
      r[d] = Jo(
        s,
        l,
        d,
        u[d],
        e,
        !we(u, d)
      );
    }
  }
  return o;
}
function Jo(e, t, r, n, s, i) {
  const o = e[r];
  if (o != null) {
    const a = we(o, "default");
    if (a && n === void 0) {
      const l = o.default;
      if (o.type !== Function && !o.skipFactory && pe(l)) {
        const { propsDefaults: u } = s;
        if (r in u)
          n = u[r];
        else {
          const c = Zn(s);
          n = u[r] = l.call(
            null,
            t
          ), c();
        }
      } else
        n = l;
      s.ce && s.ce._setProp(r, n);
    }
    o[
      0
      /* shouldCast */
    ] && (i && !a ? n = !1 : o[
      1
      /* shouldCastTrue */
    ] && (n === "" || n === or(r)) && (n = !0));
  }
  return n;
}
const wb = /* @__PURE__ */ new WeakMap();
function Wf(e, t, r = !1) {
  const n = __VUE_OPTIONS_API__ && r ? wb : t.propsCache, s = n.get(e);
  if (s)
    return s;
  const i = e.props, o = {}, a = [];
  let l = !1;
  if (__VUE_OPTIONS_API__ && !pe(e)) {
    const c = (d) => {
      l = !0;
      const [f, _] = Wf(d, t, !0);
      Ve(o, f), _ && a.push(..._);
    };
    !r && t.mixins.length && t.mixins.forEach(c), e.extends && c(e.extends), e.mixins && e.mixins.forEach(c);
  }
  if (!i && !l)
    return De(e) && n.set(e, In), In;
  if (ue(i))
    for (let c = 0; c < i.length; c++) {
      process.env.NODE_ENV !== "production" && !Pe(i[c]) && z("props must be strings when using array syntax.", i[c]);
      const d = mt(i[c]);
      Nc(d) && (o[d] = Ce);
    }
  else if (i) {
    process.env.NODE_ENV !== "production" && !De(i) && z("invalid props options", i);
    for (const c in i) {
      const d = mt(c);
      if (Nc(d)) {
        const f = i[c], _ = o[d] = ue(f) || pe(f) ? { type: f } : Ve({}, f), g = _.type;
        let p = !1, y = !0;
        if (ue(g))
          for (let A = 0; A < g.length; ++A) {
            const T = g[A], b = pe(T) && T.name;
            if (b === "Boolean") {
              p = !0;
              break;
            } else b === "String" && (y = !1);
          }
        else
          p = pe(g) && g.name === "Boolean";
        _[
          0
          /* shouldCast */
        ] = p, _[
          1
          /* shouldCastTrue */
        ] = y, (p || we(_, "default")) && a.push(d);
      }
    }
  }
  const u = [o, a];
  return De(e) && n.set(e, u), u;
}
function Nc(e) {
  return e[0] !== "$" && !Mn(e) ? !0 : (process.env.NODE_ENV !== "production" && z(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function Tb(e) {
  return e === null ? "null" : typeof e == "function" ? e.name || "" : typeof e == "object" && e.constructor && e.constructor.name || "";
}
function qf(e, t, r) {
  const n = me(t), s = r.propsOptions[0], i = Object.keys(e).map((o) => mt(o));
  for (const o in s) {
    let a = s[o];
    a != null && Sb(
      o,
      n[o],
      a,
      process.env.NODE_ENV !== "production" ? Rt(n) : n,
      !i.includes(o)
    );
  }
}
function Sb(e, t, r, n, s) {
  const { type: i, required: o, validator: a, skipCheck: l } = r;
  if (o && s) {
    z('Missing required prop: "' + e + '"');
    return;
  }
  if (!(t == null && !o)) {
    if (i != null && i !== !0 && !l) {
      let u = !1;
      const c = ue(i) ? i : [i], d = [];
      for (let f = 0; f < c.length && !u; f++) {
        const { valid: _, expectedType: g } = Ab(t, c[f]);
        d.push(g || ""), u = _;
      }
      if (!u) {
        z(Nb(e, t, d));
        return;
      }
    }
    a && !a(t, n) && z('Invalid prop: custom validator check failed for prop "' + e + '".');
  }
}
const Ob = /* @__PURE__ */ cn(
  "String,Number,Boolean,Function,Symbol,BigInt"
);
function Ab(e, t) {
  let r;
  const n = Tb(t);
  if (n === "null")
    r = e === null;
  else if (Ob(n)) {
    const s = typeof e;
    r = s === n.toLowerCase(), !r && s === "object" && (r = e instanceof t);
  } else n === "Object" ? r = De(e) : n === "Array" ? r = ue(e) : r = e instanceof t;
  return {
    valid: r,
    expectedType: n
  };
}
function Nb(e, t, r) {
  if (r.length === 0)
    return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
  let n = `Invalid prop: type check failed for prop "${e}". Expected ${r.map(_i).join(" | ")}`;
  const s = r[0], i = ka(t), o = Cc(t, s), a = Cc(t, i);
  return r.length === 1 && Dc(s) && !Cb(s, i) && (n += ` with value ${o}`), n += `, got ${i} `, Dc(i) && (n += `with value ${a}.`), n;
}
function Cc(e, t) {
  return t === "String" ? `"${e}"` : t === "Number" ? `${Number(e)}` : `${e}`;
}
function Dc(e) {
  return ["string", "number", "boolean"].some((r) => e.toLowerCase() === r);
}
function Cb(...e) {
  return e.some((t) => t.toLowerCase() === "boolean");
}
const Ja = (e) => e === "_" || e === "_ctx" || e === "$stable", Xa = (e) => ue(e) ? e.map(ht) : [ht(e)], Db = (e, t, r) => {
  if (t._n)
    return t;
  const n = Y0((...s) => (process.env.NODE_ENV !== "production" && Ue && !(r === null && rt) && !(r && r.root !== Ue.root) && z(
    `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
  ), Xa(t(...s))), r);
  return n._c = !1, n;
}, Kf = (e, t, r) => {
  const n = e._ctx;
  for (const s in e) {
    if (Ja(s)) continue;
    const i = e[s];
    if (pe(i))
      t[s] = Db(s, i, n);
    else if (i != null) {
      process.env.NODE_ENV !== "production" && z(
        `Non-function value encountered for slot "${s}". Prefer function slots for better performance.`
      );
      const o = Xa(i);
      t[s] = () => o;
    }
  }
}, zf = (e, t) => {
  process.env.NODE_ENV !== "production" && !Ka(e.vnode) && z(
    "Non-function value encountered for default slot. Prefer function slots for better performance."
  );
  const r = Xa(t);
  e.slots.default = () => r;
}, Xo = (e, t, r) => {
  for (const n in t)
    (r || !Ja(n)) && (e[n] = t[n]);
}, Ib = (e, t, r) => {
  const n = e.slots = jf();
  if (e.vnode.shapeFlag & 32) {
    const s = t._;
    s ? (Xo(n, t, r), r && Hs(n, "_", s, !0)) : Kf(t, n);
  } else t && zf(e, t);
}, Mb = (e, t, r) => {
  const { vnode: n, slots: s } = e;
  let i = !0, o = Ce;
  if (n.shapeFlag & 32) {
    const a = t._;
    a ? process.env.NODE_ENV !== "production" && kt ? (Xo(s, t, r), Lt(e, "set", "$slots")) : r && a === 1 ? i = !1 : Xo(s, t, r) : (i = !t.$stable, Kf(t, s)), o = t;
  } else t && (zf(e, t), o = { default: 1 });
  if (i)
    for (const a in s)
      !Ja(a) && o[a] == null && delete s[a];
};
let bn, Gt;
function Pr(e, t) {
  e.appContext.config.performance && Js() && Gt.mark(`vue-${t}-${e.uid}`), (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && U0(e, t, Js() ? Gt.now() : Date.now());
}
function $r(e, t) {
  if (e.appContext.config.performance && Js()) {
    const r = `vue-${t}-${e.uid}`, n = r + ":end", s = `<${wi(e, e.type)}> ${t}`;
    Gt.mark(n), Gt.measure(s, r, n), Gt.clearMeasures(s), Gt.clearMarks(r), Gt.clearMarks(n);
  }
  (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && H0(e, t, Js() ? Gt.now() : Date.now());
}
function Js() {
  return bn !== void 0 || (typeof window < "u" && window.performance ? (bn = !0, Gt = window.performance) : bn = !1), bn;
}
function Lb() {
  const e = [];
  if (typeof __VUE_OPTIONS_API__ != "boolean" && (process.env.NODE_ENV !== "production" && e.push("__VUE_OPTIONS_API__"), tr().__VUE_OPTIONS_API__ = !0), typeof __VUE_PROD_DEVTOOLS__ != "boolean" && (process.env.NODE_ENV !== "production" && e.push("__VUE_PROD_DEVTOOLS__"), tr().__VUE_PROD_DEVTOOLS__ = !1), typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ != "boolean" && (process.env.NODE_ENV !== "production" && e.push("__VUE_PROD_HYDRATION_MISMATCH_DETAILS__"), tr().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = !1), process.env.NODE_ENV !== "production" && e.length) {
    const t = e.length > 1;
    console.warn(
      `Feature flag${t ? "s" : ""} ${e.join(", ")} ${t ? "are" : "is"} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
    );
  }
}
const et = qb;
function Rb(e) {
  return kb(e);
}
function kb(e, t) {
  Lb();
  const r = tr();
  r.__VUE__ = !0, (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && Ga(r.__VUE_DEVTOOLS_GLOBAL_HOOK__, r);
  const {
    insert: n,
    remove: s,
    patchProp: i,
    createElement: o,
    createText: a,
    createComment: l,
    setText: u,
    setElementText: c,
    parentNode: d,
    nextSibling: f,
    setScopeId: _ = ke,
    insertStaticContent: g
  } = e, p = (h, E, I, P = null, k = null, x = null, q = void 0, H = null, j = process.env.NODE_ENV !== "production" && kt ? !1 : !!E.dynamicChildren) => {
    if (h === E)
      return;
    h && !wn(h, E) && (P = ye(h), U(h, k, x, !0), h = null), E.patchFlag === -2 && (j = !1, E.dynamicChildren = null);
    const { type: B, ref: ie, shapeFlag: J } = E;
    switch (B) {
      case Qn:
        y(h, E, I, P);
        break;
      case Et:
        A(h, E, I, P);
        break;
      case Ds:
        h == null ? T(E, I, P, q) : process.env.NODE_ENV !== "production" && b(h, E, I, q);
        break;
      case Mt:
        ae(
          h,
          E,
          I,
          P,
          k,
          x,
          q,
          H,
          j
        );
        break;
      default:
        J & 1 ? Y(
          h,
          E,
          I,
          P,
          k,
          x,
          q,
          H,
          j
        ) : J & 6 ? W(
          h,
          E,
          I,
          P,
          k,
          x,
          q,
          H,
          j
        ) : J & 64 || J & 128 ? B.process(
          h,
          E,
          I,
          P,
          k,
          x,
          q,
          H,
          j,
          de
        ) : process.env.NODE_ENV !== "production" && z("Invalid VNode type:", B, `(${typeof B})`);
    }
    ie != null && k ? kn(ie, h && h.ref, x, E || h, !E) : ie == null && h && h.ref != null && kn(h.ref, null, x, h, !0);
  }, y = (h, E, I, P) => {
    if (h == null)
      n(
        E.el = a(E.children),
        I,
        P
      );
    else {
      const k = E.el = h.el;
      E.children !== h.children && u(k, E.children);
    }
  }, A = (h, E, I, P) => {
    h == null ? n(
      E.el = l(E.children || ""),
      I,
      P
    ) : E.el = h.el;
  }, T = (h, E, I, P) => {
    [h.el, h.anchor] = g(
      h.children,
      E,
      I,
      P,
      h.el,
      h.anchor
    );
  }, b = (h, E, I, P) => {
    if (E.children !== h.children) {
      const k = f(h.anchor);
      v(h), [E.el, E.anchor] = g(
        E.children,
        I,
        k,
        P
      );
    } else
      E.el = h.el, E.anchor = h.anchor;
  }, C = ({ el: h, anchor: E }, I, P) => {
    let k;
    for (; h && h !== E; )
      k = f(h), n(h, I, P), h = k;
    n(E, I, P);
  }, v = ({ el: h, anchor: E }) => {
    let I;
    for (; h && h !== E; )
      I = f(h), s(h), h = I;
    s(E);
  }, Y = (h, E, I, P, k, x, q, H, j) => {
    E.type === "svg" ? q = "svg" : E.type === "math" && (q = "mathml"), h == null ? K(
      E,
      I,
      P,
      k,
      x,
      q,
      H,
      j
    ) : Z(
      h,
      E,
      k,
      x,
      q,
      H,
      j
    );
  }, K = (h, E, I, P, k, x, q, H) => {
    let j, B;
    const { props: ie, shapeFlag: J, transition: se, dirs: ce } = h;
    if (j = h.el = o(
      h.type,
      x,
      ie && ie.is,
      ie
    ), J & 8 ? c(j, h.children) : J & 16 && Q(
      h.children,
      j,
      null,
      P,
      k,
      Zi(h, x),
      q,
      H
    ), ce && fr(h, null, P, "created"), ee(j, h, h.scopeId, q, P), ie) {
      for (const Oe in ie)
        Oe !== "value" && !Mn(Oe) && i(j, Oe, null, ie[Oe], x, P);
      "value" in ie && i(j, "value", null, ie.value, x), (B = ie.onVnodeBeforeMount) && Dt(B, P, h);
    }
    (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && (Hs(j, "__vnode", h, !0), Hs(j, "__vueParentComponent", P, !0)), ce && fr(h, null, P, "beforeMount");
    const Ee = xb(k, se);
    Ee && se.beforeEnter(j), n(j, E, I), ((B = ie && ie.onVnodeMounted) || Ee || ce) && et(() => {
      B && Dt(B, P, h), Ee && se.enter(j), ce && fr(h, null, P, "mounted");
    }, k);
  }, ee = (h, E, I, P, k) => {
    if (I && _(h, I), P)
      for (let x = 0; x < P.length; x++)
        _(h, P[x]);
    if (k) {
      let x = k.subTree;
      if (process.env.NODE_ENV !== "production" && x.patchFlag > 0 && x.patchFlag & 2048 && (x = Qa(x.children) || x), E === x || tp(x.type) && (x.ssContent === E || x.ssFallback === E)) {
        const q = k.vnode;
        ee(
          h,
          q,
          q.scopeId,
          q.slotScopeIds,
          k.parent
        );
      }
    }
  }, Q = (h, E, I, P, k, x, q, H, j = 0) => {
    for (let B = j; B < h.length; B++) {
      const ie = h[B] = H ? Zt(h[B]) : ht(h[B]);
      p(
        null,
        ie,
        E,
        I,
        P,
        k,
        x,
        q,
        H
      );
    }
  }, Z = (h, E, I, P, k, x, q) => {
    const H = E.el = h.el;
    (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && (H.__vnode = E);
    let { patchFlag: j, dynamicChildren: B, dirs: ie } = E;
    j |= h.patchFlag & 16;
    const J = h.props || Ce, se = E.props || Ce;
    let ce;
    if (I && pr(I, !1), (ce = se.onVnodeBeforeUpdate) && Dt(ce, I, E, h), ie && fr(E, h, I, "beforeUpdate"), I && pr(I, !0), process.env.NODE_ENV !== "production" && kt && (j = 0, q = !1, B = null), (J.innerHTML && se.innerHTML == null || J.textContent && se.textContent == null) && c(H, ""), B ? (X(
      h.dynamicChildren,
      B,
      H,
      I,
      P,
      Zi(E, k),
      x
    ), process.env.NODE_ENV !== "production" && Cs(h, E)) : q || w(
      h,
      E,
      H,
      null,
      I,
      P,
      Zi(E, k),
      x,
      !1
    ), j > 0) {
      if (j & 16)
        le(H, J, se, I, k);
      else if (j & 2 && J.class !== se.class && i(H, "class", null, se.class, k), j & 4 && i(H, "style", J.style, se.style, k), j & 8) {
        const Ee = E.dynamicProps;
        for (let Oe = 0; Oe < Ee.length; Oe++) {
          const Ne = Ee[Oe], Ke = J[Ne], ze = se[Ne];
          (ze !== Ke || Ne === "value") && i(H, Ne, Ke, ze, k, I);
        }
      }
      j & 1 && h.children !== E.children && c(H, E.children);
    } else !q && B == null && le(H, J, se, I, k);
    ((ce = se.onVnodeUpdated) || ie) && et(() => {
      ce && Dt(ce, I, E, h), ie && fr(E, h, I, "updated");
    }, P);
  }, X = (h, E, I, P, k, x, q) => {
    for (let H = 0; H < E.length; H++) {
      const j = h[H], B = E[H], ie = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        j.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (j.type === Mt || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !wn(j, B) || // - In the case of a component, it could contain anything.
        j.shapeFlag & 198) ? d(j.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          I
        )
      );
      p(
        j,
        B,
        ie,
        null,
        P,
        k,
        x,
        q,
        !0
      );
    }
  }, le = (h, E, I, P, k) => {
    if (E !== I) {
      if (E !== Ce)
        for (const x in E)
          !Mn(x) && !(x in I) && i(
            h,
            x,
            E[x],
            null,
            k,
            P
          );
      for (const x in I) {
        if (Mn(x)) continue;
        const q = I[x], H = E[x];
        q !== H && x !== "value" && i(h, x, H, q, k, P);
      }
      "value" in I && i(h, "value", E.value, I.value, k);
    }
  }, ae = (h, E, I, P, k, x, q, H, j) => {
    const B = E.el = h ? h.el : a(""), ie = E.anchor = h ? h.anchor : a("");
    let { patchFlag: J, dynamicChildren: se, slotScopeIds: ce } = E;
    process.env.NODE_ENV !== "production" && // #5523 dev root fragment may inherit directives
    (kt || J & 2048) && (J = 0, j = !1, se = null), ce && (H = H ? H.concat(ce) : ce), h == null ? (n(B, I, P), n(ie, I, P), Q(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      E.children || [],
      I,
      ie,
      k,
      x,
      q,
      H,
      j
    )) : J > 0 && J & 64 && se && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    h.dynamicChildren ? (X(
      h.dynamicChildren,
      se,
      I,
      k,
      x,
      q,
      H
    ), process.env.NODE_ENV !== "production" ? Cs(h, E) : (
      // #2080 if the stable fragment has a key, it's a <template v-for> that may
      //  get moved around. Make sure all root level vnodes inherit el.
      // #2134 or if it's a component root, it may also get moved around
      // as the component is being moved.
      (E.key != null || k && E === k.subTree) && Cs(
        h,
        E,
        !0
        /* shallow */
      )
    )) : w(
      h,
      E,
      I,
      ie,
      k,
      x,
      q,
      H,
      j
    );
  }, W = (h, E, I, P, k, x, q, H, j) => {
    E.slotScopeIds = H, h == null ? E.shapeFlag & 512 ? k.ctx.activate(
      E,
      I,
      P,
      q,
      j
    ) : V(
      E,
      I,
      P,
      k,
      x,
      q,
      j
    ) : L(h, E, j);
  }, V = (h, E, I, P, k, x, q) => {
    const H = h.component = tw(
      h,
      P,
      k
    );
    if (process.env.NODE_ENV !== "production" && H.type.__hmrId && L0(H), process.env.NODE_ENV !== "production" && (Ss(h), Pr(H, "mount")), Ka(h) && (H.ctx.renderer = de), process.env.NODE_ENV !== "production" && Pr(H, "init"), nw(H, !1, q), process.env.NODE_ENV !== "production" && $r(H, "init"), process.env.NODE_ENV !== "production" && kt && (h.el = null), H.asyncDep) {
      if (k && k.registerDep(H, R, q), !h.el) {
        const j = H.subTree = rr(Et);
        A(null, j, E, I), h.placeholder = j.el;
      }
    } else
      R(
        H,
        h,
        E,
        I,
        k,
        x,
        q
      );
    process.env.NODE_ENV !== "production" && (Os(), $r(H, "mount"));
  }, L = (h, E, I) => {
    const P = E.component = h.component;
    if (Gb(h, E, I))
      if (P.asyncDep && !P.asyncResolved) {
        process.env.NODE_ENV !== "production" && Ss(E), M(P, E, I), process.env.NODE_ENV !== "production" && Os();
        return;
      } else
        P.next = E, P.update();
    else
      E.el = h.el, P.vnode = E;
  }, R = (h, E, I, P, k, x, q) => {
    const H = () => {
      if (h.isMounted) {
        let { next: J, bu: se, u: ce, parent: Ee, vnode: Oe } = h;
        {
          const At = Jf(h);
          if (At) {
            J && (J.el = Oe.el, M(h, J, q)), At.asyncDep.then(() => {
              h.isUnmounted || H();
            });
            return;
          }
        }
        let Ne = J, Ke;
        process.env.NODE_ENV !== "production" && Ss(J || h.vnode), pr(h, !1), J ? (J.el = Oe.el, M(h, J, q)) : J = Oe, se && En(se), (Ke = J.props && J.props.onVnodeBeforeUpdate) && Dt(Ke, Ee, J, Oe), pr(h, !0), process.env.NODE_ENV !== "production" && Pr(h, "render");
        const ze = Mc(h);
        process.env.NODE_ENV !== "production" && $r(h, "render");
        const Ot = h.subTree;
        h.subTree = ze, process.env.NODE_ENV !== "production" && Pr(h, "patch"), p(
          Ot,
          ze,
          // parent may have changed if it's in a teleport
          d(Ot.el),
          // anchor may have changed if it's in a fragment
          ye(Ot),
          h,
          k,
          x
        ), process.env.NODE_ENV !== "production" && $r(h, "patch"), J.el = ze.el, Ne === null && Wb(h, ze.el), ce && et(ce, k), (Ke = J.props && J.props.onVnodeUpdated) && et(
          () => Dt(Ke, Ee, J, Oe),
          k
        ), (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && Mf(h), process.env.NODE_ENV !== "production" && Os();
      } else {
        let J;
        const { el: se, props: ce } = E, { bm: Ee, m: Oe, parent: Ne, root: Ke, type: ze } = h, Ot = xn(E);
        pr(h, !1), Ee && En(Ee), !Ot && (J = ce && ce.onVnodeBeforeMount) && Dt(J, Ne, E), pr(h, !0);
        {
          Ke.ce && // @ts-expect-error _def is private
          Ke.ce._def.shadowRoot !== !1 && Ke.ce._injectChildStyle(ze), process.env.NODE_ENV !== "production" && Pr(h, "render");
          const At = h.subTree = Mc(h);
          process.env.NODE_ENV !== "production" && $r(h, "render"), process.env.NODE_ENV !== "production" && Pr(h, "patch"), p(
            null,
            At,
            I,
            P,
            h,
            k,
            x
          ), process.env.NODE_ENV !== "production" && $r(h, "patch"), E.el = At.el;
        }
        if (Oe && et(Oe, k), !Ot && (J = ce && ce.onVnodeMounted)) {
          const At = E;
          et(
            () => Dt(J, Ne, At),
            k
          );
        }
        (E.shapeFlag & 256 || Ne && xn(Ne.vnode) && Ne.vnode.shapeFlag & 256) && h.a && et(h.a, k), h.isMounted = !0, (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && F0(h), E = I = P = null;
      }
    };
    h.scope.on();
    const j = h.effect = new sf(H);
    h.scope.off();
    const B = h.update = j.run.bind(j), ie = h.job = j.runIfDirty.bind(j);
    ie.i = h, ie.id = h.uid, j.scheduler = () => Ei(ie), pr(h, !0), process.env.NODE_ENV !== "production" && (j.onTrack = h.rtc ? (J) => En(h.rtc, J) : void 0, j.onTrigger = h.rtg ? (J) => En(h.rtg, J) : void 0), B();
  }, M = (h, E, I) => {
    E.component = h;
    const P = h.vnode.props;
    h.vnode = E, h.next = null, bb(h, E.props, P, I), Mb(h, E.children, I), bt(), Ec(h), wt();
  }, w = (h, E, I, P, k, x, q, H, j = !1) => {
    const B = h && h.children, ie = h ? h.shapeFlag : 0, J = E.children, { patchFlag: se, shapeFlag: ce } = E;
    if (se > 0) {
      if (se & 128) {
        D(
          B,
          J,
          I,
          P,
          k,
          x,
          q,
          H,
          j
        );
        return;
      } else if (se & 256) {
        S(
          B,
          J,
          I,
          P,
          k,
          x,
          q,
          H,
          j
        );
        return;
      }
    }
    ce & 8 ? (ie & 16 && ve(B, k, x), J !== B && c(I, J)) : ie & 16 ? ce & 16 ? D(
      B,
      J,
      I,
      P,
      k,
      x,
      q,
      H,
      j
    ) : ve(B, k, x, !0) : (ie & 8 && c(I, ""), ce & 16 && Q(
      J,
      I,
      P,
      k,
      x,
      q,
      H,
      j
    ));
  }, S = (h, E, I, P, k, x, q, H, j) => {
    h = h || In, E = E || In;
    const B = h.length, ie = E.length, J = Math.min(B, ie);
    let se;
    for (se = 0; se < J; se++) {
      const ce = E[se] = j ? Zt(E[se]) : ht(E[se]);
      p(
        h[se],
        ce,
        I,
        null,
        k,
        x,
        q,
        H,
        j
      );
    }
    B > ie ? ve(
      h,
      k,
      x,
      !0,
      !1,
      J
    ) : Q(
      E,
      I,
      P,
      k,
      x,
      q,
      H,
      j,
      J
    );
  }, D = (h, E, I, P, k, x, q, H, j) => {
    let B = 0;
    const ie = E.length;
    let J = h.length - 1, se = ie - 1;
    for (; B <= J && B <= se; ) {
      const ce = h[B], Ee = E[B] = j ? Zt(E[B]) : ht(E[B]);
      if (wn(ce, Ee))
        p(
          ce,
          Ee,
          I,
          null,
          k,
          x,
          q,
          H,
          j
        );
      else
        break;
      B++;
    }
    for (; B <= J && B <= se; ) {
      const ce = h[J], Ee = E[se] = j ? Zt(E[se]) : ht(E[se]);
      if (wn(ce, Ee))
        p(
          ce,
          Ee,
          I,
          null,
          k,
          x,
          q,
          H,
          j
        );
      else
        break;
      J--, se--;
    }
    if (B > J) {
      if (B <= se) {
        const ce = se + 1, Ee = ce < ie ? E[ce].el : P;
        for (; B <= se; )
          p(
            null,
            E[B] = j ? Zt(E[B]) : ht(E[B]),
            I,
            Ee,
            k,
            x,
            q,
            H,
            j
          ), B++;
      }
    } else if (B > se)
      for (; B <= J; )
        U(h[B], k, x, !0), B++;
    else {
      const ce = B, Ee = B, Oe = /* @__PURE__ */ new Map();
      for (B = Ee; B <= se; B++) {
        const je = E[B] = j ? Zt(E[B]) : ht(E[B]);
        je.key != null && (process.env.NODE_ENV !== "production" && Oe.has(je.key) && z(
          "Duplicate keys found during update:",
          JSON.stringify(je.key),
          "Make sure keys are unique."
        ), Oe.set(je.key, B));
      }
      let Ne, Ke = 0;
      const ze = se - Ee + 1;
      let Ot = !1, At = 0;
      const gn = new Array(ze);
      for (B = 0; B < ze; B++) gn[B] = 0;
      for (B = ce; B <= J; B++) {
        const je = h[B];
        if (Ke >= ze) {
          U(je, k, x, !0);
          continue;
        }
        let Nt;
        if (je.key != null)
          Nt = Oe.get(je.key);
        else
          for (Ne = Ee; Ne <= se; Ne++)
            if (gn[Ne - Ee] === 0 && wn(je, E[Ne])) {
              Nt = Ne;
              break;
            }
        Nt === void 0 ? U(je, k, x, !0) : (gn[Nt - Ee] = B + 1, Nt >= At ? At = Nt : Ot = !0, p(
          je,
          E[Nt],
          I,
          null,
          k,
          x,
          q,
          H,
          j
        ), Ke++);
      }
      const ll = Ot ? Pb(gn) : In;
      for (Ne = ll.length - 1, B = ze - 1; B >= 0; B--) {
        const je = Ee + B, Nt = E[je], cl = E[je + 1], ul = je + 1 < ie ? (
          // #13559, fallback to el placeholder for unresolved async component
          cl.el || cl.placeholder
        ) : P;
        gn[B] === 0 ? p(
          null,
          Nt,
          I,
          ul,
          k,
          x,
          q,
          H,
          j
        ) : Ot && (Ne < 0 || B !== ll[Ne] ? G(Nt, I, ul, 2) : Ne--);
      }
    }
  }, G = (h, E, I, P, k = null) => {
    const { el: x, type: q, transition: H, children: j, shapeFlag: B } = h;
    if (B & 6) {
      G(h.component.subTree, E, I, P);
      return;
    }
    if (B & 128) {
      h.suspense.move(E, I, P);
      return;
    }
    if (B & 64) {
      q.move(h, E, I, de);
      return;
    }
    if (q === Mt) {
      n(x, E, I);
      for (let J = 0; J < j.length; J++)
        G(j[J], E, I, P);
      n(h.anchor, E, I);
      return;
    }
    if (q === Ds) {
      C(h, E, I);
      return;
    }
    if (P !== 2 && B & 1 && H)
      if (P === 0)
        H.beforeEnter(x), n(x, E, I), et(() => H.enter(x), k);
      else {
        const { leave: J, delayLeave: se, afterLeave: ce } = H, Ee = () => {
          h.ctx.isUnmounted ? s(x) : n(x, E, I);
        }, Oe = () => {
          x._isLeaving && x[q0](
            !0
            /* cancelled */
          ), J(x, () => {
            Ee(), ce && ce();
          });
        };
        se ? se(x, Ee, Oe) : Oe();
      }
    else
      n(x, E, I);
  }, U = (h, E, I, P = !1, k = !1) => {
    const {
      type: x,
      props: q,
      ref: H,
      children: j,
      dynamicChildren: B,
      shapeFlag: ie,
      patchFlag: J,
      dirs: se,
      cacheIndex: ce
    } = h;
    if (J === -2 && (k = !1), H != null && (bt(), kn(H, null, I, h, !0), wt()), ce != null && (E.renderCache[ce] = void 0), ie & 256) {
      E.ctx.deactivate(h);
      return;
    }
    const Ee = ie & 1 && se, Oe = !xn(h);
    let Ne;
    if (Oe && (Ne = q && q.onVnodeBeforeUnmount) && Dt(Ne, E, h), ie & 6)
      Se(h.component, I, P);
    else {
      if (ie & 128) {
        h.suspense.unmount(I, P);
        return;
      }
      Ee && fr(h, null, E, "beforeUnmount"), ie & 64 ? h.type.remove(
        h,
        E,
        I,
        de,
        P
      ) : B && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !B.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (x !== Mt || J > 0 && J & 64) ? ve(
        B,
        E,
        I,
        !1,
        !0
      ) : (x === Mt && J & 384 || !k && ie & 16) && ve(j, E, I), P && te(h);
    }
    (Oe && (Ne = q && q.onVnodeUnmounted) || Ee) && et(() => {
      Ne && Dt(Ne, E, h), Ee && fr(h, null, E, "unmounted");
    }, I);
  }, te = (h) => {
    const { type: E, el: I, anchor: P, transition: k } = h;
    if (E === Mt) {
      process.env.NODE_ENV !== "production" && h.patchFlag > 0 && h.patchFlag & 2048 && k && !k.persisted ? h.children.forEach((q) => {
        q.type === Et ? s(q.el) : te(q);
      }) : fe(I, P);
      return;
    }
    if (E === Ds) {
      v(h);
      return;
    }
    const x = () => {
      s(I), k && !k.persisted && k.afterLeave && k.afterLeave();
    };
    if (h.shapeFlag & 1 && k && !k.persisted) {
      const { leave: q, delayLeave: H } = k, j = () => q(I, x);
      H ? H(h.el, x, j) : j();
    } else
      x();
  }, fe = (h, E) => {
    let I;
    for (; h !== E; )
      I = f(h), s(h), h = I;
    s(E);
  }, Se = (h, E, I) => {
    process.env.NODE_ENV !== "production" && h.type.__hmrId && R0(h);
    const { bum: P, scope: k, job: x, subTree: q, um: H, m: j, a: B } = h;
    Ic(j), Ic(B), P && En(P), k.stop(), x && (x.flags |= 8, U(q, h, E, I)), H && et(H, E), et(() => {
      h.isUnmounted = !0;
    }, E), (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && B0(h);
  }, ve = (h, E, I, P = !1, k = !1, x = 0) => {
    for (let q = x; q < h.length; q++)
      U(h[q], E, I, P, k);
  }, ye = (h) => {
    if (h.shapeFlag & 6)
      return ye(h.component.subTree);
    if (h.shapeFlag & 128)
      return h.suspense.next();
    const E = f(h.anchor || h.el), I = E && E[G0];
    return I ? f(I) : E;
  };
  let ne = !1;
  const re = (h, E, I) => {
    h == null ? E._vnode && U(E._vnode, null, null, !0) : p(
      E._vnode || null,
      h,
      E,
      null,
      null,
      null,
      I
    ), E._vnode = h, ne || (ne = !0, Ec(), Cf(), ne = !1);
  }, de = {
    p,
    um: U,
    m: G,
    r: te,
    mt: V,
    mc: Q,
    pc: w,
    pbc: X,
    n: ye,
    o: e
  };
  return {
    render: re,
    hydrate: void 0,
    createApp: mb(re)
  };
}
function Zi({ type: e, props: t }, r) {
  return r === "svg" && e === "foreignObject" || r === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : r;
}
function pr({ effect: e, job: t }, r) {
  r ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function xb(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function Cs(e, t, r = !1) {
  const n = e.children, s = t.children;
  if (ue(n) && ue(s))
    for (let i = 0; i < n.length; i++) {
      const o = n[i];
      let a = s[i];
      a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = s[i] = Zt(s[i]), a.el = o.el), !r && a.patchFlag !== -2 && Cs(o, a)), a.type === Qn && // avoid cached text nodes retaining detached dom nodes
      a.patchFlag !== -1 && (a.el = o.el), a.type === Et && !a.el && (a.el = o.el), process.env.NODE_ENV !== "production" && a.el && (a.el.__vnode = a);
    }
}
function Pb(e) {
  const t = e.slice(), r = [0];
  let n, s, i, o, a;
  const l = e.length;
  for (n = 0; n < l; n++) {
    const u = e[n];
    if (u !== 0) {
      if (s = r[r.length - 1], e[s] < u) {
        t[n] = s, r.push(n);
        continue;
      }
      for (i = 0, o = r.length - 1; i < o; )
        a = i + o >> 1, e[r[a]] < u ? i = a + 1 : o = a;
      u < e[r[i]] && (i > 0 && (t[n] = r[i - 1]), r[i] = n);
    }
  }
  for (i = r.length, o = r[i - 1]; i-- > 0; )
    r[i] = o, o = t[o];
  return r;
}
function Jf(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : Jf(t);
}
function Ic(e) {
  if (e)
    for (let t = 0; t < e.length; t++)
      e[t].flags |= 8;
}
const $b = Symbol.for("v-scx"), Fb = () => {
  {
    const e = Ns($b);
    return e || process.env.NODE_ENV !== "production" && z(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), e;
  }
};
function eo(e, t, r) {
  return process.env.NODE_ENV !== "production" && !pe(t) && z(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), Xf(e, t, r);
}
function Xf(e, t, r = Ce) {
  const { immediate: n, deep: s, flush: i, once: o } = r;
  process.env.NODE_ENV !== "production" && !t && (n !== void 0 && z(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), s !== void 0 && z(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ), o !== void 0 && z(
    'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const a = Ve({}, r);
  process.env.NODE_ENV !== "production" && (a.onWarn = z);
  const l = t && n || !t && i !== "post";
  let u;
  if (Vn) {
    if (i === "sync") {
      const _ = Fb();
      u = _.__watcherHandles || (_.__watcherHandles = []);
    } else if (!l) {
      const _ = () => {
      };
      return _.stop = ke, _.resume = ke, _.pause = ke, _;
    }
  }
  const c = Ue;
  a.call = (_, g, p) => Ut(_, c, g, p);
  let d = !1;
  i === "post" ? a.scheduler = (_) => {
    et(_, c && c.suspense);
  } : i !== "sync" && (d = !0, a.scheduler = (_, g) => {
    g ? _() : Ei(_);
  }), a.augmentJob = (_) => {
    t && (_.flags |= 4), d && (_.flags |= 2, c && (_.id = c.uid, _.i = c));
  };
  const f = T0(e, t, a);
  return Vn && (u ? u.push(f) : l && f()), f;
}
function Vb(e, t, r) {
  const n = this.proxy, s = Pe(e) ? e.includes(".") ? Qf(n, e) : () => n[e] : e.bind(n, n);
  let i;
  pe(t) ? i = t : (i = t.handler, r = t);
  const o = Zn(this), a = Xf(s, i.bind(n), r);
  return o(), a;
}
function Qf(e, t) {
  const r = t.split(".");
  return () => {
    let n = e;
    for (let s = 0; s < r.length && n; s++)
      n = n[r[s]];
    return n;
  };
}
const Bb = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${mt(t)}Modifiers`] || e[`${or(t)}Modifiers`];
function Ub(e, t, ...r) {
  if (e.isUnmounted) return;
  const n = e.vnode.props || Ce;
  if (process.env.NODE_ENV !== "production") {
    const {
      emitsOptions: c,
      propsOptions: [d]
    } = e;
    if (c)
      if (!(t in c))
        (!d || !(hr(mt(t)) in d)) && z(
          `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${hr(mt(t))}" prop.`
        );
      else {
        const f = c[t];
        pe(f) && (f(...r) || z(
          `Invalid event arguments: event validation failed for event "${t}".`
        ));
      }
  }
  let s = r;
  const i = t.startsWith("update:"), o = i && Bb(n, t.slice(7));
  if (o && (o.trim && (s = r.map((c) => Pe(c) ? c.trim() : c)), o.number && (s = r.map(jv))), (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && j0(e, t, s), process.env.NODE_ENV !== "production") {
    const c = t.toLowerCase();
    c !== t && n[hr(c)] && z(
      `Event "${c}" is emitted in component ${wi(
        e,
        e.type
      )} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${or(
        t
      )}" instead of "${t}".`
    );
  }
  let a, l = n[a = hr(t)] || // also try camelCase event handler (#2249)
  n[a = hr(mt(t))];
  !l && i && (l = n[a = hr(or(t))]), l && Ut(
    l,
    e,
    6,
    s
  );
  const u = n[a + "Once"];
  if (u) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[a])
      return;
    e.emitted[a] = !0, Ut(
      u,
      e,
      6,
      s
    );
  }
}
const Hb = /* @__PURE__ */ new WeakMap();
function Zf(e, t, r = !1) {
  const n = __VUE_OPTIONS_API__ && r ? Hb : t.emitsCache, s = n.get(e);
  if (s !== void 0)
    return s;
  const i = e.emits;
  let o = {}, a = !1;
  if (__VUE_OPTIONS_API__ && !pe(e)) {
    const l = (u) => {
      const c = Zf(u, t, !0);
      c && (a = !0, Ve(o, c));
    };
    !r && t.mixins.length && t.mixins.forEach(l), e.extends && l(e.extends), e.mixins && e.mixins.forEach(l);
  }
  return !i && !a ? (De(e) && n.set(e, null), null) : (ue(i) ? i.forEach((l) => o[l] = null) : Ve(o, i), De(e) && n.set(e, o), o);
}
function bi(e, t) {
  return !e || !zn(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), we(e, t[0].toLowerCase() + t.slice(1)) || we(e, or(t)) || we(e, t));
}
let Qo = !1;
function Xs() {
  Qo = !0;
}
function Mc(e) {
  const {
    type: t,
    vnode: r,
    proxy: n,
    withProxy: s,
    propsOptions: [i],
    slots: o,
    attrs: a,
    emit: l,
    render: u,
    renderCache: c,
    props: d,
    data: f,
    setupState: _,
    ctx: g,
    inheritAttrs: p
  } = e, y = qs(e);
  let A, T;
  process.env.NODE_ENV !== "production" && (Qo = !1);
  try {
    if (r.shapeFlag & 4) {
      const v = s || n, Y = process.env.NODE_ENV !== "production" && _.__isScriptSetup ? new Proxy(v, {
        get(K, ee, Q) {
          return z(
            `Property '${String(
              ee
            )}' was accessed via 'this'. Avoid using 'this' in templates.`
          ), Reflect.get(K, ee, Q);
        }
      }) : v;
      A = ht(
        u.call(
          Y,
          v,
          c,
          process.env.NODE_ENV !== "production" ? Rt(d) : d,
          _,
          f,
          g
        )
      ), T = a;
    } else {
      const v = t;
      process.env.NODE_ENV !== "production" && a === d && Xs(), A = ht(
        v.length > 1 ? v(
          process.env.NODE_ENV !== "production" ? Rt(d) : d,
          process.env.NODE_ENV !== "production" ? {
            get attrs() {
              return Xs(), Rt(a);
            },
            slots: o,
            emit: l
          } : { attrs: a, slots: o, emit: l }
        ) : v(
          process.env.NODE_ENV !== "production" ? Rt(d) : d,
          null
        )
      ), T = t.props ? a : jb(a);
    }
  } catch (v) {
    Jn(v, e, 1), A = rr(Et);
  }
  let b = A, C;
  if (process.env.NODE_ENV !== "production" && A.patchFlag > 0 && A.patchFlag & 2048 && ([b, C] = ep(A)), T && p !== !1) {
    const v = Object.keys(T), { shapeFlag: Y } = b;
    if (v.length) {
      if (Y & 7)
        i && v.some(Us) && (T = Yb(
          T,
          i
        )), b = lr(b, T, !1, !0);
      else if (process.env.NODE_ENV !== "production" && !Qo && b.type !== Et) {
        const K = Object.keys(a), ee = [], Q = [];
        for (let Z = 0, X = K.length; Z < X; Z++) {
          const le = K[Z];
          zn(le) ? Us(le) || ee.push(le[2].toLowerCase() + le.slice(3)) : Q.push(le);
        }
        Q.length && z(
          `Extraneous non-props attributes (${Q.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`
        ), ee.length && z(
          `Extraneous non-emits event listeners (${ee.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
        );
      }
    }
  }
  return r.dirs && (process.env.NODE_ENV !== "production" && !Lc(b) && z(
    "Runtime directive used on component with non-element root node. The directives will not function as intended."
  ), b = lr(b, null, !1, !0), b.dirs = b.dirs ? b.dirs.concat(r.dirs) : r.dirs), r.transition && (process.env.NODE_ENV !== "production" && !Lc(b) && z(
    "Component inside <Transition> renders non-element root node that cannot be animated."
  ), qa(b, r.transition)), process.env.NODE_ENV !== "production" && C ? C(b) : A = b, qs(y), A;
}
const ep = (e) => {
  const t = e.children, r = e.dynamicChildren, n = Qa(t, !1);
  if (n) {
    if (process.env.NODE_ENV !== "production" && n.patchFlag > 0 && n.patchFlag & 2048)
      return ep(n);
  } else return [e, void 0];
  const s = t.indexOf(n), i = r ? r.indexOf(n) : -1, o = (a) => {
    t[s] = a, r && (i > -1 ? r[i] = a : a.patchFlag > 0 && (e.dynamicChildren = [...r, a]));
  };
  return [ht(n), o];
};
function Qa(e, t = !0) {
  let r;
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    if (tn(s)) {
      if (s.type !== Et || s.children === "v-if") {
        if (r)
          return;
        if (r = s, process.env.NODE_ENV !== "production" && t && r.patchFlag > 0 && r.patchFlag & 2048)
          return Qa(r.children);
      }
    } else
      return;
  }
  return r;
}
const jb = (e) => {
  let t;
  for (const r in e)
    (r === "class" || r === "style" || zn(r)) && ((t || (t = {}))[r] = e[r]);
  return t;
}, Yb = (e, t) => {
  const r = {};
  for (const n in e)
    (!Us(n) || !(n.slice(9) in t)) && (r[n] = e[n]);
  return r;
}, Lc = (e) => e.shapeFlag & 7 || e.type === Et;
function Gb(e, t, r) {
  const { props: n, children: s, component: i } = e, { props: o, children: a, patchFlag: l } = t, u = i.emitsOptions;
  if (process.env.NODE_ENV !== "production" && (s || a) && kt || t.dirs || t.transition)
    return !0;
  if (r && l >= 0) {
    if (l & 1024)
      return !0;
    if (l & 16)
      return n ? Rc(n, o, u) : !!o;
    if (l & 8) {
      const c = t.dynamicProps;
      for (let d = 0; d < c.length; d++) {
        const f = c[d];
        if (o[f] !== n[f] && !bi(u, f))
          return !0;
      }
    }
  } else
    return (s || a) && (!a || !a.$stable) ? !0 : n === o ? !1 : n ? o ? Rc(n, o, u) : !0 : !!o;
  return !1;
}
function Rc(e, t, r) {
  const n = Object.keys(t);
  if (n.length !== Object.keys(e).length)
    return !0;
  for (let s = 0; s < n.length; s++) {
    const i = n[s];
    if (t[i] !== e[i] && !bi(r, i))
      return !0;
  }
  return !1;
}
function Wb({ vnode: e, parent: t }, r) {
  for (; t; ) {
    const n = t.subTree;
    if (n.suspense && n.suspense.activeBranch === e && (n.el = e.el), n === e)
      (e = t.vnode).el = r, t = t.parent;
    else
      break;
  }
}
const tp = (e) => e.__isSuspense;
function qb(e, t) {
  t && t.pendingBranch ? ue(e) ? t.effects.push(...e) : t.effects.push(e) : Nf(e);
}
const Mt = Symbol.for("v-fgt"), Qn = Symbol.for("v-txt"), Et = Symbol.for("v-cmt"), Ds = Symbol.for("v-stc");
let kc = null;
function Qs(e, t = !1) {
  e < 0 && kc && t && (kc.hasOnce = !0);
}
function tn(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function wn(e, t) {
  if (process.env.NODE_ENV !== "production" && t.shapeFlag & 6 && e.component) {
    const r = As.get(t.type);
    if (r && r.has(e.component))
      return e.shapeFlag &= -257, t.shapeFlag &= -513, !1;
  }
  return e.type === t.type && e.key === t.key;
}
const Kb = (...e) => np(
  ...e
), rp = ({ key: e }) => e ?? null, Is = ({
  ref: e,
  ref_key: t,
  ref_for: r
}) => (typeof e == "number" && (e = "" + e), e != null ? Pe(e) || Fe(e) || pe(e) ? { i: rt, r: e, k: t, f: !!r } : e : null);
function zb(e, t = null, r = null, n = 0, s = null, i = e === Mt ? 0 : 1, o = !1, a = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && rp(t),
    ref: t && Is(t),
    scopeId: Rf,
    slotScopeIds: null,
    children: r,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: i,
    patchFlag: n,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: rt
  };
  return a ? (Za(l, r), i & 128 && e.normalize(l)) : r && (l.shapeFlag |= Pe(r) ? 8 : 16), process.env.NODE_ENV !== "production" && l.key !== l.key && z("VNode created with invalid key (NaN). VNode type:", l.type), l;
}
const rr = process.env.NODE_ENV !== "production" ? Kb : np;
function np(e, t = null, r = null, n = 0, s = null, i = !1) {
  if ((!e || e === ob) && (process.env.NODE_ENV !== "production" && !e && z(`Invalid vnode type when creating vnode: ${e}.`), e = Et), tn(e)) {
    const a = lr(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return r && Za(a, r), a.patchFlag = -2, a;
  }
  if (cp(e) && (e = e.__vccOpts), t) {
    t = Jb(t);
    let { class: a, style: l } = t;
    a && !Pe(a) && (t.class = $a(a)), De(l) && (js(l) && !ue(l) && (l = Ve({}, l)), t.style = Pa(l));
  }
  const o = Pe(e) ? 1 : tp(e) ? 128 : W0(e) ? 64 : De(e) ? 4 : pe(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && o & 4 && js(e) && (e = me(e), z(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), zb(
    e,
    t,
    r,
    n,
    s,
    o,
    i,
    !0
  );
}
function Jb(e) {
  return e ? js(e) || Yf(e) ? Ve({}, e) : e : null;
}
function lr(e, t, r = !1, n = !1) {
  const { props: s, ref: i, patchFlag: o, children: a, transition: l } = e, u = t ? Qb(s || {}, t) : s, c = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: u,
    key: u && rp(u),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      r && i ? ue(i) ? i.concat(Is(t)) : [i, Is(t)] : Is(t)
    ) : i,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && o === -1 && ue(a) ? a.map(sp) : a,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== Mt ? o === -1 ? 16 : o | 16 : o,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: l,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && lr(e.ssContent),
    ssFallback: e.ssFallback && lr(e.ssFallback),
    placeholder: e.placeholder,
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return l && n && qa(
    c,
    l.clone(c)
  ), c;
}
function sp(e) {
  const t = lr(e);
  return ue(e.children) && (t.children = e.children.map(sp)), t;
}
function Xb(e = " ", t = 0) {
  return rr(Qn, null, e, t);
}
function ht(e) {
  return e == null || typeof e == "boolean" ? rr(Et) : ue(e) ? rr(
    Mt,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : tn(e) ? Zt(e) : rr(Qn, null, String(e));
}
function Zt(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : lr(e);
}
function Za(e, t) {
  let r = 0;
  const { shapeFlag: n } = e;
  if (t == null)
    t = null;
  else if (ue(t))
    r = 16;
  else if (typeof t == "object")
    if (n & 65) {
      const s = t.default;
      s && (s._c && (s._d = !1), Za(e, s()), s._c && (s._d = !0));
      return;
    } else {
      r = 32;
      const s = t._;
      !s && !Yf(t) ? t._ctx = rt : s === 3 && rt && (rt.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else pe(t) ? (t = { default: t, _ctx: rt }, r = 32) : (t = String(t), n & 64 ? (r = 16, t = [Xb(t)]) : r = 8);
  e.children = t, e.shapeFlag |= r;
}
function Qb(...e) {
  const t = {};
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    for (const s in n)
      if (s === "class")
        t.class !== n.class && (t.class = $a([t.class, n.class]));
      else if (s === "style")
        t.style = Pa([t.style, n.style]);
      else if (zn(s)) {
        const i = t[s], o = n[s];
        o && i !== o && !(ue(i) && i.includes(o)) && (t[s] = i ? [].concat(i, o) : o);
      } else s !== "" && (t[s] = n[s]);
  }
  return t;
}
function Dt(e, t, r, n = null) {
  Ut(e, t, 7, [
    r,
    n
  ]);
}
const Zb = Uf();
let ew = 0;
function tw(e, t, r) {
  const n = e.type, s = (t ? t.appContext : e.appContext) || Zb, i = {
    uid: ew++,
    vnode: e,
    type: n,
    parent: t,
    appContext: s,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new Jv(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(s.provides),
    ids: t ? t.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: Wf(n, s),
    emitsOptions: Zf(n, s),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: Ce,
    // inheritAttrs
    inheritAttrs: n.inheritAttrs,
    // state
    ctx: Ce,
    data: Ce,
    props: Ce,
    attrs: Ce,
    slots: Ce,
    refs: Ce,
    setupState: Ce,
    setupContext: null,
    // suspense related
    suspense: r,
    suspenseId: r ? r.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return process.env.NODE_ENV !== "production" ? i.ctx = ab(i) : i.ctx = { _: i }, i.root = t ? t.root : i, i.emit = Ub.bind(null, i), e.ce && e.ce(i), i;
}
let Ue = null;
const ip = () => Ue || rt;
let Zs, Zo;
{
  const e = tr(), t = (r, n) => {
    let s;
    return (s = e[r]) || (s = e[r] = []), s.push(n), (i) => {
      s.length > 1 ? s.forEach((o) => o(i)) : s[0](i);
    };
  };
  Zs = t(
    "__VUE_INSTANCE_SETTERS__",
    (r) => Ue = r
  ), Zo = t(
    "__VUE_SSR_SETTERS__",
    (r) => Vn = r
  );
}
const Zn = (e) => {
  const t = Ue;
  return Zs(e), e.scope.on(), () => {
    e.scope.off(), Zs(t);
  };
}, xc = () => {
  Ue && Ue.scope.off(), Zs(null);
}, rw = /* @__PURE__ */ cn("slot,component");
function ea(e, { isNativeTag: t }) {
  (rw(e) || t(e)) && z(
    "Do not use built-in or reserved HTML elements as component id: " + e
  );
}
function op(e) {
  return e.vnode.shapeFlag & 4;
}
let Vn = !1;
function nw(e, t = !1, r = !1) {
  t && Zo(t);
  const { props: n, children: s } = e.vnode, i = op(e);
  Eb(e, n, i, t), Ib(e, s, r || t);
  const o = i ? sw(e, t) : void 0;
  return t && Zo(!1), o;
}
function sw(e, t) {
  var r;
  const n = e.type;
  if (process.env.NODE_ENV !== "production") {
    if (n.name && ea(n.name, e.appContext.config), n.components) {
      const i = Object.keys(n.components);
      for (let o = 0; o < i.length; o++)
        ea(i[o], e.appContext.config);
    }
    if (n.directives) {
      const i = Object.keys(n.directives);
      for (let o = 0; o < i.length; o++)
        kf(i[o]);
    }
    n.compilerOptions && iw() && z(
      '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
    );
  }
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, Ff), process.env.NODE_ENV !== "production" && lb(e);
  const { setup: s } = n;
  if (s) {
    bt();
    const i = e.setupContext = s.length > 1 ? aw(e) : null, o = Zn(e), a = dn(
      s,
      e,
      0,
      [
        process.env.NODE_ENV !== "production" ? Rt(e.props) : e.props,
        i
      ]
    ), l = Ra(a);
    if (wt(), o(), (l || e.sp) && !xn(e) && xf(e), l) {
      if (a.then(xc, xc), t)
        return a.then((u) => {
          Pc(e, u, t);
        }).catch((u) => {
          Jn(u, e, 0);
        });
      if (e.asyncDep = a, process.env.NODE_ENV !== "production" && !e.suspense) {
        const u = (r = n.name) != null ? r : "Anonymous";
        z(
          `Component <${u}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
        );
      }
    } else
      Pc(e, a, t);
  } else
    ap(e, t);
}
function Pc(e, t, r) {
  pe(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : De(t) ? (process.env.NODE_ENV !== "production" && tn(t) && z(
    "setup() should not return VNodes directly - return a render function instead."
  ), (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && (e.devtoolsRawSetupState = t), e.setupState = Tf(t), process.env.NODE_ENV !== "production" && cb(e)) : process.env.NODE_ENV !== "production" && t !== void 0 && z(
    `setup() should return an object. Received: ${t === null ? "null" : typeof t}`
  ), ap(e, r);
}
const iw = () => !0;
function ap(e, t, r) {
  const n = e.type;
  if (e.render || (e.render = n.render || ke), __VUE_OPTIONS_API__) {
    const s = Zn(e);
    bt();
    try {
      db(e);
    } finally {
      wt(), s();
    }
  }
  process.env.NODE_ENV !== "production" && !n.render && e.render === ke && !t && (n.template ? z(
    'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
  ) : z("Component is missing template or render function: ", n));
}
const $c = process.env.NODE_ENV !== "production" ? {
  get(e, t) {
    return Xs(), $e(e, "get", ""), e[t];
  },
  set() {
    return z("setupContext.attrs is readonly."), !1;
  },
  deleteProperty() {
    return z("setupContext.attrs is readonly."), !1;
  }
} : {
  get(e, t) {
    return $e(e, "get", ""), e[t];
  }
};
function ow(e) {
  return new Proxy(e.slots, {
    get(t, r) {
      return $e(e, "get", "$slots"), t[r];
    }
  });
}
function aw(e) {
  const t = (r) => {
    if (process.env.NODE_ENV !== "production" && (e.exposed && z("expose() should be called only once per setup()."), r != null)) {
      let n = typeof r;
      n === "object" && (ue(r) ? n = "array" : Fe(r) && (n = "ref")), n !== "object" && z(
        `expose() should be passed a plain object, received ${n}.`
      );
    }
    e.exposed = r || {};
  };
  if (process.env.NODE_ENV !== "production") {
    let r, n;
    return Object.freeze({
      get attrs() {
        return r || (r = new Proxy(e.attrs, $c));
      },
      get slots() {
        return n || (n = ow(e));
      },
      get emit() {
        return (s, ...i) => e.emit(s, ...i);
      },
      expose: t
    });
  } else
    return {
      attrs: new Proxy(e.attrs, $c),
      slots: e.slots,
      emit: e.emit,
      expose: t
    };
}
function el(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(Tf(m0(e.exposed)), {
    get(t, r) {
      if (r in t)
        return t[r];
      if (r in Sr)
        return Sr[r](e);
    },
    has(t, r) {
      return r in t || r in Sr;
    }
  })) : e.proxy;
}
const lw = /(?:^|[-_])\w/g, cw = (e) => e.replace(lw, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function lp(e, t = !0) {
  return pe(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function wi(e, t, r = !1) {
  let n = lp(t);
  if (!n && t.__file) {
    const s = t.__file.match(/([^/\\]+)\.\w+$/);
    s && (n = s[1]);
  }
  if (!n && e && e.parent) {
    const s = (i) => {
      for (const o in i)
        if (i[o] === t)
          return o;
    };
    n = s(
      e.components || e.parent.type.components
    ) || s(e.appContext.components);
  }
  return n ? cw(n) : r ? "App" : "Anonymous";
}
function cp(e) {
  return pe(e) && "__vccOpts" in e;
}
const up = (e, t) => {
  const r = b0(e, t, Vn);
  if (process.env.NODE_ENV !== "production") {
    const n = ip();
    n && n.appContext.config.warnRecursiveComputed && (r._warnRecursive = !0);
  }
  return r;
};
function uw(e, t, r) {
  const n = (i, o, a) => {
    Qs(-1);
    try {
      return rr(i, o, a);
    } finally {
      Qs(1);
    }
  }, s = arguments.length;
  return s === 2 ? De(t) && !ue(t) ? tn(t) ? n(e, null, [t]) : n(e, t) : n(e, null, t) : (s > 3 ? r = Array.prototype.slice.call(arguments, 2) : s === 3 && tn(r) && (r = [r]), n(e, t, r));
}
function dw() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, r = { style: "color:#f5222d" }, n = { style: "color:#eb2f96" }, s = {
    __vue_custom_formatter: !0,
    header(d) {
      if (!De(d))
        return null;
      if (d.__isVue)
        return ["div", e, "VueInstance"];
      if (Fe(d)) {
        bt();
        const f = d.value;
        return wt(), [
          "div",
          {},
          ["span", e, c(d)],
          "<",
          a(f),
          ">"
        ];
      } else {
        if (Yr(d))
          return [
            "div",
            {},
            ["span", e, nt(d) ? "ShallowReactive" : "Reactive"],
            "<",
            a(d),
            `>${ar(d) ? " (readonly)" : ""}`
          ];
        if (ar(d))
          return [
            "div",
            {},
            ["span", e, nt(d) ? "ShallowReadonly" : "Readonly"],
            "<",
            a(d),
            ">"
          ];
      }
      return null;
    },
    hasBody(d) {
      return d && d.__isVue;
    },
    body(d) {
      if (d && d.__isVue)
        return [
          "div",
          {},
          ...i(d.$)
        ];
    }
  };
  function i(d) {
    const f = [];
    d.type.props && d.props && f.push(o("props", me(d.props))), d.setupState !== Ce && f.push(o("setup", d.setupState)), d.data !== Ce && f.push(o("data", me(d.data)));
    const _ = l(d, "computed");
    _ && f.push(o("computed", _));
    const g = l(d, "inject");
    return g && f.push(o("injected", g)), f.push([
      "div",
      {},
      [
        "span",
        {
          style: n.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: d }]
    ]), f;
  }
  function o(d, f) {
    return f = Ve({}, f), Object.keys(f).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        d
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(f).map((_) => [
          "div",
          {},
          ["span", n, _ + ": "],
          a(f[_], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function a(d, f = !0) {
    return typeof d == "number" ? ["span", t, d] : typeof d == "string" ? ["span", r, JSON.stringify(d)] : typeof d == "boolean" ? ["span", n, d] : De(d) ? ["object", { object: f ? me(d) : d }] : ["span", r, String(d)];
  }
  function l(d, f) {
    const _ = d.type;
    if (pe(_))
      return;
    const g = {};
    for (const p in d.ctx)
      u(_, p, f) && (g[p] = d.ctx[p]);
    return g;
  }
  function u(d, f, _) {
    const g = d[_];
    if (ue(g) && g.includes(f) || De(g) && f in g || d.extends && u(d.extends, f, _) || d.mixins && d.mixins.some((p) => u(p, f, _)))
      return !0;
  }
  function c(d) {
    return nt(d) ? "ShallowRef" : d.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(s) : window.devtoolsFormatters = [s];
}
const Fc = "3.5.21", Ti = process.env.NODE_ENV !== "production" ? z : ke;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* @vue/runtime-dom v3.5.21
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let ta;
const Vc = typeof window < "u" && window.trustedTypes;
if (Vc)
  try {
    ta = /* @__PURE__ */ Vc.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch (e) {
    process.env.NODE_ENV !== "production" && Ti(`Error creating trusted types policy: ${e}`);
  }
const dp = ta ? (e) => ta.createHTML(e) : (e) => e, fw = "http://www.w3.org/2000/svg", pw = "http://www.w3.org/1998/Math/MathML", Yt = typeof document < "u" ? document : null, Bc = Yt && /* @__PURE__ */ Yt.createElement("template"), hw = {
  insert: (e, t, r) => {
    t.insertBefore(e, r || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, r, n) => {
    const s = t === "svg" ? Yt.createElementNS(fw, e) : t === "mathml" ? Yt.createElementNS(pw, e) : r ? Yt.createElement(e, { is: r }) : Yt.createElement(e);
    return e === "select" && n && n.multiple != null && s.setAttribute("multiple", n.multiple), s;
  },
  createText: (e) => Yt.createTextNode(e),
  createComment: (e) => Yt.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => Yt.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, r, n, s, i) {
    const o = r ? r.previousSibling : t.lastChild;
    if (s && (s === i || s.nextSibling))
      for (; t.insertBefore(s.cloneNode(!0), r), !(s === i || !(s = s.nextSibling)); )
        ;
    else {
      Bc.innerHTML = dp(
        n === "svg" ? `<svg>${e}</svg>` : n === "mathml" ? `<math>${e}</math>` : e
      );
      const a = Bc.content;
      if (n === "svg" || n === "mathml") {
        const l = a.firstChild;
        for (; l.firstChild; )
          a.appendChild(l.firstChild);
        a.removeChild(l);
      }
      t.insertBefore(a, r);
    }
    return [
      // first
      o ? o.nextSibling : t.firstChild,
      // last
      r ? r.previousSibling : t.lastChild
    ];
  }
}, gw = Symbol("_vtc");
function _w(e, t, r) {
  const n = e[gw];
  n && (t = (t ? [t, ...n] : [...n]).join(" ")), t == null ? e.removeAttribute("class") : r ? e.setAttribute("class", t) : e.className = t;
}
const Uc = Symbol("_vod"), mw = Symbol("_vsh"), yw = Symbol(process.env.NODE_ENV !== "production" ? "CSS_VAR_TEXT" : ""), Ew = /(?:^|;)\s*display\s*:/;
function vw(e, t, r) {
  const n = e.style, s = Pe(r);
  let i = !1;
  if (r && !s) {
    if (t)
      if (Pe(t))
        for (const o of t.split(";")) {
          const a = o.slice(0, o.indexOf(":")).trim();
          r[a] == null && Ms(n, a, "");
        }
      else
        for (const o in t)
          r[o] == null && Ms(n, o, "");
    for (const o in r)
      o === "display" && (i = !0), Ms(n, o, r[o]);
  } else if (s) {
    if (t !== r) {
      const o = n[yw];
      o && (r += ";" + o), n.cssText = r, i = Ew.test(r);
    }
  } else t && e.removeAttribute("style");
  Uc in e && (e[Uc] = i ? n.display : "", e[mw] && (n.display = "none"));
}
const bw = /[^\\];\s*$/, Hc = /\s*!important$/;
function Ms(e, t, r) {
  if (ue(r))
    r.forEach((n) => Ms(e, t, n));
  else if (r == null && (r = ""), process.env.NODE_ENV !== "production" && bw.test(r) && Ti(
    `Unexpected semicolon at the end of '${t}' style value: '${r}'`
  ), t.startsWith("--"))
    e.setProperty(t, r);
  else {
    const n = ww(e, t);
    Hc.test(r) ? e.setProperty(
      or(n),
      r.replace(Hc, ""),
      "important"
    ) : e[n] = r;
  }
}
const jc = ["Webkit", "Moz", "ms"], to = {};
function ww(e, t) {
  const r = to[t];
  if (r)
    return r;
  let n = mt(t);
  if (n !== "filter" && n in e)
    return to[t] = n;
  n = _i(n);
  for (let s = 0; s < jc.length; s++) {
    const i = jc[s] + n;
    if (i in e)
      return to[t] = i;
  }
  return t;
}
const Yc = "http://www.w3.org/1999/xlink";
function Gc(e, t, r, n, s, i = zv(t)) {
  n && t.startsWith("xlink:") ? r == null ? e.removeAttributeNS(Yc, t.slice(6, t.length)) : e.setAttributeNS(Yc, t, r) : r == null || i && !nf(r) ? e.removeAttribute(t) : e.setAttribute(
    t,
    i ? "" : un(r) ? String(r) : r
  );
}
function Wc(e, t, r, n, s) {
  if (t === "innerHTML" || t === "textContent") {
    r != null && (e[t] = t === "innerHTML" ? dp(r) : r);
    return;
  }
  const i = e.tagName;
  if (t === "value" && i !== "PROGRESS" && // custom elements may use _value internally
  !i.includes("-")) {
    const a = i === "OPTION" ? e.getAttribute("value") || "" : e.value, l = r == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(r);
    (a !== l || !("_value" in e)) && (e.value = l), r == null && e.removeAttribute(t), e._value = r;
    return;
  }
  let o = !1;
  if (r === "" || r == null) {
    const a = typeof e[t];
    a === "boolean" ? r = nf(r) : r == null && a === "string" ? (r = "", o = !0) : a === "number" && (r = 0, o = !0);
  }
  try {
    e[t] = r;
  } catch (a) {
    process.env.NODE_ENV !== "production" && !o && Ti(
      `Failed setting prop "${t}" on <${i.toLowerCase()}>: value ${r} is invalid.`,
      a
    );
  }
  o && e.removeAttribute(s || t);
}
function Tw(e, t, r, n) {
  e.addEventListener(t, r, n);
}
function Sw(e, t, r, n) {
  e.removeEventListener(t, r, n);
}
const qc = Symbol("_vei");
function Ow(e, t, r, n, s = null) {
  const i = e[qc] || (e[qc] = {}), o = i[t];
  if (n && o)
    o.value = process.env.NODE_ENV !== "production" ? zc(n, t) : n;
  else {
    const [a, l] = Aw(t);
    if (n) {
      const u = i[t] = Dw(
        process.env.NODE_ENV !== "production" ? zc(n, t) : n,
        s
      );
      Tw(e, a, u, l);
    } else o && (Sw(e, a, o, l), i[t] = void 0);
  }
}
const Kc = /(?:Once|Passive|Capture)$/;
function Aw(e) {
  let t;
  if (Kc.test(e)) {
    t = {};
    let n;
    for (; n = e.match(Kc); )
      e = e.slice(0, e.length - n[0].length), t[n[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : or(e.slice(2)), t];
}
let ro = 0;
const Nw = /* @__PURE__ */ Promise.resolve(), Cw = () => ro || (Nw.then(() => ro = 0), ro = Date.now());
function Dw(e, t) {
  const r = (n) => {
    if (!n._vts)
      n._vts = Date.now();
    else if (n._vts <= r.attached)
      return;
    Ut(
      Iw(n, r.value),
      t,
      5,
      [n]
    );
  };
  return r.value = e, r.attached = Cw(), r;
}
function zc(e, t) {
  return pe(e) || ue(e) ? e : (Ti(
    `Wrong type passed as event handler to ${t} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof e}.`
  ), ke);
}
function Iw(e, t) {
  if (ue(t)) {
    const r = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      r.call(e), e._stopped = !0;
    }, t.map(
      (n) => (s) => !s._stopped && n && n(s)
    );
  } else
    return t;
}
const Jc = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, Mw = (e, t, r, n, s, i) => {
  const o = s === "svg";
  t === "class" ? _w(e, n, o) : t === "style" ? vw(e, r, n) : zn(t) ? Us(t) || Ow(e, t, r, n, i) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : Lw(e, t, n, o)) ? (Wc(e, t, n), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && Gc(e, t, n, o, i, t !== "value")) : /* #11081 force set props for possible async custom element */ e._isVueCE && (/[A-Z]/.test(t) || !Pe(n)) ? Wc(e, mt(t), n, i, t) : (t === "true-value" ? e._trueValue = n : t === "false-value" && (e._falseValue = n), Gc(e, t, n, o));
};
function Lw(e, t, r, n) {
  if (n)
    return !!(t === "innerHTML" || t === "textContent" || t in e && Jc(t) && pe(r));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "autocorrect" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const s = e.tagName;
    if (s === "IMG" || s === "VIDEO" || s === "CANVAS" || s === "SOURCE")
      return !1;
  }
  return Jc(t) && Pe(r) ? !1 : t in e;
}
const Rw = /* @__PURE__ */ Ve({ patchProp: Mw }, hw);
let Xc;
function kw() {
  return Xc || (Xc = Rb(Rw));
}
const xw = ((...e) => {
  kw().render(...e);
});
/**
* vue v3.5.21
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function Pw() {
  dw();
}
process.env.NODE_ENV !== "production" && Pw();
let ra = null, na = null;
function RO(e) {
  return new Promise((t) => {
    ra = e, Fw(), t();
  });
}
function $w() {
  return ra || {};
}
function kO(e) {
  na = e;
}
const Be = (...e) => typeof na == "function" ? na(...e) : (console.warn("translatedData function not set!"), e[1]);
let O = {}, at = [], fn = !1;
const Fw = () => {
  var e, t;
  (!O || !Object.keys(O).length) && (O = $w()), at = ((e = O.getters) == null ? void 0 : e.eventManage) || [], fn = ((t = O.getters) == null ? void 0 : t.isAuthenticated) || !1;
}, ge = () => ({
  status: O.getters.isAuthenticated,
  user: O.getters.stateUser
});
let Qc = null, Zc = null, eu = null;
const xO = {
  gameData: {
    gameUrl: null,
    gameName: null
  },
  resolvePromise: null,
  confirmModal: null,
  gameItem: null,
  userData: null,
  setComponents(e) {
    e.GamesIframe && (Qc = e.GamesIframe), e.GamePop1 && (Zc = e.GamePop1), e.GamePop2 && (eu = e.GamePop2);
  },
  loadGame(e, t) {
    switch (this.gameItem = e, this.userData = ge().user, t.currency) {
      case 1:
        e.only_hkd == 1 ? this.getPointsConfiramtion(1) : e.only_hkd == 0 && this.callForGamesApi();
        break;
      case 2:
        e.only_hkd == 1 ? this.getPointsConfiramtion(1) : e.only_hkd == 0 && this.getPointsConfiramtion(2);
        break;
      case 3:
      case 4:
        this.callForGamesApi();
        break;
    }
  },
  getDreamCasinoLoadGames() {
    window.store.dispatch("setGlobalLoader", !0);
    let e = {
      type: "casino",
      game_code: this.gameItem.game_code,
      section_id: this.gameItem.sm_id
    };
    $("post", "GET_THIRD_PARTY_API", e, "user").then((t) => {
      var r;
      if (t && t.status == 200)
        if (window.store.dispatch("setGlobalLoader", !1), t.data.error)
          m(t.data.error);
        else {
          let n = (r = t == null ? void 0 : t.data) == null ? void 0 : r.url;
          if (n == null || n == null || n == "") {
            m("URL not found.");
            return;
          }
          this.gameData = {
            gameUrl: n,
            gameName: this.gameItem.game_name
          }, this.loadIframe(), window.store.dispatch("setGlobalLoader", !1);
        }
    }).catch((t) => {
      t && (window.store.dispatch("setGlobalLoader", !1), m(t[0]));
    });
  },
  async getPointsConfiramtion(e) {
    new Promise((r) => {
      this.resolvePromise = r, this.pointsConfirmationInit(e), this.confirmModal.show();
    }).then((r) => {
      r.isConfirmed && (this.confirmModal.hide(), this.callForGamesApi());
    });
  },
  callForGamesApi() {
    var e;
    if (((e = window.store.getters.stateUser) == null ? void 0 : e.actw) == "WB") {
      m("Casino not allowed in welcome balance.");
      return;
    }
    this.getDreamCasinoLoadGames();
  },
  createModal(e, t, r) {
    if (!document.getElementById(`games-modal-${r}`)) {
      const n = document.getElementById("app"), s = document.createElement("div");
      s.id = `games-modal-${r}`, n.appendChild(s);
      let i = uw(e, t);
      xw(i, s);
    }
    this.confirmModal = new $t(document.getElementById(r));
  },
  pointsConfirmationInit(e) {
    const t = e === 1 ? Zc : eu, r = e === 1 ? "gamePop1" : "gamePop2";
    this.createModal(t, { onAgreed: this.handleAgreed.bind(this) }, r);
  },
  handleAgreed() {
    this.resolvePromise && this.resolvePromise({ isConfirmed: !0 }), this.confirmModal.hide();
  },
  loadIframe() {
    this.createModal(
      Qc,
      {
        gameData: this.gameData,
        onCloseGame: this.closeGame.bind(this),
        userData: this.userData
      },
      "gamesIframe"
    ), this.confirmModal.show();
  },
  closeGame() {
    this.confirmModal.hide();
    const e = document.getElementById("games-modal-gamesIframe");
    e && e.remove(), this.confirmModal = null;
  }
};
let no = null, ds = {
  langData: {}
};
const PO = async (e, t = null, r = !0, n) => {
  try {
    no || (no = n), t = t ?? (localStorage.getItem("selectedLanguageCode") || "en");
    let s = e.find((i) => i.lang_code === t);
    if (!s || t == "en")
      return ds.langData = {}, localStorage.removeItem("selectedLanguageCode"), ds.langData;
    try {
      let i = await Vw(s.lang_url, no);
      return ds.langData = i.data, localStorage.setItem("selectedLanguageCode", t), ds.langData;
    } catch {
      return { errorMessage: "Failed to change language. Try different language." };
    }
  } catch {
    return r ? !1 : { errorMessage: "Failed to change language. Try different language." };
  }
}, Vw = async (e, t) => await Le.get(t + "/" + e), Ht = /* @__PURE__ */ Object.create(null);
Ht.open = "0";
Ht.close = "1";
Ht.ping = "2";
Ht.pong = "3";
Ht.message = "4";
Ht.upgrade = "5";
Ht.noop = "6";
const Ls = /* @__PURE__ */ Object.create(null);
Object.keys(Ht).forEach((e) => {
  Ls[Ht[e]] = e;
});
const sa = { type: "error", data: "parser error" }, fp = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", pp = typeof ArrayBuffer == "function", hp = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer, tl = ({ type: e, data: t }, r, n) => fp && t instanceof Blob ? r ? n(t) : tu(t, n) : pp && (t instanceof ArrayBuffer || hp(t)) ? r ? n(t) : tu(new Blob([t]), n) : n(Ht[e] + (t || "")), tu = (e, t) => {
  const r = new FileReader();
  return r.onload = function() {
    const n = r.result.split(",")[1];
    t("b" + (n || ""));
  }, r.readAsDataURL(e);
};
function ru(e) {
  return e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
}
let so;
function Bw(e, t) {
  if (fp && e.data instanceof Blob)
    return e.data.arrayBuffer().then(ru).then(t);
  if (pp && (e.data instanceof ArrayBuffer || hp(e.data)))
    return t(ru(e.data));
  tl(e, !1, (r) => {
    so || (so = new TextEncoder()), t(so.encode(r));
  });
}
const nu = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Nn = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (let e = 0; e < nu.length; e++)
  Nn[nu.charCodeAt(e)] = e;
const Uw = (e) => {
  let t = e.length * 0.75, r = e.length, n, s = 0, i, o, a, l;
  e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
  const u = new ArrayBuffer(t), c = new Uint8Array(u);
  for (n = 0; n < r; n += 4)
    i = Nn[e.charCodeAt(n)], o = Nn[e.charCodeAt(n + 1)], a = Nn[e.charCodeAt(n + 2)], l = Nn[e.charCodeAt(n + 3)], c[s++] = i << 2 | o >> 4, c[s++] = (o & 15) << 4 | a >> 2, c[s++] = (a & 3) << 6 | l & 63;
  return u;
}, Hw = typeof ArrayBuffer == "function", rl = (e, t) => {
  if (typeof e != "string")
    return {
      type: "message",
      data: gp(e, t)
    };
  const r = e.charAt(0);
  return r === "b" ? {
    type: "message",
    data: jw(e.substring(1), t)
  } : Ls[r] ? e.length > 1 ? {
    type: Ls[r],
    data: e.substring(1)
  } : {
    type: Ls[r]
  } : sa;
}, jw = (e, t) => {
  if (Hw) {
    const r = Uw(e);
    return gp(r, t);
  } else
    return { base64: !0, data: e };
}, gp = (e, t) => {
  switch (t) {
    case "blob":
      return e instanceof Blob ? e : new Blob([e]);
    case "arraybuffer":
    default:
      return e instanceof ArrayBuffer ? e : e.buffer;
  }
}, _p = "", Yw = (e, t) => {
  const r = e.length, n = new Array(r);
  let s = 0;
  e.forEach((i, o) => {
    tl(i, !1, (a) => {
      n[o] = a, ++s === r && t(n.join(_p));
    });
  });
}, Gw = (e, t) => {
  const r = e.split(_p), n = [];
  for (let s = 0; s < r.length; s++) {
    const i = rl(r[s], t);
    if (n.push(i), i.type === "error")
      break;
  }
  return n;
};
function Ww() {
  return new TransformStream({
    transform(e, t) {
      Bw(e, (r) => {
        const n = r.length;
        let s;
        if (n < 126)
          s = new Uint8Array(1), new DataView(s.buffer).setUint8(0, n);
        else if (n < 65536) {
          s = new Uint8Array(3);
          const i = new DataView(s.buffer);
          i.setUint8(0, 126), i.setUint16(1, n);
        } else {
          s = new Uint8Array(9);
          const i = new DataView(s.buffer);
          i.setUint8(0, 127), i.setBigUint64(1, BigInt(n));
        }
        e.data && typeof e.data != "string" && (s[0] |= 128), t.enqueue(s), t.enqueue(r);
      });
    }
  });
}
let io;
function fs(e) {
  return e.reduce((t, r) => t + r.length, 0);
}
function ps(e, t) {
  if (e[0].length === t)
    return e.shift();
  const r = new Uint8Array(t);
  let n = 0;
  for (let s = 0; s < t; s++)
    r[s] = e[0][n++], n === e[0].length && (e.shift(), n = 0);
  return e.length && n < e[0].length && (e[0] = e[0].slice(n)), r;
}
function qw(e, t) {
  io || (io = new TextDecoder());
  const r = [];
  let n = 0, s = -1, i = !1;
  return new TransformStream({
    transform(o, a) {
      for (r.push(o); ; ) {
        if (n === 0) {
          if (fs(r) < 1)
            break;
          const l = ps(r, 1);
          i = (l[0] & 128) === 128, s = l[0] & 127, s < 126 ? n = 3 : s === 126 ? n = 1 : n = 2;
        } else if (n === 1) {
          if (fs(r) < 2)
            break;
          const l = ps(r, 2);
          s = new DataView(l.buffer, l.byteOffset, l.length).getUint16(0), n = 3;
        } else if (n === 2) {
          if (fs(r) < 8)
            break;
          const l = ps(r, 8), u = new DataView(l.buffer, l.byteOffset, l.length), c = u.getUint32(0);
          if (c > Math.pow(2, 21) - 1) {
            a.enqueue(sa);
            break;
          }
          s = c * Math.pow(2, 32) + u.getUint32(4), n = 3;
        } else {
          if (fs(r) < s)
            break;
          const l = ps(r, s);
          a.enqueue(rl(i ? l : io.decode(l), t)), n = 0;
        }
        if (s === 0 || s > e) {
          a.enqueue(sa);
          break;
        }
      }
    }
  });
}
const mp = 4;
function xe(e) {
  if (e) return Kw(e);
}
function Kw(e) {
  for (var t in xe.prototype)
    e[t] = xe.prototype[t];
  return e;
}
xe.prototype.on = xe.prototype.addEventListener = function(e, t) {
  return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this;
};
xe.prototype.once = function(e, t) {
  function r() {
    this.off(e, r), t.apply(this, arguments);
  }
  return r.fn = t, this.on(e, r), this;
};
xe.prototype.off = xe.prototype.removeListener = xe.prototype.removeAllListeners = xe.prototype.removeEventListener = function(e, t) {
  if (this._callbacks = this._callbacks || {}, arguments.length == 0)
    return this._callbacks = {}, this;
  var r = this._callbacks["$" + e];
  if (!r) return this;
  if (arguments.length == 1)
    return delete this._callbacks["$" + e], this;
  for (var n, s = 0; s < r.length; s++)
    if (n = r[s], n === t || n.fn === t) {
      r.splice(s, 1);
      break;
    }
  return r.length === 0 && delete this._callbacks["$" + e], this;
};
xe.prototype.emit = function(e) {
  this._callbacks = this._callbacks || {};
  for (var t = new Array(arguments.length - 1), r = this._callbacks["$" + e], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  if (r) {
    r = r.slice(0);
    for (var n = 0, s = r.length; n < s; ++n)
      r[n].apply(this, t);
  }
  return this;
};
xe.prototype.emitReserved = xe.prototype.emit;
xe.prototype.listeners = function(e) {
  return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || [];
};
xe.prototype.hasListeners = function(e) {
  return !!this.listeners(e).length;
};
const Si = typeof Promise == "function" && typeof Promise.resolve == "function" ? (t) => Promise.resolve().then(t) : (t, r) => r(t, 0), lt = typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")(), zw = "arraybuffer";
function yp(e, ...t) {
  return t.reduce((r, n) => (e.hasOwnProperty(n) && (r[n] = e[n]), r), {});
}
const Jw = lt.setTimeout, Xw = lt.clearTimeout;
function Oi(e, t) {
  t.useNativeTimers ? (e.setTimeoutFn = Jw.bind(lt), e.clearTimeoutFn = Xw.bind(lt)) : (e.setTimeoutFn = lt.setTimeout.bind(lt), e.clearTimeoutFn = lt.clearTimeout.bind(lt));
}
const Qw = 1.33;
function Zw(e) {
  return typeof e == "string" ? eT(e) : Math.ceil((e.byteLength || e.size) * Qw);
}
function eT(e) {
  let t = 0, r = 0;
  for (let n = 0, s = e.length; n < s; n++)
    t = e.charCodeAt(n), t < 128 ? r += 1 : t < 2048 ? r += 2 : t < 55296 || t >= 57344 ? r += 3 : (n++, r += 4);
  return r;
}
function Ep() {
  return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}
function tT(e) {
  let t = "";
  for (let r in e)
    e.hasOwnProperty(r) && (t.length && (t += "&"), t += encodeURIComponent(r) + "=" + encodeURIComponent(e[r]));
  return t;
}
function rT(e) {
  let t = {}, r = e.split("&");
  for (let n = 0, s = r.length; n < s; n++) {
    let i = r[n].split("=");
    t[decodeURIComponent(i[0])] = decodeURIComponent(i[1]);
  }
  return t;
}
class nT extends Error {
  constructor(t, r, n) {
    super(t), this.description = r, this.context = n, this.type = "TransportError";
  }
}
class nl extends xe {
  /**
   * Transport abstract constructor.
   *
   * @param {Object} opts - options
   * @protected
   */
  constructor(t) {
    super(), this.writable = !1, Oi(this, t), this.opts = t, this.query = t.query, this.socket = t.socket, this.supportsBinary = !t.forceBase64;
  }
  /**
   * Emits an error.
   *
   * @param {String} reason
   * @param description
   * @param context - the error context
   * @return {Transport} for chaining
   * @protected
   */
  onError(t, r, n) {
    return super.emitReserved("error", new nT(t, r, n)), this;
  }
  /**
   * Opens the transport.
   */
  open() {
    return this.readyState = "opening", this.doOpen(), this;
  }
  /**
   * Closes the transport.
   */
  close() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }
  /**
   * Sends multiple packets.
   *
   * @param {Array} packets
   */
  send(t) {
    this.readyState === "open" && this.write(t);
  }
  /**
   * Called upon open
   *
   * @protected
   */
  onOpen() {
    this.readyState = "open", this.writable = !0, super.emitReserved("open");
  }
  /**
   * Called with data.
   *
   * @param {String} data
   * @protected
   */
  onData(t) {
    const r = rl(t, this.socket.binaryType);
    this.onPacket(r);
  }
  /**
   * Called with a decoded packet.
   *
   * @protected
   */
  onPacket(t) {
    super.emitReserved("packet", t);
  }
  /**
   * Called upon close.
   *
   * @protected
   */
  onClose(t) {
    this.readyState = "closed", super.emitReserved("close", t);
  }
  /**
   * Pauses the transport, in order not to lose packets during an upgrade.
   *
   * @param onPause
   */
  pause(t) {
  }
  createUri(t, r = {}) {
    return t + "://" + this._hostname() + this._port() + this.opts.path + this._query(r);
  }
  _hostname() {
    const t = this.opts.hostname;
    return t.indexOf(":") === -1 ? t : "[" + t + "]";
  }
  _port() {
    return this.opts.port && (this.opts.secure && +(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
  }
  _query(t) {
    const r = tT(t);
    return r.length ? "?" + r : "";
  }
}
class sT extends nl {
  constructor() {
    super(...arguments), this._polling = !1;
  }
  get name() {
    return "polling";
  }
  /**
   * Opens the socket (triggers polling). We write a PING message to determine
   * when the transport is open.
   *
   * @protected
   */
  doOpen() {
    this._poll();
  }
  /**
   * Pauses polling.
   *
   * @param {Function} onPause - callback upon buffers are flushed and transport is paused
   * @package
   */
  pause(t) {
    this.readyState = "pausing";
    const r = () => {
      this.readyState = "paused", t();
    };
    if (this._polling || !this.writable) {
      let n = 0;
      this._polling && (n++, this.once("pollComplete", function() {
        --n || r();
      })), this.writable || (n++, this.once("drain", function() {
        --n || r();
      }));
    } else
      r();
  }
  /**
   * Starts polling cycle.
   *
   * @private
   */
  _poll() {
    this._polling = !0, this.doPoll(), this.emitReserved("poll");
  }
  /**
   * Overloads onData to detect payloads.
   *
   * @protected
   */
  onData(t) {
    const r = (n) => {
      if (this.readyState === "opening" && n.type === "open" && this.onOpen(), n.type === "close")
        return this.onClose({ description: "transport closed by the server" }), !1;
      this.onPacket(n);
    };
    Gw(t, this.socket.binaryType).forEach(r), this.readyState !== "closed" && (this._polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this._poll());
  }
  /**
   * For polling, send a close packet.
   *
   * @protected
   */
  doClose() {
    const t = () => {
      this.write([{ type: "close" }]);
    };
    this.readyState === "open" ? t() : this.once("open", t);
  }
  /**
   * Writes a packets payload.
   *
   * @param {Array} packets - data packets
   * @protected
   */
  write(t) {
    this.writable = !1, Yw(t, (r) => {
      this.doWrite(r, () => {
        this.writable = !0, this.emitReserved("drain");
      });
    });
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const t = this.opts.secure ? "https" : "http", r = this.query || {};
    return this.opts.timestampRequests !== !1 && (r[this.opts.timestampParam] = Ep()), !this.supportsBinary && !r.sid && (r.b64 = 1), this.createUri(t, r);
  }
}
let vp = !1;
try {
  vp = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch {
}
const iT = vp;
function oT() {
}
class aT extends sT {
  /**
   * XHR Polling constructor.
   *
   * @param {Object} opts
   * @package
   */
  constructor(t) {
    if (super(t), typeof location < "u") {
      const r = location.protocol === "https:";
      let n = location.port;
      n || (n = r ? "443" : "80"), this.xd = typeof location < "u" && t.hostname !== location.hostname || n !== t.port;
    }
  }
  /**
   * Sends data.
   *
   * @param {String} data to send.
   * @param {Function} called upon flush.
   * @private
   */
  doWrite(t, r) {
    const n = this.request({
      method: "POST",
      data: t
    });
    n.on("success", r), n.on("error", (s, i) => {
      this.onError("xhr post error", s, i);
    });
  }
  /**
   * Starts a poll cycle.
   *
   * @private
   */
  doPoll() {
    const t = this.request();
    t.on("data", this.onData.bind(this)), t.on("error", (r, n) => {
      this.onError("xhr poll error", r, n);
    }), this.pollXhr = t;
  }
}
class Ft extends xe {
  /**
   * Request constructor
   *
   * @param {Object} options
   * @package
   */
  constructor(t, r, n) {
    super(), this.createRequest = t, Oi(this, n), this._opts = n, this._method = n.method || "GET", this._uri = r, this._data = n.data !== void 0 ? n.data : null, this._create();
  }
  /**
   * Creates the XHR object and sends the request.
   *
   * @private
   */
  _create() {
    var t;
    const r = yp(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
    r.xdomain = !!this._opts.xd;
    const n = this._xhr = this.createRequest(r);
    try {
      n.open(this._method, this._uri, !0);
      try {
        if (this._opts.extraHeaders) {
          n.setDisableHeaderCheck && n.setDisableHeaderCheck(!0);
          for (let s in this._opts.extraHeaders)
            this._opts.extraHeaders.hasOwnProperty(s) && n.setRequestHeader(s, this._opts.extraHeaders[s]);
        }
      } catch {
      }
      if (this._method === "POST")
        try {
          n.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch {
        }
      try {
        n.setRequestHeader("Accept", "*/*");
      } catch {
      }
      (t = this._opts.cookieJar) === null || t === void 0 || t.addCookies(n), "withCredentials" in n && (n.withCredentials = this._opts.withCredentials), this._opts.requestTimeout && (n.timeout = this._opts.requestTimeout), n.onreadystatechange = () => {
        var s;
        n.readyState === 3 && ((s = this._opts.cookieJar) === null || s === void 0 || s.parseCookies(
          // @ts-ignore
          n.getResponseHeader("set-cookie")
        )), n.readyState === 4 && (n.status === 200 || n.status === 1223 ? this._onLoad() : this.setTimeoutFn(() => {
          this._onError(typeof n.status == "number" ? n.status : 0);
        }, 0));
      }, n.send(this._data);
    } catch (s) {
      this.setTimeoutFn(() => {
        this._onError(s);
      }, 0);
      return;
    }
    typeof document < "u" && (this._index = Ft.requestsCount++, Ft.requests[this._index] = this);
  }
  /**
   * Called upon error.
   *
   * @private
   */
  _onError(t) {
    this.emitReserved("error", t, this._xhr), this._cleanup(!0);
  }
  /**
   * Cleans up house.
   *
   * @private
   */
  _cleanup(t) {
    if (!(typeof this._xhr > "u" || this._xhr === null)) {
      if (this._xhr.onreadystatechange = oT, t)
        try {
          this._xhr.abort();
        } catch {
        }
      typeof document < "u" && delete Ft.requests[this._index], this._xhr = null;
    }
  }
  /**
   * Called upon load.
   *
   * @private
   */
  _onLoad() {
    const t = this._xhr.responseText;
    t !== null && (this.emitReserved("data", t), this.emitReserved("success"), this._cleanup());
  }
  /**
   * Aborts the request.
   *
   * @package
   */
  abort() {
    this._cleanup();
  }
}
Ft.requestsCount = 0;
Ft.requests = {};
if (typeof document < "u") {
  if (typeof attachEvent == "function")
    attachEvent("onunload", su);
  else if (typeof addEventListener == "function") {
    const e = "onpagehide" in lt ? "pagehide" : "unload";
    addEventListener(e, su, !1);
  }
}
function su() {
  for (let e in Ft.requests)
    Ft.requests.hasOwnProperty(e) && Ft.requests[e].abort();
}
const lT = (function() {
  const e = bp({
    xdomain: !1
  });
  return e && e.responseType !== null;
})();
class cT extends aT {
  constructor(t) {
    super(t);
    const r = t && t.forceBase64;
    this.supportsBinary = lT && !r;
  }
  request(t = {}) {
    return Object.assign(t, { xd: this.xd }, this.opts), new Ft(bp, this.uri(), t);
  }
}
function bp(e) {
  const t = e.xdomain;
  try {
    if (typeof XMLHttpRequest < "u" && (!t || iT))
      return new XMLHttpRequest();
  } catch {
  }
  if (!t)
    try {
      return new lt[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch {
    }
}
const wp = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
class uT extends nl {
  get name() {
    return "websocket";
  }
  doOpen() {
    const t = this.uri(), r = this.opts.protocols, n = wp ? {} : yp(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
    this.opts.extraHeaders && (n.headers = this.opts.extraHeaders);
    try {
      this.ws = this.createSocket(t, r, n);
    } catch (s) {
      return this.emitReserved("error", s);
    }
    this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
  }
  /**
   * Adds event listeners to the socket
   *
   * @private
   */
  addEventListeners() {
    this.ws.onopen = () => {
      this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
    }, this.ws.onclose = (t) => this.onClose({
      description: "websocket connection closed",
      context: t
    }), this.ws.onmessage = (t) => this.onData(t.data), this.ws.onerror = (t) => this.onError("websocket error", t);
  }
  write(t) {
    this.writable = !1;
    for (let r = 0; r < t.length; r++) {
      const n = t[r], s = r === t.length - 1;
      tl(n, this.supportsBinary, (i) => {
        try {
          this.doWrite(n, i);
        } catch {
        }
        s && Si(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    typeof this.ws < "u" && (this.ws.onerror = () => {
    }, this.ws.close(), this.ws = null);
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const t = this.opts.secure ? "wss" : "ws", r = this.query || {};
    return this.opts.timestampRequests && (r[this.opts.timestampParam] = Ep()), this.supportsBinary || (r.b64 = 1), this.createUri(t, r);
  }
}
const oo = lt.WebSocket || lt.MozWebSocket;
class dT extends uT {
  createSocket(t, r, n) {
    return wp ? new oo(t, r, n) : r ? new oo(t, r) : new oo(t);
  }
  doWrite(t, r) {
    this.ws.send(r);
  }
}
class fT extends nl {
  get name() {
    return "webtransport";
  }
  doOpen() {
    try {
      this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
    } catch (t) {
      return this.emitReserved("error", t);
    }
    this._transport.closed.then(() => {
      this.onClose();
    }).catch((t) => {
      this.onError("webtransport error", t);
    }), this._transport.ready.then(() => {
      this._transport.createBidirectionalStream().then((t) => {
        const r = qw(Number.MAX_SAFE_INTEGER, this.socket.binaryType), n = t.readable.pipeThrough(r).getReader(), s = Ww();
        s.readable.pipeTo(t.writable), this._writer = s.writable.getWriter();
        const i = () => {
          n.read().then(({ done: a, value: l }) => {
            a || (this.onPacket(l), i());
          }).catch((a) => {
          });
        };
        i();
        const o = { type: "open" };
        this.query.sid && (o.data = `{"sid":"${this.query.sid}"}`), this._writer.write(o).then(() => this.onOpen());
      });
    });
  }
  write(t) {
    this.writable = !1;
    for (let r = 0; r < t.length; r++) {
      const n = t[r], s = r === t.length - 1;
      this._writer.write(n).then(() => {
        s && Si(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    var t;
    (t = this._transport) === null || t === void 0 || t.close();
  }
}
const pT = {
  websocket: dT,
  webtransport: fT,
  polling: cT
}, hT = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, gT = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
function ia(e) {
  if (e.length > 8e3)
    throw "URI too long";
  const t = e, r = e.indexOf("["), n = e.indexOf("]");
  r != -1 && n != -1 && (e = e.substring(0, r) + e.substring(r, n).replace(/:/g, ";") + e.substring(n, e.length));
  let s = hT.exec(e || ""), i = {}, o = 14;
  for (; o--; )
    i[gT[o]] = s[o] || "";
  return r != -1 && n != -1 && (i.source = t, i.host = i.host.substring(1, i.host.length - 1).replace(/;/g, ":"), i.authority = i.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), i.ipv6uri = !0), i.pathNames = _T(i, i.path), i.queryKey = mT(i, i.query), i;
}
function _T(e, t) {
  const r = /\/{2,9}/g, n = t.replace(r, "/").split("/");
  return (t.slice(0, 1) == "/" || t.length === 0) && n.splice(0, 1), t.slice(-1) == "/" && n.splice(n.length - 1, 1), n;
}
function mT(e, t) {
  const r = {};
  return t.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(n, s, i) {
    s && (r[s] = i);
  }), r;
}
const oa = typeof addEventListener == "function" && typeof removeEventListener == "function", Rs = [];
oa && addEventListener("offline", () => {
  Rs.forEach((e) => e());
}, !1);
class nr extends xe {
  /**
   * Socket constructor.
   *
   * @param {String|Object} uri - uri or options
   * @param {Object} opts - options
   */
  constructor(t, r) {
    if (super(), this.binaryType = zw, this.writeBuffer = [], this._prevBufferLen = 0, this._pingInterval = -1, this._pingTimeout = -1, this._maxPayload = -1, this._pingTimeoutTime = 1 / 0, t && typeof t == "object" && (r = t, t = null), t) {
      const n = ia(t);
      r.hostname = n.host, r.secure = n.protocol === "https" || n.protocol === "wss", r.port = n.port, n.query && (r.query = n.query);
    } else r.host && (r.hostname = ia(r.host).host);
    Oi(this, r), this.secure = r.secure != null ? r.secure : typeof location < "u" && location.protocol === "https:", r.hostname && !r.port && (r.port = this.secure ? "443" : "80"), this.hostname = r.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = r.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = [], this._transportsByName = {}, r.transports.forEach((n) => {
      const s = n.prototype.name;
      this.transports.push(s), this._transportsByName[s] = n;
    }), this.opts = Object.assign({
      path: "/engine.io",
      agent: !1,
      withCredentials: !1,
      upgrade: !0,
      timestampParam: "t",
      rememberUpgrade: !1,
      addTrailingSlash: !0,
      rejectUnauthorized: !0,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {},
      closeOnBeforeunload: !1
    }, r), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = rT(this.opts.query)), oa && (this.opts.closeOnBeforeunload && (this._beforeunloadEventListener = () => {
      this.transport && (this.transport.removeAllListeners(), this.transport.close());
    }, addEventListener("beforeunload", this._beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this._offlineEventListener = () => {
      this._onClose("transport close", {
        description: "network connection lost"
      });
    }, Rs.push(this._offlineEventListener))), this.opts.withCredentials && (this._cookieJar = void 0), this._open();
  }
  /**
   * Creates transport of the given type.
   *
   * @param {String} name - transport name
   * @return {Transport}
   * @private
   */
  createTransport(t) {
    const r = Object.assign({}, this.opts.query);
    r.EIO = mp, r.transport = t, this.id && (r.sid = this.id);
    const n = Object.assign({}, this.opts, {
      query: r,
      socket: this,
      hostname: this.hostname,
      secure: this.secure,
      port: this.port
    }, this.opts.transportOptions[t]);
    return new this._transportsByName[t](n);
  }
  /**
   * Initializes transport to use and starts probe.
   *
   * @private
   */
  _open() {
    if (this.transports.length === 0) {
      this.setTimeoutFn(() => {
        this.emitReserved("error", "No transports available");
      }, 0);
      return;
    }
    const t = this.opts.rememberUpgrade && nr.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
    this.readyState = "opening";
    const r = this.createTransport(t);
    r.open(), this.setTransport(r);
  }
  /**
   * Sets the current transport. Disables the existing one (if any).
   *
   * @private
   */
  setTransport(t) {
    this.transport && this.transport.removeAllListeners(), this.transport = t, t.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (r) => this._onClose("transport close", r));
  }
  /**
   * Called when connection is deemed open.
   *
   * @private
   */
  onOpen() {
    this.readyState = "open", nr.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush();
  }
  /**
   * Handles a packet.
   *
   * @private
   */
  _onPacket(t) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (this.emitReserved("packet", t), this.emitReserved("heartbeat"), t.type) {
        case "open":
          this.onHandshake(JSON.parse(t.data));
          break;
        case "ping":
          this._sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong"), this._resetPingTimeout();
          break;
        case "error":
          const r = new Error("server error");
          r.code = t.data, this._onError(r);
          break;
        case "message":
          this.emitReserved("data", t.data), this.emitReserved("message", t.data);
          break;
      }
  }
  /**
   * Called upon handshake completion.
   *
   * @param {Object} data - handshake obj
   * @private
   */
  onHandshake(t) {
    this.emitReserved("handshake", t), this.id = t.sid, this.transport.query.sid = t.sid, this._pingInterval = t.pingInterval, this._pingTimeout = t.pingTimeout, this._maxPayload = t.maxPayload, this.onOpen(), this.readyState !== "closed" && this._resetPingTimeout();
  }
  /**
   * Sets and resets ping timeout timer based on server pings.
   *
   * @private
   */
  _resetPingTimeout() {
    this.clearTimeoutFn(this._pingTimeoutTimer);
    const t = this._pingInterval + this._pingTimeout;
    this._pingTimeoutTime = Date.now() + t, this._pingTimeoutTimer = this.setTimeoutFn(() => {
      this._onClose("ping timeout");
    }, t), this.opts.autoUnref && this._pingTimeoutTimer.unref();
  }
  /**
   * Called on `drain` event
   *
   * @private
   */
  _onDrain() {
    this.writeBuffer.splice(0, this._prevBufferLen), this._prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
  }
  /**
   * Flush write buffers.
   *
   * @private
   */
  flush() {
    if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      const t = this._getWritablePackets();
      this.transport.send(t), this._prevBufferLen = t.length, this.emitReserved("flush");
    }
  }
  /**
   * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
   * long-polling)
   *
   * @private
   */
  _getWritablePackets() {
    if (!(this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1))
      return this.writeBuffer;
    let r = 1;
    for (let n = 0; n < this.writeBuffer.length; n++) {
      const s = this.writeBuffer[n].data;
      if (s && (r += Zw(s)), n > 0 && r > this._maxPayload)
        return this.writeBuffer.slice(0, n);
      r += 2;
    }
    return this.writeBuffer;
  }
  /**
   * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
   *
   * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
   * `write()` method then the message would not be buffered by the Socket.IO client.
   *
   * @return {boolean}
   * @private
   */
  /* private */
  _hasPingExpired() {
    if (!this._pingTimeoutTime)
      return !0;
    const t = Date.now() > this._pingTimeoutTime;
    return t && (this._pingTimeoutTime = 0, Si(() => {
      this._onClose("ping timeout");
    }, this.setTimeoutFn)), t;
  }
  /**
   * Sends a message.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  write(t, r, n) {
    return this._sendPacket("message", t, r, n), this;
  }
  /**
   * Sends a message. Alias of {@link Socket#write}.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  send(t, r, n) {
    return this._sendPacket("message", t, r, n), this;
  }
  /**
   * Sends a packet.
   *
   * @param {String} type: packet type.
   * @param {String} data.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @private
   */
  _sendPacket(t, r, n, s) {
    if (typeof r == "function" && (s = r, r = void 0), typeof n == "function" && (s = n, n = null), this.readyState === "closing" || this.readyState === "closed")
      return;
    n = n || {}, n.compress = n.compress !== !1;
    const i = {
      type: t,
      data: r,
      options: n
    };
    this.emitReserved("packetCreate", i), this.writeBuffer.push(i), s && this.once("flush", s), this.flush();
  }
  /**
   * Closes the connection.
   */
  close() {
    const t = () => {
      this._onClose("forced close"), this.transport.close();
    }, r = () => {
      this.off("upgrade", r), this.off("upgradeError", r), t();
    }, n = () => {
      this.once("upgrade", r), this.once("upgradeError", r);
    };
    return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
      this.upgrading ? n() : t();
    }) : this.upgrading ? n() : t()), this;
  }
  /**
   * Called upon transport error
   *
   * @private
   */
  _onError(t) {
    if (nr.priorWebsocketSuccess = !1, this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening")
      return this.transports.shift(), this._open();
    this.emitReserved("error", t), this._onClose("transport error", t);
  }
  /**
   * Called upon transport close.
   *
   * @private
   */
  _onClose(t, r) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
      if (this.clearTimeoutFn(this._pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), oa && (this._beforeunloadEventListener && removeEventListener("beforeunload", this._beforeunloadEventListener, !1), this._offlineEventListener)) {
        const n = Rs.indexOf(this._offlineEventListener);
        n !== -1 && Rs.splice(n, 1);
      }
      this.readyState = "closed", this.id = null, this.emitReserved("close", t, r), this.writeBuffer = [], this._prevBufferLen = 0;
    }
  }
}
nr.protocol = mp;
class yT extends nr {
  constructor() {
    super(...arguments), this._upgrades = [];
  }
  onOpen() {
    if (super.onOpen(), this.readyState === "open" && this.opts.upgrade)
      for (let t = 0; t < this._upgrades.length; t++)
        this._probe(this._upgrades[t]);
  }
  /**
   * Probes a transport.
   *
   * @param {String} name - transport name
   * @private
   */
  _probe(t) {
    let r = this.createTransport(t), n = !1;
    nr.priorWebsocketSuccess = !1;
    const s = () => {
      n || (r.send([{ type: "ping", data: "probe" }]), r.once("packet", (d) => {
        if (!n)
          if (d.type === "pong" && d.data === "probe") {
            if (this.upgrading = !0, this.emitReserved("upgrading", r), !r)
              return;
            nr.priorWebsocketSuccess = r.name === "websocket", this.transport.pause(() => {
              n || this.readyState !== "closed" && (c(), this.setTransport(r), r.send([{ type: "upgrade" }]), this.emitReserved("upgrade", r), r = null, this.upgrading = !1, this.flush());
            });
          } else {
            const f = new Error("probe error");
            f.transport = r.name, this.emitReserved("upgradeError", f);
          }
      }));
    };
    function i() {
      n || (n = !0, c(), r.close(), r = null);
    }
    const o = (d) => {
      const f = new Error("probe error: " + d);
      f.transport = r.name, i(), this.emitReserved("upgradeError", f);
    };
    function a() {
      o("transport closed");
    }
    function l() {
      o("socket closed");
    }
    function u(d) {
      r && d.name !== r.name && i();
    }
    const c = () => {
      r.removeListener("open", s), r.removeListener("error", o), r.removeListener("close", a), this.off("close", l), this.off("upgrading", u);
    };
    r.once("open", s), r.once("error", o), r.once("close", a), this.once("close", l), this.once("upgrading", u), this._upgrades.indexOf("webtransport") !== -1 && t !== "webtransport" ? this.setTimeoutFn(() => {
      n || r.open();
    }, 200) : r.open();
  }
  onHandshake(t) {
    this._upgrades = this._filterUpgrades(t.upgrades), super.onHandshake(t);
  }
  /**
   * Filters upgrades, returning only those matching client transports.
   *
   * @param {Array} upgrades - server upgrades
   * @private
   */
  _filterUpgrades(t) {
    const r = [];
    for (let n = 0; n < t.length; n++)
      ~this.transports.indexOf(t[n]) && r.push(t[n]);
    return r;
  }
}
let ET = class extends yT {
  constructor(t, r = {}) {
    const n = typeof t == "object" ? t : r;
    (!n.transports || n.transports && typeof n.transports[0] == "string") && (n.transports = (n.transports || ["polling", "websocket", "webtransport"]).map((s) => pT[s]).filter((s) => !!s)), super(t, n);
  }
};
function vT(e, t = "", r) {
  let n = e;
  r = r || typeof location < "u" && location, e == null && (e = r.protocol + "//" + r.host), typeof e == "string" && (e.charAt(0) === "/" && (e.charAt(1) === "/" ? e = r.protocol + e : e = r.host + e), /^(https?|wss?):\/\//.test(e) || (typeof r < "u" ? e = r.protocol + "//" + e : e = "https://" + e), n = ia(e)), n.port || (/^(http|ws)$/.test(n.protocol) ? n.port = "80" : /^(http|ws)s$/.test(n.protocol) && (n.port = "443")), n.path = n.path || "/";
  const i = n.host.indexOf(":") !== -1 ? "[" + n.host + "]" : n.host;
  return n.id = n.protocol + "://" + i + ":" + n.port + t, n.href = n.protocol + "://" + i + (r && r.port === n.port ? "" : ":" + n.port), n;
}
const bT = typeof ArrayBuffer == "function", wT = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e.buffer instanceof ArrayBuffer, Tp = Object.prototype.toString, TT = typeof Blob == "function" || typeof Blob < "u" && Tp.call(Blob) === "[object BlobConstructor]", ST = typeof File == "function" || typeof File < "u" && Tp.call(File) === "[object FileConstructor]";
function sl(e) {
  return bT && (e instanceof ArrayBuffer || wT(e)) || TT && e instanceof Blob || ST && e instanceof File;
}
function ks(e, t) {
  if (!e || typeof e != "object")
    return !1;
  if (Array.isArray(e)) {
    for (let r = 0, n = e.length; r < n; r++)
      if (ks(e[r]))
        return !0;
    return !1;
  }
  if (sl(e))
    return !0;
  if (e.toJSON && typeof e.toJSON == "function" && arguments.length === 1)
    return ks(e.toJSON(), !0);
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && ks(e[r]))
      return !0;
  return !1;
}
function OT(e) {
  const t = [], r = e.data, n = e;
  return n.data = aa(r, t), n.attachments = t.length, { packet: n, buffers: t };
}
function aa(e, t) {
  if (!e)
    return e;
  if (sl(e)) {
    const r = { _placeholder: !0, num: t.length };
    return t.push(e), r;
  } else if (Array.isArray(e)) {
    const r = new Array(e.length);
    for (let n = 0; n < e.length; n++)
      r[n] = aa(e[n], t);
    return r;
  } else if (typeof e == "object" && !(e instanceof Date)) {
    const r = {};
    for (const n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (r[n] = aa(e[n], t));
    return r;
  }
  return e;
}
function AT(e, t) {
  return e.data = la(e.data, t), delete e.attachments, e;
}
function la(e, t) {
  if (!e)
    return e;
  if (e && e._placeholder === !0) {
    if (typeof e.num == "number" && e.num >= 0 && e.num < t.length)
      return t[e.num];
    throw new Error("illegal attachments");
  } else if (Array.isArray(e))
    for (let r = 0; r < e.length; r++)
      e[r] = la(e[r], t);
  else if (typeof e == "object")
    for (const r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (e[r] = la(e[r], t));
  return e;
}
const NT = [
  "connect",
  "connect_error",
  "disconnect",
  "disconnecting",
  "newListener",
  "removeListener"
  // used by the Node.js EventEmitter
], CT = 5;
var be;
(function(e) {
  e[e.CONNECT = 0] = "CONNECT", e[e.DISCONNECT = 1] = "DISCONNECT", e[e.EVENT = 2] = "EVENT", e[e.ACK = 3] = "ACK", e[e.CONNECT_ERROR = 4] = "CONNECT_ERROR", e[e.BINARY_EVENT = 5] = "BINARY_EVENT", e[e.BINARY_ACK = 6] = "BINARY_ACK";
})(be || (be = {}));
class DT {
  /**
   * Encoder constructor
   *
   * @param {function} replacer - custom replacer to pass down to JSON.parse
   */
  constructor(t) {
    this.replacer = t;
  }
  /**
   * Encode a packet as a single string if non-binary, or as a
   * buffer sequence, depending on packet type.
   *
   * @param {Object} obj - packet object
   */
  encode(t) {
    return (t.type === be.EVENT || t.type === be.ACK) && ks(t) ? this.encodeAsBinary({
      type: t.type === be.EVENT ? be.BINARY_EVENT : be.BINARY_ACK,
      nsp: t.nsp,
      data: t.data,
      id: t.id
    }) : [this.encodeAsString(t)];
  }
  /**
   * Encode packet as string.
   */
  encodeAsString(t) {
    let r = "" + t.type;
    return (t.type === be.BINARY_EVENT || t.type === be.BINARY_ACK) && (r += t.attachments + "-"), t.nsp && t.nsp !== "/" && (r += t.nsp + ","), t.id != null && (r += t.id), t.data != null && (r += JSON.stringify(t.data, this.replacer)), r;
  }
  /**
   * Encode packet as 'buffer sequence' by removing blobs, and
   * deconstructing packet into object with placeholders and
   * a list of buffers.
   */
  encodeAsBinary(t) {
    const r = OT(t), n = this.encodeAsString(r.packet), s = r.buffers;
    return s.unshift(n), s;
  }
}
function iu(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
class il extends xe {
  /**
   * Decoder constructor
   *
   * @param {function} reviver - custom reviver to pass down to JSON.stringify
   */
  constructor(t) {
    super(), this.reviver = t;
  }
  /**
   * Decodes an encoded packet string into packet JSON.
   *
   * @param {String} obj - encoded packet
   */
  add(t) {
    let r;
    if (typeof t == "string") {
      if (this.reconstructor)
        throw new Error("got plaintext data when reconstructing a packet");
      r = this.decodeString(t);
      const n = r.type === be.BINARY_EVENT;
      n || r.type === be.BINARY_ACK ? (r.type = n ? be.EVENT : be.ACK, this.reconstructor = new IT(r), r.attachments === 0 && super.emitReserved("decoded", r)) : super.emitReserved("decoded", r);
    } else if (sl(t) || t.base64)
      if (this.reconstructor)
        r = this.reconstructor.takeBinaryData(t), r && (this.reconstructor = null, super.emitReserved("decoded", r));
      else
        throw new Error("got binary data when not reconstructing a packet");
    else
      throw new Error("Unknown type: " + t);
  }
  /**
   * Decode a packet String (JSON data)
   *
   * @param {String} str
   * @return {Object} packet
   */
  decodeString(t) {
    let r = 0;
    const n = {
      type: Number(t.charAt(0))
    };
    if (be[n.type] === void 0)
      throw new Error("unknown packet type " + n.type);
    if (n.type === be.BINARY_EVENT || n.type === be.BINARY_ACK) {
      const i = r + 1;
      for (; t.charAt(++r) !== "-" && r != t.length; )
        ;
      const o = t.substring(i, r);
      if (o != Number(o) || t.charAt(r) !== "-")
        throw new Error("Illegal attachments");
      n.attachments = Number(o);
    }
    if (t.charAt(r + 1) === "/") {
      const i = r + 1;
      for (; ++r && !(t.charAt(r) === "," || r === t.length); )
        ;
      n.nsp = t.substring(i, r);
    } else
      n.nsp = "/";
    const s = t.charAt(r + 1);
    if (s !== "" && Number(s) == s) {
      const i = r + 1;
      for (; ++r; ) {
        const o = t.charAt(r);
        if (o == null || Number(o) != o) {
          --r;
          break;
        }
        if (r === t.length)
          break;
      }
      n.id = Number(t.substring(i, r + 1));
    }
    if (t.charAt(++r)) {
      const i = this.tryParse(t.substr(r));
      if (il.isPayloadValid(n.type, i))
        n.data = i;
      else
        throw new Error("invalid payload");
    }
    return n;
  }
  tryParse(t) {
    try {
      return JSON.parse(t, this.reviver);
    } catch {
      return !1;
    }
  }
  static isPayloadValid(t, r) {
    switch (t) {
      case be.CONNECT:
        return iu(r);
      case be.DISCONNECT:
        return r === void 0;
      case be.CONNECT_ERROR:
        return typeof r == "string" || iu(r);
      case be.EVENT:
      case be.BINARY_EVENT:
        return Array.isArray(r) && (typeof r[0] == "number" || typeof r[0] == "string" && NT.indexOf(r[0]) === -1);
      case be.ACK:
      case be.BINARY_ACK:
        return Array.isArray(r);
    }
  }
  /**
   * Deallocates a parser's resources
   */
  destroy() {
    this.reconstructor && (this.reconstructor.finishedReconstruction(), this.reconstructor = null);
  }
}
class IT {
  constructor(t) {
    this.packet = t, this.buffers = [], this.reconPack = t;
  }
  /**
   * Method to be called when binary data received from connection
   * after a BINARY_EVENT packet.
   *
   * @param {Buffer | ArrayBuffer} binData - the raw binary data received
   * @return {null | Object} returns null if more binary data is expected or
   *   a reconstructed packet object if all buffers have been received.
   */
  takeBinaryData(t) {
    if (this.buffers.push(t), this.buffers.length === this.reconPack.attachments) {
      const r = AT(this.reconPack, this.buffers);
      return this.finishedReconstruction(), r;
    }
    return null;
  }
  /**
   * Cleans up binary packet reconstruction variables.
   */
  finishedReconstruction() {
    this.reconPack = null, this.buffers = [];
  }
}
const MT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Decoder: il,
  Encoder: DT,
  get PacketType() {
    return be;
  },
  protocol: CT
}, Symbol.toStringTag, { value: "Module" }));
function pt(e, t, r) {
  return e.on(t, r), function() {
    e.off(t, r);
  };
}
const LT = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
  newListener: 1,
  removeListener: 1
});
class Sp extends xe {
  /**
   * `Socket` constructor.
   */
  constructor(t, r, n) {
    super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = t, this.nsp = r, n && n.auth && (this.auth = n.auth), this._opts = Object.assign({}, n), this.io._autoConnect && this.open();
  }
  /**
   * Whether the socket is currently disconnected
   *
   * @example
   * const socket = io();
   *
   * socket.on("connect", () => {
   *   console.log(socket.disconnected); // false
   * });
   *
   * socket.on("disconnect", () => {
   *   console.log(socket.disconnected); // true
   * });
   */
  get disconnected() {
    return !this.connected;
  }
  /**
   * Subscribe to open, close and packet events
   *
   * @private
   */
  subEvents() {
    if (this.subs)
      return;
    const t = this.io;
    this.subs = [
      pt(t, "open", this.onopen.bind(this)),
      pt(t, "packet", this.onpacket.bind(this)),
      pt(t, "error", this.onerror.bind(this)),
      pt(t, "close", this.onclose.bind(this))
    ];
  }
  /**
   * Whether the Socket will try to reconnect when its Manager connects or reconnects.
   *
   * @example
   * const socket = io();
   *
   * console.log(socket.active); // true
   *
   * socket.on("disconnect", (reason) => {
   *   if (reason === "io server disconnect") {
   *     // the disconnection was initiated by the server, you need to manually reconnect
   *     console.log(socket.active); // false
   *   }
   *   // else the socket will automatically try to reconnect
   *   console.log(socket.active); // true
   * });
   */
  get active() {
    return !!this.subs;
  }
  /**
   * "Opens" the socket.
   *
   * @example
   * const socket = io({
   *   autoConnect: false
   * });
   *
   * socket.connect();
   */
  connect() {
    return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
  }
  /**
   * Alias for {@link connect()}.
   */
  open() {
    return this.connect();
  }
  /**
   * Sends a `message` event.
   *
   * This method mimics the WebSocket.send() method.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
   *
   * @example
   * socket.send("hello");
   *
   * // this is equivalent to
   * socket.emit("message", "hello");
   *
   * @return self
   */
  send(...t) {
    return t.unshift("message"), this.emit.apply(this, t), this;
  }
  /**
   * Override `emit`.
   * If the event is in `events`, it's emitted normally.
   *
   * @example
   * socket.emit("hello", "world");
   *
   * // all serializable datastructures are supported (no need to call JSON.stringify)
   * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
   *
   * // with an acknowledgement from the server
   * socket.emit("hello", "world", (val) => {
   *   // ...
   * });
   *
   * @return self
   */
  emit(t, ...r) {
    var n, s, i;
    if (LT.hasOwnProperty(t))
      throw new Error('"' + t.toString() + '" is a reserved event name');
    if (r.unshift(t), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile)
      return this._addToQueue(r), this;
    const o = {
      type: be.EVENT,
      data: r
    };
    if (o.options = {}, o.options.compress = this.flags.compress !== !1, typeof r[r.length - 1] == "function") {
      const c = this.ids++, d = r.pop();
      this._registerAckCallback(c, d), o.id = c;
    }
    const a = (s = (n = this.io.engine) === null || n === void 0 ? void 0 : n.transport) === null || s === void 0 ? void 0 : s.writable, l = this.connected && !(!((i = this.io.engine) === null || i === void 0) && i._hasPingExpired());
    return this.flags.volatile && !a || (l ? (this.notifyOutgoingListeners(o), this.packet(o)) : this.sendBuffer.push(o)), this.flags = {}, this;
  }
  /**
   * @private
   */
  _registerAckCallback(t, r) {
    var n;
    const s = (n = this.flags.timeout) !== null && n !== void 0 ? n : this._opts.ackTimeout;
    if (s === void 0) {
      this.acks[t] = r;
      return;
    }
    const i = this.io.setTimeoutFn(() => {
      delete this.acks[t];
      for (let a = 0; a < this.sendBuffer.length; a++)
        this.sendBuffer[a].id === t && this.sendBuffer.splice(a, 1);
      r.call(this, new Error("operation has timed out"));
    }, s), o = (...a) => {
      this.io.clearTimeoutFn(i), r.apply(this, a);
    };
    o.withError = !0, this.acks[t] = o;
  }
  /**
   * Emits an event and waits for an acknowledgement
   *
   * @example
   * // without timeout
   * const response = await socket.emitWithAck("hello", "world");
   *
   * // with a specific timeout
   * try {
   *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
   * } catch (err) {
   *   // the server did not acknowledge the event in the given delay
   * }
   *
   * @return a Promise that will be fulfilled when the server acknowledges the event
   */
  emitWithAck(t, ...r) {
    return new Promise((n, s) => {
      const i = (o, a) => o ? s(o) : n(a);
      i.withError = !0, r.push(i), this.emit(t, ...r);
    });
  }
  /**
   * Add the packet to the queue.
   * @param args
   * @private
   */
  _addToQueue(t) {
    let r;
    typeof t[t.length - 1] == "function" && (r = t.pop());
    const n = {
      id: this._queueSeq++,
      tryCount: 0,
      pending: !1,
      args: t,
      flags: Object.assign({ fromQueue: !0 }, this.flags)
    };
    t.push((s, ...i) => n !== this._queue[0] ? void 0 : (s !== null ? n.tryCount > this._opts.retries && (this._queue.shift(), r && r(s)) : (this._queue.shift(), r && r(null, ...i)), n.pending = !1, this._drainQueue())), this._queue.push(n), this._drainQueue();
  }
  /**
   * Send the first packet of the queue, and wait for an acknowledgement from the server.
   * @param force - whether to resend a packet that has not been acknowledged yet
   *
   * @private
   */
  _drainQueue(t = !1) {
    if (!this.connected || this._queue.length === 0)
      return;
    const r = this._queue[0];
    r.pending && !t || (r.pending = !0, r.tryCount++, this.flags = r.flags, this.emit.apply(this, r.args));
  }
  /**
   * Sends a packet.
   *
   * @param packet
   * @private
   */
  packet(t) {
    t.nsp = this.nsp, this.io._packet(t);
  }
  /**
   * Called upon engine `open`.
   *
   * @private
   */
  onopen() {
    typeof this.auth == "function" ? this.auth((t) => {
      this._sendConnectPacket(t);
    }) : this._sendConnectPacket(this.auth);
  }
  /**
   * Sends a CONNECT packet to initiate the Socket.IO session.
   *
   * @param data
   * @private
   */
  _sendConnectPacket(t) {
    this.packet({
      type: be.CONNECT,
      data: this._pid ? Object.assign({ pid: this._pid, offset: this._lastOffset }, t) : t
    });
  }
  /**
   * Called upon engine or manager `error`.
   *
   * @param err
   * @private
   */
  onerror(t) {
    this.connected || this.emitReserved("connect_error", t);
  }
  /**
   * Called upon engine `close`.
   *
   * @param reason
   * @param description
   * @private
   */
  onclose(t, r) {
    this.connected = !1, delete this.id, this.emitReserved("disconnect", t, r), this._clearAcks();
  }
  /**
   * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
   * the server.
   *
   * @private
   */
  _clearAcks() {
    Object.keys(this.acks).forEach((t) => {
      if (!this.sendBuffer.some((n) => String(n.id) === t)) {
        const n = this.acks[t];
        delete this.acks[t], n.withError && n.call(this, new Error("socket has been disconnected"));
      }
    });
  }
  /**
   * Called with socket packet.
   *
   * @param packet
   * @private
   */
  onpacket(t) {
    if (t.nsp === this.nsp)
      switch (t.type) {
        case be.CONNECT:
          t.data && t.data.sid ? this.onconnect(t.data.sid, t.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          break;
        case be.EVENT:
        case be.BINARY_EVENT:
          this.onevent(t);
          break;
        case be.ACK:
        case be.BINARY_ACK:
          this.onack(t);
          break;
        case be.DISCONNECT:
          this.ondisconnect();
          break;
        case be.CONNECT_ERROR:
          this.destroy();
          const n = new Error(t.data.message);
          n.data = t.data.data, this.emitReserved("connect_error", n);
          break;
      }
  }
  /**
   * Called upon a server event.
   *
   * @param packet
   * @private
   */
  onevent(t) {
    const r = t.data || [];
    t.id != null && r.push(this.ack(t.id)), this.connected ? this.emitEvent(r) : this.receiveBuffer.push(Object.freeze(r));
  }
  emitEvent(t) {
    if (this._anyListeners && this._anyListeners.length) {
      const r = this._anyListeners.slice();
      for (const n of r)
        n.apply(this, t);
    }
    super.emit.apply(this, t), this._pid && t.length && typeof t[t.length - 1] == "string" && (this._lastOffset = t[t.length - 1]);
  }
  /**
   * Produces an ack callback to emit with an event.
   *
   * @private
   */
  ack(t) {
    const r = this;
    let n = !1;
    return function(...s) {
      n || (n = !0, r.packet({
        type: be.ACK,
        id: t,
        data: s
      }));
    };
  }
  /**
   * Called upon a server acknowledgement.
   *
   * @param packet
   * @private
   */
  onack(t) {
    const r = this.acks[t.id];
    typeof r == "function" && (delete this.acks[t.id], r.withError && t.data.unshift(null), r.apply(this, t.data));
  }
  /**
   * Called upon server connect.
   *
   * @private
   */
  onconnect(t, r) {
    this.id = t, this.recovered = r && this._pid === r, this._pid = r, this.connected = !0, this.emitBuffered(), this.emitReserved("connect"), this._drainQueue(!0);
  }
  /**
   * Emit buffered events (received and emitted).
   *
   * @private
   */
  emitBuffered() {
    this.receiveBuffer.forEach((t) => this.emitEvent(t)), this.receiveBuffer = [], this.sendBuffer.forEach((t) => {
      this.notifyOutgoingListeners(t), this.packet(t);
    }), this.sendBuffer = [];
  }
  /**
   * Called upon server disconnect.
   *
   * @private
   */
  ondisconnect() {
    this.destroy(), this.onclose("io server disconnect");
  }
  /**
   * Called upon forced client/server side disconnections,
   * this method ensures the manager stops tracking us and
   * that reconnections don't get triggered for this.
   *
   * @private
   */
  destroy() {
    this.subs && (this.subs.forEach((t) => t()), this.subs = void 0), this.io._destroy(this);
  }
  /**
   * Disconnects the socket manually. In that case, the socket will not try to reconnect.
   *
   * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
   *
   * @example
   * const socket = io();
   *
   * socket.on("disconnect", (reason) => {
   *   // console.log(reason); prints "io client disconnect"
   * });
   *
   * socket.disconnect();
   *
   * @return self
   */
  disconnect() {
    return this.connected && this.packet({ type: be.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }
  /**
   * Alias for {@link disconnect()}.
   *
   * @return self
   */
  close() {
    return this.disconnect();
  }
  /**
   * Sets the compress flag.
   *
   * @example
   * socket.compress(false).emit("hello");
   *
   * @param compress - if `true`, compresses the sending data
   * @return self
   */
  compress(t) {
    return this.flags.compress = t, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
   * ready to send messages.
   *
   * @example
   * socket.volatile.emit("hello"); // the server may or may not receive it
   *
   * @returns self
   */
  get volatile() {
    return this.flags.volatile = !0, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
   * given number of milliseconds have elapsed without an acknowledgement from the server:
   *
   * @example
   * socket.timeout(5000).emit("my-event", (err) => {
   *   if (err) {
   *     // the server did not acknowledge the event in the given delay
   *   }
   * });
   *
   * @returns self
   */
  timeout(t) {
    return this.flags.timeout = t, this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * @example
   * socket.onAny((event, ...args) => {
   *   console.log(`got ${event}`);
   * });
   *
   * @param listener
   */
  onAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.push(t), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * @example
   * socket.prependAny((event, ...args) => {
   *   console.log(`got event ${event}`);
   * });
   *
   * @param listener
   */
  prependAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(t), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`got event ${event}`);
   * }
   *
   * socket.onAny(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAny(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAny();
   *
   * @param listener
   */
  offAny(t) {
    if (!this._anyListeners)
      return this;
    if (t) {
      const r = this._anyListeners;
      for (let n = 0; n < r.length; n++)
        if (t === r[n])
          return r.splice(n, 1), this;
    } else
      this._anyListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAny() {
    return this._anyListeners || [];
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.onAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  onAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(t), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.prependAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  prependAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(t), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`sent event ${event}`);
   * }
   *
   * socket.onAnyOutgoing(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAnyOutgoing(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAnyOutgoing();
   *
   * @param [listener] - the catch-all listener (optional)
   */
  offAnyOutgoing(t) {
    if (!this._anyOutgoingListeners)
      return this;
    if (t) {
      const r = this._anyOutgoingListeners;
      for (let n = 0; n < r.length; n++)
        if (t === r[n])
          return r.splice(n, 1), this;
    } else
      this._anyOutgoingListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAnyOutgoing() {
    return this._anyOutgoingListeners || [];
  }
  /**
   * Notify the listeners for each packet sent
   *
   * @param packet
   *
   * @private
   */
  notifyOutgoingListeners(t) {
    if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
      const r = this._anyOutgoingListeners.slice();
      for (const n of r)
        n.apply(this, t.data);
    }
  }
}
function pn(e) {
  e = e || {}, this.ms = e.min || 100, this.max = e.max || 1e4, this.factor = e.factor || 2, this.jitter = e.jitter > 0 && e.jitter <= 1 ? e.jitter : 0, this.attempts = 0;
}
pn.prototype.duration = function() {
  var e = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var t = Math.random(), r = Math.floor(t * this.jitter * e);
    e = (Math.floor(t * 10) & 1) == 0 ? e - r : e + r;
  }
  return Math.min(e, this.max) | 0;
};
pn.prototype.reset = function() {
  this.attempts = 0;
};
pn.prototype.setMin = function(e) {
  this.ms = e;
};
pn.prototype.setMax = function(e) {
  this.max = e;
};
pn.prototype.setJitter = function(e) {
  this.jitter = e;
};
class ca extends xe {
  constructor(t, r) {
    var n;
    super(), this.nsps = {}, this.subs = [], t && typeof t == "object" && (r = t, t = void 0), r = r || {}, r.path = r.path || "/socket.io", this.opts = r, Oi(this, r), this.reconnection(r.reconnection !== !1), this.reconnectionAttempts(r.reconnectionAttempts || 1 / 0), this.reconnectionDelay(r.reconnectionDelay || 1e3), this.reconnectionDelayMax(r.reconnectionDelayMax || 5e3), this.randomizationFactor((n = r.randomizationFactor) !== null && n !== void 0 ? n : 0.5), this.backoff = new pn({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(r.timeout == null ? 2e4 : r.timeout), this._readyState = "closed", this.uri = t;
    const s = r.parser || MT;
    this.encoder = new s.Encoder(), this.decoder = new s.Decoder(), this._autoConnect = r.autoConnect !== !1, this._autoConnect && this.open();
  }
  reconnection(t) {
    return arguments.length ? (this._reconnection = !!t, t || (this.skipReconnect = !0), this) : this._reconnection;
  }
  reconnectionAttempts(t) {
    return t === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = t, this);
  }
  reconnectionDelay(t) {
    var r;
    return t === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = t, (r = this.backoff) === null || r === void 0 || r.setMin(t), this);
  }
  randomizationFactor(t) {
    var r;
    return t === void 0 ? this._randomizationFactor : (this._randomizationFactor = t, (r = this.backoff) === null || r === void 0 || r.setJitter(t), this);
  }
  reconnectionDelayMax(t) {
    var r;
    return t === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = t, (r = this.backoff) === null || r === void 0 || r.setMax(t), this);
  }
  timeout(t) {
    return arguments.length ? (this._timeout = t, this) : this._timeout;
  }
  /**
   * Starts trying to reconnect if reconnection is enabled and we have not
   * started reconnecting yet
   *
   * @private
   */
  maybeReconnectOnOpen() {
    !this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
  }
  /**
   * Sets the current transport `socket`.
   *
   * @param {Function} fn - optional, callback
   * @return self
   * @public
   */
  open(t) {
    if (~this._readyState.indexOf("open"))
      return this;
    this.engine = new ET(this.uri, this.opts);
    const r = this.engine, n = this;
    this._readyState = "opening", this.skipReconnect = !1;
    const s = pt(r, "open", function() {
      n.onopen(), t && t();
    }), i = (a) => {
      this.cleanup(), this._readyState = "closed", this.emitReserved("error", a), t ? t(a) : this.maybeReconnectOnOpen();
    }, o = pt(r, "error", i);
    if (this._timeout !== !1) {
      const a = this._timeout, l = this.setTimeoutFn(() => {
        s(), i(new Error("timeout")), r.close();
      }, a);
      this.opts.autoUnref && l.unref(), this.subs.push(() => {
        this.clearTimeoutFn(l);
      });
    }
    return this.subs.push(s), this.subs.push(o), this;
  }
  /**
   * Alias for open()
   *
   * @return self
   * @public
   */
  connect(t) {
    return this.open(t);
  }
  /**
   * Called upon transport open.
   *
   * @private
   */
  onopen() {
    this.cleanup(), this._readyState = "open", this.emitReserved("open");
    const t = this.engine;
    this.subs.push(
      pt(t, "ping", this.onping.bind(this)),
      pt(t, "data", this.ondata.bind(this)),
      pt(t, "error", this.onerror.bind(this)),
      pt(t, "close", this.onclose.bind(this)),
      // @ts-ignore
      pt(this.decoder, "decoded", this.ondecoded.bind(this))
    );
  }
  /**
   * Called upon a ping.
   *
   * @private
   */
  onping() {
    this.emitReserved("ping");
  }
  /**
   * Called with data.
   *
   * @private
   */
  ondata(t) {
    try {
      this.decoder.add(t);
    } catch (r) {
      this.onclose("parse error", r);
    }
  }
  /**
   * Called when parser fully decodes a packet.
   *
   * @private
   */
  ondecoded(t) {
    Si(() => {
      this.emitReserved("packet", t);
    }, this.setTimeoutFn);
  }
  /**
   * Called upon socket error.
   *
   * @private
   */
  onerror(t) {
    this.emitReserved("error", t);
  }
  /**
   * Creates a new socket for the given `nsp`.
   *
   * @return {Socket}
   * @public
   */
  socket(t, r) {
    let n = this.nsps[t];
    return n ? this._autoConnect && !n.active && n.connect() : (n = new Sp(this, t, r), this.nsps[t] = n), n;
  }
  /**
   * Called upon a socket close.
   *
   * @param socket
   * @private
   */
  _destroy(t) {
    const r = Object.keys(this.nsps);
    for (const n of r)
      if (this.nsps[n].active)
        return;
    this._close();
  }
  /**
   * Writes a packet.
   *
   * @param packet
   * @private
   */
  _packet(t) {
    const r = this.encoder.encode(t);
    for (let n = 0; n < r.length; n++)
      this.engine.write(r[n], t.options);
  }
  /**
   * Clean up transport subscriptions and packet buffer.
   *
   * @private
   */
  cleanup() {
    this.subs.forEach((t) => t()), this.subs.length = 0, this.decoder.destroy();
  }
  /**
   * Close the current socket.
   *
   * @private
   */
  _close() {
    this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close");
  }
  /**
   * Alias for close()
   *
   * @private
   */
  disconnect() {
    return this._close();
  }
  /**
   * Called when:
   *
   * - the low-level engine is closed
   * - the parser encountered a badly formatted packet
   * - all sockets are disconnected
   *
   * @private
   */
  onclose(t, r) {
    var n;
    this.cleanup(), (n = this.engine) === null || n === void 0 || n.close(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", t, r), this._reconnection && !this.skipReconnect && this.reconnect();
  }
  /**
   * Attempt a reconnection.
   *
   * @private
   */
  reconnect() {
    if (this._reconnecting || this.skipReconnect)
      return this;
    const t = this;
    if (this.backoff.attempts >= this._reconnectionAttempts)
      this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
    else {
      const r = this.backoff.duration();
      this._reconnecting = !0;
      const n = this.setTimeoutFn(() => {
        t.skipReconnect || (this.emitReserved("reconnect_attempt", t.backoff.attempts), !t.skipReconnect && t.open((s) => {
          s ? (t._reconnecting = !1, t.reconnect(), this.emitReserved("reconnect_error", s)) : t.onreconnect();
        }));
      }, r);
      this.opts.autoUnref && n.unref(), this.subs.push(() => {
        this.clearTimeoutFn(n);
      });
    }
  }
  /**
   * Called upon successful reconnect.
   *
   * @private
   */
  onreconnect() {
    const t = this.backoff.attempts;
    this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", t);
  }
}
const Tn = {};
function xs(e, t) {
  typeof e == "object" && (t = e, e = void 0), t = t || {};
  const r = vT(e, t.path || "/socket.io"), n = r.source, s = r.id, i = r.path, o = Tn[s] && i in Tn[s].nsps, a = t.forceNew || t["force new connection"] || t.multiplex === !1 || o;
  let l;
  return a ? l = new ca(n, t) : (Tn[s] || (Tn[s] = new ca(n, t)), l = Tn[s]), r.query && !t.query && (t.query = r.queryKey), l.socket(r.path, t);
}
Object.assign(xs, {
  Manager: ca,
  Socket: Sp,
  io: xs,
  connect: xs
});
const RT = xs("https://zplay1.in", { transports: ["websocket"], upgrade: !1 });
class kT {
  constructor() {
    this.socketIo = RT, this.client = null, this.currSub = [], this.socketIo.on("connect", () => {
      this.client = this.socketIo.id, this.currSub.forEach((t) => {
        this.socketIo.emit(t.event, t.data);
      });
    });
  }
  on(t, r) {
    this.socketIo.on(t, r);
  }
  off(t) {
    this.socketIo.off(t);
  }
  emit(t, r) {
    t == "leave" ? r.forEach((n) => {
      this.currSub = this.currSub.filter((s) => s.data != n);
    }) : this.currSub.some((s) => s.event === t && s.data === r) || this.currSub.push({ event: t, data: r }), this.socketIo.connected && this.socketIo.emit(t, r);
  }
}
const xt = new kT();
let ou = !0;
const FO = () => {
  let e = null, t = 0, r = !1;
  return e = setTimeout(() => {
    t = window.scrollY, r = t > 80, clearTimeout(e), e = 0;
  }, 100), {
    scTimer: e,
    scY: t,
    showGoToTop: r
  };
}, xT = async (e, t, r) => {
  var n;
  try {
    let s = await $("get", "GET_SITE_VERSION", null, "user", { domain: window.location.hostname });
    if (s && s.status == 200) {
      let i = !1;
      if ((n = s == null ? void 0 : s.data) != null && n.error)
        m(s.data.error);
      else {
        let o = s.data.data, a = o == null ? void 0 : o.version, l = e || 0;
        if (!l || a != l || !t ? (r = !1, e = (await PT(e)).siteVersion) : Op(t, r), o != null && o.maintenance) {
          const { from_date: u, to_date: c } = o.maintenance, d = new Date(u).getTime(), f = new Date(c).getTime(), _ = Date.now(), g = d <= _ && _ <= f;
          d && f && g && (O.dispatch("setUnderMaintenance", o.maintenance), i = !0);
        }
        setTimeout(() => {
          var u, c;
          xT(((u = O == null ? void 0 : O.getters) == null ? void 0 : u.siteVersion) || 0, (c = O == null ? void 0 : O.getters) == null ? void 0 : c.siteSettings, r);
        }, 3e4), r = !0;
      }
      return { isSiteStatusCalled: r, isMaintenance: i };
    }
  } catch (s) {
    console.log(s), s && m(s[0]);
  }
}, PT = async (e) => {
  var t;
  try {
    let r = await $("get", "GET_SITE_SETTINGS", null, "user", { domain: window.location.hostname });
    if (r && r.status == 200)
      if (((t = r == null ? void 0 : r.data) == null ? void 0 : t.status) === 0)
        m(r.data.debug[0]);
      else {
        let n = r == null ? void 0 : r.data.data;
        n.siteSetting.announcement = JSON.parse(n.siteSetting.announcement), n.siteSetting.offer = n.siteSetting.poster.find((i) => i.poster_type == 12);
        let s;
        try {
          n.casino_url ? s = await (async () => (await Le.get(n.casino_url)).data)() : s = n == null ? void 0 : n.casinoGames;
        } catch {
          console.log("Could not get casino games");
        }
        return O.dispatch("setSettings", n.siteSetting), O.dispatch("setGamesData", s), O.dispatch("setBonusData", n.bonus_data), O.dispatch("setSiteVersion", n.siteSetting.version), Op(n.siteSetting), {
          siteVersion: n.siteSetting.version
        };
      }
  } catch (r) {
    console.log(r), r && m(r[0]);
  }
}, Op = async (e, t) => {
  try {
    if (t) return;
    if (e.meta_tags && (document.head.innerHTML += e.meta_tags), e.g_tags && FT(e.g_tags), e.meta_pixel_code && VT(e.meta_pixel_code), e.site_map) {
      const n = document.createElement("link");
      n.rel = "sitemap", n.type = "application/xml", n.title = "Sitemap", n.href = e.aws_url + e.storage_path.site_map + e.site_map, document.head.appendChild(n);
    }
    if (O.dispatch("setSettings", e), $T(e), e.front_css != null && e.front_css != "") {
      const n = document.createElement("style");
      n.type = "text/css", n.appendChild(document.createTextNode(e.front_css)), document.head.insertAdjacentElement("beforeend", n);
    }
    const r = document.createElement("link");
    r.rel = "icon", r.href = e.aws_url + e.storage_path.domain_image + e.fav_logo, document.head.insertAdjacentElement("beforeend", r), ge().status && ou && (ou = !1, ua(), BT()), t = !0;
  } catch (r) {
    console.log(r), r && m(r[0]);
  }
}, $T = async (e) => {
  try {
    let r = e.domain_name.charAt(0).toUpperCase() + e.domain_name.slice(1).toLowerCase();
    var t = {
      name: r,
      short_name: r,
      start_url: window.location.origin,
      display: "standalone",
      icons: [{
        src: e.app_logo ? e.aws_url + e.storage_path.domain_image + e.app_logo : e.aws_url + e.storage_path.domain_image + e.fav_logo,
        sizes: "256x256 512x512 192x192 144x144",
        type: "image/png",
        purpose: "any"
      }]
    };
    const n = JSON.stringify(t), s = new Blob([n], { type: "application/json" }), i = URL.createObjectURL(s), o = document.createElement("link");
    o.rel = "manifest", o.href = i, document.head.insertAdjacentElement("beforeend", o);
    let a = e.aws_url + e.storage_path.domain_image + e.logo;
    document.querySelector("#appleIcon").setAttribute("href", a), document.querySelector("#appleLaunchIcon").setAttribute("href", a);
    const l = document.createElement("meta");
    l.setAttribute("name", "apple-mobile-web-app-title"), l.setAttribute("content", r), document.head.insertAdjacentElement("beforeend", l);
  } catch (r) {
    console.log(r), r && m(r[0]);
  }
}, FT = async (e) => {
  try {
    let t = document.createElement("script");
    t.async = !0, t.src = `https://www.googletagmanager.com/gtag/js?id=${e}`;
    let r = document.createElement("script");
    r.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${e}');
    `, document.head.appendChild(t), document.head.appendChild(r);
  } catch (t) {
    console.log(t), t && m(t[0]);
  }
}, VT = async (e) => {
  try {
    const t = document.createElement("script");
    t.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${e}');
        fbq('track', 'PageView');
    `, document.head.appendChild(t);
    const r = document.createElement("noscript");
    r.innerHTML = `
        <img height="1" width="1" style="display:none"
            src="https://www.facebook.com/tr?id=${e}&ev=PageView&noscript=1"/>
    `, document.head.appendChild(r);
  } catch (t) {
    console.log(t), t && m(t[0]);
  }
}, BT = async () => {
  var n;
  try {
    let i = await $("post", "GET_FAVOURITE_LIST", {
      game_type: 1
    });
    if (i && i.status == 200 && ((n = i == null ? void 0 : i.data) == null ? void 0 : n.status) != 0) {
      for (var e = i.data.events, t = [], r = 0; r < e.length; r++)
        t.push(e[r]);
      O.dispatch("setFavouriteGames", t);
    }
  } catch (s) {
    console.log(s), s && m(s[0]);
  }
}, ua = async () => {
  try {
    let e = await $("post", "WALLET_BALANCE");
    if (e && e.status == 200 && e.data) {
      let t = O.getters.stateUser;
      t.balance = e.data.bl, t.expl = e.data.ex, t.bets_count = e.data.bc, t.earnBonus = e.data.eb, O.dispatch("setUser", t), setTimeout(function() {
        ua();
      }, 4e3);
    } else
      window.cookies.keys().forEach((t) => window.cookies.remove(t)), O.dispatch("resetAllState");
  } catch (e) {
    console.log(e), e.retry && setTimeout(function() {
      ua();
    }, 4e3), e && m(e[0]);
  }
}, VO = () => {
  try {
    ge().status && (xt.emit("sub", "DepositRequest-" + ge().user.userid), xt.on("DepositRequest", (e) => {
      successToast(e.msg);
    }));
  } catch (e) {
    console.log(e), e && m(e[0]);
  }
}, hn = (e, t, r, n) => fn && (r.length || n.length) ? !r.includes(parseInt(e)) && !n.includes(parseInt(t)) : !0, UT = (e) => fn ? !at.find((r) => r.type == e) : !0, HT = (e = null) => fn ? !at.filter((r) => r.type == "worli-matka").map((r) => r.type_id).includes(e) : !0, BO = () => fn && at ? !at.find((t) => t.type == "premium-fancy") : !0, Lr = (e) => {
  if (fn) {
    let t = at.filter((r) => r.type == "sports");
    if (t.length) {
      for (let r = 0; r < t.length; r++)
        if (t[r].type_id == e)
          return !1;
    }
  }
  return !0;
}, jT = (e) => {
  var t, r;
  try {
    let n = at == null ? void 0 : at.filter((o) => o.type == "casino-provider").map((o) => o.type_id), s = at == null ? void 0 : at.filter((o) => o.type == "provider-game").map((o) => o.type_id), i = (o, a, l, u) => l.length || u.length ? !u.includes(a) && !l.includes(o) : !0;
    for (let o in e) {
      let a = e[o];
      (t = a == null ? void 0 : a.menus) != null && t.length ? (a.menus.forEach((l) => {
        l.games = l.games.filter((u) => i(u.provider_id, u.id, n, s));
      }), a.menus = a.menus.filter((l) => l.games.length > 0)) : (r = a == null ? void 0 : a.games) != null && r.length && (a.games = a.games.filter((l) => i(l.provider_id, l.id, n, s)));
    }
  } catch {
    return e;
  }
}, UO = async (e) => {
  var t;
  try {
    let r = {}, n = await $("get", e, null, "sports");
    return n && n.status == 200 ? (r = (t = n == null ? void 0 : n.data) == null ? void 0 : t.data, { allData: r }) : { allData: r };
  } catch (r) {
    r && m(r);
  }
}, HO = (e) => {
  ge().status && (jT(e), O.dispatch("setGamesData", e));
}, jO = async () => {
  try {
    let e = await $("get", "UNREAD_NOTIFICATION_COUNT", null);
    e && e.status == 200 && localStorage.setItem("unread_notification_count", e.data.data.count);
  } catch (e) {
    e && m(e[0]);
  }
}, YO = async () => {
  try {
    let e = await $("get", "GET_MATCHES_LIST", null, "fantasy"), t = null;
    return e && e.status == 200 && (t = e.data.data), { allMatchesList: t };
  } catch (e) {
    e && console.log(e[0]);
  }
}, GO = (e, t) => {
  try {
    for (var r = 0; r < (e == null ? void 0 : e.length); r++)
      t != null && t.includes(parseInt(e == null ? void 0 : e[r].event_id)) ? e[r].favourite = !0 : e[r].favourite = !1;
    return { matches: e };
  } catch (n) {
    n && console.log(n);
  }
}, Ap = (e) => {
  try {
    let t = [], r = [];
    return ge().status && e && (t = e == null ? void 0 : e.filter((n) => n.type == "match").map((n) => n.type_id), r = e == null ? void 0 : e.filter((n) => n.type == "league").map((n) => n.type_id)), { lockedMatchIds: t, lockedLeagueIds: r };
  } catch (t) {
    t && console.log(t);
  }
}, WO = (e, t, r) => {
  try {
    let s = Ap(r), i = s.lockedMatchIds, o = s.lockedLeagueIds;
    for (var n = 0; n < (e == null ? void 0 : e.length); n++)
      Lr(e[n].sport_id) && hn(e[n].event_id, e[n].league_id, i, o) && (e[n].sport_id == 4 ? t["cricket/4"].matches.push(e[n]) : e[n].sport_id == 1 ? t["soccer/1"].matches.push(e[n]) : e[n].sport_id == 2 ? t["tennis/2"].matches.push(e[n]) : (t[`${e[n].sport_name}/${e[n].sport_id}`] || (t[`${e[n].sport_name}/${e[n].sport_id}`] = { matches: [], filterKey: [] }), t[`${e[n].sport_name}/${e[n].sport_id}`].matches.push(e[n])));
    return { matchesObj: t };
  } catch (s) {
    s && console.log(s);
  }
}, qO = (e, t, r) => {
  try {
    let s = Ap(eventManage), i = s.lockedMatchIds, o = s.lockedLeagueIds;
    for (var n = 0; n < e.length; n++)
      Lr(e[n].sport_id) && hn(e[n].matchId, e[n].league_id, i, o) && (e[n].sport_id == 4 ? t.Cricket.push(e[n]) : e[n].sport_id == 1 ? t.Football.push(e[n]) : e[n].sport_id == 2 ? t.Tennis.push(e[n]) : (t[e[n].sport_name] || (t[e[n].sport_name] = []), t[e[n].sport_name].push(e[n])), r[e[n].market_id] = e[n].runners ?? []);
    Object.entries(e).length && (socketService.emit("sub", "inplay.markets"), socketService.on("inplay.markets", (a) => {
      for (let l in a) {
        let u = e[l], c = a[l];
        if (!u) return;
        if (c != null && c.runners)
          for (let d of c.runners) {
            let f = u.find((_) => _.sid == d.sid);
            f && (d.ex.b && (f.ex.b = d.ex.b), d.ex.l && (f.ex.l = d.ex.l));
          }
      }
    }));
  } catch (s) {
    s && console.log(s);
  }
}, KO = ({ matches: e, filterKey: t }) => !t || !Array.isArray(t) || t.length === 0 ? e : e.filter((r) => {
  const n = r.isMatchLive || r.inplay, s = r.is_exclusive;
  return t.includes("live") && t.includes("virtual") ? n || s : t.includes("live") ? n && !s : t.includes("virtual") ? s : !0;
}), zO = (e) => ({
  isAffiliate() {
    var t;
    return (t = e.bonusData) == null ? void 0 : t.find((r) => (r == null ? void 0 : r.bonusType) == "affiliate bonus");
  }
}), YT = (e) => {
  try {
    let t = [], r = [];
    return ge().status && e && (t = e == null ? void 0 : e.filter((n) => n.type == "match").map((n) => n.type_id), r = e == null ? void 0 : e.filter((n) => n.type == "league").map((n) => n.type_id)), { lockedMatchIds: t, lockedLeagueIds: r };
  } catch (t) {
    t && console.log(t);
  }
}, JO = async (e) => {
  var t;
  try {
    let r = {}, n = await $("get", "MATCHES_BY_SPORT_ID", null, "sports", { sport_id: e });
    return n && n.status == 200 ? (r = (t = n == null ? void 0 : n.data) == null ? void 0 : t.data, { allData: r }) : { allData: r };
  } catch (r) {
    r && m(r);
  }
}, XO = (e, t, r) => {
  try {
    let n = YT(r), s = n.lockedMatchIds, i = n.lockedLeagueIds;
    return e = t.filter((o) => {
      var a;
      return Lr(o.sport_id) && hn(o.event_id, o.league_id, s, i) ? ((a = o.runners) == null || a.forEach((l) => {
        var c;
        const u = (c = o.runnerNames) == null ? void 0 : c.find((d) => d.SID === l.sid);
        u && (l.runner_name = u.RN);
      }), !0) : !1;
    }), e;
  } catch (n) {
    return console.log(n), [];
  }
}, QO = async (e) => {
  var t;
  try {
    let r = {
      match_id: e.event_id ?? e.eventId,
      game_type: 0
    }, n = await $("post", "MAKE_FAVOURITE", r);
    if ((n == null ? void 0 : n.status) == 200) {
      e.favourite = !e.favourite;
      let s = [...O.getters.favouriteGames];
      const i = Number(e.event_id ?? e.eventId);
      return s.includes(i) ? s = s.filter((o) => o != i) : s.push(Number(i)), O.dispatch("setFavouriteGames", s), _e((t = n == null ? void 0 : n.data) == null ? void 0 : t.success), n;
    }
  } catch (r) {
    r && m(r);
  }
}, ZO = (e) => ({
  t1FilteredMatchList() {
    var t, r, n;
    return (t = e == null ? void 0 : e.selectedFilters) != null && t.includes("live") && ((r = e == null ? void 0 : e.selectedFilters) != null && r.includes("virtual")) ? e == null ? void 0 : e.matches_list : (n = e == null ? void 0 : e.matches_list) == null ? void 0 : n.filter(
      (s) => {
        var i, o;
        return (i = e == null ? void 0 : e.selectedFilters) != null && i.includes("live") ? !s.is_exclusive : (o = e == null ? void 0 : e.selectedFilters) != null && o.includes("virtual") ? s.is_exclusive : !0;
      }
    );
  }
}), GT = () => {
  var e, t, r, n, s;
  try {
    let i = [], o = [];
    return ge().status && ((e = O == null ? void 0 : O.getters) != null && e.eventManage) && (i = (r = (t = O == null ? void 0 : O.getters) == null ? void 0 : t.eventManage) == null ? void 0 : r.filter((a) => a.type == "match").map((a) => a.type_id), o = (s = (n = O == null ? void 0 : O.getters) == null ? void 0 : n.eventManage) == null ? void 0 : s.filter((a) => a.type == "league").map((a) => a.type_id)), { lockedMatchIds: i, lockedLeagueIds: o };
  } catch (i) {
    i && console.log(i);
  }
}, eA = (e) => {
  let t = GT(), r = t.lockedMatchIds, n = t.lockedLeagueIds;
  var s = { matches: [], filterKey: [] }, i = { matches: [], filterKey: [] }, o = { matches: [], filterKey: [] };
  let a = {}, l = {};
  for (var u = 0; u < e.length; u++)
    Lr(e[u].sport_id) && hn(e[u].event_id, e[u].league_id, r, n) && (e[u].sport_id == 4 ? s.matches.push(e[u]) : e[u].sport_id == 1 ? i.matches.push(e[u]) : e[u].sport_id == 2 ? o.matches.push(e[u]) : (l[e[u].sport_name] || (l[e[u].sport_name] = {
      matches: [],
      filterKey: []
    }), l[e[u].sport_name].matches.push(e[u])));
  return s.matches.length > 0 && (a.Cricket = s), i.matches.length > 0 && (a.Soccer = i), o.matches.length > 0 && (a.Tennis = o), { allMatches: a, allsecondaryMatches: l };
}, au = (e, t) => {
  var r;
  return t ? (r = Object.keys(e)) == null ? void 0 : r.reduce((n, s) => ((s == null ? void 0 : s.toLowerCase()) === (t == null ? void 0 : t.toLowerCase()) && (n[s] = e[s]), n), {}) : e;
}, tA = (e) => ({
  t5SportsMenu() {
    var t, r, n, s, i;
    return [...(r = (t = e == null ? void 0 : e.sportList) == null ? void 0 : t.non_custom) == null ? void 0 : r.filter((o) => [1, 2, 3, 4].includes(o.rank)), ...(s = (n = e == null ? void 0 : e.sportList) == null ? void 0 : n.non_custom) == null ? void 0 : s.filter((o) => ![1, 2, 3, 4].includes(o.rank)), ...(i = e == null ? void 0 : e.sportList) == null ? void 0 : i.custom];
  },
  t5FilteredMathces() {
    var r, n;
    const t = { ...e == null ? void 0 : e.allMatches, ...e == null ? void 0 : e.allsecondaryMatches };
    if (((r = e == null ? void 0 : e.searchKey) == null ? void 0 : r.length) > 2) {
      const s = new Set((n = e == null ? void 0 : e.searchMatchResult) == null ? void 0 : n.map((o) => o.event_id)), i = Object.fromEntries(
        Object.entries(t).map(([o, a]) => {
          const l = a.matches.filter(
            (u) => s.has(u.event_id)
          );
          return [o, { ...a, matches: l }];
        }).filter(([o, a]) => a.matches.length > 0)
      );
      return au(i, e == null ? void 0 : e.selectedSport);
    } else
      return au(t, e == null ? void 0 : e.selectedSport);
  }
}), rA = {
  methods: {
    callCashout() {
      clearTimeout(this.cashoutTimeOut);
      for (let e in this.cashoutMarketData) {
        let t = this.cashoutMarketData[e], r;
        if (t.type == "market") {
          if (r = this.matchOddsData.find((i) => i.mid == e), !r) continue;
        } else if (r = this.bookmakerData.ml.find((i) => i.mi == e), !r) continue;
        let { value: n, bet: s } = this.getCashoutValue(r, t.type);
        t.value = n, t.bet = s;
      }
      this.cashoutTimeOut = setTimeout(() => {
        this.callCashout();
      }, 2e3);
    },
    calculateCashoutStake(e) {
      if (e.book) {
        let t = e.book.sort((l, u) => l.pl - u.pl), r = t[0], n = t[1];
        r.pl = parseFloat(r.pl).toFixed(2), n.pl = parseFloat(n.pl).toFixed(2);
        let s, i, o, a;
        return s = -1, a = r.back_odds, s == 1 ? (i = (n.pl - r.pl) / a, o = {
          run1: parseFloat(r.pl) + i,
          run2: parseFloat(n.pl) + -1 * ((a - 1) * 100 * i) / 100
        }) : s == -1 && (i = (n.pl - r.pl) / a, o = {
          run1: parseFloat(r.pl) + i * ((a - 1) * 100) / 100,
          run2: parseFloat(n.pl) - i
        }), [{ ...r, betOdds: a, betType: s, betStake: i, cashoutStake: o }];
      }
    },
    calculateAlternateCashoutStake(e) {
      let t = e.sort((l, u) => u.pl - l.pl), r = t[0], n = t[1], s = -1, i, o, a;
      return a = n.back_odds, i = (r.pl - n.pl) / a, o = {
        run1: parseFloat(r.pl) - i,
        run2: parseFloat(n.pl) + n.back_odds * i - i
      }, [{ ...n, betOdds: a, betType: s, betStake: i, cashoutStake: o }];
    },
    calculateCashoutStakeForBookmaker(e) {
      if (e.book) {
        let t = e.book.sort((c, d) => c.pl - d.pl), r = t[0], n = t[1];
        r.pl = parseFloat(r.pl).toFixed(2), n.pl = parseFloat(n.pl).toFixed(2);
        let s, i, o, a, l = r;
        if (e.unavailableRunners == 1)
          r.ss == "SUSPEND" ? (s = 1, a = n.lay_odds, l = n) : (s = -1, a = r.back_odds);
        else if (!e.unavailableRunners)
          s = -1, a = r.back_odds;
        else
          return null;
        s == 1 ? (i = (n.pl - r.pl) / a, o = {
          run1: parseFloat(r.pl) + i,
          run2: parseFloat(n.pl) + -1 * ((a - 1) * 100 * i) / 100
        }) : s == -1 && (i = (n.pl - r.pl) / a, o = {
          run1: parseFloat(r.pl) + i * ((a - 1) * 100) / 100,
          run2: parseFloat(n.pl) - i
        });
        let u = parseFloat(((a - 1) * 100).toFixed(2));
        return [{ ...l, betOdds: a, betType: s, betStake: i, cashoutStake: o, realBetOdds: u }];
      }
    },
    getBook(e, t) {
      var r, n, s, i, o, a, l, u;
      try {
        if (t == "market") {
          if (this.marketBookAndExposure && this.marketBookAndExposure.marketsBook && this.marketBookAndExposure.marketsBook.length) {
            let c = (r = this.marketBookAndExposure.marketsBook.find((d) => d.id == e.mid)) == null ? void 0 : r.runner_book;
            if (c = Object.create(c), c)
              if (e.marketName == "Who Will Win The Match?") {
                for (let d = 0; d < c.length; d++)
                  for (let f = 0; f < e.runners.length; f++)
                    c[d].selection_id == e.runners[f].sid && (c[d] = {
                      ...c[d],
                      back_odds: (s = (n = e.runners[f].ex.b) == null ? void 0 : n[0]) == null ? void 0 : s.p,
                      lay_odds: 0,
                      sid: e.runners[f].sid,
                      s: e.runners[f].s,
                      runner_index: f
                    });
                return this.calculateAlternateCashoutStake(c);
              } else {
                let d = 0;
                for (let _ = 0; _ < c.length; _++)
                  for (let g = 0; g < e.runners.length; g++)
                    c[_].selection_id == e.runners[g].sid && (c[_] = {
                      ...c[_],
                      back_odds: (o = (i = e.runners[g].ex.b) == null ? void 0 : i[0]) == null ? void 0 : o.p,
                      lay_odds: (l = (a = e.runners[g].ex.l) == null ? void 0 : a[0]) == null ? void 0 : l.p,
                      sid: e.runners[g].sid,
                      s: e.runners[g].s,
                      runner_index: g
                    }, !d && (!c[_].back_odds || !c[_].lay_odds || e.runners[g].s != "ACTIVE") && (d = !0));
                if (d)
                  return null;
                let f = {
                  book: c
                };
                return this.calculateCashoutStake(f);
              }
            else return null;
          }
        } else if (t == "bookmaker" && this.marketBookAndExposure && this.marketBookAndExposure.bookmakersBook && this.marketBookAndExposure.bookmakersBook.length) {
          let c = (u = this.marketBookAndExposure.bookmakersBook.find((d) => d.id == e.mi)) == null ? void 0 : u.runner_book;
          if (!c || c.length == 3)
            return null;
          if (e.mn == "TOSS") {
            for (let f = 0; f < c.length; f++)
              for (let _ = 0; _ < e.sl.length; _++)
                c[f].selection_id == e.sl[_].si && (c[f] = {
                  ...c[f],
                  back_odds: e.sl[_].ss !== "ACTIVE" || e.sn !== "ONLINE" ? 0 : e.sl[_].b / 100 + 1,
                  lay_odds: e.sl[_].l,
                  si: e.sl[_].si,
                  ss: e.sl[_].ss,
                  runner_index: _
                });
            let d = {
              book: c,
              unavailableRunners: 0
            };
            return this.calculateCashoutStakeForBookmaker(d);
          } else {
            let d = 0;
            for (let _ = 0; _ < c.length; _++)
              for (let g = 0; g < e.sl.length; g++)
                c[_].selection_id == e.sl[g].si && ((e.sl[g].ss !== "ACTIVE" || e.sn !== "ONLINE") && (d += 1), c[_] = {
                  ...c[_],
                  back_odds: e.sl[g].ss !== "ACTIVE" || e.sn !== "ONLINE" ? 0 : e.sl[g].b / 100 + 1,
                  lay_odds: e.sl[g].ss !== "ACTIVE" || e.sn !== "ONLINE" ? 0 : e.sl[g].l / 100 + 1,
                  si: e.sl[g].si,
                  ss: e.sl[g].ss,
                  runner_index: g
                });
            let f = {
              book: c,
              unavailableRunners: d
            };
            return this.calculateCashoutStakeForBookmaker(f);
          }
        }
      } catch (c) {
        console.log("=====", c);
      }
    },
    getCashoutValue(e, t) {
      var r;
      try {
        let n = this.getBook(e, t)[0], s = {
          match_id: this.eventDetails.matchId,
          sport_id: this.eventDetails.sportId,
          event_id: this.eventDetails.eventId,
          selection_type: n.betType && n.betType == 1 ? "lay" : "back",
          bet_type: t,
          bet_delay: t == "bookmaker" ? e.bd || 0 : e.bet_delay || 0,
          runner_index: n.runner_index,
          market_id: t == "bookmaker" ? e.mi : e.mid,
          runner_name: n.name,
          runner_selection_id: n.selection_id,
          odds: t == "bookmaker" ? n.realBetOdds : n.betOdds,
          stake: n.betStake.toFixed(2),
          bet_id: this.$dateTime.currentTimestamp(),
          userId: this.$auth.user.userid,
          accept_any_odds: 0,
          is_cashout: !0,
          ...this.isPool && { pool_id: (r = this.chosenPool) == null ? void 0 : r.id }
        };
        return { value: this.chashOutRunnerBook(n), bet: s };
      } catch {
        return { value: null, bet: null };
      }
    },
    // chashOutRunnerBook(betData) {
    //     if (betData) {
    //         let finalBetStake = betData.cashoutStake?.run1;
    //         if (finalBetStake >= 0) {
    //             return '<span class="cashout back-win"><img class="back-win-icon" src="/images/dot-icon.svg" alt="arow-down">&nbsp' + parseFloat(finalBetStake).toFixed(2) + '</span>';
    //         } else {
    //             return '<span class="cashout lay-loss"><img class="lay-loss-icon" src="/images/red-dot.svg" alt="lay-loss-icon">&nbsp' + ((-1) * parseFloat(finalBetStake).toFixed(2)) + '</span>';
    //         }
    //     }
    // },
    cashoutServiceCall(e, t, r) {
      this.cashoutDetails.market = e, this.cashoutDetails.type = t, this.cashoutDetails.bet = r, this.cashoutSlipCloseTime = setTimeout(() => {
        this.CashoutLoader || this.$helper.closeModal("cashout");
      }, 1e4);
    }
  }
}, nA = {
  data() {
    return {
      shouldShowMainMarket: !1,
      selectedPool: null,
      pools: null
    };
  },
  computed: {
    chosenPool() {
      return this.selectedPool;
    }
  },
  provide() {
    return {
      pools: up(() => this.pools)
    };
  },
  methods: {
    getPools(e = null) {
      var t;
      this.$store.dispatch("setGlobalLoader", !0), this.$apiCall("get", "GET_POOLS", null, "pool", { match_id: (t = this.eventDetails) == null ? void 0 : t.matchId }).then((r) => {
        var n, s, i, o, a, l;
        if ((r == null ? void 0 : r.status) === 200 && ((s = (n = r == null ? void 0 : r.data) == null ? void 0 : n.data) != null && s.length)) {
          this.pools = (i = r == null ? void 0 : r.data) == null ? void 0 : i.data, this.pools.forEach((d) => {
            d.winning_limit = JSON.parse(d.winning_limit);
          });
          const u = (o = this.$route.query.poolAmount) == null ? void 0 : o.toString(), c = u ? this.pools.find((d) => d.entry_fees.toString() == u) : e ? (a = this.pools) == null ? void 0 : a.find((d) => (d == null ? void 0 : d.id) == (e == null ? void 0 : e.id)) : (l = this.pools) == null ? void 0 : l[0];
          return this.$store.dispatch("setGlobalLoader", !1), this.handlePoolSelection(c);
        } else
          throw this.pools = null, this.$store.dispatch("setGlobalLoader", !1), new Error("No pool data found or invalid response structure.");
      }).catch((r) => {
        this.$store.dispatch("setGlobalLoader", !1), this.$errorToast("Error fetching pools:", r, ". Please Try Again"), this.pools = null;
      });
    },
    async changeSelectedPool(e) {
      try {
        await new Promise((t) => {
          this.selectedPool = e, t();
        });
      } catch (t) {
        console.log("error", t), this.$errorToast("Error in Changing The SelectedPool:", t, ".Please Try Again");
      }
    },
    async handlePoolSelection(e) {
      var t, r, n;
      try {
        await this.changeSelectedPool(e), (t = this.$auth) != null && t.status && ((r = this.chosenPool) != null && r.is_joined) && (this.getEventExposures(), await ((n = this.$refs.poolZone) == null ? void 0 : n.getPoolWallet()));
      } catch (s) {
        console.log(s), this.$errorToast("Error Handling The pool:", s, ".Please Try Again");
      }
    }
  }
}, sA = async (e) => {
  var s, i;
  try {
    let o = null, a = null, l = null, u = await $("get", "GET_MATCH_DETAILS", null, "sports", { event_id: e });
    if (u && u.status == 200) {
      if ((s = u == null ? void 0 : u.data) != null && s.error)
        m(u.data.error);
      else {
        xt.emit("sub", e), o = u.data.data.match, l = u.data.data.upcoming, a = o == null ? void 0 : o.matchOddData.sort((d, f) => d.marketName.localeCompare(f.marketName));
        for (var t = 0; t < a.length; t++)
          for (var r = 0; r < a[t].runners.length; r++)
            for (var n = 0; n < a[t].runnerName.length; n++)
              a[t].runners[r].sid == a[t].runnerName[n].SID && (a[t].runners[r].runner_name = a[t].runnerName[n].RN);
        let c = O.getters.favouriteGames;
        ge().status && (c != null && c.length) && c.includes(parseInt(o.eventId)) ? o.favourite = !0 : o.favourite = !1;
      }
      return { data: o, matchOddsData: a, upcoming: l };
    }
  } catch (o) {
    o && (m(((i = o == null ? void 0 : o.data) == null ? void 0 : i.message) || "404 Not Found"), window.router.push({ name: "Home" }));
  }
}, iA = async (e, t, r) => {
  var n;
  try {
    const s = {
      matchId: e == null ? void 0 : e.eventId
    };
    r && Object.assign(s, {
      pool_id: t,
      match_id: e == null ? void 0 : e.matchId
    });
    let i = null, o = await $("get", "GET_EVENT_EXPOSURES", null, r ? "pool" : "user", s);
    if (o && o.status == 200)
      return (n = o == null ? void 0 : o.data) != null && n.error ? m(o.data.error) : i = o.data, { data: i };
  } catch (s) {
    s && m(s);
  }
}, oA = async (e, t) => {
  var r, n, s;
  try {
    let i = {
      event_id: e.eventId
    }, o = null, a = await $("post", "GET_OPEN_BETS", i, "user", { page: t });
    if (a && a.status == 200)
      return (r = a == null ? void 0 : a.data) != null && r.error ? m(a.data.error) : o = (s = (n = a == null ? void 0 : a.data) == null ? void 0 : n.bets) == null ? void 0 : s.sort((l, u) => u.bet_timestamp_date - l.bet_timestamp_date), { data: o };
  } catch (i) {
    m(i[0]);
  }
}, aA = async (e, t, r) => {
  var n;
  try {
    let s = {
      type: t ? t.type : "markets",
      ...!t && { event_id: r || null },
      match_id: t == null ? void 0 : t.match_id
    }, i = null, o = await $("post", e, s, "user");
    if (o && o.status == 200)
      return (n = o == null ? void 0 : o.data) != null && n.error ? m(o.data.error) : i = o.data, { data: i };
  } catch (s) {
    s && m(s);
  }
}, lA = async (e) => {
  var t;
  try {
    if (UT("premium-fancy")) {
      let r = {
        type: "premium"
      }, { sport_radar_sport_id: n, sportsradar_id: s, sportId: i, eventId: o } = e, a = {
        sportId: n ? `sr:sport:${n}` : i,
        eventId: n ? `sr:match:${s}` : o
      }, l = null, u = await $("post", "GET_THIRD_PARTY_API", r, "user", a);
      if (u && u.status == 200)
        return (t = u == null ? void 0 : u.data) != null && t.error ? m(u.data.error) : l = u.data.url, { data: l };
    }
  } catch (r) {
    m(r);
  }
}, cA = async (e, t, r, n, s) => {
  var i;
  try {
    if (!ge().status || !(e && (e != null && e.fancyExposures) && (e != null && e.fancyExposures.length)) || (e == null ? void 0 : e.fancyExposures.findIndex((c) => c.id == r.mi)) < 0) return;
    let a = {
      id: r.mi,
      event_id: t.eventId,
      fancy_market_id: r.cat == "odd_even_markets" ? 4 : 1
    };
    n && Object.assign(a, {
      pool_id: s,
      match_id: t == null ? void 0 : t.matchId
    });
    let l = null, u = await $("post", "GET_FANCY_BOOK", a, n ? "pool" : "user");
    if (u && u.status == 200)
      return (i = u == null ? void 0 : u.data) != null && i.error ? m(u.data.error) : l = u.data.book, { data: l };
  } catch (o) {
    m(o);
  }
}, uA = async ({ market: e, runner: t, selection_type: r, bet_type: n, r_index: s, betDetails: i, eventDetails: o, logInModalId: a = null }) => {
  var l, u;
  try {
    if (i && i.betLoader) return;
    if ((l = ge()) != null && l.status) {
      let c = (u = ge()) == null ? void 0 : u.user;
      if (!e || (n == "market" || n == "bookmaker") && !t || n == "market" && (e && e.st != "OPEN" || t && t.s != "ACTIVE") || n == "bookmaker" && (e && e.sn != "ONLINE" || t && t.ss != "ACTIVE") || n == "fancy" && e.sn != "ONLINE" && e.sn != "ACTIVE") {
        m("market-not-active", "Market is not active!");
        return;
      }
      WT(e, n, o.eventId), i = {}, i.match_id = o.matchId, i.min_stake = n == "fancy" || n == "bookmaker" ? e.mins : e.min_stake_limit ? e.min_stake_limit : 100, i.max_stake = n == "fancy" || n == "bookmaker" ? e.ms : e.stake_limit ? e.stake_limit : 2e3, i.sport_id = o.sportId, i.eventId = o.eventId, i.selection_type = r, i.bet_type = n, i.bet_delay = n == "fancy" || n == "bookmaker" ? e.bd || 0 : e.bet_delay || 0, i.accept_any_odds = c.accept_any_odds === void 0 ? !1 : c.accept_any_odds, i.market = e, i.runner = t, i.rIndex = s, i.bet_time = Math.round(Date.now() / 1e3), i.bet_delay = n == "fancy" || n == "bookmaker" ? e.bd || 0 : e.bet_delay || 0, i.bet_type == "market" ? (i.market_id = e.mid, i.runner_name = t.runner_name, i.runner_selection_id = t.sid, i.odds = t.ex && t.ex[r == "back" ? "b" : "l"] && t.ex[r == "back" ? "b" : "l"][0] ? t.ex[r == "back" ? "b" : "l"][0].p : "", i.screen_odds = t.ex && t.ex[r == "back" ? "b" : "l"] && t.ex[r == "back" ? "b" : "l"][0] ? t.ex[r == "back" ? "b" : "l"][0].p : "") : i.bet_type == "bookmaker" ? (i.market_id = e.mi, i.runner_name = t.sln, i.runner_selection_id = t.si, i.odds = t[r == "back" ? "b" : "l"], i.screen_odds = t[r == "back" ? "b" : "l"]) : (i.runner_name = e.mn, i.market_id = e.mi, i.runner_selection_id = e.mi, i.odds = e[r == "back" ? "ry" : "rn"], i.screen_odds = e[r == "back" ? "ry" : "rn"], i.bhav = e.cat == "line_markets" ? 100 : e[r == "back" ? "oy" : "on"]);
    } else {
      a ? Re.openModal(a) : m("Please login to place the bets");
      return;
    }
    return { data: i };
  } catch (c) {
    m(c);
  }
}, WT = async (e, t, r) => {
  var n;
  try {
    let s = { ...(n = ge()) == null ? void 0 : n.user }, i = { ...s.betslipCount && s.betslipCount.eventId == r ? s.betslipCount : { eventId: r } }, o = {
      exp: Math.round(Date.now() / 1e3) + 180
      // 180 seconds for 3 minutes
    };
    t === "market" ? (i[e.mid] = i[e.mid] || [], i[e.mid].push(o)) : (t === "bookmaker" || t === "fancy") && (i[e.mi] = i[e.mi] || [], i[e.mi].push(o)), O.dispatch("setUser", { ...s, betslipCount: i });
  } catch (s) {
    m(s);
  }
}, dA = async ({
  cashout: e,
  betDetails: t,
  cashoutDetails: r,
  isPool: n,
  chosenPoolId: s,
  betCloseSetTimeOut: i,
  marketBookAndExposure: o,
  CashoutLoader: a,
  resetTimer: l,
  startTimer: u,
  cancelBetSlip: c,
  initalizeCashout: d
}) => {
  var f, _, g;
  try {
    if ((!t.stake || !t.odds) && !e)
      if (t.stake) {
        m("Odds field is required!");
        return;
      } else {
        m("Stake field is required!");
        return;
      }
    if (t.stake < t.min_stake || t.stake > t.max_stake)
      return m(`Stake value should be between ${t.min_stake} to ${t.max_stake} value.`);
    if (t.accept_any_odds || (t.accept_any_odds = 0), t.betLoader)
      return;
    let p = (f = ge()) == null ? void 0 : f.user, y = (_ = p == null ? void 0 : p.betslipCount) == null ? void 0 : _[t.market_id], A = Math.round(Date.now() / 1e3);
    if (y && y.length) {
      for (let C = 0; C < y.length; C++)
        y[C].exp < A && y.splice(C, 1);
      y.length > 2 && (t.slip_count = y.length);
    }
    t.bet_user_guid = Math.random().toString(36), t.betLoader = !0;
    let T = qT(e, t, r, n, s);
    clearInterval(i), typeof u == "function" && u();
    let b = await $("post", "SAVE_BETS", { data: T });
    if (b && b.status == 200) {
      if (clearInterval(l), e && (a = !1, Re.closeModal("cashout")), (g = b == null ? void 0 : b.data) != null && g.error) {
        t.betLoader = !1, typeof c == "function" && c(), m(b.data.error);
        return;
      } else {
        if (T.bet_type == "market") {
          if (o && o.marketsBook && o.marketsBook.length) {
            let C = o.marketsBook.find((v) => v.id == T.market_id);
            C ? (C.requiredCashout = !e, C.runner_book = b.data.runner_book) : o.marketsBook.push({
              id: T.market_id,
              requiredCashout: !e,
              runner_book: b.data.runner_book
            });
          } else
            o = {
              marketsBook: [{
                requiredCashout: !e,
                id: T.market_id,
                runner_book: b.data.runner_book
              }]
            };
          typeof d == "function" && d();
        } else if (T.bet_type == "bookmaker") {
          if (o && o.bookmakersBook && o.bookmakersBook.length) {
            let C = o.bookmakersBook.find((v) => v.id == T.market_id);
            C ? (C.requiredCashout = !e, C.runner_book = b.data.runner_book) : o.bookmakersBook.push({
              id: T.market_id,
              requiredCashout: !e,
              runner_book: b.data.runner_book
            });
          } else
            o = {
              bookmakersBook: [{
                requiredCashout: !e,
                id: T.market_id,
                runner_book: b.data.runner_book
              }]
            };
          typeof d == "function" && d();
        } else if (o && o.fancyExposures && o.fancyExposures.length || (o.fancyExposures = []), o && o.fancyExposures) {
          let C = o.fancyExposures.findIndex((v) => v.id == T.market_id);
          C >= 0 ? o.fancyExposures[C].exposures = b.data.exposures : o.fancyExposures.push({
            id: T.market_id,
            exposures: b.data.exposures
          });
        }
        p.exposure = b.data.total_exposure, p.betslipCount[t.market_id] = [], O.dispatch("setUser", p), typeof c == "function" && c(), _e(b.data.success), t.betLoader = !1;
      }
      return { data: b, CashoutLoader: a };
    } else
      clearInterval(l), m(b.data.success), typeof c == "function" && c();
  } catch (p) {
    t.betLoader = !1, clearInterval(l), e && (Re.closeModal("cashout"), a = !1), p && (Array.isArray(p) ? m(p[0]) : p.data.error ? m(p.data.error) : m(p)), typeof c == "function" && c();
  }
}, qT = (e, t, r, n, s) => {
  var i, o;
  return e ? r.bet : {
    match_id: t.match_id,
    sport_id: t.sport_id,
    event_id: t.eventId,
    selection_type: t.selection_type,
    bet_type: t.bet_type,
    bet_delay: t.bet_delay,
    runner_index: t.rIndex,
    market_id: t.market_id,
    runner_name: t.runner_name,
    runner_selection_id: t.runner_selection_id,
    odds: t.odds,
    stake: t.stake,
    bet_id: Te.currentTimestamp(),
    userId: (o = (i = ge()) == null ? void 0 : i.user) == null ? void 0 : o.userid,
    accept_any_odds: t.accept_any_odds,
    bhav: t.bhav,
    slip_count: t.slip_count,
    is_cashout: !1,
    screen_odds: t.screen_odds,
    ...n && { pool_id: s }
  };
}, fA = async () => {
  var e;
  try {
    let t = await ((e = ge()) == null ? void 0 : e.user);
    t.accept_any_odds === void 0 ? t.accept_any_odds = !0 : t.accept_any_odds ? t.accept_any_odds = !1 : t.accept_any_odds = !0, O.dispatch("setUser", t);
  } catch (t) {
    m(t);
  }
}, pA = (e, t) => {
  try {
    if (e.betLoader) return;
    var r = 0;
    parseFloat(e.odds).toFixed(2) > 1 && parseFloat(e.odds).toFixed(2) < 2 ? r = 0.01 : parseFloat(e.odds).toFixed(2) >= 2 && parseFloat(e.odds).toFixed(2) < 3 ? r = 0.02 : parseFloat(e.odds).toFixed(2) >= 3 && parseFloat(e.odds).toFixed(2) < 4 ? r = 0.05 : parseFloat(e.odds).toFixed(2) >= 4 && parseFloat(e.odds).toFixed(2) < 6 ? r = 0.1 : parseFloat(e.odds).toFixed(2) >= 6 && parseFloat(e.odds).toFixed(2) < 10 ? r = 0.2 : parseFloat(e.odds).toFixed(2) >= 10 && parseFloat(e.odds).toFixed(2) < 20 ? r = 0.5 : parseFloat(e.odds).toFixed(2) >= 20 && parseFloat(e.odds).toFixed(2) < 30 ? r = 1 : parseFloat(e.odds).toFixed(2) >= 30 && parseFloat(e.odds).toFixed(2) < 50 ? r = 2 : parseFloat(e.odds).toFixed(2) >= 50 && parseFloat(e.odds).toFixed(2) < 100 ? r = 5 : parseFloat(e.odds).toFixed(2) >= 100 && (r = 10), e.odds > 0 && (e.odds = (parseFloat(e.odds) + r).toFixed(2), Ai(e, t));
  } catch (n) {
    m(n);
  }
}, hA = (e, t) => {
  try {
    if (e.betLoader) return;
    var r = 0;
    parseFloat(e.odds).toFixed(2) > 1 && parseFloat(e.odds).toFixed(2) < 2 ? r = 0.01 : parseFloat(e.odds).toFixed(2) >= 2 && parseFloat(e.odds).toFixed(2) < 3 ? r = 0.02 : parseFloat(e.odds).toFixed(2) >= 3 && parseFloat(e.odds).toFixed(2) < 4 ? r = 0.05 : parseFloat(e.odds).toFixed(2) >= 4 && parseFloat(e.odds).toFixed(2) < 6 ? r = 0.1 : parseFloat(e.odds).toFixed(2) >= 6 && parseFloat(e.odds).toFixed(2) < 10 ? r = 0.2 : parseFloat(e.odds).toFixed(2) >= 10 && parseFloat(e.odds).toFixed(2) < 20 ? r = 0.5 : parseFloat(e.odds).toFixed(2) >= 20 && parseFloat(e.odds).toFixed(2) < 30 ? r = 1 : parseFloat(e.odds).toFixed(2) >= 30 && parseFloat(e.odds).toFixed(2) < 50 ? r = 2 : parseFloat(e.odds).toFixed(2) >= 50 && parseFloat(e.odds).toFixed(2) < 100 ? r = 5 : parseFloat(e.odds).toFixed(2) >= 100 && (r = 10), e.odds > 0 && (e.odds = (parseFloat(e.odds) - r).toFixed(2), Ai(e, t));
  } catch (n) {
    m(n);
  }
}, Ai = (e, t) => {
  try {
    if (e.pl = 0, e.bet_type == "bookmaker" ? e.pl = e.odds / 100 * (e.stake ?? 0) : e.bet_type == "market" ? e.pl = e.odds * (e.stake ?? 0) - (e.stake ?? 0) : e.pl = (e.stake ?? 0) * e.bhav / 100, e.bet_type == "fancy") return;
    KT(e, t);
  } catch (r) {
    m(r);
  }
}, KT = (e, t) => {
  try {
    e.runner_books = {};
    let n = [];
    if (e.bet_type == "market") {
      t && t.marketsBook && t.marketsBook.length ? (n = t.marketsBook.find((s) => s.id == e.market_id), n ? n = n.runner_book : n = e.market.runners) : n = e.market.runners;
      for (let s of n)
        e.runner_books[s.sid ? s.sid : s.selection_id] = s.pl ? s.pl : 0;
    } else if (e.bet_type == "bookmaker") {
      t && t.bookmakersBook && t.bookmakersBook.length ? (n = t.bookmakersBook.find((s) => s.id == e.market_id), n ? n = n.runner_book : n = e.market.sl) : n = e.market.sl;
      for (let s of n)
        e.runner_books[s.si ? s.si : s.selection_id] = s.pl ? s.pl : 0;
    }
    for (var r of Object.keys(e.runner_books))
      e.runner_books[r] = parseFloat(e.runner_books[r]), e.runner_selection_id == r ? e.selection_type == "back" ? e.runner_books[r] += parseFloat(e.pl) : e.runner_books[r] -= parseFloat(e.pl) : e.selection_type == "back" ? e.runner_books[r] -= parseFloat(e.stake ?? 0) : e.runner_books[r] += parseFloat(e.stake ?? 0);
  } catch (n) {
    m(n);
  }
}, gA = (e, t) => {
  e && e.betLoader || (e.stake = 0, Ai(e, t));
}, _A = (e, t, r, n) => {
  r.betLoader || (t ? r.stake = parseFloat(e) : r.stake = +(r.stake ? r.stake : 0) + parseFloat(e), zT(r), Ai(r, n));
}, zT = (e) => {
  var t = e.stake;
  t !== "" && parseInt(t) > e.max_stake && (e.stake = e.max_stake);
}, mA = (e, t) => {
  var r, n;
  try {
    let s = (r = ge()) == null ? void 0 : r.user;
    if (!((n = ge()) != null && n.status) || !s) {
      m("Please login to pin fancy!");
      return;
    }
    s.pinnedFancies ? s.pinnedFancies.includes(e.mi) ? (s.pinnedFancies.splice(s.pinnedFancies.indexOf(e.mi), 1), _e("Removed from Pin Fancy Market!")) : (s.pinnedFancies.push(e.mi), _e("Added this fancy under Pin Fancy Market")) : (s.pinnedFancies = [], s.pinnedFancies.push(e.mi), _e("Added this fancy under Pin Fancy Market")), t = s.pinnedFancies, O.dispatch("setUser", s);
  } catch (s) {
    m(s);
  }
}, yA = (e, t) => {
  try {
    return e ? t = JSON.parse(JSON.stringify([...O.getters.clickBetValue])) : t = [
      {
        value: 1e3,
        isSelected: !0
      },
      {
        value: 2e3,
        isSelected: !1
      },
      {
        value: 3e3,
        isSelected: !1
      },
      {
        value: 4e3,
        isSelected: !1
      }
    ], { data: t };
  } catch (r) {
    m(r);
  }
}, EA = (e, t) => {
  try {
    for (let r of e)
      if (!(r.value <= 5e3 && r.value >= 100)) {
        m("Value should be in between 100 to 5000.");
        return;
      }
    if (JT(e)) {
      m("repeated-stake-values-are-not-allowed", "Repeated stake values are not allowed!");
      return;
    } else
      return t = [], e.forEach((r) => {
        t.push(r);
      }), O.dispatch("setClickBetValue", [...t]), _e("clickbet-updated", "Click bet value updated successfully."), { saved: !0 };
  } catch (r) {
    m(r);
  }
}, JT = (e) => {
  const t = e.map((n) => n.value);
  return new Set(t).size !== t.length;
}, vA = async (e, t, r, n) => {
  try {
    xt.on("App\\\\Events\\\\SportsBroadcastData", (s) => {
      if (s && s.length)
        for (let i of s) {
          let o = e.find((a) => a.mid == i.mid);
          if (!(!o || i && !i.runners.length)) {
            i.st && (o.st = i.st);
            for (let a of i.runners) {
              let l = o.runners.find((u) => u.sid == a.sid);
              !l || a && !a.ex && !a.s || (a.s && (l.s = a.s), a.ex.b && (l.ex.b = a.ex.b), a.ex.l && (l.ex.l = a.ex.l));
            }
          }
        }
    }), xt.on("App\\\\Events\\\\BroadcastBookmaker", (s) => {
      if (s && s.length) {
        let i = s[0].ml;
        if (!i || i && !i.updated) return;
        let o = i.updated;
        if (o && o.length)
          for (let a of o) {
            let l = t.ml.find((c) => c.mi == a.mi);
            if (!l) continue;
            let u = Object.keys(a);
            for (let c of u)
              if (c != "mi")
                if (c == "sl")
                  for (let d of a.sl) {
                    let f = l.sl.find((g) => g.si == d.si);
                    if (!f) continue;
                    let _ = Object.keys(d);
                    for (let g of _)
                      f[g] = d[g];
                  }
                else
                  l[c] = a[c];
          }
      }
    }), xt.on("App\\\\Events\\\\BroadcastFancy", (s) => {
      if (s && s.length && !n) {
        let i = s[0].ml;
        if (!i || i && !i.updated && i && !i.added && i && !i.deleted) return;
        let o = i.updated, a = i.added, l = i.deleted;
        if (l && l.length && (r.ml = r.ml.filter(function(u) {
          return !l.includes(u.mi);
        })), o && o.length)
          for (let u of o) {
            let c = r.ml.find((f) => f.mi == u.mi);
            if (!c) continue;
            let d = Object.keys(u);
            for (let f of d)
              f != "mi" && (c[f] = u[f]);
          }
        if (a && a.length)
          for (let u = 0; u < a.length; u++)
            r.ml.find((d) => d.mi == a[u].mi) || (r.ml = [...r.ml, a[u]]);
      }
    });
  } catch (s) {
    s && console.log(s);
  }
}, bA = (e) => {
  try {
    xt.off("App\\\\Events\\\\SportsBroadcastData"), xt.off("App\\\\Events\\\\BroadcastBookmaker"), xt.off("App\\\\Events\\\\BroadcastFancy"), xt.emit("leave", [e]);
  } catch (t) {
    t && console.log(t);
  }
}, wA = (e) => ({
  scoreCardUrl() {
    const t = `https://scorecard.oddstrad.com/get-scorecard-iframe/${e == null ? void 0 : e.eventDetails.sportId}/${e == null ? void 0 : e.eventDetails.eventId}/${e == null ? void 0 : e.eventDetails.sportsradar_id}`, r = `https://scoreboarduser-ui.royalgame365.com/${e == null ? void 0 : e.eventDetails.eventId}`;
    return e.eventDetails.has_manual_scorecard ? r : t;
  },
  liveTvUrl() {
    return `https://vid.dreamcasino.live/GetAPI.html?MatchID=${e != null && e.eventDetails.tv_radar_id ? e == null ? void 0 : e.eventDetails.tv_radar_id : e == null ? void 0 : e.eventDetails.eventId}`;
  },
  filteredFancyList() {
    let t = [];
    for (let r of e.fancyCategories)
      r.fancies = [];
    if (e.selectedFancyCategory != null)
      if (e.selectedFancyCategory.value == "all") {
        if (e.fancyData && e.fancyData.ml) {
          t = [...e.fancyCategories];
          for (let r of e.fancyData.ml) {
            let n = t.find((s) => s.value == r.cat);
            n && n.fancies.push(r);
          }
        }
      } else
        e.fancyData && e.fancyData.ml && (e.selectedFancyCategory.fancies = e.fancyData.ml.filter((r) => r.cat == e.selectedFancyCategory.value), t = [e.selectedFancyCategory, ...t]);
    return t;
  },
  getPinnedFancies() {
    let t = [];
    return !(e.fancyData && e.fancyData.ml && e.fancyData.ml.length) || !(e.pinnedFancies && e.pinnedFancies.length) || (t = e.fancyData.ml.filter((r) => e.pinnedFancies.includes(r.mi))), t;
  },
  otherMarkets() {
    let t = [];
    return e.matchOddsData && e.matchOddsData.length && (t = e.matchOddsData.filter((r) => r.marketName != "Match Odds" && r.marketName != "Who Will Win The Match?").sort((r, n) => r.marketName.localeCompare(n.marketName))), t;
  },
  isFavourite() {
    return e.eventDetails.favourite;
  }
}), TA = async () => {
  var e;
  try {
    let t = {
      type: "sportsbook"
    }, r = null, n = await $("post", "GET_THIRD_PARTY_API", t, "user");
    if (n && n.status == 200)
      return (e = n == null ? void 0 : n.data) != null && e.error ? m(n.data.error) : r = n.data.url, { data: r };
  } catch (t) {
    t && m(t);
  }
}, SA = async ({
  pool: e,
  eventDetails: t,
  handlePoolSelection: r,
  poolWalletcCall: n,
  chosenPool: s
}) => {
  var i, o, a, l, u;
  try {
    if (!((i = ge()) != null && i.status)) {
      m("Please login to join pool"), Re.showLogin();
      return;
    }
    let c = {
      match_id: t == null ? void 0 : t.matchId,
      pool_id: e == null ? void 0 : e.id,
      userid: (a = (o = ge()) == null ? void 0 : o.user) == null ? void 0 : a.userid,
      match_name: t == null ? void 0 : t.eventName,
      event_id: t == null ? void 0 : t.eventId
    };
    console.log("dataaa", c), O.dispatch("setGlobalLoader", !0);
    let d = await $("post", "JOIN_POOL", c, "user");
    if (d && d.status == 200)
      if (O.dispatch("setGlobalLoader", !1), (l = d == null ? void 0 : d.data) != null && l.error)
        m(d.data.error);
      else
        return _e((u = d == null ? void 0 : d.data) == null ? void 0 : u.message), e.is_joined = !0, typeof r == "function" && r(e), await XT(t, n, s);
  } catch (c) {
    c && (O.dispatch("setGlobalLoader", !1), m(c[0] || "Error joining pools."));
  }
}, XT = async (e, t, r) => {
  var n, s;
  try {
    if (t && (clearTimeout(t), t = null), !(r != null && r.is_joined)) return;
    const i = {
      match_id: e == null ? void 0 : e.matchId,
      pool_id: r == null ? void 0 : r.id
    };
    let o = null, a = await $("post", "POOL_WALLET", i, "pool");
    if (a && a.status == 200)
      return (n = a == null ? void 0 : a.data) != null && n.error ? m(a.data.error) : (o = a.data, _e((s = a.data) == null ? void 0 : s.message)), { poolWallet: o, poolWalletcCall: t };
  } catch (i) {
    i && m((i == null ? void 0 : i.message) || "Error fetching pool wallet. Please try again.");
  }
}, OA = async (e) => {
  var t, r;
  try {
    let n = null;
    O.dispatch("setGlobalLoader", !0);
    let s = await $("get", "GET_POOL_WINNERS", null, "pool");
    if (O.dispatch("setGlobalLoader", !1), s && s.status == 200)
      return (t = s == null ? void 0 : s.data) != null && t.error ? m(s.data.error) : (n = s == null ? void 0 : s.data.members, _e((r = s == null ? void 0 : s.data) == null ? void 0 : r.message), setTimeout(() => {
        typeof e == "function" && e();
      }, 1e3)), { data: n };
  } catch (n) {
    O.dispatch("setGlobalLoader", !1), m(n[0] || "Error joining pools.");
  }
}, AA = async (e, t, r) => {
  var n, s;
  try {
    let i = {
      match_id: t == null ? void 0 : t.matchId
    };
    r ? i.pool_code = r : i.pool_id = e, O.dispatch("setGlobalLoader", !0);
    let o = null, a = await $("get", "POOL_LEADER_BOARD", null, "pool", i);
    if (O.dispatch("setGlobalLoader", !1), a && a.status == 200)
      return (n = a == null ? void 0 : a.data) != null && n.error ? (m(a.data.error), { data: o }) : (o && o.length || Re.openModal("#leaderModal"), o = (s = a == null ? void 0 : a.data) == null ? void 0 : s.data, _e("Leaderboard data loaded successfully."), { data: o });
  } catch (i) {
    O.dispatch("setGlobalLoader", !1), console.log("getLeaderBoardData Error:", i), m(i.message || "An unexpected error occurred while fetching leaderboard.");
  }
}, NA = async (e, t) => {
  var r, n;
  try {
    let s = {
      status: "open",
      match_id: e.matchId,
      pool_id: t == null ? void 0 : t.id
    };
    O.dispatch("setGlobalLoader", !0);
    let i = null, o = await $("post", "GET_POOL_OPEN_BETS", s, "pool");
    if (O.dispatch("setGlobalLoader", !1), o && o.status == 200)
      return (r = o == null ? void 0 : o.data) != null && r.error ? m(o.data.error) : (i = (n = o == null ? void 0 : o.data.data) == null ? void 0 : n.bets.data, Re.openModal("#open-bets-button")), { data: i };
  } catch (s) {
    O.dispatch("setGlobalLoader", !1), s && m(s[0]);
  }
}, CA = (e) => ({
  leaderBoardDataWithoutUser() {
    var t;
    return (t = e == null ? void 0 : e.leaderBoardData) == null ? void 0 : t.filter((r) => {
      var n, s;
      return (r == null ? void 0 : r.user_id) !== ((s = (n = ge()) == null ? void 0 : n.user) == null ? void 0 : s.id);
    });
  },
  userInfoFromLeaderBoard() {
    var t;
    return (t = e == null ? void 0 : e.leaderBoardData) == null ? void 0 : t.find((r) => {
      var n, s;
      return (r == null ? void 0 : r.user_id) == ((s = (n = ge()) == null ? void 0 : n.user) == null ? void 0 : s.id);
    });
  }
}), DA = (e) => ({
  setOpenBets() {
    var t;
    if (e != null && e.averageOdds) {
      let r = [];
      return (t = e == null ? void 0 : e.openBets) == null || t.forEach((n) => {
        var s;
        if ((s = n[e == null ? void 0 : e.activeOpenBetType]) != null && s.length) {
          let i = {
            event_name: n.event_name,
            lay: {
              odds: 0,
              stake: 0,
              pl: 0,
              betCount: 0
            },
            back: {
              odds: 0,
              stake: 0,
              pl: 0,
              betCount: 0
            }
          };
          for (let o = 0; o < n[e == null ? void 0 : e.activeOpenBetType].length; o++) {
            let a = n[e == null ? void 0 : e.activeOpenBetType][o];
            i[a.selection_type].odds += parseFloat(a.odds), i[a.selection_type].stake += parseFloat(a.stake), i[a.selection_type].pl += parseFloat(a.p_l), i[a.selection_type].betCount++;
          }
          ["lay", "back"].forEach((o) => {
            const a = i[o];
            a.betCount > 0 && (a.odds /= a.betCount), a.odds = parseFloat(a.odds.toFixed(2)), a.stake = parseFloat(a.stake.toFixed(2)), a.pl = parseFloat(a.pl.toFixed(2));
          }), r.push(i);
        }
      }), r;
    } else
      return e == null ? void 0 : e.openBets;
  }
}), IA = (e) => ({
  filteredBets() {
    var t, r;
    if (e.averageOdds) {
      let n = {
        bookmakers: { back: [], lay: [] },
        fancies: { back: [], lay: [] },
        main_market: { back: [], lay: [] }
      };
      return (t = e.openBets) == null || t.forEach((s) => {
        ["bookmakers", "fancies", "main_market"].forEach((i) => {
          s[i] && s[i].length > 0 && s[i].forEach((o) => {
            o.selection_type === "back" ? n[i].back.push(o) : o.selection_type === "lay" && n[i].lay.push(o);
          });
        });
      }), console.log(n), n;
    } else {
      let n = (r = e.openBets) == null ? void 0 : r.flatMap((s) => [...s.main_market, ...s.bookmakers, ...s.fancies]);
      return n == null ? void 0 : n.sort((s, i) => i.bet_timestamp_date - s.bet_timestamp_date);
    }
  }
}), MA = (e, t) => (e == null ? void 0 : e.marketName) == "Who Will Win The Match?" && (t == null ? void 0 : t.sportId) == 4, LA = (e) => (e == null ? void 0 : e.min_stake_limit) < 100 || (e == null ? void 0 : e.stake_limit) < 100, RA = (e, t) => t.s != "ACTIVE" || e.st != "OPEN", kA = (e, t) => e.sn != "ONLINE" || t.ss != "ACTIVE", xA = (e) => (e == null ? void 0 : e.mins) < 100 || (e == null ? void 0 : e.ms) < 100, PA = (e) => e.sn == "SUSPEND" || e.sn == "BALL_RUN", $A = (e) => (e == null ? void 0 : e.mins) < 100 || (e == null ? void 0 : e.ms) < 100, FA = (e, t) => t.s != "ACTIVE" || e.st != "OPEN", VA = (e) => (e == null ? void 0 : e.min_stake_limit) < 100 || (e == null ? void 0 : e.stake_limit) < 100, BA = (e) => {
  var t, r;
  return ((t = ge()) == null ? void 0 : t.status) && ((r = e == null ? void 0 : e.runners) == null ? void 0 : r.length) == 2;
}, UA = (e) => (e == null ? void 0 : e.min_stake_limit) < 100 || (e == null ? void 0 : e.stake_limit) < 100, HA = (e) => {
  var t;
  return ((t = ge()) == null ? void 0 : t.status) && e.sl.length == 2;
}, jA = (e) => (e == null ? void 0 : e.mins) < 100 || (e == null ? void 0 : e.ms) < 100, YA = (e) => {
  var t, r;
  return ((t = ge()) == null ? void 0 : t.status) && ((r = e == null ? void 0 : e.runners) == null ? void 0 : r.length) == 2;
}, GA = (e) => (e == null ? void 0 : e.min_stake_limit) < 100 || (e == null ? void 0 : e.stake_limit) < 100, WA = async (e) => {
  try {
    window.store.dispatch("setGlobalLoader", !0);
    const t = await $("post", "CLAIM_BONUS", { code: e }, "user");
    window.store.dispatch("setGlobalLoader", !1), (t == null ? void 0 : t.status) == 200 && _e(t.data.message);
  } catch (t) {
    window.store.dispatch("setGlobalLoader", !1), t && (console.log(t[0]), m(t[0]));
  }
}, qA = async () => {
  var e, t;
  try {
    O.dispatch("setGlobalLoader", !0);
    let r = null, n = await $("get", "GET_WALLET_CONFIG", null, "wallet");
    if (O.dispatch("setGlobalLoader", !1), n && n.status == 200) {
      if ((e = n == null ? void 0 : n.data) != null && e.error)
        m(n.data.error);
      else {
        r = n.data.data;
        const s = ["100", "200", "500", "1000"];
        let i = O.getters.userTransactionStakes || ((t = r.stake_button) != null && t.every((o) => Number(o) === 0) ? s : r.stake_button || s);
        r.stake_button = i, O.dispatch("setUserTransactionStakes", i);
      }
      return { data: r };
    }
  } catch (r) {
    O.dispatch("setGlobalLoader", !1), r && m(r);
  }
}, KA = (e, t, r) => {
  var n, s;
  try {
    return t = parseFloat(t) || 0, e = parseFloat(e) || 0, t += e, t > ((n = r == null ? void 0 : r.deposit_range) == null ? void 0 : n.max) && (t = (s = r == null ? void 0 : r.deposit_range) == null ? void 0 : s.max), t;
  } catch (i) {
    m(i);
  }
};
var ao = { exports: {} }, lu;
function QT() {
  return lu || (lu = 1, (function(e) {
    var t = (function(r) {
      var n = Object.prototype, s = n.hasOwnProperty, i = Object.defineProperty || function(w, S, D) {
        w[S] = D.value;
      }, o, a = typeof Symbol == "function" ? Symbol : {}, l = a.iterator || "@@iterator", u = a.asyncIterator || "@@asyncIterator", c = a.toStringTag || "@@toStringTag";
      function d(w, S, D) {
        return Object.defineProperty(w, S, {
          value: D,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), w[S];
      }
      try {
        d({}, "");
      } catch {
        d = function(S, D, G) {
          return S[D] = G;
        };
      }
      function f(w, S, D, G) {
        var U = S && S.prototype instanceof b ? S : b, te = Object.create(U.prototype), fe = new L(G || []);
        return i(te, "_invoke", { value: le(w, D, fe) }), te;
      }
      r.wrap = f;
      function _(w, S, D) {
        try {
          return { type: "normal", arg: w.call(S, D) };
        } catch (G) {
          return { type: "throw", arg: G };
        }
      }
      var g = "suspendedStart", p = "suspendedYield", y = "executing", A = "completed", T = {};
      function b() {
      }
      function C() {
      }
      function v() {
      }
      var Y = {};
      d(Y, l, function() {
        return this;
      });
      var K = Object.getPrototypeOf, ee = K && K(K(R([])));
      ee && ee !== n && s.call(ee, l) && (Y = ee);
      var Q = v.prototype = b.prototype = Object.create(Y);
      C.prototype = v, i(Q, "constructor", { value: v, configurable: !0 }), i(
        v,
        "constructor",
        { value: C, configurable: !0 }
      ), C.displayName = d(
        v,
        c,
        "GeneratorFunction"
      );
      function Z(w) {
        ["next", "throw", "return"].forEach(function(S) {
          d(w, S, function(D) {
            return this._invoke(S, D);
          });
        });
      }
      r.isGeneratorFunction = function(w) {
        var S = typeof w == "function" && w.constructor;
        return S ? S === C || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (S.displayName || S.name) === "GeneratorFunction" : !1;
      }, r.mark = function(w) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(w, v) : (w.__proto__ = v, d(w, c, "GeneratorFunction")), w.prototype = Object.create(Q), w;
      }, r.awrap = function(w) {
        return { __await: w };
      };
      function X(w, S) {
        function D(te, fe, Se, ve) {
          var ye = _(w[te], w, fe);
          if (ye.type === "throw")
            ve(ye.arg);
          else {
            var ne = ye.arg, re = ne.value;
            return re && typeof re == "object" && s.call(re, "__await") ? S.resolve(re.__await).then(function(de) {
              D("next", de, Se, ve);
            }, function(de) {
              D("throw", de, Se, ve);
            }) : S.resolve(re).then(function(de) {
              ne.value = de, Se(ne);
            }, function(de) {
              return D("throw", de, Se, ve);
            });
          }
        }
        var G;
        function U(te, fe) {
          function Se() {
            return new S(function(ve, ye) {
              D(te, fe, ve, ye);
            });
          }
          return G = // If enqueue has been called before, then we want to wait until
          // all previous Promises have been resolved before calling invoke,
          // so that results are always delivered in the correct order. If
          // enqueue has not been called before, then it is important to
          // call invoke immediately, without waiting on a callback to fire,
          // so that the async generator function has the opportunity to do
          // any necessary setup in a predictable way. This predictability
          // is why the Promise constructor synchronously invokes its
          // executor callback, and why async functions synchronously
          // execute code before the first await. Since we implement simple
          // async functions in terms of async generators, it is especially
          // important to get this right, even though it requires care.
          G ? G.then(
            Se,
            // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            Se
          ) : Se();
        }
        i(this, "_invoke", { value: U });
      }
      Z(X.prototype), d(X.prototype, u, function() {
        return this;
      }), r.AsyncIterator = X, r.async = function(w, S, D, G, U) {
        U === void 0 && (U = Promise);
        var te = new X(
          f(w, S, D, G),
          U
        );
        return r.isGeneratorFunction(S) ? te : te.next().then(function(fe) {
          return fe.done ? fe.value : te.next();
        });
      };
      function le(w, S, D) {
        var G = g;
        return function(te, fe) {
          if (G === y)
            throw new Error("Generator is already running");
          if (G === A) {
            if (te === "throw")
              throw fe;
            return M();
          }
          for (D.method = te, D.arg = fe; ; ) {
            var Se = D.delegate;
            if (Se) {
              var ve = ae(Se, D);
              if (ve) {
                if (ve === T) continue;
                return ve;
              }
            }
            if (D.method === "next")
              D.sent = D._sent = D.arg;
            else if (D.method === "throw") {
              if (G === g)
                throw G = A, D.arg;
              D.dispatchException(D.arg);
            } else D.method === "return" && D.abrupt("return", D.arg);
            G = y;
            var ye = _(w, S, D);
            if (ye.type === "normal") {
              if (G = D.done ? A : p, ye.arg === T)
                continue;
              return {
                value: ye.arg,
                done: D.done
              };
            } else ye.type === "throw" && (G = A, D.method = "throw", D.arg = ye.arg);
          }
        };
      }
      function ae(w, S) {
        var D = S.method, G = w.iterator[D];
        if (G === o)
          return S.delegate = null, D === "throw" && w.iterator.return && (S.method = "return", S.arg = o, ae(w, S), S.method === "throw") || D !== "return" && (S.method = "throw", S.arg = new TypeError(
            "The iterator does not provide a '" + D + "' method"
          )), T;
        var U = _(G, w.iterator, S.arg);
        if (U.type === "throw")
          return S.method = "throw", S.arg = U.arg, S.delegate = null, T;
        var te = U.arg;
        if (!te)
          return S.method = "throw", S.arg = new TypeError("iterator result is not an object"), S.delegate = null, T;
        if (te.done)
          S[w.resultName] = te.value, S.next = w.nextLoc, S.method !== "return" && (S.method = "next", S.arg = o);
        else
          return te;
        return S.delegate = null, T;
      }
      Z(Q), d(Q, c, "Generator"), d(Q, l, function() {
        return this;
      }), d(Q, "toString", function() {
        return "[object Generator]";
      });
      function W(w) {
        var S = { tryLoc: w[0] };
        1 in w && (S.catchLoc = w[1]), 2 in w && (S.finallyLoc = w[2], S.afterLoc = w[3]), this.tryEntries.push(S);
      }
      function V(w) {
        var S = w.completion || {};
        S.type = "normal", delete S.arg, w.completion = S;
      }
      function L(w) {
        this.tryEntries = [{ tryLoc: "root" }], w.forEach(W, this), this.reset(!0);
      }
      r.keys = function(w) {
        var S = Object(w), D = [];
        for (var G in S)
          D.push(G);
        return D.reverse(), function U() {
          for (; D.length; ) {
            var te = D.pop();
            if (te in S)
              return U.value = te, U.done = !1, U;
          }
          return U.done = !0, U;
        };
      };
      function R(w) {
        if (w) {
          var S = w[l];
          if (S)
            return S.call(w);
          if (typeof w.next == "function")
            return w;
          if (!isNaN(w.length)) {
            var D = -1, G = function U() {
              for (; ++D < w.length; )
                if (s.call(w, D))
                  return U.value = w[D], U.done = !1, U;
              return U.value = o, U.done = !0, U;
            };
            return G.next = G;
          }
        }
        return { next: M };
      }
      r.values = R;
      function M() {
        return { value: o, done: !0 };
      }
      return L.prototype = {
        constructor: L,
        reset: function(w) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = o, this.done = !1, this.delegate = null, this.method = "next", this.arg = o, this.tryEntries.forEach(V), !w)
            for (var S in this)
              S.charAt(0) === "t" && s.call(this, S) && !isNaN(+S.slice(1)) && (this[S] = o);
        },
        stop: function() {
          this.done = !0;
          var w = this.tryEntries[0], S = w.completion;
          if (S.type === "throw")
            throw S.arg;
          return this.rval;
        },
        dispatchException: function(w) {
          if (this.done)
            throw w;
          var S = this;
          function D(ve, ye) {
            return te.type = "throw", te.arg = w, S.next = ve, ye && (S.method = "next", S.arg = o), !!ye;
          }
          for (var G = this.tryEntries.length - 1; G >= 0; --G) {
            var U = this.tryEntries[G], te = U.completion;
            if (U.tryLoc === "root")
              return D("end");
            if (U.tryLoc <= this.prev) {
              var fe = s.call(U, "catchLoc"), Se = s.call(U, "finallyLoc");
              if (fe && Se) {
                if (this.prev < U.catchLoc)
                  return D(U.catchLoc, !0);
                if (this.prev < U.finallyLoc)
                  return D(U.finallyLoc);
              } else if (fe) {
                if (this.prev < U.catchLoc)
                  return D(U.catchLoc, !0);
              } else if (Se) {
                if (this.prev < U.finallyLoc)
                  return D(U.finallyLoc);
              } else
                throw new Error("try statement without catch or finally");
            }
          }
        },
        abrupt: function(w, S) {
          for (var D = this.tryEntries.length - 1; D >= 0; --D) {
            var G = this.tryEntries[D];
            if (G.tryLoc <= this.prev && s.call(G, "finallyLoc") && this.prev < G.finallyLoc) {
              var U = G;
              break;
            }
          }
          U && (w === "break" || w === "continue") && U.tryLoc <= S && S <= U.finallyLoc && (U = null);
          var te = U ? U.completion : {};
          return te.type = w, te.arg = S, U ? (this.method = "next", this.next = U.finallyLoc, T) : this.complete(te);
        },
        complete: function(w, S) {
          if (w.type === "throw")
            throw w.arg;
          return w.type === "break" || w.type === "continue" ? this.next = w.arg : w.type === "return" ? (this.rval = this.arg = w.arg, this.method = "return", this.next = "end") : w.type === "normal" && S && (this.next = S), T;
        },
        finish: function(w) {
          for (var S = this.tryEntries.length - 1; S >= 0; --S) {
            var D = this.tryEntries[S];
            if (D.finallyLoc === w)
              return this.complete(D.completion, D.afterLoc), V(D), T;
          }
        },
        catch: function(w) {
          for (var S = this.tryEntries.length - 1; S >= 0; --S) {
            var D = this.tryEntries[S];
            if (D.tryLoc === w) {
              var G = D.completion;
              if (G.type === "throw") {
                var U = G.arg;
                V(D);
              }
              return U;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function(w, S, D) {
          return this.delegate = {
            iterator: R(w),
            resultName: S,
            nextLoc: D
          }, this.method === "next" && (this.arg = o), T;
        }
      }, r;
    })(
      // If this script is executing as a CommonJS module, use module.exports
      // as the regeneratorRuntime namespace. Otherwise create a new empty
      // object. Either way, the resulting object will be used to initialize
      // the regeneratorRuntime variable at the top of this file.
      e.exports
    );
    try {
      regeneratorRuntime = t;
    } catch {
      typeof globalThis == "object" ? globalThis.regeneratorRuntime = t : Function("r", "regeneratorRuntime = r")(t);
    }
  })(ao)), ao.exports;
}
var lo, cu;
function ol() {
  return cu || (cu = 1, lo = (e, t) => `${e}-${t}-${Math.random().toString(16).slice(3, 8)}`), lo;
}
var co, uu;
function Np() {
  if (uu) return co;
  uu = 1;
  const e = ol();
  let t = 0;
  return co = ({
    id: r,
    action: n,
    payload: s = {}
  }) => {
    let i = r;
    return typeof i > "u" && (i = e("Job", t), t += 1), {
      id: i,
      action: n,
      payload: s
    };
  }, co;
}
var Sn = {}, du;
function al() {
  if (du) return Sn;
  du = 1;
  let e = !1;
  return Sn.logging = e, Sn.setLogging = (t) => {
    e = t;
  }, Sn.log = (...t) => e ? console.log.apply(this, t) : null, Sn;
}
var uo, fu;
function ZT() {
  if (fu) return uo;
  fu = 1;
  const e = Np(), { log: t } = al(), r = ol();
  let n = 0;
  return uo = () => {
    const s = r("Scheduler", n), i = {}, o = {};
    let a = [];
    n += 1;
    const l = () => a.length, u = () => Object.keys(i).length, c = () => {
      if (a.length !== 0) {
        const p = Object.keys(i);
        for (let y = 0; y < p.length; y += 1)
          if (typeof o[p[y]] > "u") {
            a[0](i[p[y]]);
            break;
          }
      }
    }, d = (p, y) => new Promise((A, T) => {
      const b = e({ action: p, payload: y });
      a.push(async (C) => {
        a.shift(), o[C.id] = b;
        try {
          A(await C[p].apply(this, [...y, b.id]));
        } catch (v) {
          T(v);
        } finally {
          delete o[C.id], c();
        }
      }), t(`[${s}]: Add ${b.id} to JobQueue`), t(`[${s}]: JobQueue length=${a.length}`), c();
    });
    return {
      addWorker: (p) => (i[p.id] = p, t(`[${s}]: Add ${p.id}`), t(`[${s}]: Number of workers=${u()}`), c(), p.id),
      addJob: async (p, ...y) => {
        if (u() === 0)
          throw Error(`[${s}]: You need to have at least one worker before adding jobs`);
        return d(p, y);
      },
      terminate: async () => {
        Object.keys(i).forEach(async (p) => {
          await i[p].terminate();
        }), a = [];
      },
      getQueueLen: l,
      getNumWorkers: u
    };
  }, uo;
}
function eS(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var fo, pu;
function tS() {
  return pu || (pu = 1, fo = (e) => {
    const t = {};
    return typeof WorkerGlobalScope < "u" ? t.type = "webworker" : typeof document == "object" ? t.type = "browser" : typeof process == "object" && typeof eS == "function" && (t.type = "node"), typeof e > "u" ? t : t[e];
  }), fo;
}
var po, hu;
function rS() {
  if (hu) return po;
  hu = 1;
  const t = tS()("type") === "browser" ? (r) => new URL(r, window.location.href).href : (r) => r;
  return po = (r) => {
    const n = { ...r };
    return ["corePath", "workerPath", "langPath"].forEach((s) => {
      r[s] && (n[s] = t(n[s]));
    }), n;
  }, po;
}
var ho, gu;
function Cp() {
  return gu || (gu = 1, ho = {
    TESSERACT_ONLY: 0,
    LSTM_ONLY: 1,
    TESSERACT_LSTM_COMBINED: 2,
    DEFAULT: 3
  }), ho;
}
const nS = "6.0.1", sS = {
  version: nS
};
var go, _u;
function iS() {
  return _u || (_u = 1, go = {
    /*
     * Use BlobURL for worker script by default
     * TODO: remove this option
     *
     */
    workerBlobURL: !0,
    logger: () => {
    }
  }), go;
}
var _o, mu;
function oS() {
  if (mu) return _o;
  mu = 1;
  const e = sS.version;
  return _o = {
    ...iS(),
    workerPath: `https://cdn.jsdelivr.net/npm/tesseract.js@v${e}/dist/worker.min.js`
  }, _o;
}
var mo, yu;
function aS() {
  return yu || (yu = 1, mo = ({ workerPath: e, workerBlobURL: t }) => {
    let r;
    if (Blob && URL && t) {
      const n = new Blob([`importScripts("${e}");`], {
        type: "application/javascript"
      });
      r = new Worker(URL.createObjectURL(n));
    } else
      r = new Worker(e);
    return r;
  }), mo;
}
var yo, Eu;
function lS() {
  return Eu || (Eu = 1, yo = (e) => {
    e.terminate();
  }), yo;
}
var Eo, vu;
function cS() {
  return vu || (vu = 1, Eo = (e, t) => {
    e.onmessage = ({ data: r }) => {
      t(r);
    };
  }), Eo;
}
var vo, bu;
function uS() {
  return bu || (bu = 1, vo = async (e, t) => {
    e.postMessage(t);
  }), vo;
}
var bo, wu;
function dS() {
  if (wu) return bo;
  wu = 1;
  const e = (r) => new Promise((n, s) => {
    const i = new FileReader();
    i.onload = () => {
      n(i.result);
    }, i.onerror = ({ target: { error: { code: o } } }) => {
      s(Error(`File could not be read! Code=${o}`));
    }, i.readAsArrayBuffer(r);
  }), t = async (r) => {
    let n = r;
    if (typeof r > "u")
      return "undefined";
    if (typeof r == "string")
      /data:image\/([a-zA-Z]*);base64,([^"]*)/.test(r) ? n = atob(r.split(",")[1]).split("").map((s) => s.charCodeAt(0)) : n = await (await fetch(r)).arrayBuffer();
    else if (typeof HTMLElement < "u" && r instanceof HTMLElement)
      r.tagName === "IMG" && (n = await t(r.src)), r.tagName === "VIDEO" && (n = await t(r.poster)), r.tagName === "CANVAS" && await new Promise((s) => {
        r.toBlob(async (i) => {
          n = await e(i), s();
        });
      });
    else if (typeof OffscreenCanvas < "u" && r instanceof OffscreenCanvas) {
      const s = await r.convertToBlob();
      n = await e(s);
    } else (r instanceof File || r instanceof Blob) && (n = await e(r));
    return new Uint8Array(n);
  };
  return bo = t, bo;
}
var wo, Tu;
function fS() {
  if (Tu) return wo;
  Tu = 1;
  const e = oS(), t = aS(), r = lS(), n = cS(), s = uS(), i = dS();
  return wo = {
    defaultOptions: e,
    spawnWorker: t,
    terminateWorker: r,
    onMessage: n,
    send: s,
    loadImage: i
  }, wo;
}
var To, Su;
function Dp() {
  if (Su) return To;
  Su = 1;
  const e = rS(), t = Np(), { log: r } = al(), n = ol(), s = Cp(), {
    defaultOptions: i,
    spawnWorker: o,
    terminateWorker: a,
    onMessage: l,
    loadImage: u,
    send: c
  } = fS();
  let d = 0;
  return To = async (f = "eng", _ = s.LSTM_ONLY, g = {}, p = {}) => {
    const y = n("Worker", d), {
      logger: A,
      errorHandler: T,
      ...b
    } = e({
      ...i,
      ...g
    }), C = {}, v = typeof f == "string" ? f.split("+") : f;
    let Y = _, K = p;
    const ee = [s.DEFAULT, s.LSTM_ONLY].includes(_) && !b.legacyCore;
    let Q, Z;
    const X = new Promise((ne, re) => {
      Z = ne, Q = re;
    }), le = (ne) => {
      Q(ne.message);
    };
    let ae = o(b);
    ae.onerror = le, d += 1;
    const W = ({ id: ne, action: re, payload: de }) => new Promise((Ie, h) => {
      r(`[${y}]: Start ${ne}, action=${re}`);
      const E = `${re}-${ne}`;
      C[E] = { resolve: Ie, reject: h }, c(ae, {
        workerId: y,
        jobId: ne,
        action: re,
        payload: de
      });
    }), V = () => console.warn("`load` is depreciated and should be removed from code (workers now come pre-loaded)"), L = (ne) => W(t({
      id: ne,
      action: "load",
      payload: { options: { lstmOnly: ee, corePath: b.corePath, logging: b.logging } }
    })), R = (ne, re, de) => W(t({
      id: de,
      action: "FS",
      payload: { method: "writeFile", args: [ne, re] }
    })), M = (ne, re) => W(t({
      id: re,
      action: "FS",
      payload: { method: "readFile", args: [ne, { encoding: "utf8" }] }
    })), w = (ne, re) => W(t({
      id: re,
      action: "FS",
      payload: { method: "unlink", args: [ne] }
    })), S = (ne, re, de) => W(t({
      id: de,
      action: "FS",
      payload: { method: ne, args: re }
    })), D = (ne, re) => W(t({
      id: re,
      action: "loadLanguage",
      payload: {
        langs: ne,
        options: {
          langPath: b.langPath,
          dataPath: b.dataPath,
          cachePath: b.cachePath,
          cacheMethod: b.cacheMethod,
          gzip: b.gzip,
          lstmOnly: [s.DEFAULT, s.LSTM_ONLY].includes(Y) && !b.legacyLang
        }
      }
    })), G = (ne, re, de, Ie) => W(t({
      id: Ie,
      action: "initialize",
      payload: { langs: ne, oem: re, config: de }
    })), U = (ne = "eng", re, de, Ie) => {
      if (ee && [s.TESSERACT_ONLY, s.TESSERACT_LSTM_COMBINED].includes(re)) throw Error("Legacy model requested but code missing.");
      const h = re || Y;
      Y = h;
      const E = de || K;
      K = E;
      const P = (typeof ne == "string" ? ne.split("+") : ne).filter((k) => !v.includes(k));
      return v.push(...P), P.length > 0 ? D(P, Ie).then(() => G(ne, h, E, Ie)) : G(ne, h, E, Ie);
    }, te = (ne = {}, re) => W(t({
      id: re,
      action: "setParameters",
      payload: { params: ne }
    })), fe = async (ne, re = {}, de = {
      text: !0
    }, Ie) => W(t({
      id: Ie,
      action: "recognize",
      payload: { image: await u(ne), options: re, output: de }
    })), Se = async (ne, re) => {
      if (ee) throw Error("`worker.detect` requires Legacy model, which was not loaded.");
      return W(t({
        id: re,
        action: "detect",
        payload: { image: await u(ne) }
      }));
    }, ve = async () => (ae !== null && (a(ae), ae = null), Promise.resolve());
    l(ae, ({
      workerId: ne,
      jobId: re,
      status: de,
      action: Ie,
      data: h
    }) => {
      const E = `${Ie}-${re}`;
      if (de === "resolve")
        r(`[${ne}]: Complete ${re}`), C[E].resolve({ jobId: re, data: h }), delete C[E];
      else if (de === "reject")
        if (C[E].reject(h), delete C[E], Ie === "load" && Q(h), T)
          T(h);
        else
          throw Error(h);
      else de === "progress" && A({ ...h, userJobId: re });
    });
    const ye = {
      id: y,
      worker: ae,
      load: V,
      writeText: R,
      readText: M,
      removeFile: w,
      FS: S,
      reinitialize: U,
      setParameters: te,
      recognize: fe,
      detect: Se,
      terminate: ve
    };
    return L().then(() => D(f)).then(() => G(f, _, p)).then(() => Z(ye)).catch(() => {
    }), X;
  }, To;
}
var So, Ou;
function pS() {
  if (Ou) return So;
  Ou = 1;
  const e = Dp();
  return So = {
    recognize: async (n, s, i) => {
      const o = await e(s, 1, i);
      return o.recognize(n).finally(async () => {
        await o.terminate();
      });
    },
    detect: async (n, s) => {
      const i = await e("osd", 0, s);
      return i.detect(n).finally(async () => {
        await i.terminate();
      });
    }
  }, So;
}
var Oo, Au;
function hS() {
  return Au || (Au = 1, Oo = {
    AFR: "afr",
    AMH: "amh",
    ARA: "ara",
    ASM: "asm",
    AZE: "aze",
    AZE_CYRL: "aze_cyrl",
    BEL: "bel",
    BEN: "ben",
    BOD: "bod",
    BOS: "bos",
    BUL: "bul",
    CAT: "cat",
    CEB: "ceb",
    CES: "ces",
    CHI_SIM: "chi_sim",
    CHI_TRA: "chi_tra",
    CHR: "chr",
    CYM: "cym",
    DAN: "dan",
    DEU: "deu",
    DZO: "dzo",
    ELL: "ell",
    ENG: "eng",
    ENM: "enm",
    EPO: "epo",
    EST: "est",
    EUS: "eus",
    FAS: "fas",
    FIN: "fin",
    FRA: "fra",
    FRK: "frk",
    FRM: "frm",
    GLE: "gle",
    GLG: "glg",
    GRC: "grc",
    GUJ: "guj",
    HAT: "hat",
    HEB: "heb",
    HIN: "hin",
    HRV: "hrv",
    HUN: "hun",
    IKU: "iku",
    IND: "ind",
    ISL: "isl",
    ITA: "ita",
    ITA_OLD: "ita_old",
    JAV: "jav",
    JPN: "jpn",
    KAN: "kan",
    KAT: "kat",
    KAT_OLD: "kat_old",
    KAZ: "kaz",
    KHM: "khm",
    KIR: "kir",
    KOR: "kor",
    KUR: "kur",
    LAO: "lao",
    LAT: "lat",
    LAV: "lav",
    LIT: "lit",
    MAL: "mal",
    MAR: "mar",
    MKD: "mkd",
    MLT: "mlt",
    MSA: "msa",
    MYA: "mya",
    NEP: "nep",
    NLD: "nld",
    NOR: "nor",
    ORI: "ori",
    PAN: "pan",
    POL: "pol",
    POR: "por",
    PUS: "pus",
    RON: "ron",
    RUS: "rus",
    SAN: "san",
    SIN: "sin",
    SLK: "slk",
    SLV: "slv",
    SPA: "spa",
    SPA_OLD: "spa_old",
    SQI: "sqi",
    SRP: "srp",
    SRP_LATN: "srp_latn",
    SWA: "swa",
    SWE: "swe",
    SYR: "syr",
    TAM: "tam",
    TEL: "tel",
    TGK: "tgk",
    TGL: "tgl",
    THA: "tha",
    TIR: "tir",
    TUR: "tur",
    UIG: "uig",
    UKR: "ukr",
    URD: "urd",
    UZB: "uzb",
    UZB_CYRL: "uzb_cyrl",
    VIE: "vie",
    YID: "yid"
  }), Oo;
}
var Ao, Nu;
function gS() {
  return Nu || (Nu = 1, Ao = {
    OSD_ONLY: "0",
    AUTO_OSD: "1",
    AUTO_ONLY: "2",
    AUTO: "3",
    SINGLE_COLUMN: "4",
    SINGLE_BLOCK_VERT_TEXT: "5",
    SINGLE_BLOCK: "6",
    SINGLE_LINE: "7",
    SINGLE_WORD: "8",
    CIRCLE_WORD: "9",
    SINGLE_CHAR: "10",
    SPARSE_TEXT: "11",
    SPARSE_TEXT_OSD: "12",
    RAW_LINE: "13"
  }), Ao;
}
var No, Cu;
function _S() {
  if (Cu) return No;
  Cu = 1, QT();
  const e = ZT(), t = Dp(), r = pS(), n = hS(), s = Cp(), i = gS(), { setLogging: o } = al();
  return No = {
    languages: n,
    OEM: s,
    PSM: i,
    createScheduler: e,
    createWorker: t,
    setLogging: o,
    ...r
  }, No;
}
var mS = _S();
const zA = {
  data() {
    return {};
  },
  methods: {
    checkAll(e) {
      try {
        e = e.replace(/[^A-Za-z0-9\s]/g, " "), e = e.replace(/\n/g, " ").replace(/\\n/g, " ").split(" ");
        let t = [], r = "";
        for (let n = 0; n < e.length; n++)
          (e[n].length == 12 || e[n].length == 10) && e[n - 2] != "UPI" && e[n - 1] != "ID:" && t.push(e[n]);
        for (let n = 0; n < t.length && (!r || r && r.length == 10); n++)
          (!isNaN(t[n]) && t[n].length == 12 || !isNaN(t[n]) && t[n].length == 10) && (r = t[n]);
        return r;
      } catch {
        return !1;
      }
    }
  }
}, yS = async (e, t) => {
  var s;
  let r = null, n = null;
  try {
    O.dispatch("setGlobalLoader", !0), console.log(t);
    let i = await $("get", "PARENT_PAYMENT_METHODS", null, "wallet", { amount: t });
    if (O.dispatch("setGlobalLoader", !1), i && i.status == 200) {
      if ((s = i == null ? void 0 : i.data) != null && s.error)
        r = [], m(i.data.error);
      else {
        let o = i.data.data, a = Object.groupBy(o, ({ method_name: c }) => c), l = o.filter((c) => c.method === "social").map((c) => c.method_name), u = {};
        l.forEach((c) => {
          a[c] && (u[c] = a[c], delete a[c]);
        }), n = [...new Set(l)].length, Object.assign(u, a), r = u;
      }
      return { data: r, nonSocialStartIndex: n };
    }
  } catch (i) {
    O.dispatch("setGlobalLoader", !1), e < 3 && !i ? yS(e + 1) : i && (r = [], m(i[0]), window.router.back());
  }
}, JA = async (e, t) => {
  var r, n, s, i, o, a, l, u, c, d;
  try {
    const f = await $("get", "PAYMENT_GATEWAY", null, "wallet", { amount: e, master_account_id: t });
    (f == null ? void 0 : f.status) == 200 && ((r = f == null ? void 0 : f.data) != null && r.success ? (i = (s = f == null ? void 0 : f.data) == null ? void 0 : s.data) != null && i.url && (window.location.href = (a = (o = f == null ? void 0 : f.data) == null ? void 0 : o.data) != null && a.url.includes("toit") ? (u = (l = f == null ? void 0 : f.data) == null ? void 0 : l.data) == null ? void 0 : u.url : `${(d = (c = f == null ? void 0 : f.data) == null ? void 0 : c.data) == null ? void 0 : d.url}&return_url=${window.location.host}`) : m((n = f == null ? void 0 : f.data) == null ? void 0 : n.error), O.dispatch("setGlobalLoader", !1));
  } catch (f) {
    O.dispatch("setGlobalLoader", !1), f && m(f[0]);
  }
}, XA = async ({
  event: e,
  depositAmount: t,
  startTimer: r,
  resetTimer: n,
  sbtBtn: s,
  checkAll: i
}) => {
  try {
    const o = e.target.files[0];
    if (!o.type.startsWith("image/")) {
      e.target.value = "", m("Only Image Files are Allowed");
      return;
    }
    const a = 5 * 1024 * 1024;
    if (o.size > a) {
      e.target.value = "", m(`File ${o.name} should be size limit of 5 MB.`);
      return;
    }
    let l = URL.createObjectURL(o), u = o;
    typeof r == "function" && r();
    let c = null;
    c = await ES(l, i), console.log(c);
    let d = c, f = null;
    return c ? (f = {
      langKey: "found-img-utr-found",
      msg: "We find this as UTR Number from uploaded screenshot by you, If it's wrong Kindly make it correct manually for fast deposit."
    }, typeof n == "function" && n(), Re.scrollToElement(s), {
      manual_utr: c,
      utrMsg: f,
      uploadedImage: u,
      previewImage: l,
      tesseract_utr: d
    }) : (f = {
      langKey: "found-img-utr-not-found",
      msg: "We didn't find any UTR Number from uploaded screenshot by you, Kindly enter UTR Number manually for fast deposit."
    }, console.log("manual_utr", c), {
      manual_utr: c,
      utrMsg: f,
      uploadedImage: u,
      previewImage: l,
      tesseract_utr: d
    });
  } catch (o) {
    o && (typeof n == "function" && n(), m(o[0] ?? o + "refresh the page and try again!!"));
  }
}, ES = async (e, t) => {
  try {
    const r = e, n = await mS.createWorker("eng");
    let { data: { text: s } } = await n.recognize(r);
    if (await n.terminate(), typeof t == "function")
      return t(s);
  } catch {
    return null;
  }
}, QA = async ({
  accountDetails: e,
  uploadedImage: t,
  depositAmount: r,
  manual_utr: n,
  removeImage: s,
  has_edited_utr: i
}) => {
  var o, a;
  try {
    if (!t || t == null) {
      m("Please upload image");
      return;
    }
    if (!r || r == null) {
      m("Please Enter Deposit Amount");
      return;
    }
    O.dispatch("setGlobalLoader", !0);
    const l = await vS(t, "payment_method");
    let u = {
      amount: r,
      transaction_id: n,
      transaction_image_url: l,
      account_index: e.master_account_id,
      client_created_date: Te.sportItemDate(e.created_at, "YYYY-MM-DD HH:mm:ss"),
      has_edited_utr: i,
      type: "client_deposit",
      multiplier_value: e.multiplier_value
    }, c = await $("post", "WALLET_DEPOSIT", u, "wallet");
    O.dispatch("setGlobalLoader", !1), c && c.status == 200 && ((o = c == null ? void 0 : c.data) != null && o.error ? m(c.data.error) : (window.router.push({ name: "Home" }), _e((a = c == null ? void 0 : c.data) == null ? void 0 : a.message), typeof resetTimer == "function" && s()));
  } catch (l) {
    O.dispatch("setGlobalLoader", !1), l && m(l[0]);
  }
}, vS = async (e, t) => {
  if (!e) return;
  if (![
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/bmp",
    "image/webp",
    "image/svg+xml",
    "text/csv",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ].includes(e.type))
    return m("Invalid file type");
  const n = {
    file_type: e.type,
    file_size: Math.round(e.size / 1024),
    // in KB
    file_name: e.name,
    type: t
  }, { data: s } = await $("post", "UPLOAD_AND_FETCH_QR_DATA", n, "wallet");
  if (!(s != null && s.success))
    throw new Error((s == null ? void 0 : s.message) || "Failed to get upload URL");
  return await bS(s.data.url, e);
}, bS = async (e, t) => {
  var r, n, s;
  try {
    const i = await Le.put(e, t, {
      headers: {
        "Content-Type": t.type,
        "x-amz-acl": "public-read"
      }
    });
    return console.log("S3 upload response:", i.status, i.statusText), (r = e.split("?")) == null ? void 0 : r[0];
  } catch (i) {
    throw console.error("S3 upload failed:", (n = i.response) == null ? void 0 : n.status, ((s = i.response) == null ? void 0 : s.data) || i.message), new Error("Failed to upload icon to storage");
  }
}, ZA = (e) => ({
  paymentBonus() {
    if (!e.bonusData || !Array.isArray(e.bonusData))
      return {};
    const t = e.bonusData.filter((r) => r.bonusType === "payment bonus");
    return t.length === 0 ? {} : t.reduce((r, n) => {
      try {
        const s = JSON.parse(n.methodIds);
        Array.isArray(s) && s.forEach((i) => {
          r[i] = n.percentage;
        });
      } catch (s) {
        console.warn("Failed to parse methodIds for payment bonus:", n.methodIds, s);
      }
      return r;
    }, {});
  }
}), eN = async (e, t, r) => {
  var n, s;
  try {
    return e == null || +e < +((n = t == null ? void 0 : t.withdrawal_range) == null ? void 0 : n.min) ? (m("Please enter amount greater than equal to " + ((s = t == null ? void 0 : t.withdrawal_range) == null ? void 0 : s.min)), !1) : +e > +r ? (m("Insufficient Balance"), !1) : !0;
  } catch (i) {
    return console.log(i), !1;
  }
}, wS = async (e, t = 0) => {
  var n;
  let r = {
    withdrawAccountType: null,
    userAccounts: [],
    paymentMethods: []
  };
  try {
    O.dispatch("setGlobalLoader", !0);
    let s = await $("get", "ACCOUNT_DETAILS", null, "wallet");
    return O.dispatch("setGlobalLoader", !1), (n = s == null ? void 0 : s.data) != null && n.success ? (r.userAccounts = s.data.data.account_list.sort(
      (i, o) => Te.convertToTimestamp(o.created_at) - Te.convertToTimestamp(i.created_at)
    ), s.data.data.is_bank_only ? r.paymentMethods = e.filter((i) => i.method_type == "bank") : r.paymentMethods = e) : m(s.data.message), r;
  } catch (s) {
    O.dispatch("setGlobalLoader", !1), t < 3 && !s ? wS(t + 1) : s && m(s[0]);
  }
}, tN = async (e) => {
  var t, r;
  try {
    let n = await $("delete", "DELETE_ACCOUNT", {}, "wallet", { accountId: e });
    return (t = n == null ? void 0 : n.data) != null && t.success ? (_e((r = n == null ? void 0 : n.data) == null ? void 0 : r.message), !0) : (m(n.data.message), !1);
  } catch (n) {
    return m(n[0]), !1;
  }
}, rN = async (e, t) => {
  var r;
  try {
    O.dispatch("setGlobalLoader", !0);
    let s = await $("post", "GET_ID_WALLET_WITHDRAW", {
      amount: e,
      client_account_index: t,
      // "client_created_date": dateTime.sportItemDate(accountDetails.created_at, 'YYYY-MM-DD HH:mm:ss'),
      type: "client_withdrawal"
    });
    return O.dispatch("setGlobalLoader", !1), s.data.error ? (m(s.data.error), { error: s.data.error }) : (_e((r = s == null ? void 0 : s.data) == null ? void 0 : r.message), !0);
  } catch (n) {
    if (O.dispatch("setGlobalLoader", !1), n)
      return m(n), { error: n };
  }
}, TS = async (e, t) => {
  if (!e) return;
  if (![
    "image/jpeg",
    "image/png",
    "image/jpg",
    "image/webp",
    "text/csv",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ].includes(e.type))
    return m("Invalid file type");
  const n = {
    file_type: e.type,
    file_size: Math.round(e.size / 1024),
    // in KB
    file_name: e.name,
    type: t
  }, { data: s } = await $("post", "UPLOAD_AND_FETCH_QR_DATA", n, "wallet");
  if (!(s != null && s.success))
    throw new Error((s == null ? void 0 : s.message) || "Failed to get upload URL");
  return await SS(s.data.url, e);
}, SS = async (e, t) => {
  var r, n, s;
  try {
    const i = await Le.put(e, t, {
      headers: {
        "Content-Type": t.type,
        "x-amz-acl": "public-read"
      }
    });
    return (r = e.split("?")) == null ? void 0 : r[0];
  } catch (i) {
    throw console.error("S3 upload failed:", (n = i.response) == null ? void 0 : n.status, ((s = i.response) == null ? void 0 : s.data) || i.message), new Error("Failed to upload icon to storage");
  }
}, nN = async (e, t, r, n) => {
  var s, i;
  try {
    const o = {};
    if (o.payment_method = e.method_type, t == "bank")
      o.method_id = r.method_id, o.account_holder_name = r.account_holder_name, o.account_number = r.account_no, o.ifsc_code = r.ifsc_code, o.transaction_password = r.withdrawal_password;
    else {
      o.method_id = n.method_id, o.account_holder_name = n.account_holder_name, t == "upi" ? o.upi_id = n.upi_id : (o.crypto_wallet_id = n.upi_id, o.crypto_type = "USDT");
      let l = await TS(n.qr_code, "qr-code");
      console.log("res", l), o.qr_code = l, o.transaction_password = n.withdrawal_password;
    }
    let a = await $("post", "ADD_ACCOUNT", o, "wallet");
    return (s = a == null ? void 0 : a.data) != null && s.success ? (_e((i = a == null ? void 0 : a.data) == null ? void 0 : i.message), !0) : (m(a.data.message), !1);
  } catch (o) {
    return m(o[0]), !1;
  }
}, sN = async () => {
  var e, t, r, n;
  try {
    let s = await $("post", "SENT_OTP_TO_MOBILE", {}, "wallet");
    return (e = s == null ? void 0 : s.data) != null && e.success ? (_e((n = s == null ? void 0 : s.data) == null ? void 0 : n.message), !0) : (m((t = s == null ? void 0 : s.data) == null ? void 0 : t.message), { error: (r = s == null ? void 0 : s.data) == null ? void 0 : r.message });
  } catch (s) {
    return m(s[0]), { error: s };
  }
}, iN = (e) => {
  const t = /* @__PURE__ */ new Date(), r = new Date(t.getTime() + 300 * 1e3);
  let n = 300, s = !1;
  const i = setInterval(() => {
    n = Math.floor((r - /* @__PURE__ */ new Date()) / 1e3), n <= 0 && (clearInterval(i), n = 0, s = !0), e({ isResentOtpBtnVisiable: s, timeLeft: n, timer: i });
  }, 1e3);
}, oN = async (e) => {
  var t, r, n, s;
  try {
    let i = await $("post", "RESET_WITHDRAWAL_PASSWORD", e, "wallet");
    return (t = i == null ? void 0 : i.data) != null && t.success ? (_e((s = i == null ? void 0 : i.data) == null ? void 0 : s.message), !0) : (m((r = i == null ? void 0 : i.data) == null ? void 0 : r.message), { error: (n = i == null ? void 0 : i.data) == null ? void 0 : n.message });
  } catch (i) {
    return m(i), console.log(i), { error: i };
  }
}, aN = async (e) => {
  var r;
  let t = {
    walletHistoryData: null,
    error: !1
  };
  try {
    let n = {
      from: e.fromDate,
      to: Te.getDateAddedByDays(1, e.toDate)
    }, s = await $("get", "WALLET_HISTORY", null, "wallet", n);
    return (r = s == null ? void 0 : s.data) != null && r.success ? t.walletHistoryData = s.data.data : (m(s.data.message), t.error = !0), t;
  } catch (n) {
    return console.log("wallet", n), m(n), { error: n };
  }
}, lN = (e) => {
  switch (e) {
    case "pending":
      return { label: "Pending", class: "bg-warning" };
    case "approve_completed":
      return { label: "Approved", class: "bg-success" };
    case "approve_in_process":
      return { label: "Approve In Process", class: "bg-success" };
    case "reject_completed":
      return { label: "Rejected", class: "bg-danger" };
    case "reject_in_process":
      return { label: "Reject In Process", class: "bg-danger" };
    case "hold":
      return { label: "Hold", class: "bg-warning" };
    case "expired":
      return { label: "Expired", class: "bg-danger" };
    case "cancelled":
      return { label: "Cancelled", class: "bg-danger" };
  }
}, cN = async (e) => {
  var r;
  let t = {
    error: !1
  };
  try {
    let s = await $("patch", "CANCEL_REQUEST", {}, "wallet", {
      transactionId: e
    });
    return (r = s == null ? void 0 : s.data) != null && r.success ? _e(s.data.message) : (m(s.data.message), t.error = !0), t;
  } catch (n) {
    return m(n), t.error = !0, t;
  }
}, uN = (e) => ({
  transactionImageLists() {
    var t, r;
    return (r = (t = e == null ? void 0 : e.transactionDetails) == null ? void 0 : t.transaction_image_url) == null ? void 0 : r.split(",");
  }
}), dN = async () => {
  var e, t;
  try {
    let r = [], n = await $("get", "GET_MATKAS", null, "sports");
    return (n == null ? void 0 : n.status) === 200 && (((e = n == null ? void 0 : n.data) == null ? void 0 : e.status) === 0 ? m(n.data.debug[0]) : r = (t = n == null ? void 0 : n.data) == null ? void 0 : t.data.filter((s) => s.is_active)), { matkasList: r };
  } catch (r) {
    r && m(r);
  }
}, fN = (e) => {
  try {
    if (!Array.isArray(e) || e.length === 0) return [];
    const t = /* @__PURE__ */ new Date();
    return e.map((r) => {
      let n = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
      try {
        const s = new Date(r.openDate), [i, o] = r.open_bids.split(":");
        s.setHours(parseInt(i)), s.setMinutes(parseInt(o));
        const a = new Date(r.closeDate), [l, u] = r.close_bids.split(":");
        a.setHours(parseInt(l)), a.setMinutes(parseInt(u));
        let c = null;
        if (t < s ? c = s : t >= s && t <= a && (c = a), c) {
          const d = c - t;
          d > 0 && (n.days = Math.floor(d / (1e3 * 60 * 60 * 24)), n.hours = Math.floor(d % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)), n.minutes = Math.floor(d % (1e3 * 60 * 60) / (1e3 * 60)), n.seconds = Math.floor(d % (1e3 * 60) / 1e3));
        }
      } catch (s) {
        console.warn("Countdown calculation error for item:", r, s);
      }
      return {
        ...r,
        countdown: n
      };
    });
  } catch (t) {
    return console.error("updateCountdownForMatka failed:", t), e;
  }
}, pN = (e) => ({
  filteredMatkaList() {
    var t;
    return (t = e == null ? void 0 : e.matkasList) == null ? void 0 : t.filter((r) => HT(r.id));
  },
  delhiMatket() {
    var t;
    return ((t = e == null ? void 0 : e.filteredMatkaList) == null ? void 0 : t.filter((r) => r.category_name == "DELHI MARKET")) || [];
  },
  matkaMatket() {
    var t;
    return ((t = e == null ? void 0 : e.filteredMatkaList) == null ? void 0 : t.filter((r) => r.category_name == "MATKA MARKET")) || [];
  }
}), hN = async (e) => {
  var t, r, n;
  try {
    const s = await $("get", "GET_MATKA_MARKETS", null, "sports", { id: e });
    let i = null;
    return (s == null ? void 0 : s.status) === 200 && (((t = s == null ? void 0 : s.data) == null ? void 0 : t.status) === 0 ? m(s.data.debug[0]) : (i = (r = s == null ? void 0 : s.data) == null ? void 0 : r.data, (!(i != null && i.is_active) || i != null && i.suspend) && m("No active market present. Please try different matka !!"))), {
      matkaDetail: (n = s == null ? void 0 : s.data) == null ? void 0 : n.data
    };
  } catch (s) {
    s && m(s[0]);
  }
}, gN = async (e) => {
  var t, r, n;
  try {
    let s = [];
    const i = await $("post", "GET_MATKA_SINGLE_BETS", {}, "user", { id: e });
    if ((i == null ? void 0 : i.status) === 200)
      return ((t = i == null ? void 0 : i.data) == null ? void 0 : t.status) === 0 ? m(i.data.debug[0]) : s = (n = (r = i == null ? void 0 : i.data) == null ? void 0 : r.bets) == null ? void 0 : n.sort(
        (o, a) => {
          var l, u;
          return (u = (l = a.created_at) == null ? void 0 : l.localeCompare) == null ? void 0 : u.call(l, o.created_at);
        }
      ), { matkaBetsList: s };
  } catch (s) {
    s && m(s[0]);
  }
}, _N = async (e, t, r, n, s, i) => {
  var o, a;
  try {
    let l = {
      date: Te.getcurrentDate(),
      market: e,
      bet_type: t,
      digits: r,
      stake: n == null ? void 0 : n.toString(),
      match_id: s,
      market_id: i
    };
    const u = await $("post", "SAVE_WORLI_MATKA_BET", l, "user");
    if (u)
      return u.status === 200 && (((o = u == null ? void 0 : u.data) == null ? void 0 : o.status) === 0 ? m(u.data.debug[0]) : (a = u == null ? void 0 : u.data) != null && a.error ? m(u.data.error) : _e(u.data.success)), u;
  } catch (l) {
    l && m(l[0]);
  }
}, mN = (e, t, r) => e == null || (e == null ? void 0 : e.length) === 0 ? (m("Please select a digit"), !1) : t == null || t < 10 || t > parseInt(r) ? (m("Please enter a stake value between 10 and " + r), !1) : !0, yN = (e, t) => {
  var s, i;
  let r = [], n = Array.isArray(e.markets) ? e.markets : (s = e.markets) == null ? void 0 : s.data;
  try {
    n.forEach((d) => {
      let f = {
        id: d.id,
        title: d.match_type.toUpperCase() + " (" + Te.convertUtcDate(d.match_time).add(5, "hours").add(30, "minutes").format("hh:mm A") + ")",
        type: d.match_type.toUpperCase(),
        disabled: t == "jodi" || d.is_suspend == 1,
        date: d.match_time
      };
      r.push(f);
    });
    let o = {
      id: n.find((d) => d.match_type == "close").id,
      title: "(Jodi)",
      type: "JODI",
      disabled: (i = n.find((d) => d.match_type == "close")) == null ? void 0 : i.is_suspend,
      date: n[1].match_time
    };
    r.push(o);
    let a = r.filter((d) => !d.disabled)[0], l = (e == null ? void 0 : e.suspend) || 0;
    a || (a = r[0], l = 1, m("No Market available at the moment. Please try different matka !!"));
    let u = Te.getcurrentDate(a.date, "DD-MM-YYYY");
    return { marketTypeList: r, isSuspend: l, currentDate: u, selectedMarketType: a };
  } catch (o) {
    console.log(o);
  }
}, EN = (e = !0, t, r, n, s) => {
  try {
    if (!e)
      for (var i = 0; i < (t == null ? void 0 : t.length); i++)
        t[i].pl = 0;
    for (var o = 0; o < (s == null ? void 0 : s.length); o++)
      if ((r == null ? void 0 : r.type) === "JODI" || (r == null ? void 0 : r.type) === s[o].type) {
        if (n === "jodi" || n === "single") {
          if (n === s[o].selection)
            for (var i = 0; i < t.length; i++)
              t[i].digit === s[o].odds ? t[i].pl = Math.round(
                t[i].pl + (s[o].p_l - s[o].stake)
              ) : t[i].pl = Math.round(
                t[i].pl - s[o].stake
              );
        } else if (s[o].selection.includes("patti"))
          for (var i = 0; i < t.length; i++)
            t[i].digit === s[o].odds ? t[i].pl = Math.round(
              t[i].pl + (s[o].p_l - s[o].stake)
            ) : t[i].pl = Math.round(
              t[i].pl - s[o].stake
            );
      }
    return t;
  } catch (a) {
    console.log(a);
  }
}, vN = (e, t) => {
  if (e.active = !e.active, e.active)
    t.push(e);
  else {
    const r = t.indexOf(e);
    r > -1 && t.splice(r, 1);
  }
  return { selectedDigits: t };
}, OS = (e, t, r) => {
  if (t.length >= r)
    return t;
  const n = Math.floor(Math.random() * e.length), s = e[n];
  return t.includes(s) || (s.active = !0, t.push(s)), OS(e, t, r);
}, bN = ({ digits: e, matkaBetsList: t, marketType: r }) => {
  var n, s, i;
  try {
    for (let o in e) {
      let a = e[o];
      for (let l = 0; l < (a == null ? void 0 : a.length); l++)
        a[l].pl = 0;
    }
    for (let o = 0; o < (t == null ? void 0 : t.length); o++)
      for (let a in e) {
        let l = a;
        if ((r == null ? void 0 : r.type) === ((n = t[o]) == null ? void 0 : n.type)) {
          if (l === "jodi" || l === "single") {
            if (l === t[o].selection)
              for (let u = 0; u < ((s = e[l]) == null ? void 0 : s.length); u++)
                e[l][u].digit == t[o].odds ? e[l][u].pl = Math.round(
                  e[l][u].pl + t[o].p_l
                ) : e[l][u].pl = Math.round(
                  e[l][u].pl - t[o].stake
                );
          } else if (t[o].selection.includes("patti"))
            for (let u = 0; u < ((i = e[l]) == null ? void 0 : i.length); u++)
              e[l][u].digit == t[o].odds ? e[l][u].pl = Math.round(
                e[l][u].pl + t[o].p_l
              ) : e[l][u].pl = Math.round(
                e[l][u].pl - t[o].stake
              );
        }
      }
    return e;
  } catch (o) {
    throw console.error("Error in getBookOfDigit:", o), o;
  }
}, wN = (e, t) => {
  const r = /* @__PURE__ */ new Date(), n = new Date(e), s = new Date(t);
  return r >= n && r <= s;
}, TN = (e) => ({
  checkMatkaActive() {
    var t, r;
    return !((t = e.matkaDetail) != null && t.is_active) || ((r = e.matkaDetail) == null ? void 0 : r.suspend);
  },
  // ------------------- Computed props for draggable design two ----------------------//
  t5FilterMatkaMarkets() {
    var t, r, n;
    if (e != null && e.worliMatkaBetType) {
      if (((t = e == null ? void 0 : e.Mtype) == null ? void 0 : t.type.toLowerCase()) == "open" || ((r = e == null ? void 0 : e.Mtype) == null ? void 0 : r.type.toLowerCase()) == "close")
        return Object.keys(e == null ? void 0 : e.worliMatkaBetType).filter((s) => s === "single" || s === "single patti" || s === "double patti" || s === "triple patti").reduce((s, i) => (s[i] = e == null ? void 0 : e.worliMatkaBetType[i], s), {});
      if (((n = e == null ? void 0 : e.Mtype) == null ? void 0 : n.type.toLowerCase()) == "jodi")
        return Object.keys(e == null ? void 0 : e.worliMatkaBetType).filter((s) => s === "jodi").reduce((s, i) => (s[i] = e == null ? void 0 : e.worliMatkaBetType[i], s), {});
    }
  },
  selectedStake() {
    return O == null ? void 0 : O.getters.selectedMatkaStake;
  }
}), SN = {
  single: [
    { digit: "0", active: !1, pl: 0 },
    { digit: "1", active: !1, pl: 0 },
    { digit: "2", active: !1, pl: 0 },
    { digit: "3", active: !1, pl: 0 },
    { digit: "4", active: !1, pl: 0 },
    { digit: "5", active: !1, pl: 0 },
    { digit: "6", active: !1, pl: 0 },
    { digit: "7", active: !1, pl: 0 },
    { digit: "8", active: !1, pl: 0 },
    { digit: "9", active: !1, pl: 0 }
  ],
  jodi: [
    { digit: "00", active: !1, pl: 0 },
    { digit: "01", active: !1, pl: 0 },
    { digit: "02", active: !1, pl: 0 },
    { digit: "03", active: !1, pl: 0 },
    { digit: "04", active: !1, pl: 0 },
    { digit: "05", active: !1, pl: 0 },
    { digit: "06", active: !1, pl: 0 },
    { digit: "07", active: !1, pl: 0 },
    { digit: "08", active: !1, pl: 0 },
    { digit: "09", active: !1, pl: 0 },
    { digit: "10", active: !1, pl: 0 },
    { digit: "11", active: !1, pl: 0 },
    { digit: "12", active: !1, pl: 0 },
    { digit: "13", active: !1, pl: 0 },
    { digit: "14", active: !1, pl: 0 },
    { digit: "15", active: !1, pl: 0 },
    { digit: "16", active: !1, pl: 0 },
    { digit: "17", active: !1, pl: 0 },
    { digit: "18", active: !1, pl: 0 },
    { digit: "19", active: !1, pl: 0 },
    { digit: "20", active: !1, pl: 0 },
    { digit: "21", active: !1, pl: 0 },
    { digit: "22", active: !1, pl: 0 },
    { digit: "23", active: !1, pl: 0 },
    { digit: "24", active: !1, pl: 0 },
    { digit: "25", active: !1, pl: 0 },
    { digit: "26", active: !1, pl: 0 },
    { digit: "27", active: !1, pl: 0 },
    { digit: "28", active: !1, pl: 0 },
    { digit: "29", active: !1, pl: 0 },
    { digit: "30", active: !1, pl: 0 },
    { digit: "31", active: !1, pl: 0 },
    { digit: "32", active: !1, pl: 0 },
    { digit: "33", active: !1, pl: 0 },
    { digit: "34", active: !1, pl: 0 },
    { digit: "35", active: !1, pl: 0 },
    { digit: "36", active: !1, pl: 0 },
    { digit: "37", active: !1, pl: 0 },
    { digit: "38", active: !1, pl: 0 },
    { digit: "39", active: !1, pl: 0 },
    { digit: "40", active: !1, pl: 0 },
    { digit: "41", active: !1, pl: 0 },
    { digit: "42", active: !1, pl: 0 },
    { digit: "43", active: !1, pl: 0 },
    { digit: "44", active: !1, pl: 0 },
    { digit: "45", active: !1, pl: 0 },
    { digit: "46", active: !1, pl: 0 },
    { digit: "47", active: !1, pl: 0 },
    { digit: "48", active: !1, pl: 0 },
    { digit: "49", active: !1, pl: 0 },
    { digit: "50", active: !1, pl: 0 },
    { digit: "51", active: !1, pl: 0 },
    { digit: "52", active: !1, pl: 0 },
    { digit: "53", active: !1, pl: 0 },
    { digit: "54", active: !1, pl: 0 },
    { digit: "55", active: !1, pl: 0 },
    { digit: "56", active: !1, pl: 0 },
    { digit: "57", active: !1, pl: 0 },
    { digit: "58", active: !1, pl: 0 },
    { digit: "59", active: !1, pl: 0 },
    { digit: "60", active: !1, pl: 0 },
    { digit: "61", active: !1, pl: 0 },
    { digit: "62", active: !1, pl: 0 },
    { digit: "63", active: !1, pl: 0 },
    { digit: "64", active: !1, pl: 0 },
    { digit: "65", active: !1, pl: 0 },
    { digit: "66", active: !1, pl: 0 },
    { digit: "67", active: !1, pl: 0 },
    { digit: "68", active: !1, pl: 0 },
    { digit: "69", active: !1, pl: 0 },
    { digit: "70", active: !1, pl: 0 },
    { digit: "71", active: !1, pl: 0 },
    { digit: "72", active: !1, pl: 0 },
    { digit: "73", active: !1, pl: 0 },
    { digit: "74", active: !1, pl: 0 },
    { digit: "75", active: !1, pl: 0 },
    { digit: "76", active: !1, pl: 0 },
    { digit: "77", active: !1, pl: 0 },
    { digit: "78", active: !1, pl: 0 },
    { digit: "79", active: !1, pl: 0 },
    { digit: "80", active: !1, pl: 0 },
    { digit: "81", active: !1, pl: 0 },
    { digit: "82", active: !1, pl: 0 },
    { digit: "83", active: !1, pl: 0 },
    { digit: "84", active: !1, pl: 0 },
    { digit: "85", active: !1, pl: 0 },
    { digit: "86", active: !1, pl: 0 },
    { digit: "87", active: !1, pl: 0 },
    { digit: "88", active: !1, pl: 0 },
    { digit: "89", active: !1, pl: 0 },
    { digit: "90", active: !1, pl: 0 },
    { digit: "91", active: !1, pl: 0 },
    { digit: "92", active: !1, pl: 0 },
    { digit: "93", active: !1, pl: 0 },
    { digit: "94", active: !1, pl: 0 },
    { digit: "95", active: !1, pl: 0 },
    { digit: "96", active: !1, pl: 0 },
    { digit: "97", active: !1, pl: 0 },
    { digit: "98", active: !1, pl: 0 },
    { digit: "99", active: !1, pl: 0 }
  ],
  "single patti": [
    { digit: "128", active: !1, pl: 0 },
    { digit: "137", active: !1, pl: 0 },
    { digit: "146", active: !1, pl: 0 },
    { digit: "236", active: !1, pl: 0 },
    { digit: "245", active: !1, pl: 0 },
    { digit: "290", active: !1, pl: 0 },
    { digit: "380", active: !1, pl: 0 },
    { digit: "470", active: !1, pl: 0 },
    { digit: "489", active: !1, pl: 0 },
    { digit: "560", active: !1, pl: 0 },
    { digit: "678", active: !1, pl: 0 },
    { digit: "579", active: !1, pl: 0 },
    { digit: "129", active: !1, pl: 0 },
    { digit: "138", active: !1, pl: 0 },
    { digit: "147", active: !1, pl: 0 },
    { digit: "156", active: !1, pl: 0 },
    { digit: "237", active: !1, pl: 0 },
    { digit: "246", active: !1, pl: 0 },
    { digit: "345", active: !1, pl: 0 },
    { digit: "390", active: !1, pl: 0 },
    { digit: "480", active: !1, pl: 0 },
    { digit: "570", active: !1, pl: 0 },
    { digit: "679", active: !1, pl: 0 },
    { digit: "589", active: !1, pl: 0 },
    { digit: "120", active: !1, pl: 0 },
    { digit: "139", active: !1, pl: 0 },
    { digit: "148", active: !1, pl: 0 },
    { digit: "157", active: !1, pl: 0 },
    { digit: "238", active: !1, pl: 0 },
    { digit: "247", active: !1, pl: 0 },
    { digit: "256", active: !1, pl: 0 },
    { digit: "346", active: !1, pl: 0 },
    { digit: "490", active: !1, pl: 0 },
    { digit: "580", active: !1, pl: 0 },
    { digit: "670", active: !1, pl: 0 },
    { digit: "689", active: !1, pl: 0 },
    { digit: "130", active: !1, pl: 0 },
    { digit: "149", active: !1, pl: 0 },
    { digit: "158", active: !1, pl: 0 },
    { digit: "167", active: !1, pl: 0 },
    { digit: "239", active: !1, pl: 0 },
    { digit: "248", active: !1, pl: 0 },
    { digit: "257", active: !1, pl: 0 },
    { digit: "347", active: !1, pl: 0 },
    { digit: "356", active: !1, pl: 0 },
    { digit: "590", active: !1, pl: 0 },
    { digit: "680", active: !1, pl: 0 },
    { digit: "789", active: !1, pl: 0 },
    { digit: "140", active: !1, pl: 0 },
    { digit: "159", active: !1, pl: 0 },
    { digit: "168", active: !1, pl: 0 },
    { digit: "230", active: !1, pl: 0 },
    { digit: "249", active: !1, pl: 0 },
    { digit: "258", active: !1, pl: 0 },
    { digit: "267", active: !1, pl: 0 },
    { digit: "348", active: !1, pl: 0 },
    { digit: "357", active: !1, pl: 0 },
    { digit: "456", active: !1, pl: 0 },
    { digit: "690", active: !1, pl: 0 },
    { digit: "780", active: !1, pl: 0 },
    { digit: "123", active: !1, pl: 0 },
    { digit: "150", active: !1, pl: 0 },
    { digit: "169", active: !1, pl: 0 },
    { digit: "178", active: !1, pl: 0 },
    { digit: "240", active: !1, pl: 0 },
    { digit: "259", active: !1, pl: 0 },
    { digit: "268", active: !1, pl: 0 },
    { digit: "349", active: !1, pl: 0 },
    { digit: "358", active: !1, pl: 0 },
    { digit: "457", active: !1, pl: 0 },
    { digit: "367", active: !1, pl: 0 },
    { digit: "790", active: !1, pl: 0 },
    { digit: "124", active: !1, pl: 0 },
    { digit: "160", active: !1, pl: 0 },
    { digit: "179", active: !1, pl: 0 },
    { digit: "250", active: !1, pl: 0 },
    { digit: "269", active: !1, pl: 0 },
    { digit: "278", active: !1, pl: 0 },
    { digit: "340", active: !1, pl: 0 },
    { digit: "359", active: !1, pl: 0 },
    { digit: "368", active: !1, pl: 0 },
    { digit: "458", active: !1, pl: 0 },
    { digit: "467", active: !1, pl: 0 },
    { digit: "890", active: !1, pl: 0 },
    { digit: "125", active: !1, pl: 0 },
    { digit: "134", active: !1, pl: 0 },
    { digit: "170", active: !1, pl: 0 },
    { digit: "189", active: !1, pl: 0 },
    { digit: "260", active: !1, pl: 0 },
    { digit: "279", active: !1, pl: 0 },
    { digit: "350", active: !1, pl: 0 },
    { digit: "369", active: !1, pl: 0 },
    { digit: "378", active: !1, pl: 0 },
    { digit: "459", active: !1, pl: 0 },
    { digit: "567", active: !1, pl: 0 },
    { digit: "468", active: !1, pl: 0 },
    { digit: "126", active: !1, pl: 0 },
    { digit: "135", active: !1, pl: 0 },
    { digit: "180", active: !1, pl: 0 },
    { digit: "234", active: !1, pl: 0 },
    { digit: "270", active: !1, pl: 0 },
    { digit: "289", active: !1, pl: 0 },
    { digit: "360", active: !1, pl: 0 },
    { digit: "379", active: !1, pl: 0 },
    { digit: "450", active: !1, pl: 0 },
    { digit: "469", active: !1, pl: 0 },
    { digit: "478", active: !1, pl: 0 },
    { digit: "568", active: !1, pl: 0 },
    { digit: "127", active: !1, pl: 0 },
    { digit: "136", active: !1, pl: 0 },
    { digit: "145", active: !1, pl: 0 },
    { digit: "190", active: !1, pl: 0 },
    { digit: "235", active: !1, pl: 0 },
    { digit: "280", active: !1, pl: 0 },
    { digit: "370", active: !1, pl: 0 },
    { digit: "479", active: !1, pl: 0 },
    { digit: "460", active: !1, pl: 0 },
    { digit: "569", active: !1, pl: 0 },
    { digit: "389", active: !1, pl: 0 },
    { digit: "578", active: !1, pl: 0 }
  ],
  "double patti": [
    { digit: "100", active: !1, pl: 0 },
    { digit: "119", active: !1, pl: 0 },
    { digit: "155", active: !1, pl: 0 },
    { digit: "227", active: !1, pl: 0 },
    { digit: "335", active: !1, pl: 0 },
    { digit: "344", active: !1, pl: 0 },
    { digit: "399", active: !1, pl: 0 },
    { digit: "588", active: !1, pl: 0 },
    { digit: "669", active: !1, pl: 0 },
    { digit: "110", active: !1, pl: 0 },
    { digit: "200", active: !1, pl: 0 },
    { digit: "228", active: !1, pl: 0 },
    { digit: "255", active: !1, pl: 0 },
    { digit: "336", active: !1, pl: 0 },
    { digit: "499", active: !1, pl: 0 },
    { digit: "660", active: !1, pl: 0 },
    { digit: "688", active: !1, pl: 0 },
    { digit: "778", active: !1, pl: 0 },
    { digit: "166", active: !1, pl: 0 },
    { digit: "229", active: !1, pl: 0 },
    { digit: "300", active: !1, pl: 0 },
    { digit: "337", active: !1, pl: 0 },
    { digit: "355", active: !1, pl: 0 },
    { digit: "445", active: !1, pl: 0 },
    { digit: "599", active: !1, pl: 0 },
    { digit: "779", active: !1, pl: 0 },
    { digit: "788", active: !1, pl: 0 },
    { digit: "112", active: !1, pl: 0 },
    { digit: "220", active: !1, pl: 0 },
    { digit: "266", active: !1, pl: 0 },
    { digit: "338", active: !1, pl: 0 },
    { digit: "400", active: !1, pl: 0 },
    { digit: "446", active: !1, pl: 0 },
    { digit: "455", active: !1, pl: 0 },
    { digit: "699", active: !1, pl: 0 },
    { digit: "770", active: !1, pl: 0 },
    { digit: "113", active: !1, pl: 0 },
    { digit: "122", active: !1, pl: 0 },
    { digit: "177", active: !1, pl: 0 },
    { digit: "339", active: !1, pl: 0 },
    { digit: "366", active: !1, pl: 0 },
    { digit: "447", active: !1, pl: 0 },
    { digit: "500", active: !1, pl: 0 },
    { digit: "799", active: !1, pl: 0 },
    { digit: "889", active: !1, pl: 0 },
    { digit: "114", active: !1, pl: 0 },
    { digit: "277", active: !1, pl: 0 },
    { digit: "330", active: !1, pl: 0 },
    { digit: "448", active: !1, pl: 0 },
    { digit: "466", active: !1, pl: 0 },
    { digit: "556", active: !1, pl: 0 },
    { digit: "600", active: !1, pl: 0 },
    { digit: "880", active: !1, pl: 0 },
    { digit: "899", active: !1, pl: 0 },
    { digit: "115", active: !1, pl: 0 },
    { digit: "133", active: !1, pl: 0 },
    { digit: "188", active: !1, pl: 0 },
    { digit: "223", active: !1, pl: 0 },
    { digit: "377", active: !1, pl: 0 },
    { digit: "449", active: !1, pl: 0 },
    { digit: "557", active: !1, pl: 0 },
    { digit: "566", active: !1, pl: 0 },
    { digit: "700", active: !1, pl: 0 },
    { digit: "116", active: !1, pl: 0 },
    { digit: "224", active: !1, pl: 0 },
    { digit: "233", active: !1, pl: 0 },
    { digit: "288", active: !1, pl: 0 },
    { digit: "440", active: !1, pl: 0 },
    { digit: "477", active: !1, pl: 0 },
    { digit: "558", active: !1, pl: 0 },
    { digit: "800", active: !1, pl: 0 },
    { digit: "990", active: !1, pl: 0 },
    { digit: "117", active: !1, pl: 0 },
    { digit: "144", active: !1, pl: 0 },
    { digit: "199", active: !1, pl: 0 },
    { digit: "225", active: !1, pl: 0 },
    { digit: "388", active: !1, pl: 0 },
    { digit: "559", active: !1, pl: 0 },
    { digit: "577", active: !1, pl: 0 },
    { digit: "667", active: !1, pl: 0 },
    { digit: "900", active: !1, pl: 0 },
    { digit: "118", active: !1, pl: 0 },
    { digit: "226", active: !1, pl: 0 },
    { digit: "244", active: !1, pl: 0 },
    { digit: "299", active: !1, pl: 0 },
    { digit: "334", active: !1, pl: 0 },
    { digit: "488", active: !1, pl: 0 },
    { digit: "550", active: !1, pl: 0 },
    { digit: "668", active: !1, pl: 0 },
    { digit: "677", active: !1, pl: 0 }
  ],
  "triple patti": [
    { digit: "000", active: !1, pl: 0 },
    { digit: "111", active: !1, pl: 0 },
    { digit: "222", active: !1, pl: 0 },
    { digit: "333", active: !1, pl: 0 },
    { digit: "444", active: !1, pl: 0 },
    { digit: "555", active: !1, pl: 0 },
    { digit: "666", active: !1, pl: 0 },
    { digit: "777", active: !1, pl: 0 },
    { digit: "888", active: !1, pl: 0 },
    { digit: "999", active: !1, pl: 0 }
  ]
}, ON = (e, t) => {
  if (e && t) {
    let r = 0, n = 0;
    for (; e; )
      r += e % 10, e = Math.floor(e / 10);
    for (; t; )
      n += t % 10, t = Math.floor(t / 10);
    return r % 10 + " " + n % 10;
  } else
    return "NYD";
}, AN = async (e) => e.mobileNo ? e.mobileNo.toString().length != 10 ? (m(Be("phone-number-must-10", "Phone Number Must be 10 digit.")), !1) : !0 : (m(Be("please-enter-phone-number", "Please Enter Phone Number.")), !1), NN = async (e, t, r) => {
  var s, i;
  let n = {
    otpErrorRes: null,
    otpSuccessRes: null,
    reactiveState: r
  };
  try {
    let o = {
      type: e,
      mobile: t.mobileNo,
      countrycode: t.code.includes("+") ? (s = t == null ? void 0 : t.code) == null ? void 0 : s.replace("+", "") : t.code
    }, a = await $("post", "SEND_OTP", o);
    return a && a.status == 200 ? (n.reactiveState.isOtpApiCalled = !0, n.reactiveState.otpSent = !0, n.reactiveState.isDisabled = !1, n.reactiveState.resendOtp = !0, n.reactiveState.timerRunning = !0, n.reactiveState.minutes = 5, n.reactiveState.seconds = 0, n.reactiveState.loadingOtp = !1, n.otpSuccessRes = { status: a.status, message: a.data.data }, _e(a.data.data)) : (n.otpErrorRes = ((i = a == null ? void 0 : a.data) == null ? void 0 : i.error) || "Something went wrong", n.reactiveState.loadingOtp = !1), n;
  } catch (o) {
    return console.log(o[0]), m(o[0] || "Something went wrong"), {
      otpErrorRes: o[0] || "Something went wrong",
      loadingOtp: !1
    };
  }
}, Ni = (e) => e.otp ? +e.otp : "", CN = async (e, t, r) => e === 0 && t === 0 ? (r = !1, { minutes: e, seconds: t, timerRunning: r, countDown: !1 }) : (t === 0 ? (e--, t = 59) : t--, { minutes: e, seconds: t, timerRunning: r, countDown: !0 }), DN = async (e, t, r) => (e == "password" ? t = t === "password" ? "text" : "password" : r = r === "password" ? "text" : "password", { passwordFieldType: t, confPasswordFieldType: r }), IN = async (e, t, r, n, s) => {
  var o, a, l, u, c, d, f, _, g, p, y, A, T, b;
  let i = {
    userData: null,
    loginErrorRes: null,
    loginSuccessRes: null
  };
  try {
    let C = {
      userid: r.toString(),
      type: AS(n),
      password: n.password,
      countrycode: n.code
    }, v = await $("post", e, t != "demo" ? C : null);
    return v && v.status == 200 ? ((o = v == null ? void 0 : v.data) == null ? void 0 : o.status) == 0 || (a = v == null ? void 0 : v.data) != null && a.error || (l = v == null ? void 0 : v.data) != null && l.msg ? ((u = v == null ? void 0 : v.data) != null && u.msg ? i.loginErrorRes = "Something went wrong" : i.loginErrorRes = (c = v == null ? void 0 : v.data) == null ? void 0 : c.error, m((d = v == null ? void 0 : v.data) == null ? void 0 : d.error)) : (_e((f = v == null ? void 0 : v.data) == null ? void 0 : f.success), i.loginSuccessRes = v.data.success, i.userData = v == null ? void 0 : v.data, O.dispatch("setClickBetValue", [...s]), window.authorization_token = `Bearer ${(g = (_ = i.userData) == null ? void 0 : _.user) == null ? void 0 : g.token}`, tf(), O.dispatch("setToken", `Bearer ${(y = (p = i.userData) == null ? void 0 : p.user) == null ? void 0 : y.token}`), t == "demo" && (i.userData.demo = !0), Ip(i.userData), Mp((T = (A = i.userData) == null ? void 0 : A.user) == null ? void 0 : T.userid, n)) : i.loginErrorRes = ((b = v == null ? void 0 : v.data) == null ? void 0 : b.error) || "Something went wrong", i;
  } catch (C) {
    return console.log(C), {
      loginErrorRes: C || "Something went wrong"
    };
  }
}, AS = (e) => (O.getters.siteSettings.business_type == 1 && (e.type = 2), e.type == 2 ? "userid" : "phone"), MN = async (e, t, r) => {
  var s, i, o, a, l, u, c, d, f, _, g, p, y, A;
  let n = {
    userData: null,
    loginErrorRes: null,
    loginSuccessRes: null
  };
  try {
    let T = {
      mobile: e.toString(),
      countrycode: t.code,
      otp: t.otp
    }, b = await $("post", "LOGIN_WITH_OTP", T);
    return b && b.status == 200 ? ((s = b == null ? void 0 : b.data) == null ? void 0 : s.status) == 0 || (i = b == null ? void 0 : b.data) != null && i.error || (o = b == null ? void 0 : b.data) != null && o.msg ? ((a = b == null ? void 0 : b.data) != null && a.msg ? n.loginErrorRes = "Something went wrong" : n.loginErrorRes = (l = b == null ? void 0 : b.data) == null ? void 0 : l.error, m((u = b == null ? void 0 : b.data) == null ? void 0 : u.error)) : (_e((c = b == null ? void 0 : b.data) == null ? void 0 : c.success), n.loginSuccessRes = b.data.success, n.userData = b == null ? void 0 : b.data, window.authorization_token = `Bearer ${(f = (d = n.userData) == null ? void 0 : d.user) == null ? void 0 : f.token}`, tf(), O.dispatch("setClickBetValue", [...r]), O.dispatch("setToken", `Bearer ${(g = (_ = n.userData) == null ? void 0 : _.user) == null ? void 0 : g.token}`), Ip(n == null ? void 0 : n.userData), Mp((y = (p = n == null ? void 0 : n.userData) == null ? void 0 : p.user) == null ? void 0 : y.userid, t)) : n.loginErrorRes = ((A = b == null ? void 0 : b.data) == null ? void 0 : A.error) || "Something went wrong", n;
  } catch (T) {
    return console.log(T), {
      loginErrorRes: T || "Something went wrong"
    };
  }
}, LN = (e) => (e.type = 1, e.userId = "demouser", e.password = "demopass", e), RN = (e, t) => {
  var r;
  return ((r = t == null ? void 0 : t.data) == null ? void 0 : r.business_type) == 2 && e.type == 1 ? e.mobileNo : e.userId;
}, Ip = async (e) => {
  var r;
  let t = {
    notificationSubscribed: null,
    notificationUnsubscribed: null,
    isDemo: (e == null ? void 0 : e.demo) || !1
  };
  O.dispatch("setUser", { ...e == null ? void 0 : e.user, ...t }), O.dispatch("setChips", (r = e == null ? void 0 : e.user) == null ? void 0 : r.chips), O.dispatch("setEventManage", e == null ? void 0 : e.event_manage);
}, Mp = (e, t) => {
  var n, s, i, o;
  let r = ((s = (n = O.getters) == null ? void 0 : n.logInData) == null ? void 0 : s.userIds) || [];
  if (t.type == 2) {
    (o = (i = ge()) == null ? void 0 : i.user) != null && o.last_login_at && r.push(e);
    let a = {
      logInWithMobile: !1,
      userIds: r
    };
    O.dispatch("setLogInData", a);
  } else {
    let a = {
      logInWithMobile: !0,
      userIds: r
    };
    O.dispatch("setLogInData", a);
  }
}, kN = async (e) => {
  var r, n, s, i, o, a, l, u, c;
  let t = {
    data: null,
    signUpErrorRes: null,
    signUpSuccessRes: null
  };
  try {
    let d = Co("downline", window.location.href), f = Co("af_code", window.location.href), _ = f ? "" : Co("refer_code", window.location.href), g = {
      userid: e.userName,
      mobile: e.mobileNo,
      password: e.password,
      otp: Ni(e),
      isDownLine: d || !1,
      refer_code: _ || e.referCode,
      country_code: e.code.includes("+") ? (r = e == null ? void 0 : e.code) == null ? void 0 : r.replace("+", "") : e.code,
      affiliate_code: f
    }, p = await $("post", "REGISTER", g);
    return p && p.status == 200 ? ((n = p == null ? void 0 : p.data) == null ? void 0 : n.status) == 0 || (s = p == null ? void 0 : p.data) != null && s.error || (i = p == null ? void 0 : p.data) != null && i.msg ? ((o = p == null ? void 0 : p.data) != null && o.msg ? t.signUpErrorRes = "Something went wrong" : t.signUpErrorRes = (a = p == null ? void 0 : p.data) == null ? void 0 : a.error, m((l = p == null ? void 0 : p.data) == null ? void 0 : l.error)) : (_e((u = p == null ? void 0 : p.data) == null ? void 0 : u.success), t.signUpSuccessRes = p.data.success, t.data = p == null ? void 0 : p.data) : t.signUpErrorRes = ((c = p == null ? void 0 : p.data) == null ? void 0 : c.error) || "Something went wrong", t;
  } catch (d) {
    return console.log(d), {
      signUpErrorRes: d
    };
  }
}, xN = async (e, t, r) => {
  try {
    if (e) {
      var n = /^(?=.*?[a-z])(?=.*?[0-9]).{8,20}$/, s = /^.{6,25}$/;
      let i = Ni(t);
      if (t.mobileNo) {
        if (i.toString().length != 6 || t.password == "" || t.confirmPassword == "")
          return m(Be("please-fill-all-fields", "Please fill all fields.")), !1;
        if (n.test(t.password)) {
          if (t.password != t.confirmPassword)
            return m(Be("password-mismatch-msg", "Password and confirm password not same.")), !1;
          if (!s.test(t.userName) && r && t.userName)
            m("User ID length should be between 6 and 25 characters.");
          else
            return !0;
        } else return m(Be("forget-valid-msg", "Must Contain At Least 1 In Capital Case. Must Be Between 8-20 Characters And Should Be Alphanumeric.")), !1;
      } else return m(Be("please-enter-mobile-number", "Please enter mobile number.")), !1;
    } else
      return m("Call for OTP."), !1;
  } catch (i) {
    return console.log(i), !1;
  }
}, Co = (e, t) => {
  t || (t = location.href), e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var r = "[\\?&]" + e + "=([^&#]*)", n = new RegExp(r), s = n.exec(t);
  return s == null ? null : s[1];
}, PN = async (e) => {
  var r, n, s, i, o, a, l, u, c;
  let t = {
    data: null,
    forgotPassErrorRes: null,
    forgotPassSuccessRes: null
  };
  try {
    let d = {
      mobile: e.mobileNo,
      countrycode: e.code.includes("+") ? (r = e == null ? void 0 : e.code) == null ? void 0 : r.replace("+", "") : e.code,
      password: e.password,
      confirm_password: e.confirmPassword,
      otp: Ni(e)
    }, f = await $("post", "FORGOT_PASSWORD", d);
    return f && f.status == 200 ? ((n = f == null ? void 0 : f.data) == null ? void 0 : n.status) == 0 || (s = f == null ? void 0 : f.data) != null && s.error || (i = f == null ? void 0 : f.data) != null && i.msg ? ((o = f == null ? void 0 : f.data) != null && o.msg ? t.forgotPassErrorRes = "Something went wrong" : t.forgotPassErrorRes = (a = f == null ? void 0 : f.data) == null ? void 0 : a.error, m((l = f == null ? void 0 : f.data) == null ? void 0 : l.error)) : (_e((u = f == null ? void 0 : f.data) == null ? void 0 : u.success), t.forgotPassSuccessRes = f.data.success, t.data = f == null ? void 0 : f.data) : t.forgotPassErrorRes = ((c = f == null ? void 0 : f.data) == null ? void 0 : c.error) || "Something went wrong", t;
  } catch (d) {
    return console.log(d), {
      forgotPassErrorRes: d
    };
  }
}, $N = async (e, t) => {
  let r = {
    passwordValidation: !1,
    continueForgetCall: !0
  };
  try {
    if (!e)
      return r.continueForgetCall = !1, r;
    let n = Ni(t);
    r.passwordValidation = !1;
    let s = /^(?=.*?[a-z])(?=.*?[0-9]).{8,20}$/, i = typeof n == "number" ? n.toString().length : typeof n == "string" ? n.length : 0;
    if (t.mobileNo) {
      if (i != 6 || t.password == "" || t.confirmPassword == "")
        return console.log(n), console.log(t), m("Please fill all fields."), r.continueForgetCall = !1;
      if (s.test(t.password)) {
        if (t.password != t.confirmPassword)
          return m("Password and confirm password not same."), r.continueForgetCall = !1;
      } else return m("Must Contain At Least 1 In Capital Case. Must Be Between 8-20 Characters And Should Be Alphanumeric."), r.continueForgetCall = !1;
    } else return m("Please enter mobile number."), r.continueForgetCall = !1;
    return r;
  } catch (n) {
    return console.log(n), r.continueForgetCall = !1, r;
  }
}, FN = async (e, t, r, n = "") => {
  var i, o, a, l, u, c, d, f, _, g, p, y, A, T, b;
  let s = {
    userData: null,
    changeErrorRes: null
  };
  try {
    const C = new FormData();
    C.append("current_password", e), C.append("password", t), C.append("confirm_password", r);
    let v = await $("post", "CHANGE_MY_PASSWORD", C);
    if (v && v.status == 200)
      if (((i = v == null ? void 0 : v.data) == null ? void 0 : i.status) == 0 || (o = v == null ? void 0 : v.data) != null && o.error || (a = v == null ? void 0 : v.data) != null && a.msg)
        v.data.msg ? s.changeErrorRes = "Something went wrong" : s.changeErrorRes = (l = v == null ? void 0 : v.data) == null ? void 0 : l.error, m((u = v == null ? void 0 : v.data) == null ? void 0 : u.error);
      else {
        if (((c = O.getters.siteSettings) == null ? void 0 : c.business_type) == 2 && !((f = (d = ge()) == null ? void 0 : d.user) != null && f.last_login_at) && n && !((g = (_ = ge()) == null ? void 0 : _.user) != null && g.phone)) {
          let K = await NS(n);
          if (K)
            return s.changeErrorRes = K, m(K), s;
        }
        _e((p = v == null ? void 0 : v.data) == null ? void 0 : p.success);
        let Y = ge().user;
        if (Y.is_fresh = 0, Y.is_password_secure = 1, Y.is_withDraw_password = !0, CS(), !((A = (y = O.getters) == null ? void 0 : y.stateUser) != null && A.last_login_at)) {
          let K = (T = O.getters) == null ? void 0 : T.stateUser;
          K.last_login_at = parseInt(Date.now() / 1e3), O.dispatch("setUser", K);
        }
      }
    else
      s.changeErrorRes = ((b = v == null ? void 0 : v.data) == null ? void 0 : b.error) || "Something went wrong";
    return s;
  } catch (C) {
    return console.log(C), {
      changeErrorRes: C || "Something went wrong"
    };
  }
}, NS = async (e) => {
  var t;
  try {
    let r = await $("post", "UPDATE_TXN_PASSWORD", { txn_password: e }, "wallet");
    return !r || r.status !== 200 ? ((t = r == null ? void 0 : r.data) == null ? void 0 : t.error) || "Something went wrong" : void 0;
  } catch (r) {
    return console.error(r), r[0] || "Something went wrong";
  }
}, CS = async () => {
  var n, s, i, o, a, l;
  (s = (n = ge()) == null ? void 0 : n.user) == null || s.userid;
  let e = ((o = (i = O.getters) == null ? void 0 : i.logInData) == null ? void 0 : o.userIds) || [], r = {
    logInWithMobile: (l = (a = O.getters) == null ? void 0 : a.logInData) == null ? void 0 : l.logInWithMobile,
    userIds: e
  };
  O.dispatch("setLogInData", r);
}, VN = async () => {
  var e, t, r, n;
  try {
    let s = await $("post", "LOGOUT_API");
    if (s && s.status == 200) {
      if (((e = s == null ? void 0 : s.data) == null ? void 0 : e.status) == 0)
        return m(s.data.debug[0]), { error: s.data.debug[0] };
      {
        O.dispatch("setIs_offer", !0), _e((t = s == null ? void 0 : s.data) == null ? void 0 : t.success), O.dispatch("resetAllState");
        let i = {
          logInWithMobile: !1,
          userIds: (n = (r = O.getters) == null ? void 0 : r.logInData) == null ? void 0 : n.userIds
        };
        return O.dispatch("setLogInData", i), { error: !1 };
      }
    }
  } catch (s) {
    return console.log(s), { error: response.data.debug[0] };
  }
}, BN = async (e) => {
  try {
    let t = {
      chips: {
        ...e
      }
    }, r = await $("post", "CHANGE_STAKE_VALUES", t);
    if (r && r.status == 200)
      return O.dispatch("setChips", e), _e(Be("saved-successfully", "Saved successfully.")), { error: !1 };
  } catch (t) {
    return m(t[0]), { error: t[0] };
  }
}, UN = async (e) => {
  var r, n;
  let t = {
    error: !1,
    isWelcomeBonus: null,
    userData: null
  };
  try {
    let i = await $("post", "CHANGE_USER_BONUS", {
      password: e
    });
    if (i && i.status == 200)
      return i.data.error ? (m(i.data.error), t.isWelcomeBonus = !1, t.error = !0, t) : (_e(i.data.success), t.userData = i == null ? void 0 : i.data, O.dispatch("setToken", `Bearer ${(n = (r = t == null ? void 0 : t.userData) == null ? void 0 : r.user) == null ? void 0 : n.token}`), DS(t.userData), t);
  } catch (s) {
    return t.isWelcomeBonus = !1, t.error = !0, m(s[0]), t;
  }
}, DS = (e) => {
  var t;
  O.dispatch("setUser", e == null ? void 0 : e.user), O.dispatch("setChips", (t = e == null ? void 0 : e.user) == null ? void 0 : t.chips), O.dispatch("setEventManage", e == null ? void 0 : e.event_manage);
}, HN = async () => {
  var t;
  let e = {
    error: !1,
    lockedEarnedData: null
  };
  try {
    let r = await $("get", "GET_LOCKED_EARNED_BONUS", null, "bonus");
    if (r && r.status == 200)
      return r.data.error ? (m(r.data.error), e.error = !0, e) : (e.lockedEarnedData = r.data.data, e.lockedEarnedData.earnBonus = (t = ge()) == null ? void 0 : t.user.earnBonus, O.dispatch("setUserBonus", e.lockedEarnedData), e);
  } catch (r) {
    return e.error = !0, m(r[0]), e;
  }
}, jN = async (e, t, r) => {
  try {
    const n = Te.currentTimestamp();
    let s = r - n;
    if (s <= 0)
      return clearInterval(t), e = { hours: 0, minutes: 0, seconds: 0 }, { countdown: e, timer: t };
    const i = String(Math.floor(s / 3600)).padStart(2, "0"), o = String(Math.floor(s % 3600 / 60)).padStart(2, "0"), a = String(s % 60).padStart(2, "0");
    return e = { hours: i, minutes: o, seconds: a }, { countdown: e, timer: t };
  } catch (n) {
    console.log(n);
  }
}, YN = async (e) => {
  let t = {
    error: !1,
    getWalletType: e,
    data: null
  };
  try {
    let r = await $("post", "UPDATE_WALLET_TYPE", {});
    if (r && r.status == 200) {
      if (r.data.error)
        return m(r.data.error), t.error = !0, t.getWalletType = !e, t;
      {
        t.data = r.data;
        let n = ge().user;
        return n.actw = r.data.active_wallet, n.token = r.data.token, O.dispatch("setUser", n), O.dispatch("setGlobalLoader", !0), _e("Changed Successfully"), O.dispatch("setToken", `Bearer ${r.data.token}`), t;
      }
    }
  } catch (r) {
    return m(r[0]), t.error = !0, t.getWalletType = !e, t;
  }
}, GN = async (e) => {
  if (navigator.clipboard && window.isSecureContext)
    navigator.clipboard.writeText(e).then(() => {
    }).catch((t) => {
      console.error("Failed to copy: ", t);
    });
  else {
    let t = document.createElement("textarea");
    t.value = e, document.body.appendChild(t), t.select(), document.execCommand("copy"), document.body.removeChild(t);
  }
}, WN = async (e) => {
  var t;
  try {
    let r = await $("post", "UPDATE_USER_NAME", { display_name: e });
    if (r && r.status == 200)
      return (t = r == null ? void 0 : r.data) != null && t.error ? (m(r.data.error), { error: r.data.error }) : (ge().user.name = e, _e(r.data.message), { error: !1 });
  } catch (r) {
    return m(r[0]), { error: r[0] };
  }
}, qN = async (e, t) => {
  let r = {
    amount: e.userBonusData.welcomeBonusData.bonus_settings.amount,
    type: "welcomeBonus"
  }, n = await $("post", "REDEEM_USER_BONUS", r, "user");
  n && (n.data.error ? m(n.data.error) : (_e(n.data), setTimeout(() => {
    t.go();
  }, 2e3)));
}, KN = (e) => ({
  isAffiliate() {
    var t;
    return (t = e == null ? void 0 : e.bonusData) == null ? void 0 : t.find((r) => (r == null ? void 0 : r.bonusType) == "affiliate bonus");
  }
}), zN = (e) => ({
  chipValues() {
    var t;
    return (t = Object.keys(e == null ? void 0 : e.chips)) == null ? void 0 : t.filter((r) => r.startsWith("chip_val"));
  }
}), JN = async () => {
  var t, r, n, s, i, o, a, l;
  let e = {
    error: null,
    iframeUrl: null
  };
  try {
    const u = (r = (t = ge()) == null ? void 0 : t.user) == null ? void 0 : r.user_id, c = (n = ge()) != null && n.status ? "GET_CHATBOT_IFRAME" : "GET_CHATBOT_IFRAME_GUEST", d = u && !((s = ge()) != null && s.status) ? { userid: u } : {}, f = await $("post", c, d);
    if (f && f.status == 200) {
      if ((i = f == null ? void 0 : f.data) != null && i.error)
        return m((o = f == null ? void 0 : f.data) == null ? void 0 : o.error), e.error = (a = f == null ? void 0 : f.data) == null ? void 0 : a.error, e;
      (l = f == null ? void 0 : f.data) != null && l.chat_bot_url && (e.iframeUrl = f.data.chat_bot_url);
    }
    return e;
  } catch (u) {
    m(u);
  }
}, XN = (e) => ({
  userName() {
    var t, r;
    return ((r = (t = O.getters) == null ? void 0 : t.stateUser) == null ? void 0 : r.userid) || null;
  }
}), QN = async (e, t, r) => {
  var n = document.createElement("textarea");
  n.innerHTML = e == "code" ? t.user.refer_code : r, document.body.appendChild(n), n.select(), document.execCommand("copy"), document.body.removeChild(n), _e(e == "code" ? "Code Successfully copied." : "Link Successfully copied.");
}, ZN = async (e) => {
  var r, n;
  let t = {
    error: !1,
    statementType: null,
    activeBonusData: null,
    totalBonusData: null
  };
  try {
    let s = {
      error: !1,
      statementType: null,
      activeBonusData: null,
      totalBonusData: null
    }, i = await $("get", "GET_BONUS_STATEMENT", null, "user", { bonusType: e });
    if (i)
      return (r = i == null ? void 0 : i.data) != null && r.error ? (m((n = i == null ? void 0 : i.data) == null ? void 0 : n.error), s.error = !0) : (s.error = !1, s.statementType = e, s.activeBonusData = i.data.data, s.totalBonusData = i.data.total), s;
  } catch (s) {
    return t.error = s, t;
  }
}, eC = async () => {
  var t, r, n;
  let e = {
    error: !1,
    referBonusData: null
  };
  try {
    let s = await $("get", "GET_REFERED_USER");
    if (s)
      return (t = s == null ? void 0 : s.data) != null && t.error ? (m((r = s == null ? void 0 : s.data) == null ? void 0 : r.error), e.error = !0) : (e.error = !1, e.referBonusData = (n = s == null ? void 0 : s.data) == null ? void 0 : n.data), e;
  } catch (s) {
    return console.log(s, "err"), e.error = s, e;
  }
}, tC = async (e) => {
  var r, n;
  let t = {
    error: !1,
    referUserLog: null
  };
  try {
    let s = await $("get", "GET_BONUS_LOGS", null, "bonus", { refer_to: e.user_id });
    return s && ((r = s == null ? void 0 : s.data) != null && r.error ? (m((n = s == null ? void 0 : s.data) == null ? void 0 : n.error), t.error = !0) : (t.error = !1, t.referUserLog = s.data.data)), t;
  } catch (s) {
    return console.log(s), t.error = s, t;
  }
}, rC = async (e, t, r) => {
  var n;
  try {
    let s = await $("post", "REDEEM_USER_BONUS", { type: t[r], id: e }, "user");
    s && ((n = s == null ? void 0 : s.data) != null && n.error ? m(s.data.error) : _e(s.data));
  } catch (s) {
    console.log(s);
  }
}, nC = (e, t) => parseFloat(t / e * 100).toFixed(2), sC = (e, t, r) => r ? parseFloat(t / e * r).toFixed(2) : 0, iC = (e) => ({
  getReferLink() {
    var t, r;
    return window.location.origin + "/register?refer_code=" + ((r = (t = ge()) == null ? void 0 : t.user) == null ? void 0 : r.refer_code);
  },
  referAndEarnBonus() {
    var t, r;
    return (r = (t = O == null ? void 0 : O.getters) == null ? void 0 : t.bonusData) == null ? void 0 : r.find((n) => n.bonusType == "first refer&earn");
  },
  t5GetReferLink() {
    var t, r;
    return window.location.origin + "/sign-up?refer_code=" + ((r = (t = ge()) == null ? void 0 : t.user) == null ? void 0 : r.refer_code);
  }
}), oC = async () => {
  var e, t;
  try {
    let n = {
      userId: O.getters.stateUser.userid,
      domainName: window.location.hostname
    }, s = await $("post", "NOTIFICATIONS_LIST_API", n, "notification");
    return s ? {
      error: !1,
      all_notifications_List: s.data.data.sort((i, o) => new Date(o.created_at) - new Date(i.created_at))
    } : (m((e = error == null ? void 0 : error.data) == null ? void 0 : e.message), { error: !0 });
  } catch (r) {
    return console.log(r), { error: (t = r == null ? void 0 : r.data) == null ? void 0 : t.message };
  }
}, aC = (e) => ({
  unreadNotifications() {
    var t;
    return (t = e == null ? void 0 : e.allNotificationsList) == null ? void 0 : t.filter((r) => (r == null ? void 0 : r.is_read) == !1);
  }
}), lC = async (e, t) => {
  var n, s, i, o;
  let r = {
    error: !1,
    marketList: null,
    selectedMarketItem: null
  };
  try {
    let a = await $("get", "GET_MY_MARKETS", null, "user", { sport_type: e, page: t });
    if (a)
      return (n = a == null ? void 0 : a.data) != null && n.error ? (m((s = a == null ? void 0 : a.data) == null ? void 0 : s.error), r.error = (i = a == null ? void 0 : a.data) == null ? void 0 : i.error) : (r.marketList = (o = a.data.data) == null ? void 0 : o.sort((l, u) => ((u == null ? void 0 : u.event_timestamp_date) ?? (u == null ? void 0 : u.worli_timestamp_date) ?? 0) - ((l == null ? void 0 : l.event_timestamp_date) ?? (l == null ? void 0 : l.worli_timestamp_date) ?? 0)), r.selectedMarketItem = e, r.pagination = Re.getPaginationData(a == null ? void 0 : a.data)), r;
  } catch (a) {
    return m(a[0]), r.error = a == null ? void 0 : a[0], r;
  }
}, cC = async (e, t) => {
  var o, a, l, u, c;
  let r = ((o = O == null ? void 0 : O.getters) == null ? void 0 : o.favouriteGames) || e, n = ((a = O == null ? void 0 : O.getters) == null ? void 0 : a.eventManage) || t, s = {
    error: !1,
    favouriteSportsList: null,
    marketOdds: {}
  };
  try {
    let d = await $("get", "FIND_BY_IDS", null, "sports", { eventIds: r.join() });
    if (d && d.status == 200) {
      if (((l = d == null ? void 0 : d.data) == null ? void 0 : l.status) == 0)
        m(d.data.debug[0]), s.error = d.data.debug[0];
      else {
        s.favouriteSportsList = (u = d == null ? void 0 : d.data) == null ? void 0 : u.data;
        let f = [], _ = [];
        (c = ge()) != null && c.status && n && (f = n == null ? void 0 : n.filter((p) => p.type == "match").map((p) => p.type_id), _ = n == null ? void 0 : n.filter((p) => p.type == "league").map((p) => p.type_id)), s.favouriteSportsList = s.favouriteSportsList.filter((p) => Lr(p.sport_id) && hn(p.event_id, p.league_id, f, _) ? (p.favourite = !0, !0) : !1);
        let g = (p) => {
          let y = p;
          for (var A = 0; A < y.runners.length; A++)
            for (var T = 0; T < y.runnerNames.length; T++)
              y.runners[A].sid == y.runnerNames[T].SID && (y.runners[A].runner_name = y.runnerNames[T].RN);
          return p;
        };
        for (var i = 0; i < s.favouriteSportsList.length; i++)
          g(s.favouriteSportsList[i]);
        for (let p of s.favouriteSportsList)
          s.marketOdds[p.market_id] = p.runners;
      }
      return s;
    }
  } catch (d) {
    return console.log(d), m(d), s.error = d, s;
  }
}, uC = async () => {
  var t;
  let e = {
    error: !1,
    marketBookAndExposure: null,
    marketOdds: {}
  };
  try {
    const r = await $("get", "GET_ALL_MARKET_BOOK", null);
    return r && r.status == 200 && (e.marketBookAndExposure = r.data.data), e;
  } catch (r) {
    return m(r), e.error = (t = r == null ? void 0 : r.data) == null ? void 0 : t.message, e;
  }
}, dC = async (e) => {
  var r, n, s, i;
  let t = {
    error: null,
    virtualSportsUrl: null
  };
  try {
    let a = await $("post", "GET_THIRD_PARTY_API", {
      type: "virtual-betradar",
      productType: e ?? "vci"
    }, "user");
    if (a) {
      if ((r = a == null ? void 0 : a.data) != null && r.error)
        return m((n = a == null ? void 0 : a.data) == null ? void 0 : n.error), t.error = (i = (s = a == null ? void 0 : a.data) == null ? void 0 : s.error) == null ? void 0 : i.toString(), t;
      t.virtualSportsUrl = a.data.url;
    }
    return t;
  } catch {
    return m("Something went wrong please refresh the page !"), t.error = "Something went wrong please refresh the page !", t;
  }
}, fC = (e) => ({
  isAffiliate() {
    var t;
    return (t = e == null ? void 0 : e.bonusData) == null ? void 0 : t.find((r) => (r == null ? void 0 : r.bonusType) == "affiliate bonus");
  }
}), pC = async (e, t, r) => {
  var s, i, o, a, l, u, c, d;
  let n = {
    error: null
  };
  try {
    let f = {
      userid: e.userName,
      mobile: e.mobileNo,
      password: e.password,
      otp: Lp(r),
      country_code: e.code.includes("+") ? (s = e == null ? void 0 : e.code) == null ? void 0 : s.replace("+", "") : e.code,
      affiliate_code: (o = (i = ge()) == null ? void 0 : i.user) == null ? void 0 : o.affiliate_code,
      confirm_password: e.confirmPassword,
      self_password: t
    }, _ = await $("post", "AFFILIATE_REGISTER", f);
    return _ && _.status == 200 ? ((a = _ == null ? void 0 : _.data) == null ? void 0 : a.status) == 0 || (l = _ == null ? void 0 : _.data) != null && l.error || (u = _ == null ? void 0 : _.data) != null && u.msg ? ((c = _ == null ? void 0 : _.data) != null && c.msg ? (n.error = !0, m("Something went wrong")) : (n.error = !0, m(_.data.error)), n) : (_e((d = _ == null ? void 0 : _.data) == null ? void 0 : d.success), n) : n;
  } catch (f) {
    return n.error = !0, console.log(f), n;
  }
}, hC = async (e, t, r, n) => {
  try {
    var s = /^(?=.*?[a-z])(?=.*?[0-9]).{8,20}$/;
    let i = Lp(n);
    return t.mobileNo && !e ? (m(Be("please-request-otp", "Please request OTP.")), !1) : t.mobileNo && (i == null ? void 0 : i.length) !== 6 ? (m(Be("please-enter-otp", "Please enter OTP.")), !1) : s.test(t.password) ? t.password !== t.confirmPassword ? (m(Be("password-mismatch-msg", "Password and confirm password not same.")), !1) : r ? !0 : (m(Be("enter-user-password", "Please enter your password.")), !1) : (m(Be("forget-valid-msg", "Must Contain At Least 1 In Capital Case. Must Be Between 8-20 Characters And Should Be Alphanumeric.")), !1);
  } catch (i) {
    return console.log(i), !1;
  }
}, Lp = (e) => e == null ? void 0 : e.join().toString().replaceAll(",", ""), gC = async (e, t) => {
  var n, s, i;
  let r = {
    error: null,
    reactiveState: t
  };
  try {
    let o = {
      type: "registration",
      mobile: e.mobileNo,
      countrycode: e.code.includes("+") ? (n = e == null ? void 0 : e.code) == null ? void 0 : n.replace("+", "") : e.code
    }, a = await $("post", "SEND_OTP", o);
    return a && a.status == 200 ? (_e(a.data.data), r.reactiveState.isOtpApiCalled = !0, r.reactiveState.timerRunning = !0, r.reactiveState.minutes = 5, r.reactiveState.seconds = 0, r.error = !1) : (r.error = ((s = a == null ? void 0 : a.data) == null ? void 0 : s.error) || "Something went wrong", m(((i = a == null ? void 0 : a.data) == null ? void 0 : i.error) || "Something went wrong")), r;
  } catch (o) {
    return console.log(o[0]), m(o[0] || "Something went wrong"), r.error = o[0] || "Something went wrong";
  }
}, _C = async (e, t) => {
  let r = e || t;
  navigator.clipboard.writeText(r).then(() => {
    _e("Successfully copied.");
  }).catch((n) => {
    console.error("Failed to copy text: ", n), m("Failed to copy.");
  });
}, mC = async (e) => {
  var r, n, s, i, o;
  let t = {
    error: null,
    reactiveState: e
  };
  try {
    let a = await $("get", "GET_AFFILIATE_DASHBOARD", null, "user");
    if (a && a.status == 200) {
      if (((r = a == null ? void 0 : a.data) == null ? void 0 : r.status) == 0)
        return m(a.data.debug[0]), t.error = a.data.debug[0], t;
      t.reactiveState.dashboardData = a.data, ((s = (n = t.reactiveState.dashboardData) == null ? void 0 : n.profit_loss) == null ? void 0 : s.length) > 0 && (t.reactiveState.profitLossEvent = t.reactiveState.dashboardData.profit_loss[0]), t.reactiveState.chartOptions = {
        ...t.reactiveState.chartOptions,
        xaxis: {
          categories: (i = t.reactiveState.dashboardData) == null ? void 0 : i.lossing_users.map((l) => l.userid)
        }
      }, t.reactiveState.chartSeries = [{
        name: "Loose Amount",
        data: (o = t.reactiveState.dashboardData) == null ? void 0 : o.lossing_users.map((l) => -1 * parseFloat(l.pl).toFixed(2))
      }];
    }
    return t;
  } catch (a) {
    return m(a), t.error = a[0], t;
  }
}, yC = async () => {
  try {
    const e = document.getElementById("qrCanvas"), t = document.createElement("a");
    t.href = e.toDataURL("image/png"), t.download = "qrcode.png", t.click();
  } catch (e) {
    console.log(e);
  }
}, EC = async (e, t) => {
  var n;
  let r = {
    error: null,
    affPl: null
  };
  try {
    let s = {
      from: Te.getcurrentDate(e, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, t, "YYYY-MM-DD")
    }, i = await $("post", "GET_PROFIT_LOSS_EVENT_USERS", s);
    if (i && i.status == 200) {
      if (((n = i == null ? void 0 : i.data) == null ? void 0 : n.status) === 0 || i.data.error)
        return m(i.data.error), r.error = i.data.error, r;
      r.affPl = i.data.data;
    }
    return r;
  } catch (s) {
    return m(s == null ? void 0 : s[0]), r.error = s == null ? void 0 : s[0], r;
  }
}, vC = async (e, t, r, n) => {
  var i, o, a, l;
  let s = {
    error: null,
    currReportType: r,
    affReport: null
  };
  try {
    if (r == "commision" && n)
      return s.error = !0, s;
    s.currReportType = "commision";
    let u = {
      type: "ab",
      from: Te.getcurrentDate(e, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, t, "YYYY-MM-DD")
    }, c = await $("post", "GET_STATEMENTS", u);
    if (c && c.status == 200) {
      if ((i = c == null ? void 0 : c.data) != null && i.error)
        return m((o = c == null ? void 0 : c.data) == null ? void 0 : o.error), s.error = (a = c == null ? void 0 : c.data) == null ? void 0 : a.error, s;
      s.affReport = (l = c == null ? void 0 : c.data) == null ? void 0 : l.data;
    }
    return s;
  } catch (u) {
    return m(u), s.error = u[0], s;
  }
}, bC = async (e, t, r, n) => {
  var i, o, a, l;
  let s = {
    error: null,
    currReportType: r,
    affReport: null
  };
  try {
    if (r == "user" && n)
      return s.error = !0, s;
    s.currReportType = "user";
    let u = {
      from: Te.getcurrentDate(e, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, t, "YYYY-MM-DD")
    }, c = await $("post", "GET_AFFILIATE_REGISTER_USER_COUNT", u);
    if (c && c.status == 200) {
      if ((i = c == null ? void 0 : c.data) != null && i.error)
        return m((o = c == null ? void 0 : c.data) == null ? void 0 : o.error), s.error = (a = c == null ? void 0 : c.data) == null ? void 0 : a.error, s;
      s.affReport = (l = c == null ? void 0 : c.data) == null ? void 0 : l.data;
    }
    return s;
  } catch (u) {
    return m(u), s.error = u[0], s;
  }
}, wC = async (e, t, r) => {
  var s, i;
  let n = {
    error: null,
    affReport: null,
    totalPage: null
  };
  try {
    let a = await $("get", "GET_AFFILIATE_USERSLIST", null, "user", {
      type: r,
      from: e,
      to: t
    });
    if (a && a.status == 200) {
      if (((s = a == null ? void 0 : a.data) == null ? void 0 : s.status) === 0)
        return m(a.data.debug[0]), n.error = a.data.debug[0], n;
      {
        let l = (i = a.data) == null ? void 0 : i.userList;
        n.totalPage = l == null ? void 0 : l.last_page, n.affReport = l == null ? void 0 : l.data;
      }
    }
    return n;
  } catch (o) {
    return m(o), n.error = o[0], n;
  }
}, TC = async (e, t, r) => {
  var s, i, o, a, l, u;
  let n = {
    error: null,
    statementsList: null
  };
  try {
    let c = {
      type: (e == null ? void 0 : e.reportType) != "all" && (e == null ? void 0 : e.reportType) != "dw" ? e == null ? void 0 : e.gameSubType : e == null ? void 0 : e.reportType,
      page_entries: 25,
      sub_type: null,
      from: Te.getcurrentDate(e.fromDate, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, e.toDate, "YYYY-MM-DD"),
      affiliate_user_id: t
    }, d = await $("post", "GET_STATEMENTS", c, "user", { page: r });
    if (d && d.status == 200) {
      if ((s = d == null ? void 0 : d.data) != null && s.error)
        return m((i = d == null ? void 0 : d.data) == null ? void 0 : i.error), n.error = (o = d == null ? void 0 : d.data) == null ? void 0 : o.error, n;
      (l = (a = d == null ? void 0 : d.data) == null ? void 0 : a.data) != null && l.statements || (n.statementsList = (u = d == null ? void 0 : d.data) == null ? void 0 : u.data, n.pagination = Re.getPaginationData(d == null ? void 0 : d.data));
    }
    return n;
  } catch (c) {
    return m(c), n.error = c[0], n;
  }
}, SC = async (e, t) => {
  var n, s, i, o, a;
  let r = {
    error: null,
    profitLossList: null
  };
  try {
    let l = {
      from: Te.getcurrentDate(e.fromDate, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, e.toDate, "YYYY-MM-DD"),
      affiliate_user_id: t
    }, u = await $("post", "GET_PROFIT_LOSS", l, "user");
    if (u && u.status == 200) {
      if ((n = u == null ? void 0 : u.data) != null && n.error)
        return m((s = u == null ? void 0 : u.data) == null ? void 0 : s.error), r.error = (i = u == null ? void 0 : u.data) == null ? void 0 : i.error, r;
      (o = u == null ? void 0 : u.data) != null && o.data.statements || (r.profitLossList = (a = u == null ? void 0 : u.data) == null ? void 0 : a.data);
    }
    return r;
  } catch (l) {
    return m(l), r.error = l[0], r;
  }
}, OC = async (e, t) => {
  var n, s, i, o, a, l, u;
  const r = [];
  if (!t || t.length === 0) {
    m("No Data Found");
    return;
  }
  for (let c = 0; c < t.length; c++) {
    let d = {
      No: c + 1,
      "Event Name": (n = t[c]) == null ? void 0 : n.event_name,
      "Match Date": Te.convertUnixDate((s = t[c]) == null ? void 0 : s.bet_timestamp_date),
      Odds: (i = t[c]) == null ? void 0 : i.odds,
      "Profit Loss": (o = t[c]) == null ? void 0 : o.p_l,
      Selection: (a = t[c]) == null ? void 0 : a.selection,
      "Selection Type": (l = t[c]) == null ? void 0 : l.selection_type,
      Stake: (u = t[c]) == null ? void 0 : u.stake
    };
    r.push(d);
  }
  r.length > 0 ? e == "E" ? Re.downloadExcel(r, "Bets.xlsx") : e == "P" && Re.downloadPdf(r, "Bets.pdf") : m("No Data Found");
}, AC = async (e, t) => {
  var r, n, s, i, o, a, l, u, c;
  if (t && t.length != 0) {
    const d = [];
    for (let f = 0; f < t.length; f++) {
      let _ = {
        No: f + 1,
        "Match Date": (r = t[f]) == null ? void 0 : r.bet_place_time,
        Commission: (s = (n = t[f]) == null ? void 0 : n.commission) == null ? void 0 : s.toFixed(2),
        // 'Liability': openBetsList[i]?.liability,
        Odds: (i = t[f]) == null ? void 0 : i.odds,
        "Profit Loss": (o = t[f]) == null ? void 0 : o.p_l,
        Rate: (a = t[f]) == null ? void 0 : a.rate,
        Selection: (l = t[f]) == null ? void 0 : l.selection,
        Stake: (u = t[f]) == null ? void 0 : u.stake,
        Type: (c = t[f]) == null ? void 0 : c.type
      };
      d.push(_);
    }
    e == "E" ? Re.downloadExcel(d, "Bets.xlsx") : e == "P" && Re.downloadPdf(d, "Bets.pdf");
  } else
    m("No Data Found");
}, NC = async (e, t) => {
  var r, n, s, i, o, a, l, u;
  if (t && t.length != 0) {
    const c = [];
    for (let d = 0; d < t.length; d++) {
      let f = {
        No: d + 1,
        Date: Te.convertDate((r = t == null ? void 0 : t[d]) == null ? void 0 : r.date, "DD MMM YYYY, hh:mm:ss A"),
        Description: (n = t[d]) == null ? void 0 : n.des,
        Credit: ((s = t[d]) == null ? void 0 : s.pl) >= 0 ? parseFloat(Re.formatNumber((i = t[d]) == null ? void 0 : i.pl)) : 0,
        Debit: ((o = t[d]) == null ? void 0 : o.pl) < 0 ? parseFloat(Re.formatNumber((a = t[d]) == null ? void 0 : a.pl)) : 0,
        Balance: Re.formatNumber((l = t[d]) == null ? void 0 : l.balance),
        Remark: ((u = t[d]) == null ? void 0 : u.remark) || "-"
      };
      c.push(f);
    }
    e == "E" ? (Re.downloadExcel(c, "Statement.xlsx"), _e("Excel File Successfully Downloaded")) : e == "P" && (Re.downloadPdf(c, "Statement.pdf"), _e("Pdf File Successfully Downloaded"));
  } else
    m("No Data Found");
}, CC = async (e, t) => {
  var r, n, s, i, o, a;
  if (t && t.length != 0) {
    const l = [];
    for (let u = 0; u < t.length; u++) {
      let c = {
        No: u + 1,
        Date: Te.convertUnixDate((r = t[u]) == null ? void 0 : r.date),
        Event: (n = t[u]) == null ? void 0 : n.match_name,
        Commission: (i = (s = t[u]) == null ? void 0 : s.com) == null ? void 0 : i.toFixed(2),
        Type: (o = t[u]) == null ? void 0 : o.type,
        PL: (a = t[u]) == null ? void 0 : a.pl
      };
      l.push(c);
    }
    e == "E" ? Re.downloadExcel(l, "ProfitLoss.xlsx") : e == "P" && Re.downloadPdf(l, "ProfitLoss.pdf");
  } else
    m("No Data Found");
}, DC = async (e, t, r, n, s) => {
  var o, a, l, u, c;
  let i = {
    error: null,
    profitAndLossList: null
  };
  try {
    let d = {
      from: Te.getcurrentDate(e, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, t, "YYYY-MM-DD"),
      type: r.type,
      sport_id: r.sport_id,
      affiliate_user_id: s
    }, f = await $("post", "GET_PROFIT_LOSS_PL_DETAIL", d, "user", { page: n });
    if (f && f.status == 200) {
      if ((o = f == null ? void 0 : f.data) != null && o.error)
        return m((a = f == null ? void 0 : f.data) == null ? void 0 : a.error), i.error = (l = f == null ? void 0 : f.data) == null ? void 0 : l.error, i;
      r.sport_id ? i.profitAndLossList = (u = f == null ? void 0 : f.data) == null ? void 0 : u.data : i.profitAndLossList = (c = f == null ? void 0 : f.data) == null ? void 0 : c.data.data;
    }
    return i;
  } catch (d) {
    return m(d), i.error = d[0], i;
  }
}, IC = async (e, t, r, n) => {
  var i, o, a;
  let s = {
    error: null,
    marketBets: null
  };
  try {
    let l = {
      from: Te.getcurrentDate(e, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, t, "YYYY-MM-DD"),
      match_id: r,
      affiliate_user_id: n
    }, u = await $("post", "GET_PROFIT_LOSS_MATCH_DETAIL", l);
    if (u && u.status == 200) {
      if ((i = u == null ? void 0 : u.data) != null && i.error)
        return m((o = u == null ? void 0 : u.data) == null ? void 0 : o.error), s.error = (a = u == null ? void 0 : u.data) == null ? void 0 : a.error, s;
      s.marketBets = u.data.data;
    }
    return s;
  } catch (l) {
    return m(l), s.error = l[0], s;
  }
}, MC = async () => {
  var e, t, r;
  try {
    const n = await $("get", "FANTASY_SETUP_DATA", null, "fantasy");
    if (n && n.status === 200)
      return ((e = n == null ? void 0 : n.data) == null ? void 0 : e.status) === 0 && m((r = (t = n == null ? void 0 : n.data) == null ? void 0 : t.debug) == null ? void 0 : r[0]), n;
  } catch (n) {
    n && m(n[0]);
  }
}, LC = async (e) => {
  var t, r, n;
  try {
    const i = await $("post", "GET_REMEMBERED_MATCHES", {
      match_ids: e
    }, "fantasy");
    if (i && i.status == 200)
      return ((t = i == null ? void 0 : i.data) == null ? void 0 : t.status) == 0 && m((n = (r = i == null ? void 0 : i.data) == null ? void 0 : r.debug) == null ? void 0 : n[0]), i;
  } catch (s) {
    s && m(s[0]);
  }
}, RC = async (e, t) => {
  var r, n, s, i;
  try {
    const a = await $("post", "ADD_MATCH_REMINDER", {
      match_id: e,
      before_minute: t
    }, "fantasy");
    if (a && a.status == 200)
      if (((r = a == null ? void 0 : a.data) == null ? void 0 : r.status) == 0)
        m((s = (n = a == null ? void 0 : a.data) == null ? void 0 : n.debug) == null ? void 0 : s[0]);
      else
        return a;
  } catch (o) {
    o && m((i = o[0].split(" ")) == null ? void 0 : i.slice(2).join(" "));
  }
}, kC = async (e) => {
  var t, r, n;
  try {
    const s = await $("post", "REMOVE_MATCH_REMINDER", { match_id: e.id }, "fantasy");
    if (s && s.status == 200)
      if (((t = s == null ? void 0 : s.data) == null ? void 0 : t.status) == 0)
        m((n = (r = s == null ? void 0 : s.data) == null ? void 0 : r.debug) == null ? void 0 : n[0]);
      else
        return s;
  } catch (s) {
    s && m(s[0]);
  }
}, xC = (e) => {
  const t = Date.now() / 1e3;
  return e.map((r) => {
    let n = r.event_date_timestamp - t, s, i, o;
    return n <= 0 ? r.remainingTime = "LIVE" : (s = Math.floor(n / 86400), r.remainingTime = s + "D : ", n -= s * 86400, i = Math.floor(n / 3600) % 24, r.remainingTime += i + "H : ", n -= i * 3600, o = Math.floor(n / 60) % 60, r.remainingTime += o + "M : ", n -= o * 60, r.remainingTime += Math.floor(n % 60) + "S"), r;
  });
}, PC = async (e) => {
  var t, r, n;
  try {
    let s = null;
    const i = await $("get", "PLAYERS_LIST_API", null, "fantasy", { matchId: e });
    if (i && i.status == 200)
      return ((t = i == null ? void 0 : i.data) == null ? void 0 : t.status) == 0 ? m((n = (r = i == null ? void 0 : i.data) == null ? void 0 : r.debug) == null ? void 0 : n[0]) : s = i.data.data.sort(() => Math.random() - 0.5), { MatchPlayersList: s };
  } catch (s) {
    m(s[0]);
  }
}, $C = async () => {
  var e, t, r;
  try {
    const n = await $("post", "GET_MY_STAKES", null, "fantasy");
    if (n && n.status == 200)
      return ((e = n == null ? void 0 : n.data) == null ? void 0 : e.status) == 0 && m((r = (t = n == null ? void 0 : n.data) == null ? void 0 : t.debug) == null ? void 0 : r[0]), n;
  } catch (n) {
    m(n[0]);
  }
}, FC = async (e, t, r, n) => {
  var s, i, o, a, l;
  try {
    let u = {
      match_id: parseInt(e),
      user_team_players: t == null ? void 0 : t.toString(),
      fight_team_players: r == null ? void 0 : r.toString(),
      team_name: n
    }, c = await $("post", "ADD_MY_TEAM", u, "fantasy");
    if (c && c.status == 200)
      return ((s = c == null ? void 0 : c.data) == null ? void 0 : s.status) == 0 && m((o = (i = c == null ? void 0 : c.data) == null ? void 0 : i.debug) == null ? void 0 : o[0]), c;
  } catch (u) {
    m((l = (a = u[0]) == null ? void 0 : a.split(" ")) == null ? void 0 : l.slice(2).join(" "));
  }
}, VC = async (e) => {
  var t, r, n;
  try {
    let s = null;
    const i = await $("post", "GET_TEAM_DETAILS", null, "fantasy", { id: e });
    return i && i.status == 200 && (((t = i == null ? void 0 : i.data) == null ? void 0 : t.status) == 0 ? m((n = (r = i == null ? void 0 : i.data) == null ? void 0 : r.debug) == null ? void 0 : n[0]) : (console.log(s, i.data.data, "response data"), s = i.data.data)), { resData: s };
  } catch (s) {
    m(s[0]);
  }
}, BC = async (e, t) => {
  var r, n, s;
  try {
    const o = await $("post", "UPDATE_MYTEAM_NAME", {
      team_id: e,
      team_name: t
    }, "fantasy");
    if (o && o.status == 200)
      return ((r = o == null ? void 0 : o.data) == null ? void 0 : r.status) == 0 && m((s = (n = o == null ? void 0 : o.data) == null ? void 0 : n.debug) == null ? void 0 : s[0]), o;
  } catch (i) {
    console.log(i), m(i[0]);
  }
}, UC = async (e, t) => {
  var r, n, s, i;
  try {
    let o = await $("post", "BET_DETAILS", { match_id: e }, "fantasy");
    if ((o == null ? void 0 : o.status) === 200 && ((r = o.data) == null ? void 0 : r.status) !== 0) {
      const a = o.data;
      a.forEach((c) => c.date = c.placed_at);
      const l = (n = a.sort((c, d) => d.date - c.date)) == null ? void 0 : n.filter((c) => c.team.team_id == t), u = (c) => l.filter((d) => d.bet_type === c).length;
      return {
        myBetLists: l,
        teamBetTypeCount: u(1),
        runBetTypeCount: u(2),
        ballBetTypeCount: u(3)
      };
    } else
      m((i = (s = o == null ? void 0 : o.data) == null ? void 0 : s.debug) == null ? void 0 : i[0]);
  } catch (o) {
    m(o[0]);
  }
}, HC = async (e, t, r, n, s) => {
  var o, a, l, u;
  if (e.bet_lock)
    return m(Be("bet-not-allowed", "Bet is not allowed for this event currently!"));
  if (t && Object.keys(t).length > 0) {
    if (!IS(r, t)) return;
  } else {
    let c = {};
    if (r.stakeAmount < 10 && (c.stakeError = "The Amount Must Be At Least 10"), r.stakeRange > 50 && (c.stakeRange = "The Range Must Be At less than 50"), (o = Object.keys(c)) != null && o.length)
      return c;
  }
  const i = {
    bets: {
      [r.betType]: {
        bet_type: r.betType,
        match_id: parseInt(s),
        stake_amount: parseInt(r.stakeAmount),
        stake_range: r.stakeRange ? parseInt(r.stakeRange) : 0,
        team_id: n.players_team_id
      }
    },
    match_id: s
  };
  try {
    const c = await $("post", "PLACE_BET", i, "fantasy");
    if (((a = c == null ? void 0 : c.data) == null ? void 0 : a.status) == 0)
      m((u = (l = c == null ? void 0 : c.data) == null ? void 0 : l.debug) == null ? void 0 : u[0]);
    else
      return c;
  } catch (c) {
    console.log(c), m(c[0]);
  }
}, IS = (e, t) => {
  const r = (s, i, o) => !(s > (i == null ? void 0 : i.max) || s < (i == null ? void 0 : i.min)), n = (s, i, o) => !(s > i);
  return e.betType === 1 ? r(e.stakeAmount, t.team_stake) : e.betType === 2 ? r(e.stakeAmount, t.run_stake) && n(e.stakeRange, t.run_count.max) : e.betType === 3 ? r(e.stakeAmount, t.ball_stake) && n(e.stakeRange, t.ball_count.max) : !0;
}, jC = async (e, t, r) => {
  const n = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set();
  if (e === "amt_stake") {
    for (let i of t)
      if (i !== "" && (i = parseInt(i)), n.add(i), i < 10 || i > 1e7)
        return m(Be("stake-limit-msg", "Stake value should be in between 10 to 10000000"));
    if (n.size !== t.length)
      return m(Be("stake-duplicate-msg", "Edit stake Fields should not accept duplicate values"));
  }
  if (e === "rate_stake") {
    for (const [i, o] of r) {
      const a = parseInt(i), l = parseInt(o);
      if (n.add(a), s.add(l), a < 10 || a > 1e7)
        return m(Be("stake-limit-msg", "Stake value should be in between 10 to 10000000"));
      if (l < 1 || l > 1e4)
        return m(Be("ball-run-1-10000", "Ball/Run should be in between 1 to 10000"));
    }
    if (n.size !== r.length || s.size !== r.length)
      return m(Be("stake-duplicate-msg", "Edit stake Fields should not accept duplicate values"));
  }
  try {
    return await $("post", "UPDATE_MY_STAKES", {
      type: e,
      stakes: e === "amt_stake" ? t : r
    }, "fantasy");
  } catch (i) {
    m(i[0]);
  }
}, YC = (e) => {
  const t = /* @__PURE__ */ new Date() / 1e3;
  let r = (e == null ? void 0 : e.event_date_timestamp) - t;
  const n = Math.floor(r / 86400);
  r -= n * 86400;
  const s = Math.floor(r / 3600);
  r -= s * 3600;
  const i = Math.floor(r / 60), o = Math.floor(r % 60), a = !(n <= 0 && s <= 0 && i <= 5);
  return { timeString: `${n}D : ${s}H : ${i}M : ${o}S`, cancelBetEnable: a };
}, GC = async (e, t) => {
  var i, o, a, l;
  const r = ((o = ((i = t == null ? void 0 : t.team) == null ? void 0 : i.team_id) || (t == null ? void 0 : t.team_id)) == null ? void 0 : o.split("0")) || [], n = ((l = ((a = t == null ? void 0 : t.team) == null ? void 0 : a.computer_team_id) || (t == null ? void 0 : t.computer_team_id)) == null ? void 0 : l.split("0")) || [], s = (u) => {
    const c = [];
    for (let d = 0; d < u.length; ) {
      const { player: f, offset: _ } = Rp(e, u[d], u, d, 0);
      f ? (c.push(f[0]), d += _ ? _ + 1 : 1) : d++;
    }
    return c.sort((d, f) => d.category_id - f.category_id);
  };
  return {
    myBetTeamPlayers: s(r),
    computerBetTeamPlayers: s(n)
  };
}, Rp = (e, t, r, n, s) => {
  const i = e.filter((a) => a.player_id == t);
  if (i.length) return { player: i, offset: s };
  const o = t + "0" + r[n + ++s];
  return Rp(e, o, r, n, s);
}, WC = (e, t, r) => {
  const n = [], s = [];
  for (let i = 0; i < e.length; i++)
    for (let o = 0; o < t.length; o++)
      t[o] == e[i].player_id && n.push(e[i]);
  for (let i = 0; i < e.length; i++)
    for (let o = 0; o < r.length; o++)
      r[o] == e[i].player_id && s.push(e[i]);
  return n.sort((i, o) => i.category_id - o.category_id), s.sort((i, o) => i.category_id - o.category_id), {
    myTeam: n,
    computerTeam: s
  };
}, qC = async (e) => {
  try {
    const r = await $("post", "RESET_MYTEAM", {
      team_id: e
    }, "fantasy");
    return r && r.status == 200 && _e(r.data.message), r;
  } catch (t) {
    console.log(t);
  }
}, KC = (e, t, r, n) => {
  const s = t.indexOf(e.player_id);
  s !== -1 ? t.splice(s, 1) : t.push(e.player_id), n.forEach((i) => {
    if (i.category_id === e.category_id && i.player_id !== e.player_id) {
      const o = r.indexOf(i.player_id);
      o !== -1 ? r.splice(o, 1) : r.push(i.player_id);
    }
  });
}, zC = async (e) => {
  var t, r, n;
  try {
    const s = { type: e };
    let i = null;
    const o = await $("post", "MY_CONTESTS_LIST", s, "fantasy");
    return o && o.status == 200 && (((t = o == null ? void 0 : o.data) == null ? void 0 : t.status) == 0 ? (void 0).$errorToast((n = (r = o == null ? void 0 : o.data) == null ? void 0 : r.debug) == null ? void 0 : n[0]) : i = o.data), { myContests: i };
  } catch (s) {
    return s && m(s[0]), s;
  }
}, JC = async (e) => {
  var t, r, n;
  try {
    const s = { match_id: e };
    let i = null;
    const o = await $("post", "MY_CONTEST_BET_LIST", s, "fantasy");
    return o && o.status == 200 && (((t = o == null ? void 0 : o.data) == null ? void 0 : t.status) == 0 ? (void 0).$errorToast((n = (r = o == null ? void 0 : o.data) == null ? void 0 : r.debug) == null ? void 0 : n[0]) : i = o.data), { teamsBetList: i };
  } catch (s) {
    return s && m(s[0]), s;
  }
}, XC = (e, t) => {
  for (var r = { runs: 0, balls: 0 }, n = { runs: 0, balls: 0 }, s = 0; s < e.length; s++) {
    var i = e[s];
    i.abandoned || (r.runs += i.runs, r.balls += i.balls);
  }
  for (var s = 0; s < t.length; s++) {
    var i = t[s];
    i.abandoned || (n.runs += i.runs, n.balls += i.balls);
  }
  return {
    myScore: r,
    computerScore: n
  };
}, QC = async (e) => {
  var t, r, n;
  try {
    const s = { match_id: e };
    let i = [], o = null;
    const a = await $("post", "MY_CONTEST_BET_LIST", s, "fantasy");
    return a && a.status === 200 && (((t = a == null ? void 0 : a.data) == null ? void 0 : t.status) === 0 ? m((n = (r = a == null ? void 0 : a.data) == null ? void 0 : r.debug) == null ? void 0 : n[0]) : (i = a.data, o = new Set(
      i.map((u) => u.team_id)
    ).size)), { teamsBetList: i, totalJoinedTeams: o };
  } catch (s) {
    return s && m(s[0]), s;
  }
}, ZC = async (e, t, r, n, s, i) => {
  var a, l, u, c, d, f;
  let o = {
    error: null,
    openBetsList: null,
    from: ""
  };
  try {
    let _ = {
      type: r,
      sub_type: t,
      status: e,
      page_entries: i,
      from: n.fromDate,
      to: n.toDate
    };
    r !== "sport" && (_.sub_type = null);
    let g = await $("post", "OPEN_BETS_EVENT_LISTING", _, "user", { page: s });
    if (g && g.status == 200) {
      if ((a = g == null ? void 0 : g.data) != null && a.error)
        return m((l = g == null ? void 0 : g.data) == null ? void 0 : l.error), o.error = (u = g == null ? void 0 : g.data) == null ? void 0 : u.error, o;
      o.openBetsList = (d = (c = g == null ? void 0 : g.data) == null ? void 0 : c.data) == null ? void 0 : d.data, o.pagination = Re.getPaginationData((f = g == null ? void 0 : g.data) == null ? void 0 : f.data);
    }
    return o;
  } catch (_) {
    return m(_), o.error = _[0], o;
  }
}, eD = async (e, t, r) => {
  var s, i, o, a;
  let n = {
    error: null,
    statementsList: null
  };
  try {
    let l = {
      type: (e == null ? void 0 : e.reportType) != "all" && (e == null ? void 0 : e.reportType) != "dw" ? e == null ? void 0 : e.gameSubType : e == null ? void 0 : e.reportType,
      page_entries: r,
      sub_type: null,
      from: Te.getcurrentDate(e.fromDate, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, e.toDate, "YYYY-MM-DD")
    }, u = await $("post", "GET_STATEMENTS", l, "user", { page: t });
    if (u && u.status == 200) {
      if ((s = u == null ? void 0 : u.data) != null && s.error)
        return m((i = u == null ? void 0 : u.data) == null ? void 0 : i.error), n.error = (o = u == null ? void 0 : u.data) == null ? void 0 : o.error, n;
      n.statementsList = (a = u == null ? void 0 : u.data) == null ? void 0 : a.data, n.pagination = Re.getPaginationData(u == null ? void 0 : u.data);
    }
    return n;
  } catch (l) {
    return m(l), n.error = l[0], n;
  }
}, tD = async (e, t) => {
  var n, s, i, o;
  let r = {
    error: null,
    profitLossList: null
  };
  try {
    let a = {
      from: Te.getcurrentDate(e.fromDate, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, e.toDate, "YYYY-MM-DD")
    }, l = await $("post", "GET_PROFIT_LOSS", a, "user", { page: t });
    if (l && l.status == 200) {
      if ((n = l == null ? void 0 : l.data) != null && n.error)
        return m((s = l == null ? void 0 : l.data) == null ? void 0 : s.error), r.error = (i = l == null ? void 0 : l.data) == null ? void 0 : i.error, r;
      r.profitLossList = (o = l == null ? void 0 : l.data) == null ? void 0 : o.data;
    }
    return r;
  } catch (a) {
    return m(a), r.error = a[0], r;
  }
}, rD = async (e) => {
  var n, s, i, o;
  let t = {
    error: null,
    statementInfo: null
  }, r = await $("post", "GET_STATEMENT_INFO", { id: e });
  if (r && r.status == 200) {
    if ((n = r == null ? void 0 : r.data) != null && n.error)
      return m((s = r == null ? void 0 : r.data) == null ? void 0 : s.error), t.error = (i = r == null ? void 0 : r.data) == null ? void 0 : i.error, t;
    t.statementInfo = (o = r == null ? void 0 : r.data) == null ? void 0 : o.data, Re.openModal("#statementInfoModal");
  }
  return t;
}, nD = (e, t, r, n, s, i) => {
  try {
    const o = t == null ? void 0 : t.toLowerCase().trim();
    switch (e) {
      case 1:
        return t ? r == null ? void 0 : r.filter((a) => {
          var l;
          return (l = a == null ? void 0 : a.event_name) == null ? void 0 : l.toLowerCase().includes(o);
        }) : r;
      case 2:
        return t ? n == null ? void 0 : n.filter((a) => {
          var l;
          return (l = a == null ? void 0 : a.event_name) == null ? void 0 : l.toLowerCase().includes(o);
        }) : n;
      case 3:
        return t ? s == null ? void 0 : s.filter((a) => {
          var l;
          return (l = a == null ? void 0 : a.des) == null ? void 0 : l.toLowerCase().includes(o);
        }) : s;
      case 4:
        return t ? Object.fromEntries(
          Object.entries(i || {}).filter(
            ([a, l]) => {
              var u;
              return (u = l == null ? void 0 : l.typeName) == null ? void 0 : u.toLowerCase().includes(o);
            }
          )
        ) : i;
      default:
        return [];
    }
  } catch (o) {
    console.log(o);
  }
}, sD = (e) => ({
  t8sortedStatementsList() {
    const t = e.getSearchList() || [], { key: r, order: n } = (e == null ? void 0 : e.currentSort) || {};
    return r ? t.sort((s, i) => {
      const o = s[r], a = i[r];
      return o < a ? n === "asc" ? -1 : 1 : o > a ? n === "asc" ? 1 : -1 : 0;
    }) : t;
  }
}), iD = async (e, t, r, n) => {
  var i, o, a, l, u;
  let s = {
    error: null,
    profitAndLossList: null
  };
  try {
    let c = {
      from: Te.getcurrentDate(e, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, t, "YYYY-MM-DD"),
      type: r.type,
      sport_id: r.sport_id
    }, d = await $("post", "GET_PROFIT_LOSS_PL_DETAIL", c, "user", { page: n });
    if (d && d.status == 200) {
      if ((i = d == null ? void 0 : d.data) != null && i.error)
        return m((o = d == null ? void 0 : d.data) == null ? void 0 : o.error), s.error = (a = d == null ? void 0 : d.data) == null ? void 0 : a.error, s;
      r.sport_id ? s.profitAndLossList = (l = d == null ? void 0 : d.data) == null ? void 0 : l.data : s.profitAndLossList = (u = d == null ? void 0 : d.data) == null ? void 0 : u.data.data;
    }
    return s;
  } catch (c) {
    return m(c), s.error = c[0], s;
  }
}, oD = async (e, t, r) => {
  var s, i, o;
  let n = {
    error: null,
    marketBets: null
  };
  try {
    let a = {
      from: Te.getcurrentDate(e, "YYYY-MM-DD"),
      to: Te.getDateAddedByDays(1, t, "YYYY-MM-DD"),
      match_id: r
    }, l = await $("post", "GET_PROFIT_LOSS_MATCH_DETAIL", a);
    if (l && l.status == 200) {
      if ((s = l == null ? void 0 : l.data) != null && s.error)
        return m((i = l == null ? void 0 : l.data) == null ? void 0 : i.error), n.error = (o = l == null ? void 0 : l.data) == null ? void 0 : o.error, n;
      n.marketBets = l.data.data;
    }
    return n;
  } catch (a) {
    return m(a), n.error = a[0], n;
  }
}, aD = (e, t, r = {}) => {
  if (!e || !t) return;
  const n = e.querySelector(t);
  n && typeof n.scrollIntoView == "function" && n.scrollIntoView({
    behavior: "smooth",
    inline: "center",
    block: "nearest",
    ...r
  });
}, lD = (e, t, r = null) => {
  if (!e || !Array.isArray(t)) return r;
  const n = t.findIndex((s) => (s == null ? void 0 : s.id) === (e == null ? void 0 : e.id));
  return n > 0 ? t[n - 1] : r;
}, cD = (e = "all", t, r = e) => {
  if (e == "all" && (t != null && t.length))
    return t[0];
  if (!e || !Array.isArray(t)) return r;
  const n = t.findIndex((s) => (s == null ? void 0 : s.id) === (e == null ? void 0 : e.id));
  return n >= 0 && n < t.length - 1 ? t[n + 1] : r;
}, uD = (e = [], t = []) => {
  const r = Array.isArray(e) && e.length > 0 ? e.flatMap((s) => s.games || []) : t || [], n = /* @__PURE__ */ new Map();
  for (const s of r)
    s != null && s.provider_id && (s != null && s.provider) && n.set(s.provider_id, {
      id: s.provider_id,
      provider_name: s.provider
    });
  return Array.from(n.values());
}, dD = (e, t) => e == null ? void 0 : e.reduce((r, n) => {
  var i;
  const s = (i = n.games) == null ? void 0 : i.filter((o) => o.provider_id === t);
  return s != null && s.length && r.push({ ...n, games: s }), r;
}, []), fD = (e) => {
  var n, s, i;
  let t = (n = O == null ? void 0 : O.getters) == null ? void 0 : n.gamesData, r = [];
  if ((s = t == null ? void 0 : t[e]) != null && s.menus) {
    let o = t[e].menus;
    return o == null || o.forEach((a) => {
      r.push(...a.games);
    }), { menuList: o, games: r };
  } else
    return r = (i = t == null ? void 0 : t[e]) == null ? void 0 : i.games, { games: r };
}, pD = (e) => {
  let t = [];
  return Object.values(O.getters.gamesData).forEach((r) => {
    r.games && r.games.forEach((n) => {
      n.provider_id === e && t.push(n);
    }), r.menus && r.menus.forEach((n) => {
      n.games && n.games.forEach((s) => {
        s.provider_id === e && t.push(s);
      });
    });
  }), t;
}, hD = () => {
  var t;
  const e = /* @__PURE__ */ new Map();
  return Object.values((t = O == null ? void 0 : O.getters) == null ? void 0 : t.gamesData).forEach((r) => {
    r != null && r.games && r.games.forEach((n) => {
      e.set(n.provider_id, { provider_id: n.provider_id, provider_name: n.provider });
    }), r != null && r.menus && r.menus.forEach((n) => {
      n.games && n.games.forEach((s) => {
        e.set(s.provider_id, { provider_id: s.provider_id, provider_name: s.provider });
      });
    });
  }), Array.from(e.values());
}, gD = (e) => ({
  t1FilterGamesList() {
    var n;
    let t = [];
    if (this.searchCasinoString != "" && ((n = e.searchCasinoString) == null ? void 0 : n.length) > 2)
      return e.searchGamesList.filter(
        (s) => s.game_name.toLowerCase().includes(e.searchCasinoString.toLowerCase())
      );
    if (e.gameList)
      return (e == null ? void 0 : e.selectedProvider) == "all" ? e.gameList : e.gameList.filter((s) => (s == null ? void 0 : s.provider_id) == e.selectedProvider);
    e.filteredMenus && e.selectedMenu && (e.selectedMenu == "all" ? e.filteredMenus.forEach((s) => {
      t.push(...s.games);
    }) : (t = e.filteredMenus.find((s) => s.id == e.selectedMenu.id), t = t.games));
    const r = new Intl.Collator(void 0, { numeric: !0, sensitivity: "base" });
    return t.sort((s, i) => r.compare(s.porder, i.porder)), t;
  }
}), _D = (e) => ({
  sitePosters() {
    var t, r, n, s, i, o;
    return (t = O.getters) != null && t.siteSettings && ((n = (r = O.getters) == null ? void 0 : r.siteSettings) != null && n.poster) && ((i = (s = O.getters) == null ? void 0 : s.siteSettings) != null && i.poster.length) ? (o = O.getters) == null ? void 0 : o.siteSettings.poster.filter((a) => a.poster_type == 1) : [];
  },
  siteLogo() {
    var t, r, n, s, i, o, a;
    return ((r = (t = O.getters) == null ? void 0 : t.siteSettings) == null ? void 0 : r.aws_url) + ((i = (s = (n = O.getters) == null ? void 0 : n.siteSettings) == null ? void 0 : s.storage_path) == null ? void 0 : i.domain_image) + ((a = (o = O.getters) == null ? void 0 : o.siteSettings) == null ? void 0 : a.logo);
  },
  checkIsOfferAvailable() {
    var t, r, n;
    return (n = (r = (t = O.getters) == null ? void 0 : t.siteSettings) == null ? void 0 : r.offer) == null ? void 0 : n.image;
  },
  offerImageUrl() {
    var t, r, n, s, i, o, a, l;
    return ((r = (t = O.getters) == null ? void 0 : t.siteSettings) == null ? void 0 : r.aws_url) + ((i = (s = (n = O.getters) == null ? void 0 : n.siteSettings) == null ? void 0 : s.storage_path) == null ? void 0 : i.poster_path) + ((l = (a = (o = O.getters) == null ? void 0 : o.siteSettings) == null ? void 0 : a.offer) == null ? void 0 : l.image);
  }
}), mD = (e) => ({
  languagesData() {
    var t;
    return (t = O.getters) == null ? void 0 : t.languagesData;
  },
  filteredLanguages() {
    var t;
    if (e != null && e.searchTerm) {
      const r = (t = e == null ? void 0 : e.searchTerm) == null ? void 0 : t.toLowerCase();
      return e == null ? void 0 : e.languagesData.filter((n) => {
        var s, i;
        return (i = (s = n.lang_name) == null ? void 0 : s.toLowerCase()) == null ? void 0 : i.includes(r);
      });
    }
    return e == null ? void 0 : e.languagesData;
  }
}), MS = (e) => {
  const t = e ?? {};
  return [
    { title: "How to Login", videoKey: "login_video", imageKey: "login_img" },
    { title: "How to Register", videoKey: "register_video", imageKey: "register_img" },
    { title: "Introduction", videoKey: "introduction_video", imageKey: null },
    { title: "How to Withdraw", videoKey: "withdrawal_video", imageKey: null },
    { title: "How to Play", videoKey: "play_video", imageKey: "play_img" },
    { title: "How to Play Bonus", videoKey: "use_bonus_video", imageKey: null },
    { title: "How to Deposit English", videoKey: "deposit_video_e", imageKey: null },
    { title: "How to Deposit Hindi", videoKey: "deposit_video_h", imageKey: null }
  ].filter((n) => !!t[n.videoKey]);
}, yD = (e) => ({
  domainName() {
    var t;
    return (t = O.getters) == null ? void 0 : t.domainName;
  },
  tutorials() {
    var t, r;
    return MS((r = (t = O.getters) == null ? void 0 : t.siteSettings) == null ? void 0 : r.user_journey);
  },
  isUserJourneyAvailable() {
    var r, n;
    const t = ((n = (r = O.getters) == null ? void 0 : r.siteSettings) == null ? void 0 : n.user_journey) || {};
    return t ? Object.values(t).some((s) => !!s) : !1;
  }
}), ED = async (e) => {
  var t, r, n, s, i;
  try {
    const o = (r = (t = ge()) == null ? void 0 : t.user) == null ? void 0 : r.cpi;
    if (!o) return { error: !0 };
    const a = ((n = O.getters.siteSettings) == null ? void 0 : n.support_numbers) || [], l = /* @__PURE__ */ new Date(), u = l.getHours() * 60 + l.getMinutes();
    return e.whatsappNumbers = a.filter((c) => c.id === o).flatMap(
      (c) => c.categories.flatMap((d) => {
        const f = d.value.split(","), _ = f[u % f.length];
        return {
          category_name: d.name,
          link: d.type == "value" ? `https://wa.me/${_}` : d[d.type]
        };
      })
    ), (s = O.getters.siteSettings) != null && s.social_link.wati_link && !e.whatsappNumbers.length ? (window.open((i = O.getters.siteSettings) == null ? void 0 : i.social_link.wati_link, "blank"), { error: !0 }) : { error: !1 };
  } catch (o) {
    return m(o == null ? void 0 : o[0]), { error: !0 };
  }
}, vD = async () => {
  var t, r, n, s, i, o;
  let e = {
    error: null,
    miniGameUrl: null
  };
  try {
    let a = (r = (t = O.getters.gamesData["mini-games"]) == null ? void 0 : t.games) == null ? void 0 : r[0], l = {
      type: "casino",
      game_code: a.game_code,
      section_id: a.sm_id
    }, u = await $("post", "GET_THIRD_PARTY_API", l, "user");
    if (u) {
      if ((n = u == null ? void 0 : u.data) != null && n.error)
        return m((s = u == null ? void 0 : u.data) == null ? void 0 : s.error), e.error = (o = (i = u == null ? void 0 : u.data) == null ? void 0 : i.error) == null ? void 0 : o.toString(), e;
      e.miniGameUrl = u.data.url;
    }
    return e;
  } catch {
    return m("Mini Game Data Not Found !"), e.error = "Mini Game Data Not Found !", e;
  }
}, bD = (e, t) => {
  document.body.style.overflow = "hidden";
  const r = e.touches[0];
  t.dragging = !0, t.snapping = !1, t.offset.x = window.innerWidth - r.clientX - t.position.x, t.offset.y = r.clientY - t.position.y;
}, wD = async (e, t) => {
  if (t.dragging) {
    const r = e.touches[0];
    t.position.x = window.innerWidth - r.clientX - t.offset.x, t.position.y = r.clientY - t.offset.y;
  }
}, TD = async (e) => {
  e.dragging && (e.dragging = !1, document.body.style.overflow = "", xp(e), e.visible && kp(e));
}, SD = (e, t) => {
  document.body.style.overflow = "hidden", t.dragging = !0, t.snapping = !1, t.offset.x = e.clientX - t.position.x, t.offset.y = e.clientY - t.position.y;
}, OD = async (e, t) => {
  t.dragging && (t.position.x = window.innerWidth - e.clientX - t.offset.x, t.position.y = e.clientY - t.offset.y);
}, AD = async (e) => {
  e.dragging && (e.dragging = !1, document.body.style.overflow = "", xp(e), e.visible && kp(e));
}, kp = async (e) => {
  const r = window.innerWidth, n = window.innerHeight, s = 60;
  e.snapping = !0, e.position.y < 10 && (e.position.y = 10), e.position.y > n - s - 10 && (e.position.y = n - s - 10), e.position.x + s / 2 < r / 2 ? e.position.x = 10 : e.position.x = r - s - 20, setTimeout(() => {
    e.snapping = !1;
  }, 300);
}, xp = async (e) => {
  const t = e.$refs.icon, r = e.$refs.closeZone;
  if (!t || !r) return;
  const n = t.getBoundingClientRect(), s = r.getBoundingClientRect();
  !(n.right < s.left || n.left > s.right || n.bottom < s.top || n.top > s.bottom) && (e.visible = !1);
}, ND = async () => {
  var t, r;
  let e = {
    error: !1,
    bonusLogs: null
  };
  try {
    let n = await $("get", "GET_BONUS_LOGS", null, "bonus");
    return n && ((t = n == null ? void 0 : n.data) != null && t.error ? (m((r = n == null ? void 0 : n.data) == null ? void 0 : r.error), e.error = !0) : (e.error = !1, e.bonusLogs = n.data.data)), e;
  } catch (n) {
    return console.log(n), e.error = n, e;
  }
}, CD = (e, t) => {
  try {
    setInterval(() => {
      var c;
      const n = new Date((c = e.maintananceData) == null ? void 0 : c.to_date).getTime(), s = Date.now(), i = n - s;
      if (i < 0) {
        O.dispatch("setUnderMaintenance", null), t.go(0);
        return;
      }
      const o = 1e3, a = o * 60, l = a * 60, u = l * 24;
      e.days = Math.floor(i / u), e.hours = Math.floor(i % u / l), e.minutes = Math.floor(i % l / a), e.seconds = Math.floor(i % a / o);
    }, 1e3);
  } catch (r) {
    console.log(r);
  }
}, DD = (e) => ({
  maintananceData() {
    var t;
    return (t = O.getters) == null ? void 0 : t.underMaintenance;
  }
}), ID = (e) => {
  if (navigator.clipboard && window.isSecureContext)
    navigator.clipboard.writeText(e).then(() => {
      _e("Successfully copied.");
    }).catch((t) => {
      console.error("Failed to copy: ", t);
    });
  else {
    let t = document.createElement("textarea");
    t.value = e, document.body.appendChild(t), t.select(), document.execCommand("copy"), _e("Successfully copied.");
  }
}, MD = (e, t) => {
  var r;
  try {
    let n = ((r = e.logInData) == null ? void 0 : r.userIds) || [];
    n.push(t);
    let s = {
      logInWithMobile: !0,
      userIds: n
    };
    O.dispatch("setLogInData", s);
  } catch (n) {
    console.log(n);
  }
}, LD = async (e, t) => {
  var n, s, i, o, a;
  let r = ((n = O == null ? void 0 : O.getters) == null ? void 0 : n.eventManage) || t;
  try {
    let l = null, u = [], c = await $("get", "GET_SEARCH_EVENTS", {}, "user", { searchKey: e.searchKey });
    if (c) {
      if ((s = c == null ? void 0 : c.data) != null && s.error)
        m((i = c == null ? void 0 : c.data) == null ? void 0 : i.error);
      else {
        l = (o = c == null ? void 0 : c.data) == null ? void 0 : o.data;
        for (let d = 0; d < l.length; d++) {
          let f = [], _ = [];
          (a = ge()) != null && a.status && r && (f = r == null ? void 0 : r.filter((g) => g.type == "match").map((g) => g.type_id), _ = r == null ? void 0 : r.filter((g) => g.type == "league").map((g) => g.type_id)), Lr(l[d].sportId) && hn(l[d].event_id, l[d].id, f, _) && u.push(l[d]);
        }
      }
      return { data: u };
    }
  } catch (l) {
    console.log(l, "err");
  }
}, RD = async () => {
  var n;
  try {
    let s = await $("get", "GET_SPORTS", null, "sports");
    if (s && s.status == 200) {
      var e = (n = s == null ? void 0 : s.data) == null ? void 0 : n.data;
      let i = [], o = [];
      for (var t = 0; t < (e == null ? void 0 : e.length); t++)
        Lr(e[t].id) && (e[t].is_custom == 0 ? i.push(e[t]) : o.push(e[t]));
      i.sort((a, l) => a.rank - l.rank);
      var r = {};
      r.custom = o, r.non_custom = i, O.dispatch("setSport", r);
    }
  } catch (s) {
    s && m(s);
  }
}, kD = async (e) => {
  try {
    let t = await $("get", "INPLAY_MATCHES_COUNT", null, "sports");
    if (t && t.status == 200) {
      let r = t.data.data, n = {
        cricket: 0,
        soccer: 0,
        tennis: 0,
        inplay: 0
      };
      for (const s in r) {
        if (s == 4)
          n.cricket = r[s].total;
        else if (s == 1)
          n.soccer = r[s].total;
        else if (s == 2)
          n.tennis = r[s].total;
        else {
          const i = r[s].sport_name;
          n[i] = r[s].total;
        }
        n.inplay += r[s].inplay;
      }
      e.matchCounts = n;
    }
  } catch (t) {
    m(t[0]);
  }
}, xD = (e) => ({
  primaryNonCustomSports() {
    var t, r;
    return (r = (t = e == null ? void 0 : e.sportList) == null ? void 0 : t.non_custom) == null ? void 0 : r.filter((n) => [1, 2, 4].includes(n.id));
  },
  secondaryNonCustomSports() {
    var t, r;
    return (r = (t = e == null ? void 0 : e.sportList) == null ? void 0 : t.non_custom) == null ? void 0 : r.filter((n) => ![1, 2, 4].includes(n.id));
  },
  customSports() {
    var t;
    return (t = e == null ? void 0 : e.sportList) == null ? void 0 : t.custom;
  }
}), LS = {
  user: null,
  chips: null,
  token: null,
  eventManage: null,
  eventDetailHideSections: [],
  siteVersion: null,
  is_offer: !0
}, RS = {
  isAuthenticated: (e) => !!(e != null && e.user),
  stateUser: (e) => e == null ? void 0 : e.user,
  chips: (e) => e == null ? void 0 : e.chips,
  token: (e) => e == null ? void 0 : e.token,
  eventManage: (e) => e == null ? void 0 : e.eventManage,
  eventDetailHideSections: (e) => e == null ? void 0 : e.eventDetailHideSections,
  siteVersion: (e) => e == null ? void 0 : e.siteVersion,
  is_offer: (e) => e == null ? void 0 : e.is_offer
}, kS = {
  setUser({ commit: e }, t) {
    e("setUser", t);
  },
  setChips({ commit: e }, t) {
    e("setChips", t);
  },
  setToken({ commit: e }, t) {
    e("setToken", t);
  },
  setEventManage({ commit: e }, t) {
    e("setEventManage", t);
  },
  seteventDetailHideSections({ commit: e }, t) {
    e("seteventDetailHideSections", t);
  },
  setSiteVersion({ commit: e }, t) {
    e("setSiteVersion", t);
  },
  setIs_offer({ commit: e }, t) {
    e("setIs_offer", t);
  }
}, xS = {
  setUser(e, t) {
    e.user = t;
  },
  setChips(e, t) {
    e.chips = t;
  },
  setToken(e, t) {
    e.token = t;
  },
  setEventManage(e, t) {
    e.eventManage = t;
  },
  seteventDetailHideSections(e, t) {
    e.eventDetailHideSections = t;
  },
  setSiteVersion(e, t) {
    e.siteVersion = t;
  },
  setIs_offer(e, t) {
    e.is_offer = t;
  }
}, PD = {
  state: LS,
  getters: RS,
  actions: kS,
  mutations: xS
}, PS = {
  siteSettings: null,
  gamesData: null,
  domainName: window.location.hostname.split(".").slice(-2)[0] ? window.location.hostname.split(".").slice(-2)[0].toUpperCase() : "",
  clickBetValue: null,
  favouriteGames: [],
  globalLoader: !1,
  captchaData: null,
  notification: 0,
  languagesData: null,
  sportList: null,
  successMsg: null,
  errorMsg: null,
  underMaintenance: null,
  bonusData: null,
  count: 0,
  logInData: {
    logInWithMobile: !1,
    userIds: []
  },
  matkaStakesList: null,
  selectedMatkaStake: null,
  sideMenuLeagueList: null,
  userTransactionStakes: null,
  downloadInfo: !0
}, $S = {
  siteSettings: (e) => e == null ? void 0 : e.siteSettings,
  languagesData: (e) => {
    var t;
    return (t = e == null ? void 0 : e.siteSettings) == null ? void 0 : t.languagesList;
  },
  gamesData: (e) => e == null ? void 0 : e.gamesData,
  bonusData: (e) => e == null ? void 0 : e.bonusData,
  domainName: (e) => e == null ? void 0 : e.domainName,
  clickBetValue: (e) => e == null ? void 0 : e.clickBetValue,
  clickBetActive: (e) => {
    var t;
    return ((t = e == null ? void 0 : e.clickBetValue) == null ? void 0 : t.find((r) => r.isSelected)) ?? !1;
  },
  favouriteGames: (e) => e == null ? void 0 : e.favouriteGames,
  globalLoader: (e) => e == null ? void 0 : e.globalLoader,
  captchaData: (e) => e == null ? void 0 : e.captchaData,
  getNotification: (e) => e == null ? void 0 : e.notification,
  sportList: (e) => e == null ? void 0 : e.sportList,
  successMsg: (e) => e == null ? void 0 : e.successMsg,
  errorMsg: (e) => e == null ? void 0 : e.errorMsg,
  underMaintenance: (e) => e == null ? void 0 : e.underMaintenance,
  count: (e) => e == null ? void 0 : e.count,
  logInData: (e) => e == null ? void 0 : e.logInData,
  matkaStakesList: (e) => e == null ? void 0 : e.matkaStakesList,
  selectedMatkaStake: (e) => e == null ? void 0 : e.selectedMatkaStake,
  sideMenuLeagueList: (e) => e == null ? void 0 : e.sideMenuLeagueList,
  userTransactionStakes: (e) => e == null ? void 0 : e.userTransactionStakes,
  downloadInfo: (e) => e == null ? void 0 : e.downloadInfo
}, FS = {
  setSettings({ commit: e }, t) {
    e("setSettings", t);
  },
  setLanguagesData({ commit: e }, t) {
    e("setLanguagesData", t);
  },
  setBonusData({ commit: e }, t) {
    e("setBonusData", t);
  },
  setGamesData({ commit: e }, t) {
    e("setGamesData", t);
  },
  setClickBetValue({ commit: e }, t) {
    e("setClickBetValue", t);
  },
  setFavouriteGames({ commit: e }, t) {
    e("setFavouriteGames", t);
  },
  setGlobalLoader({ commit: e }, t) {
    e("setGlobalLoader", t);
  },
  setCaptchaData({ commit: e }, t) {
    e("setCaptchaData", t);
  },
  setNotification({ commit: e }, t) {
    e("setNotification", t);
  },
  setSport({ commit: e }, t) {
    e("setSport", t);
  },
  showSuccessModal({ commit: e }, t) {
    e("showSuccessModal", t), setTimeout(() => {
      e("showSuccessModal", null);
    }, 2e3);
  },
  showErrorModal({ commit: e }, t) {
    e("showErrorModal", t), setTimeout(() => {
      e("showErrorModal", null);
    }, 2e3);
  },
  setUnderMaintenance({ commit: e }, t) {
    e("setUnderMaintenance", t);
  },
  incrementCount({ commit: e }) {
    e("incrementCount");
  },
  // Userid and offer ------------------------------------
  setLogInData({ commit: e }, t) {
    e("setLogInData", t);
  },
  // -----------------------------------------------------
  // -----------Matka
  setMatkaStakesList({ commit: e }, t) {
    e("setMatkaStakesList", t);
  },
  setSelectedMatkaStake({ commit: e }, t) {
    e("setSelectedMatkaStake", t);
  },
  // side menu sports list (leagues)
  setSideMenuLeagueList({ commit: e }, t) {
    e("setSideMenuLeagueList", t);
  },
  setUserTransactionStakes({ commit: e }, t) {
    e("setUserTransactionStakes", t);
  },
  SetdownloadInfo({ commit: e }, t) {
    e("SetdownloadInfo", t);
  }
}, VS = {
  setSettings(e, t) {
    e.siteSettings = t;
  },
  setLanguagesData(e, t) {
    e.languagesData = t;
  },
  setBonusData(e, t) {
    e.bonusData = t;
  },
  setGamesData(e, t) {
    e.gamesData = t;
  },
  setClickBetValue(e, t) {
    e.clickBetValue = t;
  },
  setFavouriteGames(e, t) {
    e.favouriteGames = t;
  },
  setGlobalLoader(e, t) {
    e.globalLoader = t;
  },
  setCaptchaData(e, t) {
    e.captchaData = t;
  },
  setNotification(e) {
    e.notification = e.notification + 1;
  },
  setSport(e, t) {
    e.sportList = t;
  },
  showSuccessModal(e, t) {
    e.successMsg = t;
  },
  showErrorModal(e, t) {
    e.errorMsg = t;
  },
  setUnderMaintenance(e, t) {
    e.underMaintenance = t;
  },
  incrementCount(e) {
    e.count++;
  },
  // Userid and offer ------------------------------------
  setLogInData(e, t) {
    console.log(t), e.logInData = t;
  },
  // -----------------------------------------------------
  // ---------------Matka draggable chips
  setMatkaStakesList(e, t) {
    e.matkaStakesList = t;
  },
  setSelectedMatkaStake(e, t) {
    e.selectedMatkaStake = t;
  },
  // side menu leagues, sports list
  setSideMenuLeagueList(e, t) {
    e.sideMenuLeagueList = t;
  },
  setUserTransactionStakes(e, t) {
    e.userTransactionStakes = t;
  },
  SetdownloadInfo(e, t) {
    e.downloadInfo = t;
  }
}, $D = {
  state: PS,
  getters: $S,
  actions: FS,
  mutations: VS
}, BS = {
  profitLossItem: null,
  viewBetsItem: null,
  plFilterOption: null
}, US = {
  profitLossItem: (e) => e == null ? void 0 : e.profitLossItem,
  viewBetsItem: (e) => e == null ? void 0 : e.viewBetsItem,
  plFilterOption: (e) => e == null ? void 0 : e.plFilterOption
}, HS = {
  setProfitLossItem({ commit: e }, t) {
    e("setProfitLossItem", t);
  },
  setViewBetsItem({ commit: e }, t) {
    e("setViewBetsItem", t);
  },
  setPlFilterOption({ commit: e }, t) {
    e("setPlFilterOption", t);
  }
}, jS = {
  setProfitLossItem(e, t) {
    e.profitLossItem = t;
  },
  setViewBetsItem(e, t) {
    e.viewBetsItem = t;
  },
  setPlFilterOption(e, t) {
    e.plFilterOption = t;
  }
}, FD = {
  state: BS,
  getters: US,
  actions: HS,
  mutations: jS
}, YS = {
  userBonus: null
}, GS = {
  userBonus: (e) => e == null ? void 0 : e.userBonus
}, WS = {
  setUserBonus({ commit: e }, t) {
    e("setUserBonus", t);
  }
}, qS = {
  setUserBonus(e, t) {
    e.userBonus = t;
  }
}, VD = {
  state: YS,
  getters: GS,
  actions: WS,
  mutations: qS
}, KS = {
  cricFightMatchDetails: null,
  cricFightPlayersList: null,
  tutorials: null,
  teamData: null,
  selectedPlayers: null,
  myContest: null
}, zS = {
  cricFightMatchDetails: (e) => e == null ? void 0 : e.cricFightMatchDetails,
  cricFightPlayersList: (e) => e == null ? void 0 : e.cricFightPlayersList,
  tutorials: (e) => e == null ? void 0 : e.tutorials,
  teamData: (e) => e == null ? void 0 : e.teamData,
  selectedPlayers: (e) => e == null ? void 0 : e.selectedPlayers,
  myContest: (e) => e == null ? void 0 : e.myContest
}, JS = {
  setCricFightMatchDetails({ commit: e }, t) {
    e("setCricFightMatchDetails", t);
  },
  setCricFightPlayersList({ commit: e }, t) {
    e("setCricFightPlayersList", t);
  },
  setTutorials({ commit: e }, t) {
    e("setTutorials", t);
  },
  setTeamData({ commit: e }, t) {
    e("setTeamData", t);
  },
  setSelctedPlayers({ commit: e }, t) {
    e("setSelctedPlayers", t);
  },
  setMyContest({ commit: e }, t) {
    e("setMyContest", t);
  }
}, XS = {
  setCricFightMatchDetails(e, t) {
    e.cricFightMatchDetails = t;
  },
  setCricFightPlayersList(e, t) {
    e.cricFightPlayersList = t;
  },
  setTutorials(e, t) {
    e.tutorials = t;
  },
  setTeamData(e, t) {
    e.teamData = t;
  },
  setSelctedPlayers(e, t) {
    e.selectedPlayers = t;
  },
  setMyContest(e, t) {
    e.myContest = t;
  }
}, BD = {
  state: KS,
  getters: zS,
  actions: JS,
  mutations: XS
}, QS = {
  depositAmount: 0,
  withdrawAmount: 0,
  paymentMethod: null,
  transactionDetails: null
}, ZS = {
  depositAmount: (e) => e == null ? void 0 : e.depositAmount,
  withdrawAmount: (e) => e == null ? void 0 : e.withdrawAmount,
  paymentMethod: (e) => e == null ? void 0 : e.paymentMethod,
  transactionDetails: (e) => e == null ? void 0 : e.transactionDetails
}, eO = {
  setDepositAmount({ commit: e }, t) {
    e("setDepositAmount", t);
  },
  setWithdrawAmount({ commit: e }, t) {
    e("setWithdrawAmount", t);
  },
  setPaymentMethodDetails({ commit: e }, t) {
    e("setPaymentMethodDetails", t);
  },
  setTransactionDetails({ commit: e }, t) {
    e("setTransactionDetails", t);
  }
}, tO = {
  setDepositAmount(e, t) {
    e.depositAmount = t;
  },
  setWithdrawAmount(e, t) {
    e.withdrawAmount = t;
  },
  setPaymentMethodDetails(e, t) {
    e.paymentMethod = t;
  },
  setTransactionDetails(e, t) {
    e.transactionDetails = t;
  }
}, UD = {
  state: QS,
  getters: ZS,
  actions: eO,
  mutations: tO
}, HD = {
  resetState(e) {
    e.auth.user = null, e.auth.token = null, e.auth = {
      user: null,
      chips: null,
      token: null,
      eventManage: null,
      eventDetailHideSections: [],
      siteVersion: null
    }, e.commonStore.clickBetValue = null;
  }
}, jD = {
  resetAllState({ commit: e }) {
    e("resetState");
  }
}, YD = "AUTH_TOKEN", rO = [
  {
    id: 1,
    type: "Open Bets"
  },
  {
    id: 2,
    type: "Settled Bets"
  },
  {
    id: 3,
    type: "Statement"
  },
  {
    id: 4,
    type: "Profit & Loss"
  }
], nO = [
  {
    id: 1,
    type: "Sports"
  },
  {
    id: 2,
    type: "Games"
  }
], sO = [
  {
    id: 4,
    type: "Cricket"
  },
  {
    id: 1,
    type: "Football"
  },
  {
    id: 2,
    type: "Tennis"
  }
], iO = [
  {
    id: 999,
    type: "Live Cards"
  },
  {
    id: 4,
    type: "Matka Market"
  },
  {
    id: 2222,
    type: "Sportsbook"
  }
], oO = [
  {
    id: 2,
    type: "Settle Bets"
  },
  {
    id: 4,
    type: "Void"
  },
  {
    id: 5,
    type: "Invalid"
  }
], aO = [
  {
    id: "all",
    type: "All"
  },
  {
    id: "dw",
    type: "Deposit/Withdrawal"
  },
  {
    id: "sport",
    type: "Sports"
  }
], lO = [
  {
    id: "all",
    type: "All"
  },
  {
    id: 4,
    type: "Cricket"
  },
  {
    id: 1,
    type: "Soccer"
  },
  {
    id: 2,
    type: "Tennis"
  }
], cO = [
  {
    id: "all",
    type: "All"
  },
  {
    id: 1,
    type: "Sports"
  },
  {
    id: 2,
    type: "Games"
  }
], uO = [
  {
    id: "worli_matka",
    type: "Matka market"
  },
  {
    id: 2222,
    type: "Sportbook"
  }
];
var dO = [
  {
    id: "all",
    type: "All"
  },
  {
    id: 4,
    type: "Cricket"
  },
  {
    id: 1,
    type: "Football"
  },
  {
    id: 2,
    type: "Tennis"
  },
  {
    id: "dw",
    type: "Deposit/Withdraw"
  },
  {
    id: "sportsbook",
    type: "Sportsbook"
  },
  {
    id: "matka",
    type: "Matka"
  },
  {
    id: "fantasy_cricket",
    type: "Fantasy cricket"
  },
  {
    id: "casino",
    type: "Casino"
  },
  {
    id: "premium",
    type: "Premium"
  },
  {
    id: "virtual_sport",
    type: "Virtual sports"
  }
];
const fO = [
  {
    id: 1,
    type: "open"
  },
  {
    id: 2,
    type: "settled"
  },
  {
    id: 4,
    type: "void"
  },
  {
    id: 5,
    type: "invalid"
  },
  {
    id: 6,
    type: "cancelled"
  }
];
var pO = [
  {
    id: "sport",
    type: "Sports"
  },
  {
    id: "sportsbook",
    type: "Sportsbook"
  },
  {
    id: "matka",
    type: "Matka"
  },
  {
    id: "fantasy_cricket",
    type: "Fantasy Cricket"
  },
  {
    id: "premium",
    type: "Premium"
  },
  {
    id: "casino",
    type: "Casino"
  },
  {
    id: "virtual_sport",
    type: "Virtual Sports"
  }
];
const GD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BETS_STATIC_GAMES: pO,
  BET_STATUS: fO,
  BET_TYPES: oO,
  GAME_SUB_TYPES: iO,
  GAME_TYPES: nO,
  NEW_STATIC_GAMES: dO,
  REPORT_TYPES: aO,
  SPORTS_SUB_TYPES: sO,
  SPORTS_TYPES: lO,
  TYPES: rO,
  WIN_GAMES_TYPES: uO,
  WIN_LOSS_TYPES: cO
}, Symbol.toStringTag, { value: "Module" }));
export {
  YD as AUTH_TOKEN,
  VD as accountStore,
  jD as actions,
  nN as addAccount,
  uA as addBetCall,
  RC as addMatchRemainder,
  xC as addRemainingTimeToCricketFightMatches,
  gC as affSendOtpServiceCall,
  hC as affSignUpCall,
  pC as affSignUpServiceCall,
  $ as apiCall,
  PD as auth,
  FD as betsStore,
  YC as calculateRemainingTime,
  XC as calculateTeamScores,
  Ai as calculationOfProfitLoss,
  FN as callChangePasswordServiceFunction,
  BN as callChangeStakeValue,
  TA as callForSportsBooksUrl,
  dC as callForvirtualSportsUrl,
  cN as cancelRequest,
  rA as cashout,
  jA as cashoutDisableForBookmaker,
  UA as cashoutDisableForMainMarket,
  GA as cashoutDisableForOtherMarket,
  xO as casinoGamesHandler,
  fA as changeAcceptOdds,
  HA as checkCashoutConditionForBookmaker,
  BA as checkCashoutConditionForMainMarket,
  YA as checkCashoutConditionForOtherMarkets,
  yA as checkClickBetValues,
  HT as checkEventManageForMatka,
  UT as checkEventManageforSingleType,
  Lr as checkEventManageforSports,
  hn as checkForLockedMatches,
  BO as checkForPremiumFancyEvent,
  jT as checkInEventMangeForSection,
  gA as clearStake,
  MD as closeUserId,
  $D as commonStore,
  _C as copyAffUrl,
  QN as copyRefUrl,
  GN as copyRefUrlInAccount,
  ID as copyUserIdRefUrl,
  CN as countdown,
  fC as createComputedPropertiesForAffilliateModule,
  zN as createComputedPropertiesForEditStakes,
  yD as createComputedPropertiesForFooter,
  mD as createComputedPropertiesForLanguageSelection,
  DD as createComputedPropertiesForMaintenance,
  TN as createComputedPropertiesForMatkaDetails,
  aC as createComputedPropertiesForNotifications,
  DA as createComputedPropertiesForOpenBetsInSports,
  CA as createComputedPropertiesForPoolZoneLeaderBoard,
  _D as createComputedPropertiesForPostersAndLogos,
  iC as createComputedPropertiesForReferAndEarn,
  wA as createComputedPropertiesForSportEventDetails,
  xD as createComputedPropertiesForSportSelection,
  uN as createComputedPropertiesForTransactionDetails,
  zO as createSharedComputed,
  ZA as createSharedComputedForDepositPayment,
  tA as createSharedComputedForInplay,
  sD as createSharedComputedForStatements,
  KN as createSharedComputedPropertiesForAccount,
  gD as createSharedComputedPropertiesForCasino,
  XN as createSharedComputedPropertiesForChatbot,
  pN as createSharedComputedPropertiesForMatka,
  ZO as createSharedComputedPropertiesForSports,
  Te as dateTime,
  LN as demoUserLoginData,
  xA as disableBookmakerMarketOdds,
  $A as disableFancyMarketOdds,
  LA as disableMainMarketOdds,
  VA as disableOtherMarketOdds,
  OC as downloadOpenBets,
  AC as downloadOpenBetsNotSports,
  CC as downloadProfitLoss,
  yC as downloadQR,
  NC as downloadStatement,
  m as errorToast,
  BD as fantasyCricketStore,
  KO as filterSportsMatchesByKey,
  $N as forgetPasswordCall,
  PN as forgotServiceCall,
  OS as generateGuruSelection,
  Lp as getAffOtp,
  DC as getAffProfitLossDetail,
  SC as getAffProfitLossServiceCall,
  TC as getAffStatementServiceCall,
  vC as getAffiliateComReport,
  mC as getAffiliateDashboard,
  bC as getAffiliateRegisterUserCount,
  wC as getAffiliateUsersList,
  ND as getBonusLogs,
  ZN as getBonusStatements,
  EN as getBookOfDigit,
  HO as getCasinoGamesServiceCall,
  JC as getContestBetList,
  QC as getContestBetListInMyTeams,
  uC as getEventBookExposures,
  sA as getEventDetails,
  iA as getEventExposuresCall,
  YO as getFantasyMatchList,
  cC as getFavouriteEventIdsServiceCall,
  RN as getId,
  kD as getInplayMatchCounts,
  UO as getInplayMatches,
  ON as getJodiData,
  AA as getLeaderBoardData,
  HN as getLockedEarnedBonus,
  oD as getMarketBetsServiceCall,
  UC as getMatchedBets,
  hN as getMatkaMarkets,
  gN as getMatkaSingleBets,
  dN as getMatkasServiceCall,
  zC as getMyContests,
  lC as getMyMarketsServiceCall,
  oC as getMyNotificationsList,
  $C as getMyStakes,
  cD as getNextMenuItem,
  jO as getNotficationsCount,
  oA as getOpenBets,
  ZC as getOpenBetsServiceCall,
  aA as getOpenMarketBets,
  yS as getParentPaymentsMethods,
  ED as getParentWhatsappNumber,
  JA as getPaymentGatewayUrl,
  PC as getPlayersList,
  NA as getPoolOpenBetsServiceCall,
  XT as getPoolWallet,
  lD as getPreviousMenuItem,
  OA as getPreviousPoolWinners,
  iD as getProfitLossDetail,
  EC as getProfitLossEventUsers,
  tD as getProfitLossServiceCall,
  Co as getQueryParam,
  eC as getReferStatements,
  LC as getRememberedMatches,
  LD as getSearch,
  nD as getSearchList,
  MC as getSetUpData,
  xT as getSiteVersion,
  JO as getSportsList,
  eD as getStatementServiceCall,
  VC as getTeamDetails,
  sC as getTotalRolling,
  lN as getTransactionStatus,
  nC as getUsedBonus,
  wS as getUserAccounts,
  IC as getUserMarketBetsServiceCall,
  qA as getWalletAuth,
  aN as getWalletHistory,
  RD as get_sportsList,
  cA as getfancyBookServiceCall,
  KC as handlePlayerSelectionInCricketFight,
  ef as headers,
  Re as helper,
  wN as isCurrentTimeInRange,
  kA as isSuspendedBookmaker,
  PA as isSuspendedFancy,
  RA as isSuspenedMainMarket,
  FA as isSuspenedOtherMarket,
  SA as joinPool,
  vD as loadMiniGames,
  IN as loginServiceCall,
  VN as logoutServiceCall,
  QO as makeFavouriteCall,
  WC as makePlayerFormation,
  SN as maktaDigits,
  GO as markingFavouriteInMatches,
  HD as mutations,
  zA as ocrCheck,
  hA as oddsMinus,
  pA as oddsPlus,
  OD as onDrag,
  wD as onTouchMove,
  XA as onUploadImage,
  rD as openStatementInfo,
  sN as openWithdrawPasswordModal,
  mA as pinUnpinFancy,
  HC as placeBet,
  nA as poolZone,
  lA as premiumFancyServiceCall,
  qN as redeemBonus,
  WA as redeemPromoBonus,
  rC as redeemRefBonus,
  tN as removeAccount,
  kC as removeReminder,
  qC as resetTeam,
  oN as resetWithdrawalPassword,
  dA as saveBetsCall,
  EA as saveClickBetValue,
  _N as saveWorliMatkaBetServiceCall,
  aD as scrollActiveElementIntoView,
  vN as selectDigit,
  AN as sendOtpCall,
  NN as sendOtpServiceCall,
  fD as setCasinoGamesList,
  PO as setCurrentLangDataFn,
  tf as setHeaders,
  yN as setMarketList,
  uD as setProviderList,
  _A as setStakeValue,
  RO as setStore,
  kO as setTranslatedDataFn,
  LO as setWalletHeaders,
  KA as setWalletStakeValue,
  FO as setonScroll,
  MA as showIncSuperOverLabelForWhoWillTheMatch,
  MN as signInwithOtp,
  xN as signUpCall,
  kN as signUpServiceCall,
  kp as snapToEdge,
  VO as socketAllEvents,
  vA as socketServiceCall,
  bA as socketServiceOff,
  SD as startDrag,
  CD as startTimer,
  bD as startTouch,
  iN as startWithdrawTimer,
  AD as stopDrag,
  TD as stopTouch,
  QA as submitDepositAmount,
  FC as submitSelectedPlayersTeam,
  _e as successToast,
  UN as switchToWelcomeBonus,
  WO as t1FilteringOutLockedMatches,
  XO as t1FilteringOutSportLockedMatches,
  DN as t1TogglePasswordVisibility,
  qO as t3FilteringOutLockedMatches,
  pD as t5FilterGamesByProviderId,
  bN as t5GetBookOfDigit,
  hD as t5SetUniqueProviders,
  eA as t5setInplayMatches,
  IA as t8CreateComputedPropertiesForOpenBetsInSports,
  JN as toggleChatModal,
  MS as tutorialsList,
  GD as types,
  jN as updateCountdown,
  fN as updateCountdownForMatka,
  dD as updateMenuListForProvider,
  jC as updateMyStakes,
  BC as updateTeamName,
  WN as updateUserName,
  YN as updateWalletType,
  mN as verifySubmitBet,
  GC as viewBetDetails,
  tC as viewReferedUserLog,
  Ev as walletHeaders,
  UD as walletStore,
  eN as withdrawAmountClickValidation,
  rN as withdrawWalletAmount
};
